(function () {
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec6c5"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec6c5"] = parcelRequire;
}
parcelRequire.register("6rwMJ", function(module, exports) {
module.exports = [
    {
        date: "2022-10-29",
        open: 36.01,
        close: 35.1,
        high: 36,
        low: 34.98,
        volume: 2617774,
        uOpen: 36.25,
        uClose: 33.9,
        uHigh: 34.98,
        uLow: 34.64,
        uVolume: 2653970,
        change: 0,
        changePercent: 0,
        label: "Oct 29, 19",
        changeOverTime: 0
    },
    {
        date: "2022-10-30",
        open: 34.8,
        close: 34.33,
        high: 35.3,
        low: 34.23,
        volume: 1779815,
        uOpen: 34.5,
        uClose: 34.5,
        uHigh: 34.69,
        uLow: 34.61,
        uVolume: 1795109,
        change: -0.63,
        changePercent: -1.8933,
        label: "Oct 30, 19",
        changeOverTime: -0.018531
    },
    {
        date: "2022-10-31",
        open: 33.53,
        close: 33.17,
        high: 34.62,
        low: 33.23,
        volume: 2803319,
        uOpen: 33.96,
        uClose: 32.9,
        uHigh: 33.17,
        uLow: 32.39,
        uVolume: 2781295,
        change: -0.64,
        changePercent: -1.8875,
        label: "Oct 31, 19",
        changeOverTime: -0.036709
    },
    {
        date: "2022-11-01",
        open: 33.21,
        close: 34.55,
        high: 34.4,
        low: 33.66,
        volume: 2141225,
        uOpen: 34.12,
        uClose: 34.35,
        uHigh: 34.7,
        uLow: 33.89,
        uVolume: 2168664,
        change: 1.12,
        changePercent: 3.4975,
        label: "Nov 1, 19",
        changeOverTime: -0.003292
    },
    {
        date: "2022-11-04",
        open: 34.9,
        close: 35.59,
        high: 35.5,
        low: 34.98,
        volume: 1519871,
        uOpen: 34.2,
        uClose: 35.06,
        uHigh: 34.8,
        uLow: 34.59,
        uVolume: 1486370,
        change: 0.29,
        changePercent: 0.8865,
        label: "Nov 4, 19",
        changeOverTime: 0.005584
    },
    {
        date: "2022-11-05",
        open: 35.77,
        close: 33.38,
        high: 35.76,
        low: 33.8,
        volume: 1926635,
        uOpen: 34.46,
        uClose: 34.28,
        uHigh: 34.42,
        uLow: 33.97,
        uVolume: 1912218,
        change: -0.65,
        changePercent: -1.8931,
        label: "Nov 5, 19",
        changeOverTime: -0.013049
    },
    {
        date: "2022-11-06",
        open: 33.88,
        close: 34.61,
        high: 34.13,
        low: 34.07,
        volume: 2111260,
        uOpen: 34.41,
        uClose: 33.72,
        uHigh: 34.09,
        uLow: 34.23,
        uVolume: 2085817,
        change: 0.28,
        changePercent: 0.8178,
        label: "Nov 6, 19",
        changeOverTime: -0.00518
    },
    {
        date: "2022-11-07",
        open: 34.2,
        close: 34.26,
        high: 36.22,
        low: 34.36,
        volume: 6259928,
        uOpen: 33.8,
        uClose: 33.59,
        uHigh: 36.23,
        uLow: 34.34,
        uVolume: 6398894,
        change: -0.19,
        changePercent: -0.592,
        label: "Nov 7, 19",
        changeOverTime: -0.0107
    },
    {
        date: "2022-11-08",
        open: 38.38,
        close: 37.7,
        high: 40.1,
        low: 36.66,
        volume: 10755989,
        uOpen: 37.85,
        uClose: 38.33,
        uHigh: 39.4,
        uLow: 36.58,
        uVolume: 10519839,
        change: 4.3,
        changePercent: 12.3091,
        label: "Nov 8, 19",
        changeOverTime: 0.115294
    },
    {
        date: "2022-11-11",
        open: 38.14,
        close: 39.99,
        high: 40.41,
        low: 37.79,
        volume: 4011919,
        uOpen: 37.43,
        uClose: 39.7,
        uHigh: 40.45,
        uLow: 38.07,
        uVolume: 3998775,
        change: 1.09,
        changePercent: 2.9954,
        label: "Nov 11, 19",
        changeOverTime: 0.145084
    },
    {
        date: "2022-11-12",
        open: 39.98,
        close: 39.59,
        high: 39.56,
        low: 38.82,
        volume: 3794301,
        uOpen: 40.03,
        uClose: 39.62,
        uHigh: 39.35,
        uLow: 38.77,
        uVolume: 3735517,
        change: -0.8,
        changePercent: -2.1297,
        label: "Nov 12, 19",
        changeOverTime: 0.123626
    },
    {
        date: "2022-11-13",
        open: 38.97,
        close: 39.69,
        high: 39.98,
        low: 38.35,
        volume: 2324031,
        uOpen: 37.65,
        uClose: 38.26,
        uHigh: 40,
        uLow: 37.51,
        uVolume: 2298571,
        change: 0.33,
        changePercent: 0.8629,
        label: "Nov 13, 19",
        changeOverTime: 0.131566
    },
    {
        date: "2022-11-14",
        open: 38.86,
        close: 39.85,
        high: 40.82,
        low: 38.56,
        volume: 2593341,
        uOpen: 39.42,
        uClose: 39.21,
        uHigh: 39.71,
        uLow: 39.04,
        uVolume: 2584979,
        change: 0.85,
        changePercent: 2.2146,
        label: "Nov 14, 19",
        changeOverTime: 0.153453
    },
    {
        date: "2022-11-15",
        open: 41,
        close: 40.52,
        high: 39.81,
        low: 40.48,
        volume: 2314080,
        uOpen: 41,
        uClose: 41.52,
        uHigh: 40.31,
        uLow: 38.69,
        uVolume: 2306652,
        change: 0.76,
        changePercent: 1.8872,
        label: "Nov 15, 19",
        changeOverTime: 0.179917
    },
    {
        date: "2022-11-18",
        open: 40.46,
        close: 40.6,
        high: 41.4,
        low: 39.95,
        volume: 1877989,
        uOpen: 39.63,
        uClose: 41.6,
        uHigh: 41,
        uLow: 40.04,
        uVolume: 1854103,
        change: 0.28,
        changePercent: 0.6903,
        label: "Nov 18, 19",
        changeOverTime: 0.189738
    },
    {
        date: "2022-11-19",
        open: 40.02,
        close: 38.83,
        high: 40.22,
        low: 37.94,
        volume: 2486004,
        uOpen: 39.7,
        uClose: 39,
        uHigh: 39.95,
        uLow: 38.19,
        uVolume: 2455938,
        change: -2.17,
        changePercent: -5.4722,
        label: "Nov 19, 19",
        changeOverTime: 0.121886
    },
    {
        date: "2022-11-20",
        open: 38.53,
        close: 40.35,
        high: 39.78,
        low: 38.11,
        volume: 2824626,
        uOpen: 38.08,
        uClose: 40,
        uHigh: 39.68,
        uLow: 38.39,
        uVolume: 2753415,
        change: 1.11,
        changePercent: 3.011,
        label: "Nov 20, 19",
        changeOverTime: 0.154067
    },
    {
        date: "2022-11-21",
        open: 39.6,
        close: 40.09,
        high: 41.33,
        low: 38.87,
        volume: 3427350,
        uOpen: 40.88,
        uClose: 41.7,
        uHigh: 40.13,
        uLow: 40.44,
        uVolume: 3368350,
        change: 0.93,
        changePercent: 2.45,
        label: "Nov 21, 19",
        changeOverTime: 0.181371
    },
    {
        date: "2022-11-22",
        open: 40.51,
        close: 43.2,
        high: 41.41,
        low: 40.2,
        volume: 3748525,
        uOpen: 39.99,
        uClose: 42.6,
        uHigh: 41.69,
        uLow: 41.6,
        uVolume: 3744138,
        change: 1.36,
        changePercent: 3.3768,
        label: "Nov 22, 19",
        changeOverTime: 0.224899
    },
    {
        date: "2022-11-25",
        open: 42.43,
        close: 42.63,
        high: 41.9,
        low: 41.7,
        volume: 2797902,
        uOpen: 42.21,
        uClose: 42.61,
        uHigh: 41.76,
        uLow: 42.2,
        uVolume: 2787678,
        change: -0.21,
        changePercent: -0.5315,
        label: "Nov 25, 19",
        changeOverTime: 0.211682
    },
    {
        date: "2022-11-26",
        open: 41.87,
        close: 40.39,
        high: 42.62,
        low: 40.42,
        volume: 2368962,
        uOpen: 42.26,
        uClose: 41.7,
        uHigh: 41.67,
        uLow: 40.45,
        uVolume: 2344501,
        change: -0.7,
        changePercent: -1.7388,
        label: "Nov 26, 19",
        changeOverTime: 0.191759
    },
    {
        date: "2022-11-27",
        open: 41.92,
        close: 40,
        high: 41.98,
        low: 39.97,
        volume: 2331335,
        uOpen: 41.88,
        uClose: 41,
        uHigh: 40.72,
        uLow: 39.54,
        uVolume: 2320826,
        change: -1.2,
        changePercent: -3.114,
        label: "Nov 27, 19",
        changeOverTime: 0.154846
    },
    {
        date: "2022-11-29",
        open: 39.96,
        close: 39.75,
        high: 39.65,
        low: 39.95,
        volume: 940129,
        uOpen: 39.77,
        uClose: 40.44,
        uHigh: 39.97,
        uLow: 38.9,
        uVolume: 936524,
        change: 0.16,
        changePercent: 0.3998,
        label: "Nov 29, 19",
        changeOverTime: 0.1583
    },
    {
        date: "2022-12-02",
        open: 39.69,
        close: 41.17,
        high: 41.82,
        low: 38.75,
        volume: 3215782,
        uOpen: 40.3,
        uClose: 41.32,
        uHigh: 40.6,
        uLow: 39.75,
        uVolume: 3114082,
        change: 0.72,
        changePercent: 1.8667,
        label: "Dec 2, 19",
        changeOverTime: 0.1814
    },
    {
        date: "2022-12-03",
        open: 40.98,
        close: 40.46,
        high: 42.09,
        low: 40.85,
        volume: 2415909,
        uOpen: 39.51,
        uClose: 42.17,
        uHigh: 41.35,
        uLow: 40.85,
        uVolume: 2358707,
        change: 0.34,
        changePercent: 0.824,
        label: "Dec 3, 19",
        changeOverTime: 0.1935
    },
    {
        date: "2022-12-04",
        open: 41.67,
        close: 41.84,
        high: 42.78,
        low: 41,
        volume: 2687715,
        uOpen: 41.34,
        uClose: 40.91,
        uHigh: 42.21,
        uLow: 42,
        uVolume: 2645240,
        change: 0.41,
        changePercent: 0.9874,
        label: "Dec 4, 19",
        changeOverTime: 0.201521
    },
    {
        date: "2022-12-05",
        open: 41.71,
        close: 41.56,
        high: 42.91,
        low: 41.3,
        volume: 1613906,
        uOpen: 41.6,
        uClose: 43.05,
        uHigh: 41.24,
        uLow: 41.6,
        uVolume: 1632653,
        change: 0.5,
        changePercent: 1.1908,
        label: "Dec 5, 19",
        changeOverTime: 0.220602
    },
    {
        date: "2022-12-06",
        open: 43.2,
        close: 42.78,
        high: 43.5,
        low: 42.6,
        volume: 4979568,
        uOpen: 41.41,
        uClose: 42.55,
        uHigh: 43.52,
        uLow: 41.73,
        uVolume: 4874735,
        change: 0.02,
        changePercent: 0.0493,
        label: "Dec 6, 19",
        changeOverTime: 0.223518
    },
    {
        date: "2022-12-09",
        open: 41.54,
        close: 41.24,
        high: 43.26,
        low: 41.04,
        volume: 4044464,
        uOpen: 41.53,
        uClose: 42.49,
        uHigh: 42.82,
        uLow: 40.61,
        uVolume: 4064602,
        change: -0.3,
        changePercent: -0.7155,
        label: "Dec 9, 19",
        changeOverTime: 0.215761
    },
    {
        date: "2022-12-10",
        open: 42.46,
        close: 43.16,
        high: 42.6,
        low: 41.65,
        volume: 4041974,
        uOpen: 42.63,
        uClose: 43.45,
        uHigh: 42,
        uLow: 40.61,
        uVolume: 3978412,
        change: 0.77,
        changePercent: 1.8707,
        label: "Dec 10, 19",
        changeOverTime: 0.233554
    },
    {
        date: "2022-12-11",
        open: 42.9,
        close: 44.07,
        high: 44.34,
        low: 42.59,
        volume: 3608823,
        uOpen: 43.2,
        uClose: 44.06,
        uHigh: 44.95,
        uLow: 42.14,
        uVolume: 3538718,
        change: 1.26,
        changePercent: 3.0731,
        label: "Dec 11, 19",
        changeOverTime: 0.276079
    },
    {
        date: "2022-12-12",
        open: 43.6,
        close: 43.88,
        high: 44.1,
        low: 43.03,
        volume: 2553774,
        uOpen: 44.1,
        uClose: 44.67,
        uHigh: 43.4,
        uLow: 43.77,
        uVolume: 2565016,
        change: -0.2,
        changePercent: -0.4835,
        label: "Dec 12, 19",
        changeOverTime: 0.25902
    },
    {
        date: "2022-12-13",
        open: 43.5,
        close: 43.33,
        high: 44.35,
        low: 41.94,
        volume: 3337673,
        uOpen: 42.6,
        uClose: 43.62,
        uHigh: 43.98,
        uLow: 42.11,
        uVolume: 3225719,
        change: -0.28,
        changePercent: -0.6349,
        label: "Dec 13, 19",
        changeOverTime: 0.257432
    },
    {
        date: "2022-12-16",
        open: 44.34,
        close: 44,
        high: 44.67,
        low: 43.35,
        volume: 3170427,
        uOpen: 44.32,
        uClose: 44,
        uHigh: 44.21,
        uLow: 42.53,
        uVolume: 3254426,
        change: 0.75,
        changePercent: 1.793,
        label: "Dec 16, 19",
        changeOverTime: 0.278754
    },
    {
        date: "2022-12-17",
        open: 43.78,
        close: 44.75,
        high: 45.61,
        low: 43.6,
        volume: 1885914,
        uOpen: 43.74,
        uClose: 45.31,
        uHigh: 44.04,
        uLow: 44.3,
        uVolume: 1843376,
        change: 0.29,
        changePercent: 0.7075,
        label: "Dec 17, 19",
        changeOverTime: 0.286196
    },
    {
        date: "2022-12-18",
        open: 44.7,
        close: 46.06,
        high: 45.44,
        low: 44.35,
        volume: 5388376,
        uOpen: 44,
        uClose: 45.56,
        uHigh: 46.55,
        uLow: 45.25,
        uVolume: 5397277,
        change: 0.97,
        changePercent: 2.2507,
        label: "Dec 18, 19",
        changeOverTime: 0.324178
    },
    {
        date: "2022-12-19",
        open: 45.88,
        close: 46.42,
        high: 46.25,
        low: 44.41,
        volume: 1799269,
        uOpen: 44.75,
        uClose: 45.4,
        uHigh: 45.49,
        uLow: 44.44,
        uVolume: 1814408,
        change: 0.7,
        changePercent: 1.5879,
        label: "Dec 19, 19",
        changeOverTime: 0.341763
    },
    {
        date: "2022-12-20",
        open: 45.68,
        close: 44,
        high: 47.08,
        low: 43.82,
        volume: 2130269,
        uOpen: 46.59,
        uClose: 44.32,
        uHigh: 47.38,
        uLow: 45.7,
        uVolume: 2116397,
        change: -1.02,
        changePercent: -2.3298,
        label: "Dec 20, 19",
        changeOverTime: 0.313338
    },
    {
        date: "2022-12-23",
        open: 45.06,
        close: 46,
        high: 45.57,
        low: 45.11,
        volume: 1745837,
        uOpen: 45.93,
        uClose: 45.7,
        uHigh: 45.33,
        uLow: 44.13,
        uVolume: 1773684,
        change: 0.49,
        changePercent: 1.1098,
        label: "Dec 23, 19",
        changeOverTime: 0.318653
    },
    {
        date: "2022-12-24",
        open: 45.95,
        close: 45.49,
        high: 45.4,
        low: 46.3,
        volume: 2281142,
        uOpen: 46.01,
        uClose: 45.62,
        uHigh: 45.18,
        uLow: 46,
        uVolume: 2272076,
        change: 0.6,
        changePercent: 1.3653,
        label: "Dec 24, 19",
        changeOverTime: 0.340028
    },
    {
        date: "2022-12-26",
        open: 45.23,
        close: 45.81,
        high: 47.52,
        low: 45.69,
        volume: 1007288,
        uOpen: 46.82,
        uClose: 47.07,
        uHigh: 46.55,
        uLow: 46.71,
        uVolume: 1004690,
        change: 0.6,
        changePercent: 1.2985,
        label: "Dec 26, 19",
        changeOverTime: 0.352027
    },
    {
        date: "2022-12-27",
        open: 47.63,
        close: 46.7,
        high: 47.13,
        low: 45.41,
        volume: 1547642,
        uOpen: 46.5,
        uClose: 47.8,
        uHigh: 47.99,
        uLow: 47.29,
        uVolume: 1496844,
        change: 0.54,
        changePercent: 1.2306,
        label: "Dec 27, 19",
        changeOverTime: 0.37105
    },
    {
        date: "2022-12-30",
        open: 46.74,
        close: 47.75,
        high: 47.17,
        low: 45.94,
        volume: 1564049,
        uOpen: 46.76,
        uClose: 46.76,
        uHigh: 46.96,
        uLow: 46.03,
        uVolume: 1570778,
        change: -0.48,
        changePercent: -1.0364,
        label: "Dec 30, 19",
        changeOverTime: 0.35
    },
    {
        date: "2022-12-31",
        open: 47.13,
        close: 47.24,
        high: 47.68,
        low: 45.63,
        volume: 1546059,
        uOpen: 47.43,
        uClose: 46.78,
        uHigh: 47.51,
        uLow: 46.22,
        uVolume: 1579825,
        change: 0.31,
        changePercent: 0.7029,
        label: "Dec 31, 19",
        changeOverTime: 0.366055
    },
    {
        date: "2023-01-02",
        open: 47.08,
        close: 45.43,
        high: 46.63,
        low: 46.91,
        volume: 2244769,
        uOpen: 46.64,
        uClose: 46.29,
        uHigh: 48.74,
        uLow: 45.32,
        uVolume: 2209444,
        change: -0.76,
        changePercent: -1.634,
        label: "Jan 2, 20",
        changeOverTime: 0.337854
    },
    {
        date: "2023-01-03",
        open: 44.83,
        close: 46.74,
        high: 47.4,
        low: 44.77,
        volume: 2231937,
        uOpen: 46.56,
        uClose: 44.97,
        uHigh: 47.52,
        uLow: 44.61,
        uVolume: 2231156,
        change: -0.51,
        changePercent: -1.1018,
        label: "Jan 3, 20",
        changeOverTime: 0.327509
    },
    {
        date: "2023-01-06",
        open: 45.13,
        close: 46.2,
        high: 46.06,
        low: 46.13,
        volume: 2636978,
        uOpen: 45.18,
        uClose: 44.93,
        uHigh: 46.7,
        uLow: 44.17,
        uVolume: 2539124,
        change: -0.08,
        changePercent: -0.1806,
        label: "Jan 6, 20",
        changeOverTime: 0.32392
    },
    {
        date: "2023-01-07",
        open: 46.95,
        close: 47.21,
        high: 46.58,
        low: 46.09,
        volume: 2204053,
        uOpen: 45.83,
        uClose: 46.18,
        uHigh: 47.73,
        uLow: 45.64,
        uVolume: 2184855,
        change: 1.15,
        changePercent: 2.5379,
        label: "Jan 7, 20",
        changeOverTime: 0.368658
    },
    {
        date: "2023-01-08",
        open: 46.18,
        close: 46.75,
        high: 47.4,
        low: 46.74,
        volume: 2835645,
        uOpen: 46.19,
        uClose: 47.15,
        uHigh: 46.5,
        uLow: 47.48,
        uVolume: 2840960,
        change: 0,
        changePercent: 0,
        label: "Jan 8, 20",
        changeOverTime: 0.367444
    },
    {
        date: "2023-01-09",
        open: 47.65,
        close: 46.1,
        high: 46.69,
        low: 45.94,
        volume: 1798940,
        uOpen: 48.41,
        uClose: 47.18,
        uHigh: 48.4,
        uLow: 46.41,
        uVolume: 1871398,
        change: 0.01,
        changePercent: 0.0222,
        label: "Jan 9, 20",
        changeOverTime: 0.364816
    },
    {
        date: "2023-01-10",
        open: 47.7,
        close: 47.41,
        high: 46.19,
        low: 47.06,
        volume: 1438084,
        uOpen: 48.12,
        uClose: 46.72,
        uHigh: 46.48,
        uLow: 46.51,
        uVolume: 1475593,
        change: -0.2,
        changePercent: -0.428,
        label: "Jan 10, 20",
        changeOverTime: 0.350805
    },
    {
        date: "2023-01-13",
        open: 47.05,
        close: 47.19,
        high: 48.96,
        low: 47.1,
        volume: 1885520,
        uOpen: 46.72,
        uClose: 46.58,
        uHigh: 48.74,
        uLow: 46.4,
        uVolume: 1835214,
        change: 1.03,
        changePercent: 2.1742,
        label: "Jan 13, 20",
        changeOverTime: 0.391872
    },
    {
        date: "2023-01-14",
        open: 46.35,
        close: 48.11,
        high: 48.66,
        low: 46.73,
        volume: 2852495,
        uOpen: 48.22,
        uClose: 48.85,
        uHigh: 49.41,
        uLow: 48.11,
        uVolume: 2926009,
        change: 0.49,
        changePercent: 1.092,
        label: "Jan 14, 20",
        changeOverTime: 0.41189
    },
    {
        date: "2023-01-15",
        open: 47.81,
        close: 48.09,
        high: 48.18,
        low: 47.99,
        volume: 2449875,
        uOpen: 47.84,
        uClose: 47.93,
        uHigh: 49.16,
        uLow: 47.4,
        uVolume: 2508068,
        change: -0.4,
        changePercent: -0.8613,
        label: "Jan 15, 20",
        changeOverTime: 0.39127
    },
    {
        date: "2023-01-16",
        open: 48.04,
        close: 47.66,
        high: 48.84,
        low: 47,
        volume: 4557541,
        uOpen: 49.19,
        uClose: 48.97,
        uHigh: 48.19,
        uLow: 47,
        uVolume: 4554773,
        change: 0.5,
        changePercent: 1.0982,
        label: "Jan 16, 20",
        changeOverTime: 0.398581
    },
    {
        date: "2023-01-17",
        open: 47.66,
        close: 48.89,
        high: 49.02,
        low: 48.71,
        volume: 3070011,
        uOpen: 49.23,
        uClose: 49.04,
        uHigh: 48.24,
        uLow: 47.69,
        uVolume: 3009781,
        change: 0.79,
        changePercent: 1.672,
        label: "Jan 17, 20",
        changeOverTime: 0.434328
    },
    {
        date: "2023-01-21",
        open: 48.18,
        close: 49.52,
        high: 50.67,
        low: 48.11,
        volume: 1693203,
        uOpen: 49.58,
        uClose: 50.43,
        uHigh: 50.62,
        uLow: 49.17,
        uVolume: 1689118,
        change: 0.19,
        changePercent: 0.4057,
        label: "Jan 21, 20",
        changeOverTime: 0.431955
    },
    {
        date: "2023-01-22",
        open: 48.3,
        close: 48.28,
        high: 50.6,
        low: 49.41,
        volume: 1566984,
        uOpen: 48.8,
        uClose: 48.63,
        uHigh: 49.05,
        uLow: 48.95,
        uVolume: 1573676,
        change: -0.06,
        changePercent: -0.1265,
        label: "Jan 22, 20",
        changeOverTime: 0.424542
    },
    {
        date: "2023-01-23",
        open: 48.48,
        close: 48.47,
        high: 50.19,
        low: 49.69,
        volume: 1550914,
        uOpen: 48.01,
        uClose: 49.02,
        uHigh: 49.62,
        uLow: 48.69,
        uVolume: 1523544,
        change: 0.14,
        changePercent: 0.298,
        label: "Jan 23, 20",
        changeOverTime: 0.443
    },
    {
        date: "2023-01-24",
        open: 50.1,
        close: 50.6,
        high: 49.11,
        low: 48.47,
        volume: 3162138,
        uOpen: 49.7,
        uClose: 49.12,
        uHigh: 49.82,
        uLow: 48.12,
        uVolume: 3182422,
        change: 0.22,
        changePercent: 0.4506,
        label: "Jan 24, 20",
        changeOverTime: 0.445355
    },
    {
        date: "2023-01-27",
        open: 49.64,
        close: 48.94,
        high: 49.37,
        low: 47.8,
        volume: 2098460,
        uOpen: 47.95,
        uClose: 48.07,
        uHigh: 48.95,
        uLow: 47.4,
        uVolume: 2043522,
        change: -1.27,
        changePercent: -2.6018,
        label: "Jan 27, 20",
        changeOverTime: 0.400044
    },
    {
        date: "2023-01-28",
        open: 47.8,
        close: 47.78,
        high: 48.51,
        low: 49.02,
        volume: 2086436,
        uOpen: 48.5,
        uClose: 48.31,
        uHigh: 49.16,
        uLow: 48.43,
        uVolume: 2088876,
        change: -0.02,
        changePercent: -0.0426,
        label: "Jan 28, 20",
        changeOverTime: 0.396792
    },
    {
        date: "2023-01-29",
        open: 48.5,
        close: 49.25,
        high: 50.08,
        low: 48.19,
        volume: 2075493,
        uOpen: 48.04,
        uClose: 48.71,
        uHigh: 49.79,
        uLow: 47.88,
        uVolume: 2075113,
        change: 0.58,
        changePercent: 1.2293,
        label: "Jan 29, 20",
        changeOverTime: 0.41235
    },
    {
        date: "2023-01-30",
        open: 48.46,
        close: 48.57,
        high: 49.47,
        low: 47.89,
        volume: 1293161,
        uOpen: 47.81,
        uClose: 49.07,
        uHigh: 48.86,
        uLow: 46.91,
        uVolume: 1316043,
        change: -0.4,
        changePercent: -0.8497,
        label: "Jan 30, 20",
        changeOverTime: 0.417095
    },
    {
        date: "2023-01-31",
        open: 49.2,
        close: 46.78,
        high: 49,
        low: 45.52,
        volume: 1937638,
        uOpen: 48.8,
        uClose: 46.63,
        uHigh: 47.6,
        uLow: 45.87,
        uVolume: 1892186,
        change: -1.14,
        changePercent: -2.4,
        label: "Jan 31, 20",
        changeOverTime: 0.37076
    },
    {
        date: "2023-02-03",
        open: 47.84,
        close: 48.85,
        high: 47.17,
        low: 46.75,
        volume: 1058785,
        uOpen: 46.7,
        uClose: 48.06,
        uHigh: 47.33,
        uLow: 46.87,
        uVolume: 1062627,
        change: 0.38,
        changePercent: 0.8027,
        label: "Feb 3, 20",
        changeOverTime: 0.396564
    },
    {
        date: "2023-02-04",
        open: 49.22,
        close: 49.4,
        high: 49.65,
        low: 47.97,
        volume: 1668735,
        uOpen: 49.39,
        uClose: 50.83,
        uHigh: 49.9,
        uLow: 48.42,
        uVolume: 1667918,
        change: 2.5,
        changePercent: 5.2626,
        label: "Feb 4, 20",
        changeOverTime: 0.462467
    },
    {
        date: "2023-02-05",
        open: 51.35,
        close: 50.71,
        high: 51,
        low: 49.71,
        volume: 2257712,
        uOpen: 51.23,
        uClose: 49.19,
        uHigh: 50.2,
        uLow: 49.44,
        uVolume: 2255050,
        change: 0.14,
        changePercent: 0.2661,
        label: "Feb 5, 20",
        changeOverTime: 0.464711
    },
    {
        date: "2023-02-06",
        open: 49.32,
        close: 51.11,
        high: 51.13,
        low: 50.42,
        volume: 3494975,
        uOpen: 50.67,
        uClose: 51.6,
        uHigh: 51.75,
        uLow: 50.58,
        uVolume: 3493465,
        change: 1.05,
        changePercent: 2.2215,
        label: "Feb 6, 20",
        changeOverTime: 0.503036
    },
    {
        date: "2023-02-07",
        open: 52.43,
        close: 52.01,
        high: 53.58,
        low: 51.07,
        volume: 2812294,
        uOpen: 52.61,
        uClose: 51.6,
        uHigh: 51.57,
        uLow: 51.99,
        uVolume: 2883659,
        change: 0.02,
        changePercent: 0.0412,
        label: "Feb 7, 20",
        changeOverTime: 0.50744
    },
    {
        date: "2023-02-10",
        open: 52,
        close: 52.25,
        high: 52.82,
        low: 51.48,
        volume: 2088125,
        uOpen: 52,
        uClose: 51.91,
        uHigh: 51.64,
        uLow: 52.4,
        uVolume: 2112854,
        change: 0.29,
        changePercent: 0.5644,
        label: "Feb 10, 20",
        changeOverTime: 0.504868
    },
    {
        date: "2023-02-11",
        open: 50.75,
        close: 52.38,
        high: 53.93,
        low: 51.59,
        volume: 2656238,
        uOpen: 52.79,
        uClose: 52.52,
        uHigh: 52.18,
        uLow: 52.66,
        uVolume: 2664417,
        change: 0.38,
        changePercent: 0.7623,
        label: "Feb 11, 20",
        changeOverTime: 0.513742
    },
    {
        date: "2023-02-12",
        open: 52.19,
        close: 52.76,
        high: 52.01,
        low: 51.52,
        volume: 1761837,
        uOpen: 53.13,
        uClose: 51.41,
        uHigh: 53.8,
        uLow: 51.42,
        uVolume: 1774812,
        change: -0.16,
        changePercent: -0.3163,
        label: "Feb 12, 20",
        changeOverTime: 0.511551
    },
    {
        date: "2023-02-13",
        open: 51.55,
        close: 53.73,
        high: 55.21,
        low: 52.06,
        volume: 3881933,
        uOpen: 52.94,
        uClose: 51.84,
        uHigh: 53.5,
        uLow: 50.46,
        uVolume: 3729984,
        change: 1.08,
        changePercent: 2.1462,
        label: "Feb 13, 20",
        changeOverTime: 0.553317
    },
    {
        date: "2023-02-14",
        open: 52,
        close: 52.98,
        high: 52.58,
        low: 51.32,
        volume: 1372336,
        uOpen: 51,
        uClose: 51.96,
        uHigh: 53.72,
        uLow: 52.06,
        uVolume: 1348117,
        change: 0.14,
        changePercent: 0.2799,
        label: "Feb 14, 20",
        changeOverTime: 0.544297
    },
    {
        date: "2023-02-18",
        open: 53.39,
        close: 52.36,
        high: 55.66,
        low: 54.1,
        volume: 4904739,
        uOpen: 52.51,
        uClose: 53.62,
        uHigh: 54.01,
        uLow: 51.9,
        uVolume: 4857484,
        change: 0.44,
        changePercent: 0.87,
        label: "Feb 18, 20",
        changeOverTime: 0.550921
    },
    {
        date: "2023-02-19",
        open: 55.1,
        close: 56.42,
        high: 57.5,
        low: 52.84,
        volume: 7249561,
        uOpen: 55.03,
        uClose: 54.69,
        uHigh: 57.75,
        uLow: 53.19,
        uVolume: 6974177,
        change: 2.3,
        changePercent: 4.352,
        label: "Feb 19, 20",
        changeOverTime: 0.611965
    },
    {
        date: "2023-02-20",
        open: 63.93,
        close: 63.7,
        high: 67.88,
        low: 64.67,
        volume: 20152454,
        uOpen: 62.91,
        uClose: 64.05,
        uHigh: 67.32,
        uLow: 62.9,
        uVolume: 19494864,
        change: 9.28,
        changePercent: 17.0981,
        label: "Feb 20, 20",
        changeOverTime: 0.921422
    },
    {
        date: "2023-02-21",
        open: 63.23,
        close: 65,
        high: 66.57,
        low: 65.64,
        volume: 7042314,
        uOpen: 65.16,
        uClose: 66,
        uHigh: 68,
        uLow: 65.32,
        uVolume: 6955470,
        change: 1.38,
        changePercent: 2.2297,
        label: "Feb 21, 20",
        changeOverTime: 0.953469
    },
    {
        date: "2023-02-24",
        open: 63.1,
        close: 60.1,
        high: 63.07,
        low: 58.86,
        volume: 8915859,
        uOpen: 61.86,
        uClose: 62.47,
        uHigh: 63.91,
        uLow: 61.1,
        uVolume: 8638833,
        change: -5.38,
        changePercent: -8.2212,
        label: "Feb 24, 20",
        changeOverTime: 0.782824
    },
    {
        date: "2023-02-25",
        open: 60.3,
        close: 59.29,
        high: 62,
        low: 58.46,
        volume: 3362544,
        uOpen: 62.86,
        uClose: 58.9,
        uHigh: 61.3,
        uLow: 58.58,
        uVolume: 3362907,
        change: -1.95,
        changePercent: -3.3124,
        label: "Feb 25, 20",
        changeOverTime: 0.726049
    },
    {
        date: "2023-02-26",
        open: 58.4,
        close: 57.97,
        high: 60.67,
        low: 58.87,
        volume: 4794291,
        uOpen: 59.5,
        uClose: 59.69,
        uHigh: 59.69,
        uLow: 56.82,
        uVolume: 4822847,
        change: -0.7,
        changePercent: -1.2435,
        label: "Feb 26, 20",
        changeOverTime: 0.698812
    },
    {
        date: "2023-02-27",
        open: 57,
        close: 55.85,
        high: 59.07,
        low: 54.35,
        volume: 4047778,
        uOpen: 56,
        uClose: 54.64,
        uHigh: 59.27,
        uLow: 54.07,
        uVolume: 3927905,
        change: -2.52,
        changePercent: -4.4424,
        label: "Feb 27, 20",
        changeOverTime: 0.620978
    },
    {
        date: "2023-02-28",
        open: 56,
        close: 56.97,
        high: 57.3,
        low: 52.03,
        volume: 5851971,
        uOpen: 55,
        uClose: 58.45,
        uHigh: 57.3,
        uLow: 52.81,
        uVolume: 5921181,
        change: 1.24,
        changePercent: 2.2791,
        label: "Feb 28, 20",
        changeOverTime: 0.660746
    },
    {
        date: "2023-03-02",
        open: 56.44,
        close: 54.5,
        high: 58.17,
        low: 54.44,
        volume: 4166814,
        uOpen: 58.29,
        uClose: 55,
        uHigh: 58.2,
        uLow: 54.18,
        uVolume: 4179194,
        change: -1.48,
        changePercent: -2.5378,
        label: "Mar 2, 20",
        changeOverTime: 0.610416
    },
    {
        date: "2023-03-03",
        open: 56.36,
        close: 55.55,
        high: 56.81,
        low: 51.9,
        volume: 3165374,
        uOpen: 54.99,
        uClose: 54.5,
        uHigh: 56.8,
        uLow: 53.5,
        uVolume: 3053736,
        change: -1.23,
        changePercent: -2.1907,
        label: "Mar 3, 20",
        changeOverTime: 0.58889
    },
    {
        date: "2023-03-04",
        open: 55.15,
        close: 54.52,
        high: 57.01,
        low: 55.65,
        volume: 1969099,
        uOpen: 56.48,
        uClose: 54.58,
        uHigh: 56.72,
        uLow: 54.34,
        uVolume: 1970551,
        change: 1.09,
        changePercent: 2.0472,
        label: "Mar 4, 20",
        changeOverTime: 0.61544
    },
    {
        date: "2023-03-05",
        open: 55.25,
        close: 52.89,
        high: 54.42,
        low: 51.08,
        volume: 2420775,
        uOpen: 55.01,
        uClose: 53.83,
        uHigh: 55.61,
        uLow: 53.23,
        uVolume: 2377498,
        change: -2.8,
        changePercent: -5.204,
        label: "Mar 5, 20",
        changeOverTime: 0.525582
    },
    {
        date: "2023-03-06",
        open: 51.01,
        close: 51.77,
        high: 53.36,
        low: 48.87,
        volume: 3141870,
        uOpen: 50.81,
        uClose: 51.49,
        uHigh: 51.29,
        uLow: 49.78,
        uVolume: 3182581,
        change: -2.2,
        changePercent: -4.4353,
        label: "Mar 6, 20",
        changeOverTime: 0.481616
    },
    {
        date: "2023-03-09",
        open: 46.75,
        close: 45.17,
        high: 46.38,
        low: 44.49,
        volume: 4652912,
        uOpen: 46.53,
        uClose: 45.76,
        uHigh: 46.93,
        uLow: 46.04,
        uVolume: 4672987,
        change: -4.57,
        changePercent: -9.2491,
        label: "Mar 9, 20",
        changeOverTime: 0.342603
    },
    {
        date: "2023-03-10",
        open: 47.08,
        close: 46.71,
        high: 48.43,
        low: 42.11,
        volume: 4682252,
        uOpen: 48.29,
        uClose: 46.74,
        uHigh: 48.87,
        uLow: 41.65,
        uVolume: 4639639,
        change: 0.43,
        changePercent: 0.941,
        label: "Mar 10, 20",
        changeOverTime: 0.344948
    },
    {
        date: "2023-03-11",
        open: 45.38,
        close: 43.03,
        high: 44.84,
        low: 40.25,
        volume: 5323041,
        uOpen: 43.82,
        uClose: 42.28,
        uHigh: 45.35,
        uLow: 41.45,
        uVolume: 5332339,
        change: -4,
        changePercent: -8.617,
        label: "Mar 11, 20",
        changeOverTime: 0.232207
    },
    {
        date: "2023-03-12",
        open: 38,
        close: 36.63,
        high: 38.68,
        low: 34.75,
        volume: 7912132,
        uOpen: 40,
        uClose: 37.05,
        uHigh: 38.44,
        uLow: 34.97,
        uVolume: 7791062,
        change: -6.17,
        changePercent: -14.4803,
        label: "Mar 12, 20",
        changeOverTime: 0.052644
    },
    {
        date: "2023-03-13",
        open: 39.47,
        close: 37.51,
        high: 41,
        low: 34.56,
        volume: 4708163,
        uOpen: 39.03,
        uClose: 37.94,
        uHigh: 41,
        uLow: 34.56,
        uVolume: 4791822,
        change: 0.84,
        changePercent: 2.3551,
        label: "Mar 13, 20",
        changeOverTime: 0.076718
    },
    {
        date: "2023-03-16",
        open: 32.53,
        close: 29.97,
        high: 33,
        low: 28.01,
        volume: 7337898,
        uOpen: 31.52,
        uClose: 28.9,
        uHigh: 33,
        uLow: 28.23,
        uVolume: 7466123,
        change: -7.71,
        changePercent: -21.2668,
        label: "Mar 16, 20",
        changeOverTime: -0.154443
    },
    {
        date: "2023-03-17",
        open: 29.3,
        close: 29.3,
        high: 30.92,
        low: 25.89,
        volume: 5700201,
        uOpen: 30.6,
        uClose: 28.29,
        uHigh: 31.17,
        uLow: 25.59,
        uVolume: 5531575,
        change: -0.57,
        changePercent: -1.9431,
        label: "Mar 17, 20",
        changeOverTime: -0.172099
    },
    {
        date: "2023-03-18",
        open: 27.17,
        close: 25.21,
        high: 26.81,
        low: 20.08,
        volume: 9483232,
        uOpen: 26.74,
        uClose: 25.61,
        uHigh: 27,
        uLow: 20.23,
        uVolume: 9740632,
        change: -3.15,
        changePercent: -11.3624,
        label: "Mar 18, 20",
        changeOverTime: -0.266802
    },
    {
        date: "2023-03-19",
        open: 25.22,
        close: 27.34,
        high: 28.27,
        low: 23.48,
        volume: 5296850,
        uOpen: 25.32,
        uClose: 26.38,
        uHigh: 27.79,
        uLow: 23.63,
        uVolume: 5478589,
        change: 1.35,
        changePercent: 5.256,
        label: "Mar 19, 20",
        changeOverTime: -0.230395
    },
    {
        date: "2023-03-20",
        open: 27.62,
        close: 27.88,
        high: 32.21,
        low: 26.66,
        volume: 8228380,
        uOpen: 27.61,
        uClose: 28.15,
        uHigh: 32.24,
        uLow: 27.4,
        uVolume: 8251335,
        change: 0.91,
        changePercent: 3.4186,
        label: "Mar 20, 20",
        changeOverTime: -0.205202
    },
    {
        date: "2023-03-23",
        open: 28.04,
        close: 32.35,
        high: 32.22,
        low: 26.9,
        volume: 7862800,
        uOpen: 27.61,
        uClose: 32.33,
        uHigh: 31.69,
        uLow: 27.06,
        uVolume: 7896729,
        change: 4.16,
        changePercent: 14.8559,
        label: "Mar 23, 20",
        changeOverTime: -0.07647
    },
    {
        date: "2023-03-24",
        open: 35.85,
        close: 38.47,
        high: 40.1,
        low: 35.3,
        volume: 8720822,
        uOpen: 36.76,
        uClose: 36.83,
        uHigh: 40.4,
        uLow: 35.2,
        uVolume: 8558076,
        change: 5.9,
        changePercent: 18.8177,
        label: "Mar 24, 20",
        changeOverTime: 0.090634
    },
    {
        date: "2023-03-25",
        open: 37.17,
        close: 39.98,
        high: 44.24,
        low: 37.87,
        volume: 6776258,
        uOpen: 37.44,
        uClose: 40.08,
        uHigh: 45.34,
        uLow: 37.54,
        uVolume: 6863668,
        change: 3.09,
        changePercent: 8.5549,
        label: "Mar 25, 20",
        changeOverTime: 0.183329
    },
    {
        date: "2023-03-26",
        open: 41.5,
        close: 42.71,
        high: 42.71,
        low: 39.8,
        volume: 5865166,
        uOpen: 41.2,
        uClose: 42.18,
        uHigh: 43.72,
        uLow: 40.64,
        uVolume: 5875536,
        change: 0.92,
        changePercent: 2.297,
        label: "Mar 26, 20",
        changeOverTime: 0.20815
    },
    {
        date: "2023-03-27",
        open: 38.58,
        close: 39.06,
        high: 40.81,
        low: 38.45,
        volume: 4504876,
        uOpen: 39.43,
        uClose: 38.77,
        uHigh: 41.12,
        uLow: 37.12,
        uVolume: 4504415,
        change: -2.91,
        changePercent: -7.2413,
        label: "Mar 27, 20",
        changeOverTime: 0.12377
    },
    {
        date: "2023-03-30",
        open: 39.75,
        close: 37.43,
        high: 40.28,
        low: 36.18,
        volume: 4598458,
        uOpen: 39.06,
        uClose: 38.56,
        uHigh: 41.4,
        uLow: 36.11,
        uVolume: 4477356,
        change: -0.9,
        changePercent: -2.3815,
        label: "Mar 30, 20",
        changeOverTime: 0.09786
    },
    {
        date: "2023-03-31",
        open: 37.86,
        close: 37.03,
        high: 39.19,
        low: 35.89,
        volume: 4176393,
        uOpen: 37.57,
        uClose: 36.92,
        uHigh: 38.4,
        uLow: 35.24,
        uVolume: 4162168,
        change: -1.08,
        changePercent: -2.8227,
        label: "Mar 31, 20",
        changeOverTime: 0.06873
    },
    {
        date: "2023-04-01",
        open: 35.09,
        close: 33,
        high: 35.94,
        low: 32.4,
        volume: 6054881,
        uOpen: 34.36,
        uClose: 32.45,
        uHigh: 35.34,
        uLow: 31.97,
        uVolume: 6090273,
        change: -4.59,
        changePercent: -12.8553,
        label: "Apr 1, 20",
        changeOverTime: -0.071469
    },
    {
        date: "2023-04-02",
        open: 32.51,
        close: 31.36,
        high: 33.19,
        low: 29.83,
        volume: 4340447,
        uOpen: 31.21,
        uClose: 31.38,
        uHigh: 33.4,
        uLow: 30.48,
        uVolume: 4284035,
        change: -1.32,
        changePercent: -4.3042,
        label: "Apr 2, 20",
        changeOverTime: -0.1138
    },
    {
        date: "2023-04-03",
        open: 31.58,
        close: 31.02,
        high: 31.32,
        low: 29.53,
        volume: 3371618,
        uOpen: 30.98,
        uClose: 31.16,
        uHigh: 31.72,
        uLow: 30.05,
        uVolume: 3331987,
        change: 0.18,
        changePercent: 0.6249,
        label: "Apr 3, 20",
        changeOverTime: -0.103632
    },
    {
        date: "2023-04-06",
        open: 32.8,
        close: 38.43,
        high: 38.93,
        low: 32.66,
        volume: 4929697,
        uOpen: 33.01,
        uClose: 38.13,
        uHigh: 38.26,
        uLow: 33.49,
        uVolume: 5050497,
        change: 7.06,
        changePercent: 22.8363,
        label: "Apr 6, 20",
        changeOverTime: 0.098608
    },
    {
        date: "2023-04-07",
        open: 40.22,
        close: 39.6,
        high: 42.79,
        low: 38,
        volume: 5956689,
        uOpen: 40.27,
        uClose: 39.1,
        uHigh: 43.14,
        uLow: 39.1,
        uVolume: 5933744,
        change: 0.71,
        changePercent: 1.8806,
        label: "Apr 7, 20",
        changeOverTime: 0.122962
    },
    {
        date: "2023-04-08",
        open: 40.82,
        close: 40.3,
        high: 41.3,
        low: 39.59,
        volume: 5700339,
        uOpen: 39.16,
        uClose: 40.42,
        uHigh: 41.8,
        uLow: 39.04,
        uVolume: 5551999,
        change: 1.41,
        changePercent: 3.7573,
        label: "Apr 8, 20",
        changeOverTime: 0.166948
    },
    {
        date: "2023-04-09",
        open: 42.56,
        close: 42.12,
        high: 42.83,
        low: 40.26,
        volume: 4748921,
        uOpen: 42.56,
        uClose: 41.15,
        uHigh: 43.9,
        uLow: 40.82,
        uVolume: 4829968,
        change: 1.46,
        changePercent: 3.8487,
        label: "Apr 9, 20",
        changeOverTime: 0.20994
    },
    {
        date: "2023-04-13",
        open: 41.14,
        close: 39.57,
        high: 42.09,
        low: 37.97,
        volume: 2536659,
        uOpen: 40.38,
        uClose: 39.97,
        uHigh: 41.64,
        uLow: 38.96,
        uVolume: 2626143,
        change: -2.19,
        changePercent: -5.5932,
        label: "Apr 13, 20",
        changeOverTime: 0.139859
    },
    {
        date: "2023-04-14",
        open: 40.33,
        close: 39.5,
        high: 42.01,
        low: 39.7,
        volume: 3572563,
        uOpen: 41.12,
        uClose: 39.7,
        uHigh: 41.02,
        uLow: 38.6,
        uVolume: 3479573,
        change: 0.26,
        changePercent: 0.6722,
        label: "Apr 14, 20",
        changeOverTime: 0.149793
    },
    {
        date: "2023-04-15",
        open: 38.24,
        close: 37.46,
        high: 37.72,
        low: 37.13,
        volume: 3626593,
        uOpen: 38.6,
        uClose: 36.41,
        uHigh: 38.6,
        uLow: 36.8,
        uVolume: 3643000,
        change: -2.61,
        changePercent: -6.9108,
        label: "Apr 15, 20",
        changeOverTime: 0.069413
    },
    {
        date: "2023-04-16",
        open: 37.45,
        close: 34.7,
        high: 37.07,
        low: 33.97,
        volume: 3291147,
        uOpen: 36.75,
        uClose: 34.17,
        uHigh: 38.32,
        uLow: 34.52,
        uVolume: 3249128,
        change: -2.78,
        changePercent: -7.6247,
        label: "Apr 16, 20",
        changeOverTime: -0.01316
    },
    {
        date: "2023-04-17",
        open: 35.43,
        close: 37.92,
        high: 37.91,
        low: 35.1,
        volume: 3095232,
        uOpen: 36.74,
        uClose: 36.65,
        uHigh: 37.11,
        uLow: 35,
        uVolume: 3093215,
        change: 3.1,
        changePercent: 8.9248,
        label: "Apr 17, 20",
        changeOverTime: 0.076802
    },
    {
        date: "2023-04-20",
        open: 36,
        close: 37.44,
        high: 37.33,
        low: 35.43,
        volume: 2339418,
        uOpen: 35.28,
        uClose: 36.96,
        uHigh: 38.26,
        uLow: 35.27,
        uVolume: 2396599,
        change: 0.13,
        changePercent: 0.3677,
        label: "Apr 20, 20",
        changeOverTime: 0.082212
    },
    {
        date: "2023-04-21",
        open: 35.83,
        close: 36.8,
        high: 38.64,
        low: 35.35,
        volume: 1886815,
        uOpen: 36.95,
        uClose: 36.5,
        uHigh: 37.41,
        uLow: 35.52,
        uVolume: 1904771,
        change: -0.27,
        changePercent: -0.7363,
        label: "Apr 21, 20",
        changeOverTime: 0.071657
    },
    {
        date: "2023-04-22",
        open: 38.43,
        close: 40.6,
        high: 39.54,
        low: 37.54,
        volume: 3184601,
        uOpen: 37.57,
        uClose: 39.46,
        uHigh: 39.79,
        uLow: 38.24,
        uVolume: 3271350,
        change: 2.54,
        changePercent: 7.1218,
        label: "Apr 22, 20",
        changeOverTime: 0.15192
    },
    {
        date: "2023-04-23",
        open: 41,
        close: 38.93,
        high: 42.15,
        low: 39.19,
        volume: 2867327,
        uOpen: 39.34,
        uClose: 39,
        uHigh: 41.31,
        uLow: 38.94,
        uVolume: 2844288,
        change: -0.39,
        changePercent: -0.9824,
        label: "Apr 23, 20",
        changeOverTime: 0.13651
    },
    {
        date: "2023-04-24",
        open: 39,
        close: 41.1,
        high: 42.73,
        low: 39.32,
        volume: 3127803,
        uOpen: 39.4,
        uClose: 42.54,
        uHigh: 42.47,
        uLow: 40.12,
        uVolume: 3092452,
        change: 2.39,
        changePercent: 6.2802,
        label: "Apr 24, 20",
        changeOverTime: 0.21133
    },
    {
        date: "2023-04-27",
        open: 42.13,
        close: 44.29,
        high: 44.09,
        low: 42.1,
        volume: 2594437,
        uOpen: 41.88,
        uClose: 44.49,
        uHigh: 43.54,
        uLow: 41,
        uVolume: 2616165,
        change: 2.35,
        changePercent: 5.9304,
        label: "Apr 27, 20",
        changeOverTime: 0.283126
    },
    {
        date: "2023-04-28",
        open: 45,
        close: 42.65,
        high: 45.9,
        low: 42.34,
        volume: 2698941,
        uOpen: 46,
        uClose: 43.72,
        uHigh: 47.7,
        uLow: 43.27,
        uVolume: 2645368,
        change: -0.88,
        changePercent: -2.0427,
        label: "Apr 28, 20",
        changeOverTime: 0.251323
    },
    {
        date: "2023-04-29",
        open: 45.45,
        close: 47.08,
        high: 47.73,
        low: 45.2,
        volume: 3352490,
        uOpen: 45.98,
        uClose: 45.94,
        uHigh: 47.32,
        uLow: 43.33,
        uVolume: 3275150,
        change: 3.57,
        changePercent: 8.2455,
        label: "Apr 29, 20",
        changeOverTime: 0.363908
    },
    {
        date: "2023-04-30",
        open: 45.41,
        close: 44.13,
        high: 45.55,
        low: 44.7,
        volume: 3313924,
        uOpen: 46.26,
        uClose: 44.45,
        uHigh: 46.42,
        uLow: 44.38,
        uVolume: 3234484,
        change: -1.66,
        changePercent: -3.7303,
        label: "Apr 30, 20",
        changeOverTime: 0.302418
    },
    {
        date: "2023-05-01",
        open: 42.72,
        close: 43.98,
        high: 44.53,
        low: 41.32,
        volume: 2419428,
        uOpen: 41.79,
        uClose: 42.69,
        uHigh: 43.41,
        uLow: 42.12,
        uVolume: 2406372,
        change: -1.6,
        changePercent: -3.5278,
        label: "May 1, 20",
        changeOverTime: 0.268163
    },
    {
        date: "2023-05-04",
        open: 42.6,
        close: 43.31,
        high: 43.9,
        low: 41.79,
        volume: 1976993,
        uOpen: 43.55,
        uClose: 43.15,
        uHigh: 43.1,
        uLow: 41.63,
        uVolume: 1942559,
        change: 0.14,
        changePercent: 0.3126,
        label: "May 4, 20",
        changeOverTime: 0.271869
    },
    {
        date: "2023-05-05",
        open: 45.2,
        close: 44.9,
        high: 45.43,
        low: 43.91,
        volume: 3223418,
        uOpen: 45.6,
        uClose: 43.7,
        uHigh: 45.27,
        uLow: 44.34,
        uVolume: 3121254,
        change: 1.03,
        changePercent: 2.4457,
        label: "May 5, 20",
        changeOverTime: 0.292188
    },
    {
        date: "2023-05-06",
        open: 44.79,
        close: 45.45,
        high: 45.36,
        low: 45.49,
        volume: 4076870,
        uOpen: 45.23,
        uClose: 44.33,
        uHigh: 45.99,
        uLow: 44.61,
        uVolume: 4088599,
        change: -0.17,
        changePercent: -0.3952,
        label: "May 6, 20",
        changeOverTime: 0.28799
    },
    {
        date: "2023-05-07",
        open: 45.81,
        close: 50.17,
        high: 50.76,
        low: 45.31,
        volume: 7658071,
        uOpen: 44.72,
        uClose: 50.74,
        uHigh: 51.97,
        uLow: 44.73,
        uVolume: 7416023,
        change: 5.27,
        changePercent: 12.0591,
        label: "May 7, 20",
        changeOverTime: 0.449954
    },
    {
        date: "2023-05-08",
        open: 52,
        close: 54.13,
        high: 59.73,
        low: 49.77,
        volume: 12790072,
        uOpen: 53,
        uClose: 53.39,
        uHigh: 59.91,
        uLow: 49.74,
        uVolume: 12979282,
        change: 4.45,
        changePercent: 9.088,
        label: "May 8, 20",
        changeOverTime: 0.59392
    },
    {
        date: "2023-05-11",
        open: 54.19,
        close: 56.37,
        high: 58.24,
        low: 52.2,
        volume: 5254611,
        uOpen: 53.34,
        uClose: 57.27,
        uHigh: 58.18,
        uLow: 53.14,
        uVolume: 5273610,
        change: 2.93,
        changePercent: 5.3909,
        label: "May 11, 20",
        changeOverTime: 0.664999
    },
    {
        date: "2023-05-12",
        open: 54.26,
        close: 51.44,
        high: 57,
        low: 49.76,
        volume: 8831018,
        uOpen: 53.37,
        uClose: 50.77,
        uHigh: 55,
        uLow: 50.33,
        uVolume: 8794895,
        change: -6.74,
        changePercent: -12.0341,
        label: "May 12, 20",
        changeOverTime: 0.457483
    },
    {
        date: "2023-05-13",
        open: 47.2,
        close: 47.08,
        high: 49.07,
        low: 46.22,
        volume: 15030187,
        uOpen: 47.5,
        uClose: 48.15,
        uHigh: 49.25,
        uLow: 46.53,
        uVolume: 15153469,
        change: -2.75,
        changePercent: -5.5523,
        label: "May 13, 20",
        changeOverTime: 0.377454
    },
    {
        date: "2023-05-14",
        open: 46.89,
        close: 47.72,
        high: 49.53,
        low: 46.29,
        volume: 6417268,
        uOpen: 45.45,
        uClose: 48.85,
        uHigh: 49.01,
        uLow: 47.02,
        uVolume: 6351751,
        change: 0.96,
        changePercent: 2.0648,
        label: "May 14, 20",
        changeOverTime: 0.406023
    },
    {
        date: "2023-05-15",
        open: 49.02,
        close: 50.11,
        high: 51.42,
        low: 47.9,
        volume: 4822039,
        uOpen: 47.9,
        uClose: 49.37,
        uHigh: 51.66,
        uLow: 48.4,
        uVolume: 4941006,
        change: 1.32,
        changePercent: 2.793,
        label: "May 15, 20",
        changeOverTime: 0.461551
    },
    {
        date: "2023-05-18",
        open: 51.48,
        close: 51.45,
        high: 52.27,
        low: 50.92,
        volume: 4756206,
        uOpen: 51.54,
        uClose: 50.83,
        uHigh: 52.32,
        uLow: 49.8,
        uVolume: 4711934,
        change: 0.85,
        changePercent: 1.763,
        label: "May 18, 20",
        changeOverTime: 0.477374
    },
    {
        date: "2023-05-19",
        open: 50.84,
        close: 52.51,
        high: 53.1,
        low: 49.51,
        volume: 3311406,
        uOpen: 50.17,
        uClose: 53.13,
        uHigh: 55,
        uLow: 49.62,
        uVolume: 3330267,
        change: 1.54,
        changePercent: 2.9696,
        label: "May 19, 20",
        changeOverTime: 0.519174
    },
    {
        date: "2023-05-20",
        open: 53.1,
        close: 55.59,
        high: 55.19,
        low: 53.35,
        volume: 3742877,
        uOpen: 54.1,
        uClose: 56.69,
        uHigh: 55.28,
        uLow: 53.95,
        uVolume: 3800781,
        change: 2.98,
        changePercent: 5.9624,
        label: "May 20, 20",
        changeOverTime: 0.599448
    },
    {
        date: "2023-05-21",
        open: 54.77,
        close: 54.58,
        high: 56.33,
        low: 53.42,
        volume: 2038377,
        uOpen: 56.5,
        uClose: 55.55,
        uHigh: 57.6,
        uLow: 54.38,
        uVolume: 1985188,
        change: 0.11,
        changePercent: 0.2042,
        label: "May 21, 20",
        changeOverTime: 0.613152
    },
    {
        date: "2023-05-22",
        open: 56.4,
        close: 58.4,
        high: 58.22,
        low: 55.79,
        volume: 5167092,
        uOpen: 56.1,
        uClose: 56.8,
        uHigh: 59.27,
        uLow: 55.8,
        uVolume: 5264772,
        change: 2.38,
        changePercent: 4.3355,
        label: "May 22, 20",
        changeOverTime: 0.688629
    },
    {
        date: "2023-05-26",
        open: 60.51,
        close: 60.6,
        high: 61.4,
        low: 60.46,
        volume: 4942220,
        uOpen: 58.67,
        uClose: 60.25,
        uHigh: 60.8,
        uLow: 59.64,
        uVolume: 4868289,
        change: 2.47,
        changePercent: 4.2722,
        label: "May 26, 20",
        changeOverTime: 0.769251
    },
    {
        date: "2023-05-27",
        open: 62,
        close: 59.41,
        high: 61.16,
        low: 58.4,
        volume: 3849615,
        uOpen: 60,
        uClose: 60.9,
        uHigh: 60.8,
        uLow: 58.2,
        uVolume: 3932022,
        change: 0.19,
        changePercent: 0.3173,
        label: "May 27, 20",
        changeOverTime: 0.759573
    },
    {
        date: "2023-05-28",
        open: 61.3,
        close: 58.4,
        high: 61.11,
        low: 58.31,
        volume: 3510853,
        uOpen: 59.1,
        uClose: 58.8,
        uHigh: 63.13,
        uLow: 59.01,
        uVolume: 3507559,
        change: -1.69,
        changePercent: -2.927,
        label: "May 28, 20",
        changeOverTime: 0.729463
    },
    {
        date: "2023-05-29",
        open: 59.8,
        close: 59.93,
        high: 59.32,
        low: 57.42,
        volume: 3870684,
        uOpen: 59.4,
        uClose: 58.19,
        uHigh: 59.03,
        uLow: 58.79,
        uVolume: 3805095,
        change: 0.64,
        changePercent: 1.1203,
        label: "May 29, 20",
        changeOverTime: 0.74926
    },
    {
        date: "2023-06-01",
        open: 59.22,
        close: 60.93,
        high: 60.21,
        low: 59.92,
        volume: 3243097,
        uOpen: 59.54,
        uClose: 59.7,
        uHigh: 59.27,
        uLow: 59.76,
        uVolume: 3291370,
        change: 0.23,
        changePercent: 0.4026,
        label: "Jun 1, 20",
        changeOverTime: 0.746021
    },
    {
        date: "2023-06-02",
        open: 60,
        close: 62.23,
        high: 61.01,
        low: 58.41,
        volume: 3069398,
        uOpen: 60,
        uClose: 59.55,
        uHigh: 62.33,
        uLow: 59.23,
        uVolume: 3192477,
        change: 1.16,
        changePercent: 2.0728,
        label: "Jun 2, 20",
        changeOverTime: 0.760133
    },
    {
        date: "2023-06-03",
        open: 62.83,
        close: 64.5,
        high: 63.81,
        low: 61.18,
        volume: 4706713,
        uOpen: 60.46,
        uClose: 62.56,
        uHigh: 64.87,
        uLow: 60.6,
        uVolume: 4606525,
        change: 2.71,
        changePercent: 4.6633,
        label: "Jun 3, 20",
        changeOverTime: 0.85758
    },
    {
        date: "2023-06-04",
        open: 65.73,
        close: 64.19,
        high: 67.85,
        low: 62.62,
        volume: 5131102,
        uOpen: 64.49,
        uClose: 64.18,
        uHigh: 68.45,
        uLow: 60.71,
        uVolume: 4957445,
        change: -0.68,
        changePercent: -1.0511,
        label: "Jun 4, 20",
        changeOverTime: 0.85401
    },
    {
        date: "2023-06-05",
        open: 65.96,
        close: 61.41,
        high: 66.62,
        low: 61.37,
        volume: 4104738,
        uOpen: 64.57,
        uClose: 61.02,
        uHigh: 66.73,
        uLow: 61.74,
        uVolume: 4028685,
        change: -2.1,
        changePercent: -3.4418,
        label: "Jun 5, 20",
        changeOverTime: 0.79106
    },
    {
        date: "2023-06-08",
        open: 65.1,
        close: 64.12,
        high: 64.55,
        low: 62.8,
        volume: 4129459,
        uOpen: 65.15,
        uClose: 62.95,
        uHigh: 64.12,
        uLow: 62.89,
        uVolume: 4025632,
        change: 2.96,
        changePercent: 4.9651,
        label: "Jun 8, 20",
        changeOverTime: 0.873656
    },
    {
        date: "2023-06-09",
        open: 64.25,
        close: 64.12,
        high: 63.07,
        low: 61.85,
        volume: 2296945,
        uOpen: 62.5,
        uClose: 63.11,
        uHigh: 62.89,
        uLow: 62.58,
        uVolume: 2289795,
        change: -1.11,
        changePercent: -1.7237,
        label: "Jun 9, 20",
        changeOverTime: 0.825421
    },
    {
        date: "2023-06-10",
        open: 62.59,
        close: 59.89,
        high: 62.72,
        low: 61.08,
        volume: 3571569,
        uOpen: 64.19,
        uClose: 62.42,
        uHigh: 63.72,
        uLow: 60.87,
        uVolume: 3559484,
        change: -1.6,
        changePercent: -2.7274,
        label: "Jun 10, 20",
        changeOverTime: 0.794154
    },
    {
        date: "2023-06-11",
        open: 57.66,
        close: 57.8,
        high: 59.27,
        low: 57.68,
        volume: 4010088,
        uOpen: 57.79,
        uClose: 56.4,
        uHigh: 60.95,
        uLow: 57.44,
        uVolume: 3961722,
        change: -3.36,
        changePercent: -5.7391,
        label: "Jun 11, 20",
        changeOverTime: 0.68122
    },
    {
        date: "2023-06-12",
        open: 61.33,
        close: 57.26,
        high: 59.86,
        low: 56.47,
        volume: 2327723,
        uOpen: 60,
        uClose: 59.19,
        uHigh: 59.78,
        uLow: 56.7,
        uVolume: 2324679,
        change: 0.5,
        changePercent: 0.8846,
        label: "Jun 12, 20",
        changeOverTime: 0.688404
    },
    {
        date: "2023-06-15",
        open: 56.6,
        close: 63,
        high: 62.47,
        low: 56.17,
        volume: 3791551,
        uOpen: 56.7,
        uClose: 60,
        uHigh: 62.86,
        uLow: 58.18,
        uVolume: 3763954,
        change: 3.29,
        changePercent: 5.8257,
        label: "Jun 15, 20",
        changeOverTime: 0.808185
    },
    {
        date: "2023-06-16",
        open: 65.17,
        close: 60.9,
        high: 64.38,
        low: 59.66,
        volume: 4766798,
        uOpen: 63.87,
        uClose: 61.3,
        uHigh: 63.07,
        uLow: 59.03,
        uVolume: 4848495,
        change: -0.9,
        changePercent: -1.5,
        label: "Jun 16, 20",
        changeOverTime: 0.767913
    },
    {
        date: "2023-06-17",
        open: 62.2,
        close: 62.07,
        high: 62.9,
        low: 62.19,
        volume: 2559429,
        uOpen: 61.9,
        uClose: 62.78,
        uHigh: 64.1,
        uLow: 61.51,
        uVolume: 2612826,
        change: 1.71,
        changePercent: 2.775,
        label: "Jun 17, 20",
        changeOverTime: 0.817332
    },
    {
        date: "2023-06-18",
        open: 62.66,
        close: 61.68,
        high: 64,
        low: 62,
        volume: 1639482,
        uOpen: 62.36,
        uClose: 63.2,
        uHigh: 64,
        uLow: 60.36,
        uVolume: 1661269,
        change: 0.6,
        changePercent: 1.0008,
        label: "Jun 18, 20",
        changeOverTime: 0.849587
    },
    {
        date: "2023-06-19",
        open: 63.93,
        close: 64.04,
        high: 64.86,
        low: 63.1,
        volume: 5255484,
        uOpen: 63.06,
        uClose: 64.53,
        uHigh: 66.17,
        uLow: 62.1,
        uVolume: 5082785,
        change: 0.91,
        changePercent: 1.511,
        label: "Jun 19, 20",
        changeOverTime: 0.843871
    },
    {
        date: "2023-06-22",
        open: 65.31,
        close: 63.27,
        high: 64,
        low: 61.9,
        volume: 4696624,
        uOpen: 65.96,
        uClose: 61.62,
        uHigh: 65,
        uLow: 62.2,
        uVolume: 4777935,
        change: -1.64,
        changePercent: -2.5853,
        label: "Jun 22, 20",
        changeOverTime: 0.809858
    },
    {
        date: "2023-06-23",
        open: 63.47,
        close: 64.08,
        high: 64.36,
        low: 63.7,
        volume: 3248388,
        uOpen: 61.48,
        uClose: 63.42,
        uHigh: 64.71,
        uLow: 61.9,
        uVolume: 3148849,
        change: 2.49,
        changePercent: 4.0413,
        label: "Jun 23, 20",
        changeOverTime: 0.87969
    },
    {
        date: "2023-06-24",
        open: 62.54,
        close: 61,
        high: 65.04,
        low: 60.78,
        volume: 3845966,
        uOpen: 63.76,
        uClose: 62.2,
        uHigh: 65.56,
        uLow: 59.01,
        uVolume: 3785171,
        change: -3.96,
        changePercent: -6.2079,
        label: "Jun 24, 20",
        changeOverTime: 0.763668
    },
    {
        date: "2023-06-25",
        open: 60.24,
        close: 60.26,
        high: 61.96,
        low: 60.29,
        volume: 2217363,
        uOpen: 61.02,
        uClose: 60.08,
        uHigh: 61.07,
        uLow: 60.39,
        uVolume: 2213705,
        change: -0.23,
        changePercent: -0.377,
        label: "Jun 25, 20",
        changeOverTime: 0.783979
    },
    {
        date: "2023-06-26",
        open: 60.92,
        close: 58.14,
        high: 61.82,
        low: 56.48,
        volume: 5218141,
        uOpen: 60.55,
        uClose: 57.06,
        uHigh: 61.07,
        uLow: 54.85,
        uVolume: 5349003,
        change: -3.6,
        changePercent: -5.9271,
        label: "Jun 26, 20",
        changeOverTime: 0.662021
    },
    {
        date: "2023-06-29",
        open: 57.05,
        close: 58.47,
        high: 59.87,
        low: 55.44,
        volume: 4039981,
        uOpen: 58.39,
        uClose: 58,
        uHigh: 58.54,
        uLow: 54.82,
        uVolume: 3997351,
        change: 1.57,
        changePercent: 2.771,
        label: "Jun 29, 20",
        changeOverTime: 0.71128
    },
    {
        date: "2023-06-30",
        open: 58,
        close: 58.63,
        high: 60.54,
        low: 57.2,
        volume: 2326404,
        uOpen: 59,
        uClose: 57.99,
        uHigh: 59.78,
        uLow: 58.37,
        uVolume: 2240398,
        change: 0.49,
        changePercent: 0.867,
        label: "Jun 30, 20",
        changeOverTime: 0.738371
    },
    {
        date: "2023-07-01",
        open: 58.5,
        close: 61.63,
        high: 61.94,
        low: 59.06,
        volume: 2849011,
        uOpen: 57.7,
        uClose: 58.96,
        uHigh: 61.96,
        uLow: 57.68,
        uVolume: 2838214,
        change: 1.3,
        changePercent: 2.3574,
        label: "Jul 1, 20",
        changeOverTime: 0.765241
    },
    {
        date: "2023-07-02",
        open: 61,
        close: 62.84,
        high: 61.3,
        low: 61.91,
        volume: 2206319,
        uOpen: 60,
        uClose: 62.22,
        uHigh: 62.1,
        uLow: 61.28,
        uVolume: 2217723,
        change: 1.06,
        changePercent: 1.8074,
        label: "Jul 2, 20",
        changeOverTime: 0.783944
    },
    {
        date: "2023-07-06",
        open: 62.74,
        close: 61.56,
        high: 64.3,
        low: 60.86,
        volume: 2754405,
        uOpen: 63.46,
        uClose: 64.13,
        uHigh: 64.91,
        uLow: 62.73,
        uVolume: 2695276,
        change: 1.34,
        changePercent: 2.2915,
        label: "Jul 6, 20",
        changeOverTime: 0.840216
    },
    {
        date: "2023-07-07",
        open: 63.57,
        close: 63.49,
        high: 67.29,
        low: 62.28,
        volume: 5659806,
        uOpen: 63.21,
        uClose: 65.54,
        uHigh: 69.74,
        uLow: 62.92,
        uVolume: 5692975,
        change: 1.46,
        changePercent: 2.4021,
        label: "Jul 7, 20",
        changeOverTime: 0.882124
    },
    {
        date: "2023-07-08",
        open: 65,
        close: 64.91,
        high: 65.03,
        low: 63.53,
        volume: 3339116,
        uOpen: 64.8,
        uClose: 65.03,
        uHigh: 66.94,
        uLow: 63.38,
        uVolume: 3252388,
        change: 0.92,
        changePercent: 1.5026,
        label: "Jul 8, 20",
        changeOverTime: 0.881969
    },
    {
        date: "2023-07-09",
        open: 64.92,
        close: 63.21,
        high: 67.45,
        low: 64.61,
        volume: 2386964,
        uOpen: 66.65,
        uClose: 63.72,
        uHigh: 66.18,
        uLow: 63.33,
        uVolume: 2456595,
        change: -0.62,
        changePercent: -1.0143,
        label: "Jul 9, 20",
        changeOverTime: 0.87532
    },
    {
        date: "2023-07-10",
        open: 63.53,
        close: 62.95,
        high: 64.5,
        low: 64.21,
        volume: 1649858,
        uOpen: 66.05,
        uClose: 64.75,
        uHigh: 66.42,
        uLow: 61.59,
        uVolume: 1689025,
        change: -0.77,
        changePercent: -1.2232,
        label: "Jul 10, 20",
        changeOverTime: 0.845413
    },
    {
        date: "2023-07-13",
        open: 64.1,
        close: 58.8,
        high: 65.39,
        low: 60.1,
        volume: 3002661,
        uOpen: 65.7,
        uClose: 60.1,
        uHigh: 63.4,
        uLow: 60.56,
        uVolume: 2969132,
        change: -4.11,
        changePercent: -6.773,
        label: "Jul 13, 20",
        changeOverTime: 0.741617
    },
    {
        date: "2023-07-14",
        open: 61,
        close: 58.01,
        high: 61.2,
        low: 58.64,
        volume: 3964394,
        uOpen: 58.98,
        uClose: 60.63,
        uHigh: 61.79,
        uLow: 58.28,
        uVolume: 3846104,
        change: -0.36,
        changePercent: -0.6105,
        label: "Jul 14, 20",
        changeOverTime: 0.717899
    },
    {
        date: "2023-07-15",
        open: 60.95,
        close: 60.05,
        high: 62.4,
        low: 58.87,
        volume: 1867214,
        uOpen: 61.8,
        uClose: 59.13,
        uHigh: 59.9,
        uLow: 59.81,
        uVolume: 1875647,
        change: 1.27,
        changePercent: 2.1878,
        label: "Jul 15, 20",
        changeOverTime: 0.780549
    },
    {
        date: "2023-07-16",
        open: 59.35,
        close: 62.54,
        high: 63.1,
        low: 59.42,
        volume: 3470963,
        uOpen: 59.64,
        uClose: 63.7,
        uHigh: 65.92,
        uLow: 58.32,
        uVolume: 3478546,
        change: 3.23,
        changePercent: 5.446,
        label: "Jul 16, 20",
        changeOverTime: 0.878551
    },
    {
        date: "2023-07-17",
        open: 63.49,
        close: 65.29,
        high: 66.99,
        low: 63.11,
        volume: 2919970,
        uOpen: 65.18,
        uClose: 66.72,
        uHigh: 66.89,
        uLow: 64.06,
        uVolume: 2940978,
        change: 2.11,
        changePercent: 3.3657,
        label: "Jul 17, 20",
        changeOverTime: 0.944867
    },
    {
        date: "2023-07-20",
        open: 65.74,
        close: 66.56,
        high: 69.8,
        low: 65.46,
        volume: 4412290,
        uOpen: 66.07,
        uClose: 66.45,
        uHigh: 68.3,
        uLow: 66.56,
        uVolume: 4499298,
        change: 2,
        changePercent: 3.1542,
        label: "Jul 20, 20",
        changeOverTime: 0.982897
    },
    {
        date: "2023-07-21",
        open: 67.99,
        close: 66.73,
        high: 68.62,
        low: 66.41,
        volume: 2899362,
        uOpen: 68.46,
        uClose: 65.36,
        uHigh: 70.69,
        uLow: 67.61,
        uVolume: 2868567,
        change: -1.23,
        changePercent: -1.9104,
        label: "Jul 21, 20",
        changeOverTime: 0.929798
    },
    {
        date: "2023-07-22",
        open: 66.64,
        close: 70.2,
        high: 69.51,
        low: 65.2,
        volume: 2635450,
        uOpen: 65.34,
        uClose: 70.5,
        uHigh: 68.62,
        uLow: 65.6,
        uVolume: 2679519,
        change: 2.47,
        changePercent: 3.6666,
        label: "Jul 22, 20",
        changeOverTime: 1.042607
    },
    {
        date: "2023-07-23",
        open: 68.08,
        close: 66,
        high: 69.6,
        low: 65.69,
        volume: 4415555,
        uOpen: 68.86,
        uClose: 65.7,
        uHigh: 70,
        uLow: 64.86,
        uVolume: 4457942,
        change: -2,
        changePercent: -2.958,
        label: "Jul 23, 20",
        changeOverTime: 0.94552
    },
    {
        date: "2023-07-24",
        open: 64.9,
        close: 68.3,
        high: 68.52,
        low: 65.34,
        volume: 2701141,
        uOpen: 67.57,
        uClose: 67.89,
        uHigh: 68.8,
        uLow: 67.09,
        uVolume: 2650056,
        change: 0.22,
        changePercent: 0.3455,
        label: "Jul 24, 20",
        changeOverTime: 0.987518
    },
    {
        date: "2023-07-27",
        open: 67.71,
        close: 68.08,
        high: 68.83,
        low: 67.63,
        volume: 4047055,
        uOpen: 70.07,
        uClose: 67.18,
        uHigh: 68.39,
        uLow: 67.62,
        uVolume: 3978981,
        change: 1.24,
        changePercent: 1.8214,
        label: "Jul 27, 20",
        changeOverTime: 1.012459
    },
    {
        date: "2023-07-28",
        open: 69.08,
        close: 65,
        high: 69.09,
        low: 66.66,
        volume: 2171562,
        uOpen: 66.51,
        uClose: 66,
        uHigh: 70.24,
        uLow: 65.35,
        uVolume: 2225164,
        change: -1.93,
        changePercent: -2.9382,
        label: "Jul 28, 20",
        changeOverTime: 0.965657
    },
    {
        date: "2023-07-29",
        open: 66.69,
        close: 68.47,
        high: 68,
        low: 67.65,
        volume: 2041172,
        uOpen: 67.54,
        uClose: 67.73,
        uHigh: 68.39,
        uLow: 67.13,
        uVolume: 2054921,
        change: 1.54,
        changePercent: 2.2931,
        label: "Jul 29, 20",
        changeOverTime: 0.98395
    },
    {
        date: "2023-07-30",
        open: 68.27,
        close: 70.3,
        high: 70.73,
        low: 66.2,
        volume: 3975033,
        uOpen: 68.25,
        uClose: 69.9,
        uHigh: 70.42,
        uLow: 66.3,
        uVolume: 3983668,
        change: 3.48,
        changePercent: 5.3779,
        label: "Jul 30, 20",
        changeOverTime: 1.102867
    },
    {
        date: "2023-07-31",
        open: 73.3,
        close: 71.07,
        high: 74,
        low: 67.91,
        volume: 3072595,
        uOpen: 73.78,
        uClose: 71.02,
        uHigh: 74,
        uLow: 67.93,
        uVolume: 2941945,
        change: -1.54,
        changePercent: -2.2318,
        label: "Jul 31, 20",
        changeOverTime: 1.044144
    },
    {
        date: "2023-08-03",
        open: 71.21,
        close: 68.96,
        high: 70.82,
        low: 67.13,
        volume: 2769545,
        uOpen: 70.07,
        uClose: 70.28,
        uHigh: 72.81,
        uLow: 67.74,
        uVolume: 2680288,
        change: -0.45,
        changePercent: -0.673,
        label: "Aug 3, 20",
        changeOverTime: 1.038481
    },
    {
        date: "2023-08-04",
        open: 71.9,
        close: 70.89,
        high: 71.2,
        low: 69.53,
        volume: 3323465,
        uOpen: 71.8,
        uClose: 71.42,
        uHigh: 71.6,
        uLow: 70.72,
        uVolume: 3296835,
        change: 0.3,
        changePercent: 0.459,
        label: "Aug 4, 20",
        changeOverTime: 1.056066
    },
    {
        date: "2023-08-05",
        open: 69.22,
        close: 72.1,
        high: 72.18,
        low: 69.33,
        volume: 2617083,
        uOpen: 70.97,
        uClose: 72.5,
        uHigh: 72.73,
        uLow: 68.33,
        uVolume: 2604569,
        change: 2.47,
        changePercent: 3.502,
        label: "Aug 5, 20",
        changeOverTime: 1.13668
    },
    {
        date: "2023-08-06",
        open: 72.55,
        close: 73.15,
        high: 73.6,
        low: 72.09,
        volume: 6589767,
        uOpen: 71.12,
        uClose: 72.55,
        uHigh: 75.3,
        uLow: 72.25,
        uVolume: 6649827,
        change: 0.84,
        changePercent: 1.1665,
        label: "Aug 6, 20",
        changeOverTime: 1.128941
    },
    {
        date: "2023-08-07",
        open: 81.65,
        close: 82.64,
        high: 87.7,
        low: 76,
        volume: 27655931,
        uOpen: 79.51,
        uClose: 80.28,
        uHigh: 85.5,
        uLow: 77,
        uVolume: 28649161,
        change: 8.52,
        changePercent: 12.0405,
        label: "Aug 7, 20",
        changeOverTime: 1.365881
    },
    {
        date: "2023-08-10",
        open: 83.03,
        close: 79.69,
        high: 82.8,
        low: 78.6,
        volume: 4119285,
        uOpen: 82.81,
        uClose: 80.73,
        uHigh: 81.54,
        uLow: 82.2,
        uVolume: 4165296,
        change: -0.43,
        changePercent: -0.5444,
        label: "Aug 10, 20",
        changeOverTime: 1.398748
    },
    {
        date: "2023-08-11",
        open: 81.44,
        close: 76.78,
        high: 80.97,
        low: 76.4,
        volume: 4190930,
        uOpen: 82.33,
        uClose: 79.04,
        uHigh: 80.08,
        uLow: 76.77,
        uVolume: 4129386,
        change: -4.07,
        changePercent: -5.0925,
        label: "Aug 11, 20",
        changeOverTime: 1.288909
    },
    {
        date: "2023-08-12",
        open: 75.6,
        close: 77,
        high: 82.32,
        low: 77.36,
        volume: 3404497,
        uOpen: 77.03,
        uClose: 79,
        uHigh: 79.56,
        uLow: 77.52,
        uVolume: 3312565,
        change: 0.68,
        changePercent: 0.8949,
        label: "Aug 12, 20",
        changeOverTime: 1.261838
    },
    {
        date: "2023-08-13",
        open: 78.31,
        close: 75.2,
        high: 80.61,
        low: 77.17,
        volume: 4622309,
        uOpen: 78.85,
        uClose: 77.93,
        uHigh: 78.58,
        uLow: 77.5,
        uVolume: 4622267,
        change: -1.59,
        changePercent: -2.1312,
        label: "Aug 13, 20",
        changeOverTime: 1.222435
    },
    {
        date: "2023-08-14",
        open: 75.29,
        close: 78.85,
        high: 79.73,
        low: 76.72,
        volume: 3044461,
        uOpen: 74.71,
        uClose: 77.48,
        uHigh: 79.59,
        uLow: 76.03,
        uVolume: 3101444,
        change: 2.3,
        changePercent: 3.0697,
        label: "Aug 14, 20",
        changeOverTime: 1.308327
    },
    {
        date: "2023-08-17",
        open: 80.42,
        close: 83.21,
        high: 83,
        low: 78.8,
        volume: 3460224,
        uOpen: 79.97,
        uClose: 83.12,
        uHigh: 83.3,
        uLow: 78.55,
        uVolume: 3493198,
        change: 3.16,
        changePercent: 4.1797,
        label: "Aug 17, 20",
        changeOverTime: 1.397892
    },
    {
        date: "2023-08-18",
        open: 83.6,
        close: 84.49,
        high: 84.63,
        low: 80.36,
        volume: 3657034,
        uOpen: 81,
        uClose: 85.6,
        uHigh: 83.61,
        uLow: 81.19,
        uVolume: 3571098,
        change: 2.61,
        changePercent: 3.2646,
        label: "Aug 18, 20",
        changeOverTime: 1.503208
    },
    {
        date: "2023-08-19",
        open: 85.18,
        close: 85.93,
        high: 86.82,
        low: 84.61,
        volume: 3698565,
        uOpen: 83.87,
        uClose: 87.32,
        uHigh: 86.62,
        uLow: 83.43,
        uVolume: 3745594,
        change: 1.54,
        changePercent: 1.8827,
        label: "Aug 19, 20",
        changeOverTime: 1.547065
    },
    {
        date: "2023-08-20",
        open: 84.25,
        close: 85.23,
        high: 88,
        low: 85.83,
        volume: 2610434,
        uOpen: 85.42,
        uClose: 83.87,
        uHigh: 86,
        uLow: 83.22,
        uVolume: 2538611,
        change: -1.01,
        changePercent: -1.173,
        label: "Aug 20, 20",
        changeOverTime: 1.488569
    },
    {
        date: "2023-08-21",
        open: 83.41,
        close: 87.2,
        high: 86.13,
        low: 86.88,
        volume: 1831305,
        uOpen: 86.5,
        uClose: 83.7,
        uHigh: 84.42,
        uLow: 85.06,
        uVolume: 1823325,
        change: 0.37,
        changePercent: 0.4253,
        label: "Aug 21, 20",
        changeOverTime: 1.523688
    },
    {
        date: "2023-08-24",
        open: 86.62,
        close: 87.4,
        high: 87.87,
        low: 83.85,
        volume: 2074975,
        uOpen: 87.02,
        uClose: 84.8,
        uHigh: 85.4,
        uLow: 82.28,
        uVolume: 2041726,
        change: 0.4,
        changePercent: 0.4954,
        label: "Aug 24, 20",
        changeOverTime: 1.48216
    },
    {
        date: "2023-08-25",
        open: 86.27,
        close: 84.51,
        high: 87.16,
        low: 82.34,
        volume: 2091374,
        uOpen: 84.48,
        uClose: 84.35,
        uHigh: 87.17,
        uLow: 82.54,
        uVolume: 2131332,
        change: -0.81,
        changePercent: -0.9366,
        label: "Aug 25, 20",
        changeOverTime: 1.511231
    },
    {
        date: "2023-08-26",
        open: 83.59,
        close: 84.32,
        high: 89.5,
        low: 85.6,
        volume: 3704448,
        uOpen: 85.45,
        uClose: 87.57,
        uHigh: 87.65,
        uLow: 86,
        uVolume: 3856979,
        change: 1.02,
        changePercent: 1.2578,
        label: "Aug 26, 20",
        changeOverTime: 1.54771
    },
    {
        date: "2023-08-27",
        open: 85.62,
        close: 85.59,
        high: 90.17,
        low: 85.58,
        volume: 2620131,
        uOpen: 84.97,
        uClose: 85.6,
        uHigh: 88.81,
        uLow: 86.92,
        uVolume: 2540983,
        change: 1.41,
        changePercent: 1.6747,
        label: "Aug 27, 20",
        changeOverTime: 1.523364
    },
    {
        date: "2023-08-28",
        open: 86.45,
        close: 91.39,
        high: 91.03,
        low: 86.27,
        volume: 1862283,
        uOpen: 88.29,
        uClose: 89.87,
        uHigh: 90.78,
        uLow: 87.59,
        uVolume: 1886349,
        change: 2.12,
        changePercent: 2.4947,
        label: "Aug 28, 20",
        changeOverTime: 1.588418
    },
    {
        date: "2023-08-31",
        open: 88.57,
        close: 87.82,
        high: 91.3,
        low: 88.14,
        volume: 2186316,
        uOpen: 90.17,
        uClose: 87.42,
        uHigh: 87.41,
        uLow: 87.3,
        uVolume: 2181231,
        change: -1.63,
        changePercent: -1.7874,
        label: "Aug 31, 20",
        changeOverTime: 1.608187
    },
    {
        date: "2023-09-01",
        open: 89.7,
        close: 91.69,
        high: 92.53,
        low: 85.73,
        volume: 2470735,
        uOpen: 88.2,
        uClose: 89.97,
        uHigh: 89.9,
        uLow: 89.22,
        uVolume: 2407566,
        change: 2.75,
        changePercent: 3.136,
        label: "Sep 1, 20",
        changeOverTime: 1.645636
    },
    {
        date: "2023-09-02",
        open: 93.79,
        close: 89.43,
        high: 96.44,
        low: 91.96,
        volume: 4704602,
        uOpen: 91.88,
        uClose: 91.72,
        uHigh: 94.5,
        uLow: 88.92,
        uVolume: 4700253,
        change: 0.84,
        changePercent: 0.9801,
        label: "Sep 2, 20",
        changeOverTime: 1.64721
    },
    {
        date: "2023-09-03",
        open: 90.2,
        close: 85.69,
        high: 90.08,
        low: 82.69,
        volume: 3428732,
        uOpen: 91.4,
        uClose: 87.74,
        uHigh: 92.32,
        uLow: 85.11,
        uVolume: 3439760,
        change: -4,
        changePercent: -4.4538,
        label: "Sep 3, 20",
        changeOverTime: 1.593497
    },
    {
        date: "2023-09-04",
        open: 88.33,
        close: 86.94,
        high: 86.3,
        low: 79.17,
        volume: 3390869,
        uOpen: 86.4,
        uClose: 86.42,
        uHigh: 89.79,
        uLow: 81.02,
        uVolume: 3394052,
        change: -1.59,
        changePercent: -1.8638,
        label: "Sep 4, 20",
        changeOverTime: 1.507897
    },
    {
        date: "2023-09-08",
        open: 82.27,
        close: 81.7,
        high: 85.67,
        low: 81.62,
        volume: 2765641,
        uOpen: 80.97,
        uClose: 80.84,
        uHigh: 88.21,
        uLow: 83.31,
        uVolume: 2752630,
        change: -3.24,
        changePercent: -4.0236,
        label: "Sep 8, 20",
        changeOverTime: 1.453855
    },
    {
        date: "2023-09-09",
        open: 82.4,
        close: 84.16,
        high: 85.16,
        low: 80.5,
        volume: 3337068,
        uOpen: 83.93,
        uClose: 82.99,
        uHigh: 87.7,
        uLow: 82.1,
        uVolume: 3394890,
        change: 1.71,
        changePercent: 2.109,
        label: "Sep 9, 20",
        changeOverTime: 1.479008
    },
    {
        date: "2023-09-10",
        open: 86.09,
        close: 86.42,
        high: 87.82,
        low: 82.17,
        volume: 2942550,
        uOpen: 86.53,
        uClose: 86.1,
        uHigh: 86.77,
        uLow: 82.04,
        uVolume: 3059185,
        change: 0.45,
        changePercent: 0.5557,
        label: "Sep 10, 20",
        changeOverTime: 1.497985
    },
    {
        date: "2023-09-11",
        open: 86.96,
        close: 87.31,
        high: 86.84,
        low: 86.21,
        volume: 3087711,
        uOpen: 85.44,
        uClose: 89.45,
        uHigh: 89.71,
        uLow: 84.51,
        uVolume: 3061715,
        change: 2.67,
        changePercent: 3.3003,
        label: "Sep 11, 20",
        changeOverTime: 1.599546
    },
    {
        date: "2023-09-14",
        open: 91.22,
        close: 91.26,
        high: 91.77,
        low: 87.1,
        volume: 3291760,
        uOpen: 88.05,
        uClose: 90.87,
        uHigh: 91.32,
        uLow: 87.65,
        uVolume: 3309967,
        change: 1.8,
        changePercent: 2.1932,
        label: "Sep 14, 20",
        changeOverTime: 1.64021
    },
    {
        date: "2023-09-15",
        open: 88.02,
        close: 95.37,
        high: 96.84,
        low: 90.07,
        volume: 5720465,
        uOpen: 91.25,
        uClose: 93.28,
        uHigh: 96.78,
        uLow: 88.21,
        uVolume: 5614291,
        change: 4.06,
        changePercent: 4.7012,
        label: "Sep 15, 20",
        changeOverTime: 1.765879
    },
    {
        date: "2023-09-16",
        open: 94.95,
        close: 96.71,
        high: 97.17,
        low: 92.1,
        volume: 6895440,
        uOpen: 95.95,
        uClose: 95.88,
        uHigh: 98.43,
        uLow: 93.51,
        uVolume: 6777002,
        change: 3.82,
        changePercent: 4.29,
        label: "Sep 16, 20",
        changeOverTime: 1.81224
    },
    {
        date: "2023-09-17",
        open: 95.3,
        close: 99.24,
        high: 97,
        low: 92.94,
        volume: 5239616,
        uOpen: 94.9,
        uClose: 101.24,
        uHigh: 101,
        uLow: 95.47,
        uVolume: 5424180,
        change: 1.48,
        changePercent: 1.5575,
        label: "Sep 17, 20",
        changeOverTime: 1.9374
    },
    {
        date: "2023-09-18",
        open: 102.08,
        close: 97.23,
        high: 101,
        low: 93.57,
        volume: 4845904,
        uOpen: 101.46,
        uClose: 97.99,
        uHigh: 100,
        uLow: 93.29,
        uVolume: 4842493,
        change: -0.58,
        changePercent: -0.6073,
        label: "Sep 18, 20",
        changeOverTime: 1.919154
    },
    {
        date: "2023-09-21",
        open: 97.39,
        close: 99.27,
        high: 99.07,
        low: 93.85,
        volume: 3884415,
        uOpen: 96.21,
        uClose: 96.77,
        uHigh: 99.84,
        uLow: 94.08,
        uVolume: 3972011,
        change: -0.16,
        changePercent: -0.1712,
        label: "Sep 21, 20",
        changeOverTime: 1.85587
    },
    {
        date: "2023-09-22",
        open: 99.32,
        close: 99.33,
        high: 100.34,
        low: 95.01,
        volume: 3742355,
        uOpen: 99.1,
        uClose: 101.55,
        uHigh: 104.19,
        uLow: 97.01,
        uVolume: 3672388,
        change: 3.49,
        changePercent: 3.66,
        label: "Sep 22, 20",
        changeOverTime: 1.942257
    },
    {
        date: "2023-09-23",
        open: 102,
        close: 98.67,
        high: 105.57,
        low: 96.32,
        volume: 3731500,
        uOpen: 102,
        uClose: 97.21,
        uHigh: 102.95,
        uLow: 96.55,
        uVolume: 3828640,
        change: -2.9,
        changePercent: -2.9555,
        label: "Sep 23, 20",
        changeOverTime: 1.856195
    },
    {
        date: "2023-09-24",
        open: 97.08,
        close: 97.89,
        high: 104.27,
        low: 97.3,
        volume: 2809754,
        uOpen: 96.71,
        uClose: 98.7,
        uHigh: 104.94,
        uLow: 97.3,
        uVolume: 2786988,
        change: 1.55,
        changePercent: 1.562,
        label: "Sep 24, 20",
        changeOverTime: 1.972281
    },
    {
        date: "2023-09-25",
        open: 104.09,
        close: 106.15,
        high: 105.36,
        low: 101.59,
        volume: 2709590,
        uOpen: 102.8,
        uClose: 102.47,
        uHigh: 103.57,
        uLow: 101.24,
        uVolume: 2647857,
        change: 3.59,
        changePercent: 3.55,
        label: "Sep 25, 20",
        changeOverTime: 1.998297
    },
    {
        date: "2023-09-28",
        open: 104.93,
        close: 101.81,
        high: 103.72,
        low: 102.09,
        volume: 2791773,
        uOpen: 104.9,
        uClose: 103.87,
        uHigh: 103.71,
        uLow: 101.43,
        uVolume: 2736799,
        change: -0.11,
        changePercent: -0.1089,
        label: "Sep 28, 20",
        changeOverTime: 2.037776
    },
    {
        date: "2023-09-29",
        open: 104.3,
        close: 102.25,
        high: 107.81,
        low: 103.99,
        volume: 1805648,
        uOpen: 104.23,
        uClose: 103.25,
        uHigh: 106.43,
        uLow: 100.28,
        uVolume: 1817865,
        change: 0.27,
        changePercent: 0.259,
        label: "Sep 29, 20",
        changeOverTime: 2.017937
    },
    {
        date: "2023-09-30",
        open: 103.47,
        close: 106.58,
        high: 104.43,
        low: 102.73,
        volume: 3579571,
        uOpen: 104.35,
        uClose: 102.6,
        uHigh: 107.74,
        uLow: 105.64,
        uVolume: 3517357,
        change: 0.17,
        changePercent: 0.173,
        label: "Sep 30, 20",
        changeOverTime: 2.073814
    },
    {
        date: "2023-10-01",
        open: 105.3,
        close: 108.43,
        high: 108.94,
        low: 104.2,
        volume: 3736880,
        uOpen: 104.35,
        uClose: 111.55,
        uHigh: 110.89,
        uLow: 102.9,
        uVolume: 3632715,
        change: 6.22,
        changePercent: 5.949,
        label: "Oct 1, 20",
        changeOverTime: 2.220223
    },
    {
        date: "2023-10-02",
        open: 104.27,
        close: 108.42,
        high: 111.95,
        low: 105.75,
        volume: 2259231,
        uOpen: 105.21,
        uClose: 111.55,
        uHigh: 114.42,
        uLow: 107.33,
        uVolume: 2309381,
        change: 0.65,
        changePercent: 0.6341,
        label: "Oct 2, 20",
        changeOverTime: 2.242286
    },
    {
        date: "2023-10-05",
        open: 111.88,
        close: 111.63,
        high: 115.55,
        low: 113.14,
        volume: 2483078,
        uOpen: 109.83,
        uClose: 112.33,
        uHigh: 112.54,
        uLow: 112.8,
        uVolume: 2520390,
        change: 2.01,
        changePercent: 1.8416,
        label: "Oct 5, 20",
        changeOverTime: 2.346159
    },
    {
        date: "2023-10-06",
        open: 114.58,
        close: 106.13,
        high: 115.03,
        low: 108.26,
        volume: 3431045,
        uOpen: 110.71,
        uClose: 107.3,
        uHigh: 114.13,
        uLow: 105.65,
        uVolume: 3440514,
        change: -5.27,
        changePercent: -4.81,
        label: "Oct 6, 20",
        changeOverTime: 2.126056
    },
    {
        date: "2023-10-07",
        open: 108.75,
        close: 105.61,
        high: 108.37,
        low: 106.8,
        volume: 3617091,
        uOpen: 110.85,
        uClose: 109.74,
        uHigh: 109.59,
        uLow: 108.1,
        uVolume: 3650700,
        change: 0.53,
        changePercent: 0.5007,
        label: "Oct 7, 20",
        changeOverTime: 2.200404
    },
    {
        date: "2023-10-08",
        open: 109.15,
        close: 105.24,
        high: 107.04,
        low: 106.61,
        volume: 2396645,
        uOpen: 111.59,
        uClose: 107.75,
        uHigh: 111.5,
        uLow: 105.4,
        uVolume: 2344767,
        change: -0.48,
        changePercent: -0.4479,
        label: "Oct 8, 20",
        changeOverTime: 2.14279
    },
    {
        date: "2023-10-09",
        open: 105.63,
        close: 107.84,
        high: 107.6,
        low: 107.09,
        volume: 1928629,
        uOpen: 106.79,
        uClose: 106.12,
        uHigh: 107.6,
        uLow: 106.61,
        uVolume: 1909490,
        change: -0.79,
        changePercent: -0.7652,
        label: "Oct 9, 20",
        changeOverTime: 2.162448
    },
    {
        date: "2023-10-12",
        open: 109.75,
        close: 102,
        high: 109.4,
        low: 104.75,
        volume: 2618535,
        uOpen: 107.75,
        uClose: 104.64,
        uHigh: 110.03,
        uLow: 100.29,
        uVolume: 2509132,
        change: -3.39,
        changePercent: -3.2343,
        label: "Oct 12, 20",
        changeOverTime: 2.010983
    },
    {
        date: "2023-10-13",
        open: 104.38,
        close: 105.9,
        high: 106.04,
        low: 100.05,
        volume: 2463768,
        uOpen: 105.7,
        uClose: 101.4,
        uHigh: 106.09,
        uLow: 104.18,
        uVolume: 2481854,
        change: 0.2,
        changePercent: 0.1909,
        label: "Oct 13, 20",
        changeOverTime: 2.040108
    },
    {
        date: "2023-10-14",
        open: 104.7,
        close: 103.15,
        high: 109.21,
        low: 101.55,
        volume: 2611266,
        uOpen: 104.4,
        uClose: 105.87,
        uHigh: 105.52,
        uLow: 106.15,
        uVolume: 2603572,
        change: 1.72,
        changePercent: 1.6702,
        label: "Oct 14, 20",
        changeOverTime: 2.083144
    },
    {
        date: "2023-10-15",
        open: 103.2,
        close: 102.79,
        high: 110.86,
        low: 103.8,
        volume: 3572217,
        uOpen: 103,
        uClose: 104.09,
        uHigh: 111.14,
        uLow: 104.1,
        uVolume: 3525170,
        change: -1.05,
        changePercent: -1.0231,
        label: "Oct 15, 20",
        changeOverTime: 2.106425
    },
    {
        date: "2023-10-16",
        open: 107.16,
        close: 99.12,
        high: 106.36,
        low: 101.83,
        volume: 3956866,
        uOpen: 106.57,
        uClose: 98.99,
        uHigh: 105.33,
        uLow: 101.68,
        uVolume: 3932165,
        change: -4.92,
        changePercent: -4.8453,
        label: "Oct 16, 20",
        changeOverTime: 1.884921
    },
    {
        date: "2023-10-19",
        open: 100.63,
        close: 98.52,
        high: 102.32,
        low: 101,
        volume: 2837884,
        uOpen: 102.79,
        uClose: 99.1,
        uHigh: 103.23,
        uLow: 97.8,
        uVolume: 2861952,
        change: 1.39,
        changePercent: 1.4317,
        label: "Oct 19, 20",
        changeOverTime: 1.946531
    },
    {
        date: "2023-10-20",
        open: 99.34,
        close: 102.75,
        high: 104.89,
        low: 98.24,
        volume: 2793832,
        uOpen: 100.07,
        uClose: 102.63,
        uHigh: 102.15,
        uLow: 100.04,
        uVolume: 2776911,
        change: -0.02,
        changePercent: -0.0206,
        label: "Oct 20, 20",
        changeOverTime: 1.99701
    },
    {
        date: "2023-10-21",
        open: 102.47,
        close: 99.64,
        high: 103.79,
        low: 101.08,
        volume: 1703418,
        uOpen: 100.29,
        uClose: 100.99,
        uHigh: 106.42,
        uLow: 100.41,
        uVolume: 1693219,
        change: 0.22,
        changePercent: 0.2344,
        label: "Oct 21, 20",
        changeOverTime: 2.001882
    },
    {
        date: "2023-10-22",
        open: 102.48,
        close: 98.19,
        high: 102.32,
        low: 96.94,
        volume: 2291145,
        uOpen: 102.98,
        uClose: 98.67,
        uHigh: 101.46,
        uLow: 98.21,
        uVolume: 2328063,
        change: -1.9,
        changePercent: -1.9523,
        label: "Oct 22, 20",
        changeOverTime: 1.923123
    },
    {
        date: "2023-10-23",
        open: 99.75,
        close: 97.93,
        high: 102.07,
        low: 97,
        volume: 1593163,
        uOpen: 101.16,
        uClose: 97.73,
        uHigh: 99.1,
        uLow: 96,
        uVolume: 1619528,
        change: -0.64,
        changePercent: -0.6674,
        label: "Oct 23, 20",
        changeOverTime: 1.8512
    },
    {
        date: "2023-10-26",
        open: 97,
        close: 93.6,
        high: 99.47,
        low: 93.27,
        volume: 2328125,
        uOpen: 99,
        uClose: 94.52,
        uHigh: 100.26,
        uLow: 94.16,
        uVolume: 2325606,
        change: -4.28,
        changePercent: -4.3517,
        label: "Oct 26, 20",
        changeOverTime: 1.779216
    },
    {
        date: "2023-10-27",
        open: 95.66,
        close: 95.63,
        high: 96.42,
        low: 95.25,
        volume: 1881902,
        uOpen: 96.89,
        uClose: 96.6,
        uHigh: 97.72,
        uLow: 91.61,
        uVolume: 1870465,
        change: 0.48,
        changePercent: 0.5286,
        label: "Oct 27, 20",
        changeOverTime: 1.749557
    },
    {
        date: "2023-10-28",
        open: 91.24,
        close: 92.18,
        high: 92.79,
        low: 89.74,
        volume: 1734513,
        uOpen: 92.87,
        uClose: 91.37,
        uHigh: 94.05,
        uLow: 92.24,
        uVolume: 1763200,
        change: -2.94,
        changePercent: -3.153,
        label: "Oct 28, 20",
        changeOverTime: 1.669745
    }
];

});

// Bootstrap JS
/*!
  * Bootstrap v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $0df88669b608f125$exports = {};

$parcel$export($0df88669b608f125$exports, "popperGenerator", function () { return $049daf6251bd50a0$export$ed5e13716264f202; });
$parcel$export($0df88669b608f125$exports, "detectOverflow", function () { return $139c53ba42f4d00a$export$2e2bcd8739ae039; });
$parcel$export($0df88669b608f125$exports, "createPopperBase", function () { return $049daf6251bd50a0$export$8f7491d57c8f97a9; });
$parcel$export($0df88669b608f125$exports, "createPopper", function () { return $76cb06c64be98270$export$8f7491d57c8f97a9; });
$parcel$export($0df88669b608f125$exports, "createPopperLite", function () { return $828ba2b453546dbe$export$8f7491d57c8f97a9; });
var $44c2dd89be3518f8$exports = {};

$parcel$export($44c2dd89be3518f8$exports, "top", function () { return $44c2dd89be3518f8$export$1e95b668f3b82d; });
$parcel$export($44c2dd89be3518f8$exports, "bottom", function () { return $44c2dd89be3518f8$export$40e543e69a8b3fbb; });
$parcel$export($44c2dd89be3518f8$exports, "right", function () { return $44c2dd89be3518f8$export$79ffe56a765070d2; });
$parcel$export($44c2dd89be3518f8$exports, "left", function () { return $44c2dd89be3518f8$export$eabcd2c8791e7bf4; });
$parcel$export($44c2dd89be3518f8$exports, "auto", function () { return $44c2dd89be3518f8$export$dfb5619354ba860; });
$parcel$export($44c2dd89be3518f8$exports, "basePlacements", function () { return $44c2dd89be3518f8$export$aec2ce47c367b8c3; });
$parcel$export($44c2dd89be3518f8$exports, "start", function () { return $44c2dd89be3518f8$export$b3571188c770cc5a; });
$parcel$export($44c2dd89be3518f8$exports, "end", function () { return $44c2dd89be3518f8$export$bd5df0f255a350f8; });
$parcel$export($44c2dd89be3518f8$exports, "clippingParents", function () { return $44c2dd89be3518f8$export$390fd549c5303b4d; });
$parcel$export($44c2dd89be3518f8$exports, "viewport", function () { return $44c2dd89be3518f8$export$d7b7311ec04a3e8f; });
$parcel$export($44c2dd89be3518f8$exports, "popper", function () { return $44c2dd89be3518f8$export$ae5ab1c730825774; });
$parcel$export($44c2dd89be3518f8$exports, "reference", function () { return $44c2dd89be3518f8$export$ca50aac9f3ba507f; });
$parcel$export($44c2dd89be3518f8$exports, "variationPlacements", function () { return $44c2dd89be3518f8$export$368f9a87e87fa4e1; });
$parcel$export($44c2dd89be3518f8$exports, "placements", function () { return $44c2dd89be3518f8$export$803cd8101b6c182b; });
$parcel$export($44c2dd89be3518f8$exports, "beforeRead", function () { return $44c2dd89be3518f8$export$421679a7c3d56e; });
$parcel$export($44c2dd89be3518f8$exports, "read", function () { return $44c2dd89be3518f8$export$aafa59e2e03f2942; });
$parcel$export($44c2dd89be3518f8$exports, "afterRead", function () { return $44c2dd89be3518f8$export$6964f6c886723980; });
$parcel$export($44c2dd89be3518f8$exports, "beforeMain", function () { return $44c2dd89be3518f8$export$c65e99957a05207c; });
$parcel$export($44c2dd89be3518f8$exports, "main", function () { return $44c2dd89be3518f8$export$f22da7240b7add18; });
$parcel$export($44c2dd89be3518f8$exports, "afterMain", function () { return $44c2dd89be3518f8$export$bab79516f2d662fe; });
$parcel$export($44c2dd89be3518f8$exports, "beforeWrite", function () { return $44c2dd89be3518f8$export$8d4d2d70e7d46032; });
$parcel$export($44c2dd89be3518f8$exports, "write", function () { return $44c2dd89be3518f8$export$68d8715fc104d294; });
$parcel$export($44c2dd89be3518f8$exports, "afterWrite", function () { return $44c2dd89be3518f8$export$70a6e5159acce2e6; });
$parcel$export($44c2dd89be3518f8$exports, "modifierPhases", function () { return $44c2dd89be3518f8$export$d087d3878fdf71d5; });
var $44c2dd89be3518f8$export$1e95b668f3b82d = "top";
var $44c2dd89be3518f8$export$40e543e69a8b3fbb = "bottom";
var $44c2dd89be3518f8$export$79ffe56a765070d2 = "right";
var $44c2dd89be3518f8$export$eabcd2c8791e7bf4 = "left";
var $44c2dd89be3518f8$export$dfb5619354ba860 = "auto";
var $44c2dd89be3518f8$export$aec2ce47c367b8c3 = [
    $44c2dd89be3518f8$export$1e95b668f3b82d,
    $44c2dd89be3518f8$export$40e543e69a8b3fbb,
    $44c2dd89be3518f8$export$79ffe56a765070d2,
    $44c2dd89be3518f8$export$eabcd2c8791e7bf4
];
var $44c2dd89be3518f8$export$b3571188c770cc5a = "start";
var $44c2dd89be3518f8$export$bd5df0f255a350f8 = "end";
var $44c2dd89be3518f8$export$390fd549c5303b4d = "clippingParents";
var $44c2dd89be3518f8$export$d7b7311ec04a3e8f = "viewport";
var $44c2dd89be3518f8$export$ae5ab1c730825774 = "popper";
var $44c2dd89be3518f8$export$ca50aac9f3ba507f = "reference";
var $44c2dd89be3518f8$export$368f9a87e87fa4e1 = /*#__PURE__*/ $44c2dd89be3518f8$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $44c2dd89be3518f8$export$b3571188c770cc5a,
        placement + "-" + $44c2dd89be3518f8$export$bd5df0f255a350f8
    ]);
}, []);
var $44c2dd89be3518f8$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($44c2dd89be3518f8$export$aec2ce47c367b8c3, [
    $44c2dd89be3518f8$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $44c2dd89be3518f8$export$b3571188c770cc5a,
        placement + "-" + $44c2dd89be3518f8$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $44c2dd89be3518f8$export$421679a7c3d56e = "beforeRead";
var $44c2dd89be3518f8$export$aafa59e2e03f2942 = "read";
var $44c2dd89be3518f8$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $44c2dd89be3518f8$export$c65e99957a05207c = "beforeMain";
var $44c2dd89be3518f8$export$f22da7240b7add18 = "main";
var $44c2dd89be3518f8$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $44c2dd89be3518f8$export$8d4d2d70e7d46032 = "beforeWrite";
var $44c2dd89be3518f8$export$68d8715fc104d294 = "write";
var $44c2dd89be3518f8$export$70a6e5159acce2e6 = "afterWrite";
var $44c2dd89be3518f8$export$d087d3878fdf71d5 = [
    $44c2dd89be3518f8$export$421679a7c3d56e,
    $44c2dd89be3518f8$export$aafa59e2e03f2942,
    $44c2dd89be3518f8$export$6964f6c886723980,
    $44c2dd89be3518f8$export$c65e99957a05207c,
    $44c2dd89be3518f8$export$f22da7240b7add18,
    $44c2dd89be3518f8$export$bab79516f2d662fe,
    $44c2dd89be3518f8$export$8d4d2d70e7d46032,
    $44c2dd89be3518f8$export$68d8715fc104d294,
    $44c2dd89be3518f8$export$70a6e5159acce2e6
];


var $3f03cd5f40678225$exports = {};

$parcel$export($3f03cd5f40678225$exports, "applyStyles", function () { return $84d6c9387d86b289$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "arrow", function () { return $405b9984ca38949b$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "computeStyles", function () { return $5b90979be3b63764$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "eventListeners", function () { return $731531bb0061091c$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "flip", function () { return $81d0169780badc64$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "hide", function () { return $508946bb3efcee61$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "offset", function () { return $8fba5e15d8a8b7a5$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "popperOffsets", function () { return $b58fb9ccaf78e9c4$export$2e2bcd8739ae039; });
$parcel$export($3f03cd5f40678225$exports, "preventOverflow", function () { return $cb12de4aac27c625$export$2e2bcd8739ae039; });
function $72e7e0a596e83b61$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $49faf5ede31d6b8a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $fe1db73f0dadc4df$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $fe1db73f0dadc4df$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $fe1db73f0dadc4df$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $84d6c9387d86b289$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(element) || !(0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $84d6c9387d86b289$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(element) || !(0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $84d6c9387d86b289$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $84d6c9387d86b289$var$applyStyles,
    effect: $84d6c9387d86b289$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $c63646c50c3526cf$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $b3b7e21ff958ee45$export$8960430cfd85939f = Math.max;
var $b3b7e21ff958ee45$export$96ec731ed4dcb222 = Math.min;
var $b3b7e21ff958ee45$export$2077e0241d6afd3c = Math.round;



function $9633ffee15e68c11$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $a01ed46d9d8baaa6$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9633ffee15e68c11$export$2e2bcd8739ae039)());
}


function $bc2ea0c97dd5d40d$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $b3b7e21ff958ee45$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $b3b7e21ff958ee45$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(element) ? (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $a01ed46d9d8baaa6$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $d170e057670916d0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bc2ea0c97dd5d40d$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $1dc319a5340eb0fa$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fe1db73f0dadc4df$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $764bc1839ac1da48$export$2e2bcd8739ae039(element) {
    return (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $0178fd2e57ca7d80$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(element)) >= 0;
}




function $dc27a463a564c2df$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $7a74174d0dcb207e$export$2e2bcd8739ae039(element) {
    if ((0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fe1db73f0dadc4df$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $dc27a463a564c2df$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $d07a561118a1289f$var$getTrueOffsetParent(element) {
    if (!(0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $764bc1839ac1da48$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $d07a561118a1289f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9633ffee15e68c11$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9633ffee15e68c11$export$2e2bcd8739ae039)());
    if (isIE && (0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $764bc1839ac1da48$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $7a74174d0dcb207e$export$2e2bcd8739ae039)(element);
    if ((0, $fe1db73f0dadc4df$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $764bc1839ac1da48$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $d07a561118a1289f$export$2e2bcd8739ae039(element) {
    var window = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(element);
    var offsetParent = $d07a561118a1289f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $0178fd2e57ca7d80$export$2e2bcd8739ae039)(offsetParent) && (0, $764bc1839ac1da48$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $d07a561118a1289f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $764bc1839ac1da48$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $d07a561118a1289f$var$getContainingBlock(element) || window;
}


function $0366b7371b1be75a$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $23e56dc74fea3c0e$export$f28d906d67a997f3(min, value, max) {
    return (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(min, (0, $b3b7e21ff958ee45$export$96ec731ed4dcb222)(value, max));
}
function $23e56dc74fea3c0e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $23e56dc74fea3c0e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $e92134524fffa7f5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $727336dcc38d1591$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $e92134524fffa7f5$export$2e2bcd8739ae039)(), paddingObject);
}


function $a819033efb4ce854$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $405b9984ca38949b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $727336dcc38d1591$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $a819033efb4ce854$export$2e2bcd8739ae039)(padding, (0, $44c2dd89be3518f8$export$aec2ce47c367b8c3)));
};
function $405b9984ca38949b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $0366b7371b1be75a$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4),
        (0, $44c2dd89be3518f8$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $405b9984ca38949b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $d170e057670916d0$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $44c2dd89be3518f8$export$1e95b668f3b82d) : (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb) : (0, $44c2dd89be3518f8$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $d07a561118a1289f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $23e56dc74fea3c0e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $405b9984ca38949b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $1dc319a5340eb0fa$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $405b9984ca38949b$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $405b9984ca38949b$var$arrow,
    effect: $405b9984ca38949b$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $c3844446f4d8b1ae$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $5b90979be3b63764$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $5b90979be3b63764$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $b3b7e21ff958ee45$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $b3b7e21ff958ee45$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $5b90979be3b63764$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4);
    var sideY = (0, $44c2dd89be3518f8$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $d07a561118a1289f$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $dc27a463a564c2df$export$2e2bcd8739ae039)(popper);
            if ((0, $764bc1839ac1da48$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $44c2dd89be3518f8$export$1e95b668f3b82d) || (placement === (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4) || placement === (0, $44c2dd89be3518f8$export$79ffe56a765070d2)) && variation === (0, $44c2dd89be3518f8$export$bd5df0f255a350f8)) {
            sideY = (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4) || (placement === (0, $44c2dd89be3518f8$export$1e95b668f3b82d) || placement === (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb)) && variation === (0, $44c2dd89be3518f8$export$bd5df0f255a350f8)) {
            sideX = (0, $44c2dd89be3518f8$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $5b90979be3b63764$var$unsetSides);
    var _ref4 = roundOffsets === true ? $5b90979be3b63764$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $5b90979be3b63764$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $c3844446f4d8b1ae$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $5b90979be3b63764$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $5b90979be3b63764$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5b90979be3b63764$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $5b90979be3b63764$var$computeStyles,
    data: {}
};



var $731531bb0061091c$var$passive = {
    passive: true
};
function $731531bb0061091c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $731531bb0061091c$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $731531bb0061091c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $731531bb0061091c$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $731531bb0061091c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $731531bb0061091c$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $731531bb0061091c$var$effect,
    data: {}
};


var $90a7a375c70ab38d$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $90a7a375c70ab38d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $90a7a375c70ab38d$var$hash[matched];
    });
}



var $056f99c88c2906ca$var$hash = {
    start: "end",
    end: "start"
};
function $056f99c88c2906ca$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $056f99c88c2906ca$var$hash[matched];
    });
}








function $7050442deb1f96fc$export$2e2bcd8739ae039(node) {
    var win = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $a9af9a40f81aaf3e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bc2ea0c97dd5d40d$export$2e2bcd8739ae039)((0, $dc27a463a564c2df$export$2e2bcd8739ae039)(element)).left + (0, $7050442deb1f96fc$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4b556eb5ef1c4f6f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(element);
    var html = (0, $dc27a463a564c2df$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $a01ed46d9d8baaa6$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $a9af9a40f81aaf3e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e3bb76461b0c110a$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $dc27a463a564c2df$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $7050442deb1f96fc$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $a9af9a40f81aaf3e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $764bc1839ac1da48$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $290d0e07ef537762$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $764bc1839ac1da48$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $7f6662bfb174425e$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(node) && (0, $290d0e07ef537762$export$2e2bcd8739ae039)(node)) return node;
    return $7f6662bfb174425e$export$2e2bcd8739ae039((0, $7a74174d0dcb207e$export$2e2bcd8739ae039)(node));
}





function $e09c0f227c0290d7$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $7f6662bfb174425e$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $290d0e07ef537762$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($e09c0f227c0290d7$export$2e2bcd8739ae039((0, $7a74174d0dcb207e$export$2e2bcd8739ae039)(target)));
}










function $a7fc05ddb366c0f8$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $1d12493a3ba9b4c7$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bc2ea0c97dd5d40d$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $1d12493a3ba9b4c7$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $44c2dd89be3518f8$export$d7b7311ec04a3e8f) ? (0, $a7fc05ddb366c0f8$export$2e2bcd8739ae039)((0, $4b556eb5ef1c4f6f$export$2e2bcd8739ae039)(element, strategy)) : (0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(clippingParent) ? $1d12493a3ba9b4c7$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $a7fc05ddb366c0f8$export$2e2bcd8739ae039)((0, $e3bb76461b0c110a$export$2e2bcd8739ae039)((0, $dc27a463a564c2df$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $1d12493a3ba9b4c7$var$getClippingParents(element) {
    var clippingParents = (0, $e09c0f227c0290d7$export$2e2bcd8739ae039)((0, $7a74174d0dcb207e$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $764bc1839ac1da48$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(element) ? (0, $d07a561118a1289f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(clippingParent) && (0, $1dc319a5340eb0fa$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $1d12493a3ba9b4c7$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $1d12493a3ba9b4c7$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $1d12493a3ba9b4c7$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $b3b7e21ff958ee45$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $b3b7e21ff958ee45$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $1d12493a3ba9b4c7$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5cd36666192968c1$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $c3844446f4d8b1ae$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $44c2dd89be3518f8$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $44c2dd89be3518f8$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $44c2dd89be3518f8$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $0366b7371b1be75a$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $44c2dd89be3518f8$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $44c2dd89be3518f8$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $139c53ba42f4d00a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $44c2dd89be3518f8$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $44c2dd89be3518f8$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $44c2dd89be3518f8$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $727336dcc38d1591$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $a819033efb4ce854$export$2e2bcd8739ae039)(padding, (0, $44c2dd89be3518f8$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $44c2dd89be3518f8$export$ae5ab1c730825774) ? (0, $44c2dd89be3518f8$export$ca50aac9f3ba507f) : (0, $44c2dd89be3518f8$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $1d12493a3ba9b4c7$export$2e2bcd8739ae039)((0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $dc27a463a564c2df$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bc2ea0c97dd5d40d$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5cd36666192968c1$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $a7fc05ddb366c0f8$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $44c2dd89be3518f8$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $44c2dd89be3518f8$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $44c2dd89be3518f8$export$79ffe56a765070d2),
                (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $44c2dd89be3518f8$export$1e95b668f3b82d),
                (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $1dc518636ff33926$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $44c2dd89be3518f8$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $c3844446f4d8b1ae$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $44c2dd89be3518f8$export$368f9a87e87fa4e1) : (0, $44c2dd89be3518f8$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $c3844446f4d8b1ae$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $44c2dd89be3518f8$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $139c53ba42f4d00a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c63646c50c3526cf$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $81d0169780badc64$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c63646c50c3526cf$export$2e2bcd8739ae039)(placement) === (0, $44c2dd89be3518f8$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $90a7a375c70ab38d$export$2e2bcd8739ae039)(placement);
    return [
        (0, $056f99c88c2906ca$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $056f99c88c2906ca$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $81d0169780badc64$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $90a7a375c70ab38d$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $81d0169780badc64$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c63646c50c3526cf$export$2e2bcd8739ae039)(placement) === (0, $44c2dd89be3518f8$export$dfb5619354ba860) ? (0, $1dc518636ff33926$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $c3844446f4d8b1ae$export$2e2bcd8739ae039)(placement) === (0, $44c2dd89be3518f8$export$b3571188c770cc5a);
        var isVertical = [
            (0, $44c2dd89be3518f8$export$1e95b668f3b82d),
            (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $139c53ba42f4d00a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $44c2dd89be3518f8$export$79ffe56a765070d2) : (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb) : (0, $44c2dd89be3518f8$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $90a7a375c70ab38d$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $90a7a375c70ab38d$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $81d0169780badc64$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $81d0169780badc64$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $508946bb3efcee61$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $508946bb3efcee61$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $44c2dd89be3518f8$export$1e95b668f3b82d),
        (0, $44c2dd89be3518f8$export$79ffe56a765070d2),
        (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb),
        (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $508946bb3efcee61$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $139c53ba42f4d00a$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $139c53ba42f4d00a$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $508946bb3efcee61$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $508946bb3efcee61$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $508946bb3efcee61$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $508946bb3efcee61$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $508946bb3efcee61$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $508946bb3efcee61$var$hide
};




function $8fba5e15d8a8b7a5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4),
        (0, $44c2dd89be3518f8$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4),
        (0, $44c2dd89be3518f8$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8fba5e15d8a8b7a5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $44c2dd89be3518f8$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8fba5e15d8a8b7a5$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8fba5e15d8a8b7a5$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $8fba5e15d8a8b7a5$var$offset
};



function $b58fb9ccaf78e9c4$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5cd36666192968c1$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b58fb9ccaf78e9c4$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $b58fb9ccaf78e9c4$var$popperOffsets,
    data: {}
};





function $92f1a4b3b0737ba8$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $cb12de4aac27c625$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $139c53ba42f4d00a$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c63646c50c3526cf$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $c3844446f4d8b1ae$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $0366b7371b1be75a$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $92f1a4b3b0737ba8$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $44c2dd89be3518f8$export$1e95b668f3b82d) : (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb) : (0, $44c2dd89be3518f8$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $44c2dd89be3518f8$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $44c2dd89be3518f8$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $d170e057670916d0$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $e92134524fffa7f5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $23e56dc74fea3c0e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $d07a561118a1289f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $23e56dc74fea3c0e$export$f28d906d67a997f3)(tether ? (0, $b3b7e21ff958ee45$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $b3b7e21ff958ee45$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $44c2dd89be3518f8$export$1e95b668f3b82d) : (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $44c2dd89be3518f8$export$40e543e69a8b3fbb) : (0, $44c2dd89be3518f8$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $44c2dd89be3518f8$export$1e95b668f3b82d),
            (0, $44c2dd89be3518f8$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $23e56dc74fea3c0e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $23e56dc74fea3c0e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cb12de4aac27c625$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $cb12de4aac27c625$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $1c7d7f3b430fab5d$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $54f3540cd553f6ed$export$2e2bcd8739ae039(node) {
    if (node === (0, $49faf5ede31d6b8a$export$2e2bcd8739ae039)(node) || !(0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(node)) return (0, $7050442deb1f96fc$export$2e2bcd8739ae039)(node);
    else return (0, $1c7d7f3b430fab5d$export$2e2bcd8739ae039)(node);
}








function $ed9fb7aa870790e1$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $b3b7e21ff958ee45$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $b3b7e21ff958ee45$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ed9fb7aa870790e1$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(offsetParent) && $ed9fb7aa870790e1$var$isElementScaled(offsetParent);
    var documentElement = (0, $dc27a463a564c2df$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $bc2ea0c97dd5d40d$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $72e7e0a596e83b61$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $290d0e07ef537762$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $54f3540cd553f6ed$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $fe1db73f0dadc4df$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $bc2ea0c97dd5d40d$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $a9af9a40f81aaf3e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $2c34b161f08bfec5$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2c34b161f08bfec5$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2c34b161f08bfec5$var$order(modifiers); // order based on phase
    return (0, $44c2dd89be3518f8$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $ba4db914a4a0aa69$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $0e059e16589badc2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $049daf6251bd50a0$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $049daf6251bd50a0$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $049daf6251bd50a0$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $049daf6251bd50a0$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $049daf6251bd50a0$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fe1db73f0dadc4df$export$45a5e7f76e0caa8d)(reference) ? (0, $e09c0f227c0290d7$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $e09c0f227c0290d7$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $e09c0f227c0290d7$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2c34b161f08bfec5$export$2e2bcd8739ae039)((0, $0e059e16589badc2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$049daf6251bd50a0$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ed9fb7aa870790e1$export$2e2bcd8739ae039)(reference, (0, $d07a561118a1289f$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $d170e057670916d0$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $ba4db914a4a0aa69$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$049daf6251bd50a0$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $049daf6251bd50a0$export$8f7491d57c8f97a9 = /*#__PURE__*/ $049daf6251bd50a0$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $76cb06c64be98270$export$d34966752335dd47 = [
    (0, $731531bb0061091c$export$2e2bcd8739ae039),
    (0, $b58fb9ccaf78e9c4$export$2e2bcd8739ae039),
    (0, $5b90979be3b63764$export$2e2bcd8739ae039),
    (0, $84d6c9387d86b289$export$2e2bcd8739ae039),
    (0, $8fba5e15d8a8b7a5$export$2e2bcd8739ae039),
    (0, $81d0169780badc64$export$2e2bcd8739ae039),
    (0, $cb12de4aac27c625$export$2e2bcd8739ae039),
    (0, $405b9984ca38949b$export$2e2bcd8739ae039),
    (0, $508946bb3efcee61$export$2e2bcd8739ae039)
];
var $76cb06c64be98270$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $049daf6251bd50a0$export$ed5e13716264f202)({
    defaultModifiers: $76cb06c64be98270$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $828ba2b453546dbe$export$d34966752335dd47 = [
    (0, $731531bb0061091c$export$2e2bcd8739ae039),
    (0, $b58fb9ccaf78e9c4$export$2e2bcd8739ae039),
    (0, $5b90979be3b63764$export$2e2bcd8739ae039),
    (0, $84d6c9387d86b289$export$2e2bcd8739ae039)
];
var $828ba2b453546dbe$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $049daf6251bd50a0$export$ed5e13716264f202)({
    defaultModifiers: $828ba2b453546dbe$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($0df88669b608f125$exports, $44c2dd89be3518f8$exports);
$parcel$exportWildcard($0df88669b608f125$exports, $3f03cd5f40678225$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$elementMap = new Map();
const $922d1ae1010e6efd$var$Data = {
    set (element, key, instance) {
        if (!$922d1ae1010e6efd$var$elementMap.has(element)) $922d1ae1010e6efd$var$elementMap.set(element, new Map());
        const instanceMap = $922d1ae1010e6efd$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($922d1ae1010e6efd$var$elementMap.has(element)) return $922d1ae1010e6efd$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$922d1ae1010e6efd$var$elementMap.has(element)) return;
        const instanceMap = $922d1ae1010e6efd$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $922d1ae1010e6efd$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $922d1ae1010e6efd$var$MAX_UID = 1000000;
const $922d1ae1010e6efd$var$MILLISECONDS_MULTIPLIER = 1000;
const $922d1ae1010e6efd$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $922d1ae1010e6efd$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $922d1ae1010e6efd$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $922d1ae1010e6efd$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $922d1ae1010e6efd$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $922d1ae1010e6efd$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $922d1ae1010e6efd$var$MILLISECONDS_MULTIPLIER;
};
const $922d1ae1010e6efd$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($922d1ae1010e6efd$var$TRANSITION_END));
};
const $922d1ae1010e6efd$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $922d1ae1010e6efd$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($922d1ae1010e6efd$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($922d1ae1010e6efd$var$parseSelector(object));
    return null;
};
const $922d1ae1010e6efd$var$isVisible = (element)=>{
    if (!$922d1ae1010e6efd$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $922d1ae1010e6efd$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $922d1ae1010e6efd$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $922d1ae1010e6efd$var$findShadowRoot(element.parentNode);
};
const $922d1ae1010e6efd$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $922d1ae1010e6efd$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $922d1ae1010e6efd$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $922d1ae1010e6efd$var$DOMContentLoadedCallbacks = [];
const $922d1ae1010e6efd$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$922d1ae1010e6efd$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $922d1ae1010e6efd$var$DOMContentLoadedCallbacks)callback();
        });
        $922d1ae1010e6efd$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $922d1ae1010e6efd$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $922d1ae1010e6efd$var$defineJQueryPlugin = (plugin)=>{
    $922d1ae1010e6efd$var$onDOMContentLoaded(()=>{
        const $ = $922d1ae1010e6efd$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $922d1ae1010e6efd$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $922d1ae1010e6efd$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $922d1ae1010e6efd$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $922d1ae1010e6efd$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($922d1ae1010e6efd$var$TRANSITION_END, handler);
        $922d1ae1010e6efd$var$execute(callback);
    };
    transitionElement.addEventListener($922d1ae1010e6efd$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $922d1ae1010e6efd$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $922d1ae1010e6efd$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $922d1ae1010e6efd$var$stripNameRegex = /\..*/;
const $922d1ae1010e6efd$var$stripUidRegex = /::\d+$/;
const $922d1ae1010e6efd$var$eventRegistry = {}; // Events storage
let $922d1ae1010e6efd$var$uidEvent = 1;
const $922d1ae1010e6efd$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $922d1ae1010e6efd$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $922d1ae1010e6efd$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$922d1ae1010e6efd$var$uidEvent++}` || element.uidEvent || $922d1ae1010e6efd$var$uidEvent++;
}
function $922d1ae1010e6efd$var$getElementEvents(element) {
    const uid = $922d1ae1010e6efd$var$makeEventUid(element);
    element.uidEvent = uid;
    $922d1ae1010e6efd$var$eventRegistry[uid] = $922d1ae1010e6efd$var$eventRegistry[uid] || {};
    return $922d1ae1010e6efd$var$eventRegistry[uid];
}
function $922d1ae1010e6efd$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $922d1ae1010e6efd$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $922d1ae1010e6efd$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $922d1ae1010e6efd$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $922d1ae1010e6efd$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $922d1ae1010e6efd$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $922d1ae1010e6efd$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $922d1ae1010e6efd$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $922d1ae1010e6efd$var$getTypeEvent(originalTypeEvent);
    if (!$922d1ae1010e6efd$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $922d1ae1010e6efd$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $922d1ae1010e6efd$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $922d1ae1010e6efd$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $922d1ae1010e6efd$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $922d1ae1010e6efd$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $922d1ae1010e6efd$var$makeEventUid(callable, originalTypeEvent.replace($922d1ae1010e6efd$var$namespaceRegex, ""));
    const fn = isDelegated ? $922d1ae1010e6efd$var$bootstrapDelegationHandler(element, handler, callable) : $922d1ae1010e6efd$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $922d1ae1010e6efd$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $922d1ae1010e6efd$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $922d1ae1010e6efd$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $922d1ae1010e6efd$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $922d1ae1010e6efd$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($922d1ae1010e6efd$var$stripNameRegex, "");
    return $922d1ae1010e6efd$var$customEvents[event] || event;
}
const $922d1ae1010e6efd$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $922d1ae1010e6efd$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $922d1ae1010e6efd$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $922d1ae1010e6efd$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $922d1ae1010e6efd$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $922d1ae1010e6efd$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$922d1ae1010e6efd$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($922d1ae1010e6efd$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $922d1ae1010e6efd$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $922d1ae1010e6efd$var$getjQuery();
        const typeEvent = $922d1ae1010e6efd$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $922d1ae1010e6efd$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $922d1ae1010e6efd$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $922d1ae1010e6efd$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $922d1ae1010e6efd$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $922d1ae1010e6efd$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$922d1ae1010e6efd$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$922d1ae1010e6efd$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $922d1ae1010e6efd$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $922d1ae1010e6efd$var$normalizeData(element.getAttribute(`data-bs-${$922d1ae1010e6efd$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $922d1ae1010e6efd$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $922d1ae1010e6efd$var$isElement(element) ? $922d1ae1010e6efd$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$922d1ae1010e6efd$var$isElement(element) ? $922d1ae1010e6efd$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $922d1ae1010e6efd$var$isElement(value) ? "element" : $922d1ae1010e6efd$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$VERSION = "5.3.2";
/**
 * Class definition
 */ class $922d1ae1010e6efd$var$BaseComponent extends $922d1ae1010e6efd$var$Config {
    // Public
    dispose() {
        $922d1ae1010e6efd$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $922d1ae1010e6efd$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $922d1ae1010e6efd$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $922d1ae1010e6efd$var$Data.get($922d1ae1010e6efd$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $922d1ae1010e6efd$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
    constructor(element, config){
        super();
        element = $922d1ae1010e6efd$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $922d1ae1010e6efd$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $922d1ae1010e6efd$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? $922d1ae1010e6efd$var$parseSelector(hrefAttribute.trim()) : null;
    }
    return selector;
};
const $922d1ae1010e6efd$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$922d1ae1010e6efd$var$isDisabled(el) && $922d1ae1010e6efd$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $922d1ae1010e6efd$var$getSelector(element);
        if (selector) return $922d1ae1010e6efd$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $922d1ae1010e6efd$var$getSelector(element);
        return selector ? $922d1ae1010e6efd$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $922d1ae1010e6efd$var$getSelector(element);
        return selector ? $922d1ae1010e6efd$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $922d1ae1010e6efd$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $922d1ae1010e6efd$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($922d1ae1010e6efd$var$isDisabled(this)) return;
        const target = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$f = "alert";
const $922d1ae1010e6efd$var$DATA_KEY$a = "bs.alert";
const $922d1ae1010e6efd$var$EVENT_KEY$b = `.${$922d1ae1010e6efd$var$DATA_KEY$a}`;
const $922d1ae1010e6efd$var$EVENT_CLOSE = `close${$922d1ae1010e6efd$var$EVENT_KEY$b}`;
const $922d1ae1010e6efd$var$EVENT_CLOSED = `closed${$922d1ae1010e6efd$var$EVENT_KEY$b}`;
const $922d1ae1010e6efd$var$CLASS_NAME_FADE$5 = "fade";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$caec2af78bcc877f extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$enableDismissTrigger($922d1ae1010e6efd$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$e = "button";
const $922d1ae1010e6efd$var$DATA_KEY$9 = "bs.button";
const $922d1ae1010e6efd$var$EVENT_KEY$a = `.${$922d1ae1010e6efd$var$DATA_KEY$9}`;
const $922d1ae1010e6efd$var$DATA_API_KEY$6 = ".data-api";
const $922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$3 = "active";
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$6 = `click${$922d1ae1010e6efd$var$EVENT_KEY$a}${$922d1ae1010e6efd$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$353f5b6fc5456de1 extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$6, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$5);
    const data = $922d1ae1010e6efd$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$d = "swipe";
const $922d1ae1010e6efd$var$EVENT_KEY$9 = ".bs.swipe";
const $922d1ae1010e6efd$var$EVENT_TOUCHSTART = `touchstart${$922d1ae1010e6efd$var$EVENT_KEY$9}`;
const $922d1ae1010e6efd$var$EVENT_TOUCHMOVE = `touchmove${$922d1ae1010e6efd$var$EVENT_KEY$9}`;
const $922d1ae1010e6efd$var$EVENT_TOUCHEND = `touchend${$922d1ae1010e6efd$var$EVENT_KEY$9}`;
const $922d1ae1010e6efd$var$EVENT_POINTERDOWN = `pointerdown${$922d1ae1010e6efd$var$EVENT_KEY$9}`;
const $922d1ae1010e6efd$var$EVENT_POINTERUP = `pointerup${$922d1ae1010e6efd$var$EVENT_KEY$9}`;
const $922d1ae1010e6efd$var$POINTER_TYPE_TOUCH = "touch";
const $922d1ae1010e6efd$var$POINTER_TYPE_PEN = "pen";
const $922d1ae1010e6efd$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $922d1ae1010e6efd$var$SWIPE_THRESHOLD = 40;
const $922d1ae1010e6efd$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $922d1ae1010e6efd$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$var$Swipe extends $922d1ae1010e6efd$var$Config {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$c;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$c;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$d;
    }
    // Public
    dispose() {
        $922d1ae1010e6efd$var$EventHandler.off(this._element, $922d1ae1010e6efd$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $922d1ae1010e6efd$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $922d1ae1010e6efd$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $922d1ae1010e6efd$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $922d1ae1010e6efd$var$POINTER_TYPE_PEN || event.pointerType === $922d1ae1010e6efd$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$922d1ae1010e6efd$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$c = "carousel";
const $922d1ae1010e6efd$var$DATA_KEY$8 = "bs.carousel";
const $922d1ae1010e6efd$var$EVENT_KEY$8 = `.${$922d1ae1010e6efd$var$DATA_KEY$8}`;
const $922d1ae1010e6efd$var$DATA_API_KEY$5 = ".data-api";
const $922d1ae1010e6efd$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $922d1ae1010e6efd$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $922d1ae1010e6efd$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $922d1ae1010e6efd$var$ORDER_NEXT = "next";
const $922d1ae1010e6efd$var$ORDER_PREV = "prev";
const $922d1ae1010e6efd$var$DIRECTION_LEFT = "left";
const $922d1ae1010e6efd$var$DIRECTION_RIGHT = "right";
const $922d1ae1010e6efd$var$EVENT_SLIDE = `slide${$922d1ae1010e6efd$var$EVENT_KEY$8}`;
const $922d1ae1010e6efd$var$EVENT_SLID = `slid${$922d1ae1010e6efd$var$EVENT_KEY$8}`;
const $922d1ae1010e6efd$var$EVENT_KEYDOWN$1 = `keydown${$922d1ae1010e6efd$var$EVENT_KEY$8}`;
const $922d1ae1010e6efd$var$EVENT_MOUSEENTER$1 = `mouseenter${$922d1ae1010e6efd$var$EVENT_KEY$8}`;
const $922d1ae1010e6efd$var$EVENT_MOUSELEAVE$1 = `mouseleave${$922d1ae1010e6efd$var$EVENT_KEY$8}`;
const $922d1ae1010e6efd$var$EVENT_DRAG_START = `dragstart${$922d1ae1010e6efd$var$EVENT_KEY$8}`;
const $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API$3 = `load${$922d1ae1010e6efd$var$EVENT_KEY$8}${$922d1ae1010e6efd$var$DATA_API_KEY$5}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$5 = `click${$922d1ae1010e6efd$var$EVENT_KEY$8}${$922d1ae1010e6efd$var$DATA_API_KEY$5}`;
const $922d1ae1010e6efd$var$CLASS_NAME_CAROUSEL = "carousel";
const $922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$2 = "active";
const $922d1ae1010e6efd$var$CLASS_NAME_SLIDE = "slide";
const $922d1ae1010e6efd$var$CLASS_NAME_END = "carousel-item-end";
const $922d1ae1010e6efd$var$CLASS_NAME_START = "carousel-item-start";
const $922d1ae1010e6efd$var$CLASS_NAME_NEXT = "carousel-item-next";
const $922d1ae1010e6efd$var$CLASS_NAME_PREV = "carousel-item-prev";
const $922d1ae1010e6efd$var$SELECTOR_ACTIVE = ".active";
const $922d1ae1010e6efd$var$SELECTOR_ITEM = ".carousel-item";
const $922d1ae1010e6efd$var$SELECTOR_ACTIVE_ITEM = $922d1ae1010e6efd$var$SELECTOR_ACTIVE + $922d1ae1010e6efd$var$SELECTOR_ITEM;
const $922d1ae1010e6efd$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $922d1ae1010e6efd$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $922d1ae1010e6efd$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $922d1ae1010e6efd$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $922d1ae1010e6efd$var$KEY_TO_DIRECTION = {
    [$922d1ae1010e6efd$var$ARROW_LEFT_KEY$1]: $922d1ae1010e6efd$var$DIRECTION_RIGHT,
    [$922d1ae1010e6efd$var$ARROW_RIGHT_KEY$1]: $922d1ae1010e6efd$var$DIRECTION_LEFT
};
const $922d1ae1010e6efd$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $922d1ae1010e6efd$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$144901db2ea8e967 extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$b;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$b;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$c;
    }
    // Public
    next() {
        this._slide($922d1ae1010e6efd$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $922d1ae1010e6efd$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($922d1ae1010e6efd$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $922d1ae1010e6efd$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $922d1ae1010e6efd$var$EventHandler.one(this._element, $922d1ae1010e6efd$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $922d1ae1010e6efd$var$EventHandler.one(this._element, $922d1ae1010e6efd$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $922d1ae1010e6efd$var$ORDER_NEXT : $922d1ae1010e6efd$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $922d1ae1010e6efd$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_ITEM_IMG, this._element))$922d1ae1010e6efd$var$EventHandler.on(img, $922d1ae1010e6efd$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $922d1ae1010e6efd$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($922d1ae1010e6efd$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($922d1ae1010e6efd$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $922d1ae1010e6efd$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $922d1ae1010e6efd$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $922d1ae1010e6efd$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $922d1ae1010e6efd$var$ORDER_NEXT;
        const nextElement = element || $922d1ae1010e6efd$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $922d1ae1010e6efd$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($922d1ae1010e6efd$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $922d1ae1010e6efd$var$CLASS_NAME_START : $922d1ae1010e6efd$var$CLASS_NAME_END;
        const orderClassName = isNext ? $922d1ae1010e6efd$var$CLASS_NAME_NEXT : $922d1ae1010e6efd$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $922d1ae1010e6efd$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($922d1ae1010e6efd$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($922d1ae1010e6efd$var$isRTL()) return direction === $922d1ae1010e6efd$var$DIRECTION_LEFT ? $922d1ae1010e6efd$var$ORDER_PREV : $922d1ae1010e6efd$var$ORDER_NEXT;
        return direction === $922d1ae1010e6efd$var$DIRECTION_LEFT ? $922d1ae1010e6efd$var$ORDER_NEXT : $922d1ae1010e6efd$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($922d1ae1010e6efd$var$isRTL()) return order === $922d1ae1010e6efd$var$ORDER_PREV ? $922d1ae1010e6efd$var$DIRECTION_LEFT : $922d1ae1010e6efd$var$DIRECTION_RIGHT;
        return order === $922d1ae1010e6efd$var$ORDER_PREV ? $922d1ae1010e6efd$var$DIRECTION_RIGHT : $922d1ae1010e6efd$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $922d1ae1010e6efd$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$5, $922d1ae1010e6efd$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $922d1ae1010e6efd$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($922d1ae1010e6efd$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$922d1ae1010e6efd$var$EventHandler.on(window, $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$922d1ae1010e6efd$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$b = "collapse";
const $922d1ae1010e6efd$var$DATA_KEY$7 = "bs.collapse";
const $922d1ae1010e6efd$var$EVENT_KEY$7 = `.${$922d1ae1010e6efd$var$DATA_KEY$7}`;
const $922d1ae1010e6efd$var$DATA_API_KEY$4 = ".data-api";
const $922d1ae1010e6efd$var$EVENT_SHOW$6 = `show${$922d1ae1010e6efd$var$EVENT_KEY$7}`;
const $922d1ae1010e6efd$var$EVENT_SHOWN$6 = `shown${$922d1ae1010e6efd$var$EVENT_KEY$7}`;
const $922d1ae1010e6efd$var$EVENT_HIDE$6 = `hide${$922d1ae1010e6efd$var$EVENT_KEY$7}`;
const $922d1ae1010e6efd$var$EVENT_HIDDEN$6 = `hidden${$922d1ae1010e6efd$var$EVENT_KEY$7}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$4 = `click${$922d1ae1010e6efd$var$EVENT_KEY$7}${$922d1ae1010e6efd$var$DATA_API_KEY$4}`;
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$7 = "show";
const $922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE = "collapse";
const $922d1ae1010e6efd$var$CLASS_NAME_COLLAPSING = "collapsing";
const $922d1ae1010e6efd$var$CLASS_NAME_COLLAPSED = "collapsed";
const $922d1ae1010e6efd$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE} .${$922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE}`;
const $922d1ae1010e6efd$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $922d1ae1010e6efd$var$WIDTH = "width";
const $922d1ae1010e6efd$var$HEIGHT = "height";
const $922d1ae1010e6efd$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $922d1ae1010e6efd$var$Default$a = {
    parent: null,
    toggle: true
};
const $922d1ae1010e6efd$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$78768a9af065a7b extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$a;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$a;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($922d1ae1010e6efd$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$922d1ae1010e6efd$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE, $922d1ae1010e6efd$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $922d1ae1010e6efd$var$reflow(this._element);
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE, $922d1ae1010e6efd$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSE);
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $922d1ae1010e6efd$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_HORIZONTAL) ? $922d1ae1010e6efd$var$WIDTH : $922d1ae1010e6efd$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $922d1ae1010e6efd$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($922d1ae1010e6efd$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $922d1ae1010e6efd$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $922d1ae1010e6efd$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$4, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $922d1ae1010e6efd$var$SelectorEngine.getMultipleElementsFromSelector(this))$922d1ae1010e6efd$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$a = "dropdown";
const $922d1ae1010e6efd$var$DATA_KEY$6 = "bs.dropdown";
const $922d1ae1010e6efd$var$EVENT_KEY$6 = `.${$922d1ae1010e6efd$var$DATA_KEY$6}`;
const $922d1ae1010e6efd$var$DATA_API_KEY$3 = ".data-api";
const $922d1ae1010e6efd$var$ESCAPE_KEY$2 = "Escape";
const $922d1ae1010e6efd$var$TAB_KEY$1 = "Tab";
const $922d1ae1010e6efd$var$ARROW_UP_KEY$1 = "ArrowUp";
const $922d1ae1010e6efd$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $922d1ae1010e6efd$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $922d1ae1010e6efd$var$EVENT_HIDE$5 = `hide${$922d1ae1010e6efd$var$EVENT_KEY$6}`;
const $922d1ae1010e6efd$var$EVENT_HIDDEN$5 = `hidden${$922d1ae1010e6efd$var$EVENT_KEY$6}`;
const $922d1ae1010e6efd$var$EVENT_SHOW$5 = `show${$922d1ae1010e6efd$var$EVENT_KEY$6}`;
const $922d1ae1010e6efd$var$EVENT_SHOWN$5 = `shown${$922d1ae1010e6efd$var$EVENT_KEY$6}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$3 = `click${$922d1ae1010e6efd$var$EVENT_KEY$6}${$922d1ae1010e6efd$var$DATA_API_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_KEYDOWN_DATA_API = `keydown${$922d1ae1010e6efd$var$EVENT_KEY$6}${$922d1ae1010e6efd$var$DATA_API_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_KEYUP_DATA_API = `keyup${$922d1ae1010e6efd$var$EVENT_KEY$6}${$922d1ae1010e6efd$var$DATA_API_KEY$3}`;
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$6 = "show";
const $922d1ae1010e6efd$var$CLASS_NAME_DROPUP = "dropup";
const $922d1ae1010e6efd$var$CLASS_NAME_DROPEND = "dropend";
const $922d1ae1010e6efd$var$CLASS_NAME_DROPSTART = "dropstart";
const $922d1ae1010e6efd$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $922d1ae1010e6efd$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3}.${$922d1ae1010e6efd$var$CLASS_NAME_SHOW$6}`;
const $922d1ae1010e6efd$var$SELECTOR_MENU = ".dropdown-menu";
const $922d1ae1010e6efd$var$SELECTOR_NAVBAR = ".navbar";
const $922d1ae1010e6efd$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $922d1ae1010e6efd$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $922d1ae1010e6efd$var$PLACEMENT_TOP = $922d1ae1010e6efd$var$isRTL() ? "top-end" : "top-start";
const $922d1ae1010e6efd$var$PLACEMENT_TOPEND = $922d1ae1010e6efd$var$isRTL() ? "top-start" : "top-end";
const $922d1ae1010e6efd$var$PLACEMENT_BOTTOM = $922d1ae1010e6efd$var$isRTL() ? "bottom-end" : "bottom-start";
const $922d1ae1010e6efd$var$PLACEMENT_BOTTOMEND = $922d1ae1010e6efd$var$isRTL() ? "bottom-start" : "bottom-end";
const $922d1ae1010e6efd$var$PLACEMENT_RIGHT = $922d1ae1010e6efd$var$isRTL() ? "left-start" : "right-start";
const $922d1ae1010e6efd$var$PLACEMENT_LEFT = $922d1ae1010e6efd$var$isRTL() ? "right-start" : "left-start";
const $922d1ae1010e6efd$var$PLACEMENT_TOPCENTER = "top";
const $922d1ae1010e6efd$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $922d1ae1010e6efd$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $922d1ae1010e6efd$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$931cbfb6bfb85fc extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$9;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$9;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($922d1ae1010e6efd$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($922d1ae1010e6efd$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$922d1ae1010e6efd$var$EventHandler.on(element, "mouseover", $922d1ae1010e6efd$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$6);
        $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($922d1ae1010e6efd$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$922d1ae1010e6efd$var$EventHandler.off(element, "mouseover", $922d1ae1010e6efd$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $922d1ae1010e6efd$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$922d1ae1010e6efd$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$922d1ae1010e6efd$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $0df88669b608f125$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($922d1ae1010e6efd$var$isElement(this._config.reference)) referenceElement = $922d1ae1010e6efd$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $0df88669b608f125$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_DROPEND)) return $922d1ae1010e6efd$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_DROPSTART)) return $922d1ae1010e6efd$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_DROPUP_CENTER)) return $922d1ae1010e6efd$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_DROPDOWN_CENTER)) return $922d1ae1010e6efd$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_DROPUP)) return isEnd ? $922d1ae1010e6efd$var$PLACEMENT_TOPEND : $922d1ae1010e6efd$var$PLACEMENT_TOP;
        return isEnd ? $922d1ae1010e6efd$var$PLACEMENT_BOTTOMEND : $922d1ae1010e6efd$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($922d1ae1010e6efd$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $922d1ae1010e6efd$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$922d1ae1010e6efd$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$922d1ae1010e6efd$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $922d1ae1010e6efd$var$getNextActiveElement(items, target, key === $922d1ae1010e6efd$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $922d1ae1010e6efd$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $922d1ae1010e6efd$var$TAB_KEY$1) return;
        const openToggles = $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $922d1ae1010e6efd$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $922d1ae1010e6efd$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $922d1ae1010e6efd$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $922d1ae1010e6efd$var$ARROW_UP_KEY$1,
            $922d1ae1010e6efd$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3) ? this : $922d1ae1010e6efd$var$SelectorEngine.prev(this, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3)[0] || $922d1ae1010e6efd$var$SelectorEngine.next(this, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3)[0] || $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $922d1ae1010e6efd$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $922d1ae1010e6efd$var$SelectorEngine.next(this._element, $922d1ae1010e6efd$var$SELECTOR_MENU)[0] || $922d1ae1010e6efd$var$SelectorEngine.prev(this._element, $922d1ae1010e6efd$var$SELECTOR_MENU)[0] || $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_KEYDOWN_DATA_API, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3, $922d1ae1010e6efd$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_KEYDOWN_DATA_API, $922d1ae1010e6efd$var$SELECTOR_MENU, $922d1ae1010e6efd$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$3, $922d1ae1010e6efd$export$931cbfb6bfb85fc.clearMenus);
$922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_KEYUP_DATA_API, $922d1ae1010e6efd$export$931cbfb6bfb85fc.clearMenus);
$922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$3, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $922d1ae1010e6efd$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$9 = "backdrop";
const $922d1ae1010e6efd$var$CLASS_NAME_FADE$4 = "fade";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$5 = "show";
const $922d1ae1010e6efd$var$EVENT_MOUSEDOWN = `mousedown.bs.${$922d1ae1010e6efd$var$NAME$9}`;
const $922d1ae1010e6efd$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $922d1ae1010e6efd$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$var$Backdrop extends $922d1ae1010e6efd$var$Config {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$8;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$8;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $922d1ae1010e6efd$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $922d1ae1010e6efd$var$reflow(element);
        element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $922d1ae1010e6efd$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $922d1ae1010e6efd$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $922d1ae1010e6efd$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $922d1ae1010e6efd$var$EventHandler.off(this._element, $922d1ae1010e6efd$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($922d1ae1010e6efd$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $922d1ae1010e6efd$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $922d1ae1010e6efd$var$EventHandler.on(element, $922d1ae1010e6efd$var$EVENT_MOUSEDOWN, ()=>{
            $922d1ae1010e6efd$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $922d1ae1010e6efd$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$8 = "focustrap";
const $922d1ae1010e6efd$var$DATA_KEY$5 = "bs.focustrap";
const $922d1ae1010e6efd$var$EVENT_KEY$5 = `.${$922d1ae1010e6efd$var$DATA_KEY$5}`;
const $922d1ae1010e6efd$var$EVENT_FOCUSIN$2 = `focusin${$922d1ae1010e6efd$var$EVENT_KEY$5}`;
const $922d1ae1010e6efd$var$EVENT_KEYDOWN_TAB = `keydown.tab${$922d1ae1010e6efd$var$EVENT_KEY$5}`;
const $922d1ae1010e6efd$var$TAB_KEY = "Tab";
const $922d1ae1010e6efd$var$TAB_NAV_FORWARD = "forward";
const $922d1ae1010e6efd$var$TAB_NAV_BACKWARD = "backward";
const $922d1ae1010e6efd$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $922d1ae1010e6efd$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$var$FocusTrap extends $922d1ae1010e6efd$var$Config {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$7;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$7;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $922d1ae1010e6efd$var$EventHandler.off(document, $922d1ae1010e6efd$var$EVENT_KEY$5); // guard against infinite focus loop
        $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $922d1ae1010e6efd$var$EventHandler.off(document, $922d1ae1010e6efd$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $922d1ae1010e6efd$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $922d1ae1010e6efd$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $922d1ae1010e6efd$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $922d1ae1010e6efd$var$TAB_NAV_BACKWARD : $922d1ae1010e6efd$var$TAB_NAV_FORWARD;
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $922d1ae1010e6efd$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $922d1ae1010e6efd$var$PROPERTY_PADDING = "padding-right";
const $922d1ae1010e6efd$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $922d1ae1010e6efd$var$ScrollBarHelper {
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $922d1ae1010e6efd$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($922d1ae1010e6efd$var$SELECTOR_FIXED_CONTENT, $922d1ae1010e6efd$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($922d1ae1010e6efd$var$SELECTOR_STICKY_CONTENT, $922d1ae1010e6efd$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $922d1ae1010e6efd$var$PROPERTY_PADDING);
        this._resetElementAttributes($922d1ae1010e6efd$var$SELECTOR_FIXED_CONTENT, $922d1ae1010e6efd$var$PROPERTY_PADDING);
        this._resetElementAttributes($922d1ae1010e6efd$var$SELECTOR_STICKY_CONTENT, $922d1ae1010e6efd$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $922d1ae1010e6efd$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $922d1ae1010e6efd$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $922d1ae1010e6efd$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($922d1ae1010e6efd$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $922d1ae1010e6efd$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
    constructor(){
        this._element = document.body;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$7 = "modal";
const $922d1ae1010e6efd$var$DATA_KEY$4 = "bs.modal";
const $922d1ae1010e6efd$var$EVENT_KEY$4 = `.${$922d1ae1010e6efd$var$DATA_KEY$4}`;
const $922d1ae1010e6efd$var$DATA_API_KEY$2 = ".data-api";
const $922d1ae1010e6efd$var$ESCAPE_KEY$1 = "Escape";
const $922d1ae1010e6efd$var$EVENT_HIDE$4 = `hide${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_HIDDEN$4 = `hidden${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_SHOW$4 = `show${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_SHOWN$4 = `shown${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_RESIZE$1 = `resize${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DISMISS = `click.dismiss${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$922d1ae1010e6efd$var$EVENT_KEY$4}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$2 = `click${$922d1ae1010e6efd$var$EVENT_KEY$4}${$922d1ae1010e6efd$var$DATA_API_KEY$2}`;
const $922d1ae1010e6efd$var$CLASS_NAME_OPEN = "modal-open";
const $922d1ae1010e6efd$var$CLASS_NAME_FADE$3 = "fade";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$4 = "show";
const $922d1ae1010e6efd$var$CLASS_NAME_STATIC = "modal-static";
const $922d1ae1010e6efd$var$OPEN_SELECTOR$1 = ".modal.show";
const $922d1ae1010e6efd$var$SELECTOR_DIALOG = ".modal-dialog";
const $922d1ae1010e6efd$var$SELECTOR_MODAL_BODY = ".modal-body";
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $922d1ae1010e6efd$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $922d1ae1010e6efd$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$2b77a92f1a5ad772 extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$6;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$6;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($922d1ae1010e6efd$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $922d1ae1010e6efd$var$EventHandler.off(window, $922d1ae1010e6efd$var$EVENT_KEY$4);
        $922d1ae1010e6efd$var$EventHandler.off(this._dialog, $922d1ae1010e6efd$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $922d1ae1010e6efd$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $922d1ae1010e6efd$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $922d1ae1010e6efd$var$reflow(this._element);
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $922d1ae1010e6efd$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $922d1ae1010e6efd$var$EventHandler.on(window, $922d1ae1010e6efd$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $922d1ae1010e6efd$var$EventHandler.one(this._element, $922d1ae1010e6efd$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $922d1ae1010e6efd$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $922d1ae1010e6efd$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
    constructor(element, config){
        super(element, config);
        this._dialog = $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $922d1ae1010e6efd$var$ScrollBarHelper();
        this._addEventListeners();
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$2, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $922d1ae1010e6efd$var$EventHandler.one(target, $922d1ae1010e6efd$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $922d1ae1010e6efd$var$EventHandler.one(target, $922d1ae1010e6efd$var$EVENT_HIDDEN$4, ()=>{
            if ($922d1ae1010e6efd$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $922d1ae1010e6efd$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $922d1ae1010e6efd$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$922d1ae1010e6efd$var$enableDismissTrigger($922d1ae1010e6efd$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$6 = "offcanvas";
const $922d1ae1010e6efd$var$DATA_KEY$3 = "bs.offcanvas";
const $922d1ae1010e6efd$var$EVENT_KEY$3 = `.${$922d1ae1010e6efd$var$DATA_KEY$3}`;
const $922d1ae1010e6efd$var$DATA_API_KEY$1 = ".data-api";
const $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API$2 = `load${$922d1ae1010e6efd$var$EVENT_KEY$3}${$922d1ae1010e6efd$var$DATA_API_KEY$1}`;
const $922d1ae1010e6efd$var$ESCAPE_KEY = "Escape";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$3 = "show";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOWING$1 = "showing";
const $922d1ae1010e6efd$var$CLASS_NAME_HIDING = "hiding";
const $922d1ae1010e6efd$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $922d1ae1010e6efd$var$OPEN_SELECTOR = ".offcanvas.show";
const $922d1ae1010e6efd$var$EVENT_SHOW$3 = `show${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_SHOWN$3 = `shown${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_HIDE$3 = `hide${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_HIDE_PREVENTED = `hidePrevented${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_HIDDEN$3 = `hidden${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_RESIZE = `resize${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$1 = `click${$922d1ae1010e6efd$var$EVENT_KEY$3}${$922d1ae1010e6efd$var$DATA_API_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$922d1ae1010e6efd$var$EVENT_KEY$3}`;
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $922d1ae1010e6efd$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $922d1ae1010e6efd$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$591ca0244c9dfcd4 extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$5;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$5;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $922d1ae1010e6efd$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOWING$1);
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$3, $922d1ae1010e6efd$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $922d1ae1010e6efd$var$ScrollBarHelper().reset();
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $922d1ae1010e6efd$var$Backdrop({
            className: $922d1ae1010e6efd$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $922d1ae1010e6efd$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $922d1ae1010e6efd$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API$1, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($922d1ae1010e6efd$var$isDisabled(this)) return;
    $922d1ae1010e6efd$var$EventHandler.one(target, $922d1ae1010e6efd$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($922d1ae1010e6efd$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $922d1ae1010e6efd$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $922d1ae1010e6efd$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$922d1ae1010e6efd$var$EventHandler.on(window, $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$OPEN_SELECTOR))$922d1ae1010e6efd$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$922d1ae1010e6efd$var$EventHandler.on(window, $922d1ae1010e6efd$var$EVENT_RESIZE, ()=>{
    for (const element of $922d1ae1010e6efd$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $922d1ae1010e6efd$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$922d1ae1010e6efd$var$enableDismissTrigger($922d1ae1010e6efd$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $922d1ae1010e6efd$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $922d1ae1010e6efd$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $922d1ae1010e6efd$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $922d1ae1010e6efd$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $922d1ae1010e6efd$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $922d1ae1010e6efd$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($922d1ae1010e6efd$var$uriAttributes.has(attributeName)) return Boolean($922d1ae1010e6efd$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $922d1ae1010e6efd$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$922d1ae1010e6efd$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$5 = "TemplateFactory";
const $922d1ae1010e6efd$var$Default$4 = {
    allowList: $922d1ae1010e6efd$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $922d1ae1010e6efd$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $922d1ae1010e6efd$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$var$TemplateFactory extends $922d1ae1010e6efd$var$Config {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$4;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$4;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $922d1ae1010e6efd$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $922d1ae1010e6efd$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($922d1ae1010e6efd$var$isElement(content)) {
            this._putElementInTemplate($922d1ae1010e6efd$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $922d1ae1010e6efd$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $922d1ae1010e6efd$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$4 = "tooltip";
const $922d1ae1010e6efd$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $922d1ae1010e6efd$var$CLASS_NAME_FADE$2 = "fade";
const $922d1ae1010e6efd$var$CLASS_NAME_MODAL = "modal";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$2 = "show";
const $922d1ae1010e6efd$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $922d1ae1010e6efd$var$SELECTOR_MODAL = `.${$922d1ae1010e6efd$var$CLASS_NAME_MODAL}`;
const $922d1ae1010e6efd$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $922d1ae1010e6efd$var$TRIGGER_HOVER = "hover";
const $922d1ae1010e6efd$var$TRIGGER_FOCUS = "focus";
const $922d1ae1010e6efd$var$TRIGGER_CLICK = "click";
const $922d1ae1010e6efd$var$TRIGGER_MANUAL = "manual";
const $922d1ae1010e6efd$var$EVENT_HIDE$2 = "hide";
const $922d1ae1010e6efd$var$EVENT_HIDDEN$2 = "hidden";
const $922d1ae1010e6efd$var$EVENT_SHOW$2 = "show";
const $922d1ae1010e6efd$var$EVENT_SHOWN$2 = "shown";
const $922d1ae1010e6efd$var$EVENT_INSERTED = "inserted";
const $922d1ae1010e6efd$var$EVENT_CLICK$1 = "click";
const $922d1ae1010e6efd$var$EVENT_FOCUSIN$1 = "focusin";
const $922d1ae1010e6efd$var$EVENT_FOCUSOUT$1 = "focusout";
const $922d1ae1010e6efd$var$EVENT_MOUSEENTER = "mouseenter";
const $922d1ae1010e6efd$var$EVENT_MOUSELEAVE = "mouseleave";
const $922d1ae1010e6efd$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $922d1ae1010e6efd$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $922d1ae1010e6efd$var$isRTL() ? "right" : "left"
};
const $922d1ae1010e6efd$var$Default$3 = {
    allowList: $922d1ae1010e6efd$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $922d1ae1010e6efd$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$28c660c63b792dea extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$3;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$3;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $922d1ae1010e6efd$var$EventHandler.off(this._element.closest($922d1ae1010e6efd$var$SELECTOR_MODAL), $922d1ae1010e6efd$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, this.constructor.eventName($922d1ae1010e6efd$var$EVENT_SHOW$2));
        const shadowRoot = $922d1ae1010e6efd$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, this.constructor.eventName($922d1ae1010e6efd$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$922d1ae1010e6efd$var$EventHandler.on(element, "mouseover", $922d1ae1010e6efd$var$noop);
        const complete = ()=>{
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, this.constructor.eventName($922d1ae1010e6efd$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, this.constructor.eventName($922d1ae1010e6efd$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$922d1ae1010e6efd$var$EventHandler.off(element, "mouseover", $922d1ae1010e6efd$var$noop);
        this._activeTrigger[$922d1ae1010e6efd$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$922d1ae1010e6efd$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$922d1ae1010e6efd$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, this.constructor.eventName($922d1ae1010e6efd$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_FADE$2, $922d1ae1010e6efd$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $922d1ae1010e6efd$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($922d1ae1010e6efd$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $922d1ae1010e6efd$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$922d1ae1010e6efd$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $922d1ae1010e6efd$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $922d1ae1010e6efd$var$AttachmentMap[placement.toUpperCase()];
        return $0df88669b608f125$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $922d1ae1010e6efd$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$922d1ae1010e6efd$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $922d1ae1010e6efd$var$EventHandler.on(this._element, this.constructor.eventName($922d1ae1010e6efd$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $922d1ae1010e6efd$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $922d1ae1010e6efd$var$TRIGGER_HOVER ? this.constructor.eventName($922d1ae1010e6efd$var$EVENT_MOUSEENTER) : this.constructor.eventName($922d1ae1010e6efd$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $922d1ae1010e6efd$var$TRIGGER_HOVER ? this.constructor.eventName($922d1ae1010e6efd$var$EVENT_MOUSELEAVE) : this.constructor.eventName($922d1ae1010e6efd$var$EVENT_FOCUSOUT$1);
                $922d1ae1010e6efd$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $922d1ae1010e6efd$var$TRIGGER_FOCUS : $922d1ae1010e6efd$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $922d1ae1010e6efd$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $922d1ae1010e6efd$var$TRIGGER_FOCUS : $922d1ae1010e6efd$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $922d1ae1010e6efd$var$EventHandler.on(this._element.closest($922d1ae1010e6efd$var$SELECTOR_MODAL), $922d1ae1010e6efd$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $922d1ae1010e6efd$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($922d1ae1010e6efd$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $922d1ae1010e6efd$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element, config){
        if (typeof $0df88669b608f125$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
}
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$3 = "popover";
const $922d1ae1010e6efd$var$SELECTOR_TITLE = ".popover-header";
const $922d1ae1010e6efd$var$SELECTOR_CONTENT = ".popover-body";
const $922d1ae1010e6efd$var$Default$2 = {
    ...$922d1ae1010e6efd$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $922d1ae1010e6efd$var$DefaultType$2 = {
    ...$922d1ae1010e6efd$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$5b6b19405a83ff9d extends $922d1ae1010e6efd$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$2;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$2;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$922d1ae1010e6efd$var$SELECTOR_TITLE]: this._getTitle(),
            [$922d1ae1010e6efd$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$2 = "scrollspy";
const $922d1ae1010e6efd$var$DATA_KEY$2 = "bs.scrollspy";
const $922d1ae1010e6efd$var$EVENT_KEY$2 = `.${$922d1ae1010e6efd$var$DATA_KEY$2}`;
const $922d1ae1010e6efd$var$DATA_API_KEY = ".data-api";
const $922d1ae1010e6efd$var$EVENT_ACTIVATE = `activate${$922d1ae1010e6efd$var$EVENT_KEY$2}`;
const $922d1ae1010e6efd$var$EVENT_CLICK = `click${$922d1ae1010e6efd$var$EVENT_KEY$2}`;
const $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API$1 = `load${$922d1ae1010e6efd$var$EVENT_KEY$2}${$922d1ae1010e6efd$var$DATA_API_KEY}`;
const $922d1ae1010e6efd$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1 = "active";
const $922d1ae1010e6efd$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $922d1ae1010e6efd$var$SELECTOR_TARGET_LINKS = "[href]";
const $922d1ae1010e6efd$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $922d1ae1010e6efd$var$SELECTOR_NAV_LINKS = ".nav-link";
const $922d1ae1010e6efd$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $922d1ae1010e6efd$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $922d1ae1010e6efd$var$SELECTOR_LINK_ITEMS = `${$922d1ae1010e6efd$var$SELECTOR_NAV_LINKS}, ${$922d1ae1010e6efd$var$SELECTOR_NAV_ITEMS} > ${$922d1ae1010e6efd$var$SELECTOR_NAV_LINKS}, ${$922d1ae1010e6efd$var$SELECTOR_LIST_ITEMS}`;
const $922d1ae1010e6efd$var$SELECTOR_DROPDOWN = ".dropdown";
const $922d1ae1010e6efd$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $922d1ae1010e6efd$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $922d1ae1010e6efd$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$a6472a5298a374be extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default$1;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType$1;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $922d1ae1010e6efd$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $922d1ae1010e6efd$var$EventHandler.off(this._config.target, $922d1ae1010e6efd$var$EVENT_CLICK);
        $922d1ae1010e6efd$var$EventHandler.on(this._config.target, $922d1ae1010e6efd$var$EVENT_CLICK, $922d1ae1010e6efd$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $922d1ae1010e6efd$var$isDisabled(anchor)) continue;
            const observableSection = $922d1ae1010e6efd$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($922d1ae1010e6efd$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($922d1ae1010e6efd$var$SELECTOR_DROPDOWN)).classList.add($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $922d1ae1010e6efd$var$SelectorEngine.parents(target, $922d1ae1010e6efd$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $922d1ae1010e6efd$var$SelectorEngine.prev(listGroup, $922d1ae1010e6efd$var$SELECTOR_LINK_ITEMS))item.classList.add($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $922d1ae1010e6efd$var$SelectorEngine.find(`${$922d1ae1010e6efd$var$SELECTOR_TARGET_LINKS}.${$922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(window, $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_DATA_SPY))$922d1ae1010e6efd$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME$1 = "tab";
const $922d1ae1010e6efd$var$DATA_KEY$1 = "bs.tab";
const $922d1ae1010e6efd$var$EVENT_KEY$1 = `.${$922d1ae1010e6efd$var$DATA_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_HIDE$1 = `hide${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_HIDDEN$1 = `hidden${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_SHOW$1 = `show${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_SHOWN$1 = `shown${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API = `click${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_KEYDOWN = `keydown${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API = `load${$922d1ae1010e6efd$var$EVENT_KEY$1}`;
const $922d1ae1010e6efd$var$ARROW_LEFT_KEY = "ArrowLeft";
const $922d1ae1010e6efd$var$ARROW_RIGHT_KEY = "ArrowRight";
const $922d1ae1010e6efd$var$ARROW_UP_KEY = "ArrowUp";
const $922d1ae1010e6efd$var$ARROW_DOWN_KEY = "ArrowDown";
const $922d1ae1010e6efd$var$HOME_KEY = "Home";
const $922d1ae1010e6efd$var$END_KEY = "End";
const $922d1ae1010e6efd$var$CLASS_NAME_ACTIVE = "active";
const $922d1ae1010e6efd$var$CLASS_NAME_FADE$1 = "fade";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW$1 = "show";
const $922d1ae1010e6efd$var$CLASS_DROPDOWN = "dropdown";
const $922d1ae1010e6efd$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $922d1ae1010e6efd$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $922d1ae1010e6efd$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$922d1ae1010e6efd$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $922d1ae1010e6efd$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $922d1ae1010e6efd$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $922d1ae1010e6efd$var$SELECTOR_INNER = `.nav-link${$922d1ae1010e6efd$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$922d1ae1010e6efd$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$922d1ae1010e6efd$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $922d1ae1010e6efd$var$SELECTOR_INNER_ELEM = `${$922d1ae1010e6efd$var$SELECTOR_INNER}, ${$922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE}`;
const $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$922d1ae1010e6efd$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$922d1ae1010e6efd$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$922d1ae1010e6efd$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$3e41faf802a29e71 extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $922d1ae1010e6efd$var$EventHandler.trigger(active, $922d1ae1010e6efd$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $922d1ae1010e6efd$var$EventHandler.trigger(innerElem, $922d1ae1010e6efd$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE);
        this._activate($922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $922d1ae1010e6efd$var$EventHandler.trigger(element, $922d1ae1010e6efd$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $922d1ae1010e6efd$var$EventHandler.trigger(element, $922d1ae1010e6efd$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $922d1ae1010e6efd$var$ARROW_LEFT_KEY,
            $922d1ae1010e6efd$var$ARROW_RIGHT_KEY,
            $922d1ae1010e6efd$var$ARROW_UP_KEY,
            $922d1ae1010e6efd$var$ARROW_DOWN_KEY,
            $922d1ae1010e6efd$var$HOME_KEY,
            $922d1ae1010e6efd$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$922d1ae1010e6efd$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $922d1ae1010e6efd$var$HOME_KEY,
            $922d1ae1010e6efd$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $922d1ae1010e6efd$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $922d1ae1010e6efd$var$ARROW_RIGHT_KEY,
                $922d1ae1010e6efd$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $922d1ae1010e6efd$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $922d1ae1010e6efd$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $922d1ae1010e6efd$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($922d1ae1010e6efd$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $922d1ae1010e6efd$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($922d1ae1010e6efd$var$SELECTOR_DROPDOWN_TOGGLE, $922d1ae1010e6efd$var$CLASS_NAME_ACTIVE);
        toggle($922d1ae1010e6efd$var$SELECTOR_DROPDOWN_MENU, $922d1ae1010e6efd$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($922d1ae1010e6efd$var$SELECTOR_INNER_ELEM) ? elem : $922d1ae1010e6efd$var$SelectorEngine.findOne($922d1ae1010e6efd$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($922d1ae1010e6efd$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element){
        super(element);
        this._parent = this._element.closest($922d1ae1010e6efd$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$EventHandler.on(document, $922d1ae1010e6efd$var$EVENT_CLICK_DATA_API, $922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($922d1ae1010e6efd$var$isDisabled(this)) return;
    $922d1ae1010e6efd$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $922d1ae1010e6efd$var$EventHandler.on(window, $922d1ae1010e6efd$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $922d1ae1010e6efd$var$SelectorEngine.find($922d1ae1010e6efd$var$SELECTOR_DATA_TOGGLE_ACTIVE))$922d1ae1010e6efd$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $922d1ae1010e6efd$var$NAME = "toast";
const $922d1ae1010e6efd$var$DATA_KEY = "bs.toast";
const $922d1ae1010e6efd$var$EVENT_KEY = `.${$922d1ae1010e6efd$var$DATA_KEY}`;
const $922d1ae1010e6efd$var$EVENT_MOUSEOVER = `mouseover${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_MOUSEOUT = `mouseout${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_FOCUSIN = `focusin${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_FOCUSOUT = `focusout${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_HIDE = `hide${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_HIDDEN = `hidden${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_SHOW = `show${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$EVENT_SHOWN = `shown${$922d1ae1010e6efd$var$EVENT_KEY}`;
const $922d1ae1010e6efd$var$CLASS_NAME_FADE = "fade";
const $922d1ae1010e6efd$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $922d1ae1010e6efd$var$CLASS_NAME_SHOW = "show";
const $922d1ae1010e6efd$var$CLASS_NAME_SHOWING = "showing";
const $922d1ae1010e6efd$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $922d1ae1010e6efd$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $922d1ae1010e6efd$export$8d8dc7d5f743331b extends $922d1ae1010e6efd$var$BaseComponent {
    // Getters
    static get Default() {
        return $922d1ae1010e6efd$var$Default;
    }
    static get DefaultType() {
        return $922d1ae1010e6efd$var$DefaultType;
    }
    static get NAME() {
        return $922d1ae1010e6efd$var$NAME;
    }
    // Public
    show() {
        const showEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOWING);
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_HIDE); // @deprecated
        $922d1ae1010e6efd$var$reflow(this._element);
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOW, $922d1ae1010e6efd$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOWING, $922d1ae1010e6efd$var$CLASS_NAME_SHOW);
            $922d1ae1010e6efd$var$EventHandler.trigger(this._element, $922d1ae1010e6efd$var$EVENT_HIDDEN);
        };
        this._element.classList.add($922d1ae1010e6efd$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($922d1ae1010e6efd$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($922d1ae1010e6efd$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $922d1ae1010e6efd$var$EventHandler.on(this._element, $922d1ae1010e6efd$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $922d1ae1010e6efd$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
}
/**
 * Data API implementation
 */ $922d1ae1010e6efd$var$enableDismissTrigger($922d1ae1010e6efd$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $922d1ae1010e6efd$var$defineJQueryPlugin($922d1ae1010e6efd$export$8d8dc7d5f743331b);


var $9782e7c5651bfc5f$exports = {};
//
// Apex line chart
//
"use strict";
var $d4be73e5731103af$exports = {};
/*!
 * ApexCharts v3.42.0
 * (c) 2018-2023 ApexCharts
 * Released under the MIT License.
 */ "use strict";
function $d4be73e5731103af$var$t(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        e && (a = a.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, a);
    }
    return i;
}
function $d4be73e5731103af$var$e(e) {
    for(var i = 1; i < arguments.length; i++){
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d4be73e5731103af$var$t(Object(a), !0).forEach(function(t) {
            $d4be73e5731103af$var$o(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : $d4be73e5731103af$var$t(Object(a)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
    }
    return e;
}
function $d4be73e5731103af$var$i(t) {
    return $d4be73e5731103af$var$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $d4be73e5731103af$var$i(t);
}
function $d4be73e5731103af$var$a(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function $d4be73e5731103af$var$s(t, e) {
    for(var i = 0; i < e.length; i++){
        var a = e[i];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
}
function $d4be73e5731103af$var$r(t, e, i) {
    return e && $d4be73e5731103af$var$s(t.prototype, e), i && $d4be73e5731103af$var$s(t, i), t;
}
function $d4be73e5731103af$var$o(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function $d4be73e5731103af$var$n(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), e && $d4be73e5731103af$var$h(t, e);
}
function $d4be73e5731103af$var$l(t) {
    return $d4be73e5731103af$var$l = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d4be73e5731103af$var$l(t);
}
function $d4be73e5731103af$var$h(t, e) {
    return $d4be73e5731103af$var$h = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $d4be73e5731103af$var$h(t, e);
}
function $d4be73e5731103af$var$c(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return function(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }(t);
}
function $d4be73e5731103af$var$d(t) {
    var e = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }();
    return function() {
        var i, a = $d4be73e5731103af$var$l(t);
        if (e) {
            var s = $d4be73e5731103af$var$l(this).constructor;
            i = Reflect.construct(a, arguments, s);
        } else i = a.apply(this, arguments);
        return $d4be73e5731103af$var$c(this, i);
    };
}
function $d4be73e5731103af$var$g(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, e) {
        var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null == i) return;
        var a, s, r = [], o = !0, n = !1;
        try {
            for(i = i.call(t); !(o = (a = i.next()).done) && (r.push(a.value), !e || r.length !== e); o = !0);
        } catch (t) {
            n = !0, s = t;
        } finally{
            try {
                o || null == i.return || i.return();
            } finally{
                if (n) throw s;
            }
        }
        return r;
    }(t, e) || $d4be73e5731103af$var$p(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $d4be73e5731103af$var$u(t) {
    return function(t) {
        if (Array.isArray(t)) return $d4be73e5731103af$var$f(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || $d4be73e5731103af$var$p(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $d4be73e5731103af$var$p(t, e) {
    if (t) {
        if ("string" == typeof t) return $d4be73e5731103af$var$f(t, e);
        var i = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? $d4be73e5731103af$var$f(t, e) : void 0;
    }
}
function $d4be73e5731103af$var$f(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, a = new Array(e); i < e; i++)a[i] = t[i];
    return a;
}
var $d4be73e5731103af$var$x = function() {
    function t() {
        $d4be73e5731103af$var$a(this, t);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "shadeRGBColor",
            value: function(t, e) {
                var i = e.split(","), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = parseInt(i[0].slice(4), 10), o = parseInt(i[1], 10), n = parseInt(i[2], 10);
                return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - o) * s) + o) + "," + (Math.round((a - n) * s) + n) + ")";
            }
        },
        {
            key: "shadeHexColor",
            value: function(t, e) {
                var i = parseInt(e.slice(1), 16), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = i >> 16, o = i >> 8 & 255, n = 255 & i;
                return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - o) * s) + o) + (Math.round((a - n) * s) + n)).toString(16).slice(1);
            }
        },
        {
            key: "shadeColor",
            value: function(e, i) {
                return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i);
            }
        }
    ], [
        {
            key: "bind",
            value: function(t, e) {
                return function() {
                    return t.apply(e, arguments);
                };
            }
        },
        {
            key: "isObject",
            value: function(t) {
                return t && "object" === $d4be73e5731103af$var$i(t) && !Array.isArray(t) && null != t;
            }
        },
        {
            key: "is",
            value: function(t, e) {
                return Object.prototype.toString.call(e) === "[object " + t + "]";
            }
        },
        {
            key: "listToArray",
            value: function(t) {
                var e, i = [];
                for(e = 0; e < t.length; e++)i[e] = t[e];
                return i;
            }
        },
        {
            key: "extend",
            value: function(t, e) {
                var i = this;
                "function" != typeof Object.assign && (Object.assign = function(t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for(var e = Object(t), i = 1; i < arguments.length; i++){
                        var a = arguments[i];
                        if (null != a) for(var s in a)a.hasOwnProperty(s) && (e[s] = a[s]);
                    }
                    return e;
                });
                var a = Object.assign({}, t);
                return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach(function(s) {
                    i.isObject(e[s]) && s in t ? a[s] = i.extend(t[s], e[s]) : Object.assign(a, $d4be73e5731103af$var$o({}, s, e[s]));
                }), a;
            }
        },
        {
            key: "extendArray",
            value: function(e, i) {
                var a = [];
                return e.map(function(e) {
                    a.push(t.extend(i, e));
                }), e = a;
            }
        },
        {
            key: "monthMod",
            value: function(t) {
                return t % 12;
            }
        },
        {
            key: "clone",
            value: function(e) {
                if (t.is("Array", e)) {
                    for(var a = [], s = 0; s < e.length; s++)a[s] = this.clone(e[s]);
                    return a;
                }
                if (t.is("Null", e)) return null;
                if (t.is("Date", e)) return e;
                if ("object" === $d4be73e5731103af$var$i(e)) {
                    var r = {};
                    for(var o in e)e.hasOwnProperty(o) && (r[o] = this.clone(e[o]));
                    return r;
                }
                return e;
            }
        },
        {
            key: "log10",
            value: function(t) {
                return Math.log(t) / Math.LN10;
            }
        },
        {
            key: "roundToBase10",
            value: function(t) {
                return Math.pow(10, Math.floor(Math.log10(t)));
            }
        },
        {
            key: "roundToBase",
            value: function(t, e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)));
            }
        },
        {
            key: "parseNumber",
            value: function(t) {
                return null === t ? t : parseFloat(t);
            }
        },
        {
            key: "stripNumber",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
                return parseFloat(t.toPrecision(e));
            }
        },
        {
            key: "randomId",
            value: function() {
                return (Math.random() + 1).toString(36).substring(4);
            }
        },
        {
            key: "noExponents",
            value: function(t) {
                var e = String(t).split(/[eE]/);
                if (1 === e.length) return e[0];
                var i = "", a = t < 0 ? "-" : "", s = e[0].replace(".", ""), r = Number(e[1]) + 1;
                if (r < 0) {
                    for(i = a + "0."; r++;)i += "0";
                    return i + s.replace(/^-/, "");
                }
                for(r -= s.length; r--;)i += "0";
                return s + i;
            }
        },
        {
            key: "getDimensions",
            value: function(t) {
                var e = getComputedStyle(t, null), i = t.clientHeight, a = t.clientWidth;
                return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [
                    a -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                    i
                ];
            }
        },
        {
            key: "getBoundingClientRect",
            value: function(t) {
                var e = t.getBoundingClientRect();
                return {
                    top: e.top,
                    right: e.right,
                    bottom: e.bottom,
                    left: e.left,
                    width: t.clientWidth,
                    height: t.clientHeight,
                    x: e.left,
                    y: e.top
                };
            }
        },
        {
            key: "getLargestStringFromArr",
            value: function(t) {
                return t.reduce(function(t, e) {
                    return Array.isArray(e) && (e = e.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    })), t.length > e.length ? t : e;
                }, 0);
            }
        },
        {
            key: "hexToRgba",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                "#" !== t.substring(0, 1) && (t = "#999999");
                var i = t.replace("#", "");
                i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                for(var a = 0; a < i.length; a++)i[a] = parseInt(1 === i[a].length ? i[a] + i[a] : i[a], 16);
                return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")";
            }
        },
        {
            key: "getOpacityFromRGBA",
            value: function(t) {
                return parseFloat(t.replace(/^.*,(.+)\)/, "$1"));
            }
        },
        {
            key: "rgb2hex",
            value: function(t) {
                return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : "";
            }
        },
        {
            key: "isColorHex",
            value: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t);
            }
        },
        {
            key: "getPolygonPos",
            value: function(t, e) {
                for(var i = [], a = 2 * Math.PI / e, s = 0; s < e; s++){
                    var r = {};
                    r.x = t * Math.sin(s * a), r.y = -t * Math.cos(s * a), i.push(r);
                }
                return i;
            }
        },
        {
            key: "polarToCartesian",
            value: function(t, e, i, a) {
                var s = (a - 90) * Math.PI / 180;
                return {
                    x: t + i * Math.cos(s),
                    y: e + i * Math.sin(s)
                };
            }
        },
        {
            key: "escapeString",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x", i = t.toString().slice();
                return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, e);
            }
        },
        {
            key: "negToZero",
            value: function(t) {
                return t < 0 ? 0 : t;
            }
        },
        {
            key: "moveIndexInArray",
            value: function(t, e, i) {
                if (i >= t.length) for(var a = i - t.length + 1; a--;)t.push(void 0);
                return t.splice(i, 0, t.splice(e, 1)[0]), t;
            }
        },
        {
            key: "extractNumber",
            value: function(t) {
                return parseFloat(t.replace(/[^\d.]*/g, ""));
            }
        },
        {
            key: "findAncestor",
            value: function(t, e) {
                for(; (t = t.parentElement) && !t.classList.contains(e););
                return t;
            }
        },
        {
            key: "setELstyles",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && (t.style.key = e[i]);
            }
        },
        {
            key: "isNumber",
            value: function(t) {
                return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10));
            }
        },
        {
            key: "isFloat",
            value: function(t) {
                return Number(t) === t && t % 1 != 0;
            }
        },
        {
            key: "isSafari",
            value: function() {
                return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        {
            key: "isFirefox",
            value: function() {
                return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            }
        },
        {
            key: "isIE11",
            value: function() {
                if (-1 !== window.navigator.userAgent.indexOf("MSIE") || window.navigator.appVersion.indexOf("Trident/") > -1) return !0;
            }
        },
        {
            key: "isIE",
            value: function() {
                var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
                if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
                if (t.indexOf("Trident/") > 0) {
                    var i = t.indexOf("rv:");
                    return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10);
                }
                var a = t.indexOf("Edge/");
                return a > 0 && parseInt(t.substring(a + 5, t.indexOf(".", a)), 10);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$b = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.setEasingFunctions();
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "setEasingFunctions",
            value: function() {
                var t;
                if (!this.w.globals.easing) {
                    switch(this.w.config.chart.animations.easing){
                        case "linear":
                            t = "-";
                            break;
                        case "easein":
                            t = "<";
                            break;
                        case "easeout":
                            t = ">";
                            break;
                        case "easeinout":
                        default:
                            t = "<>";
                            break;
                        case "swing":
                            t = function(t) {
                                var e = 1.70158;
                                return (t -= 1) * t * ((e + 1) * t + e) + 1;
                            };
                            break;
                        case "bounce":
                            t = function(t) {
                                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                            };
                            break;
                        case "elastic":
                            t = function(t) {
                                return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1;
                            };
                    }
                    this.w.globals.easing = t;
                }
            }
        },
        {
            key: "animateLine",
            value: function(t, e, i, a) {
                t.attr(e).animate(a).attr(i);
            }
        },
        {
            key: "animateMarker",
            value: function(t, e, i, a, s, r) {
                e || (e = 0), t.attr({
                    r: e,
                    width: e,
                    height: e
                }).animate(a, s).attr({
                    r: i,
                    width: i.width,
                    height: i.height
                }).afterAll(function() {
                    r();
                });
            }
        },
        {
            key: "animateCircle",
            value: function(t, e, i, a, s) {
                t.attr({
                    r: e.r,
                    cx: e.cx,
                    cy: e.cy
                }).animate(a, s).attr({
                    r: i.r,
                    cx: i.cx,
                    cy: i.cy
                });
            }
        },
        {
            key: "animateRect",
            value: function(t, e, i, a, s) {
                t.attr(e).animate(a).attr(i).afterAll(function() {
                    return s();
                });
            }
        },
        {
            key: "animatePathsGradually",
            value: function(t) {
                var e = t.el, i = t.realIndex, a = t.j, s = t.fill, r = t.pathFrom, o = t.pathTo, n = t.speed, l = t.delay, h = this.w, c = 0;
                h.config.chart.animations.animateGradually.enabled && (c = h.config.chart.animations.animateGradually.delay), h.config.chart.animations.dynamicAnimation.enabled && h.globals.dataChanged && "bar" !== h.config.chart.type && (c = 0), this.morphSVG(e, i, a, "line" !== h.config.chart.type || h.globals.comboCharts ? s : "stroke", r, o, n, l * c);
            }
        },
        {
            key: "showDelayedElements",
            value: function() {
                this.w.globals.delayedElements.forEach(function(t) {
                    var e = t.el;
                    e.classList.remove("apexcharts-element-hidden"), e.classList.add("apexcharts-hidden-element-shown");
                });
            }
        },
        {
            key: "animationCompleted",
            value: function(t) {
                var e = this.w;
                e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                    el: t,
                    w: e
                }));
            }
        },
        {
            key: "morphSVG",
            value: function(t, e, i, a, s, r, o, n) {
                var l = this, h = this.w;
                s || (s = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                var c = function(t) {
                    return "radar" === h.config.chart.type && (o = 1), "M 0 ".concat(h.globals.gridHeight);
                };
                (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = c()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = c()), h.globals.shouldAnimate || (o = 1), t.plot(s).animate(1, h.globals.easing, n).plot(s).animate(o, h.globals.easing, n).plot(r).afterAll(function() {
                    $d4be73e5731103af$var$x.isNumber(i) ? i === h.globals.series[h.globals.maxValsInArrayIndex].length - 2 && h.globals.shouldAnimate && l.animationCompleted(t) : "none" !== a && h.globals.shouldAnimate && (!h.globals.comboCharts && e === h.globals.series.length - 1 || h.globals.comboCharts) && l.animationCompleted(t), l.showDelayedElements();
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$v = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getDefaultFilter",
            value: function(t, e) {
                var i = this.w;
                t.unfilter(!0), (new window.SVG.Filter).size("120%", "180%", "-5%", "-40%"), "none" !== i.config.states.normal.filter ? this.applyFilter(t, e, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addNormalFilter",
            value: function(t, e) {
                var i = this.w;
                i.config.chart.dropShadow.enabled && !t.node.classList.contains("apexcharts-marker") && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addLightenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: 1.5,
                            intercept: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "addDarkenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "applyFilter",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                switch(i){
                    case "none":
                        this.addNormalFilter(t, e);
                        break;
                    case "lighten":
                        this.addLightenFilter(t, e, {
                            intensity: a
                        });
                        break;
                    case "darken":
                        this.addDarkenFilter(t, e, {
                            intensity: a
                        });
                }
            }
        },
        {
            key: "addShadow",
            value: function(t, e, i) {
                var a = i.blur, s = i.top, r = i.left, o = i.color, n = i.opacity, l = t.flood(Array.isArray(o) ? o[e] : o, n).composite(t.sourceAlpha, "in").offset(r, s).gaussianBlur(a).merge(t.source);
                return t.blend(t.source, l);
            }
        },
        {
            key: "dropShadow",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = e.top, s = e.left, r = e.blur, o = e.color, n = e.opacity, l = e.noUserSpaceOnUse, h = this.w;
                return t.unfilter(!0), $d4be73e5731103af$var$x.isIE() && "radialBar" === h.config.chart.type || (o = Array.isArray(o) ? o[i] : o, t.filter(function(t) {
                    var e = null;
                    e = $d4be73e5731103af$var$x.isSafari() || $d4be73e5731103af$var$x.isFirefox() || $d4be73e5731103af$var$x.isIE() ? t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r) : t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r).merge(t.source), t.blend(t.source, e);
                }), l || t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)), t;
            }
        },
        {
            key: "setSelectionFilter",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.globals.selectedDataPoints[e] && a.globals.selectedDataPoints[e].indexOf(i) > -1) {
                    t.node.setAttribute("selected", !0);
                    var s = a.config.states.active.filter;
                    "none" !== s && this.applyFilter(t, e, s.type, s.value);
                }
            }
        },
        {
            key: "_scaleFilterSize",
            value: function(t) {
                !function(e) {
                    for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
                }({
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$m = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "roundPathCorners",
            value: function(t, e) {
                function i(t, e, i) {
                    var s = e.x - t.x, r = e.y - t.y, o = Math.sqrt(s * s + r * r);
                    return a(t, e, Math.min(1, i / o));
                }
                function a(t, e, i) {
                    return {
                        x: t.x + (e.x - t.x) * i,
                        y: t.y + (e.y - t.y) * i
                    };
                }
                function s(t, e) {
                    t.length > 2 && (t[t.length - 2] = e.x, t[t.length - 1] = e.y);
                }
                function r(t) {
                    return {
                        x: parseFloat(t[t.length - 2]),
                        y: parseFloat(t[t.length - 1])
                    };
                }
                t.indexOf("NaN") > -1 && (t = "");
                var o = t.split(/[,\s]/).reduce(function(t, e) {
                    var i = e.match("([a-zA-Z])(.+)");
                    return i ? (t.push(i[1]), t.push(i[2])) : t.push(e), t;
                }, []).reduce(function(t, e) {
                    return parseFloat(e) == e && t.length ? t[t.length - 1].push(e) : t.push([
                        e
                    ]), t;
                }, []), n = [];
                if (o.length > 1) {
                    var l = r(o[0]), h = null;
                    "Z" == o[o.length - 1][0] && o[0].length > 2 && (h = [
                        "L",
                        l.x,
                        l.y
                    ], o[o.length - 1] = h), n.push(o[0]);
                    for(var c = 1; c < o.length; c++){
                        var d = n[n.length - 1], g = o[c], u = g == h ? o[1] : o[c + 1];
                        if (u && d && d.length > 2 && "L" == g[0] && u.length > 2 && "L" == u[0]) {
                            var p, f, x = r(d), b = r(g), v = r(u);
                            p = i(b, x, e), f = i(b, v, e), s(g, p), g.origPoint = b, n.push(g);
                            var m = a(p, b, .5), y = a(b, f, .5), w = [
                                "C",
                                m.x,
                                m.y,
                                y.x,
                                y.y,
                                f.x,
                                f.y
                            ];
                            w.origPoint = b, n.push(w);
                        } else n.push(g);
                    }
                    if (h) {
                        var k = r(n[n.length - 1]);
                        n.push([
                            "Z"
                        ]), s(n[0], k);
                    }
                } else n = o;
                return n.reduce(function(t, e) {
                    return t + e.join(" ") + " ";
                }, "");
            }
        },
        {
            key: "drawLine",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "butt";
                return this.w.globals.dom.Paper.line().attr({
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: a,
                    stroke: s,
                    "stroke-dasharray": r,
                    "stroke-width": o,
                    "stroke-linecap": n
                });
            }
        },
        {
            key: "drawRect",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe", o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null, h = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, c = this.w.globals.dom.Paper.rect();
                return c.attr({
                    x: t,
                    y: e,
                    width: i > 0 ? i : 0,
                    height: a > 0 ? a : 0,
                    rx: s,
                    ry: s,
                    opacity: o,
                    "stroke-width": null !== n ? n : 0,
                    stroke: null !== l ? l : "none",
                    "stroke-dasharray": h
                }), c.node.setAttribute("fill", r), c;
            }
        },
        {
            key: "drawPolygon",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none";
                return this.w.globals.dom.Paper.polygon(t).attr({
                    fill: a,
                    stroke: e,
                    "stroke-width": i
                });
            }
        },
        {
            key: "drawCircle",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                t < 0 && (t = 0);
                var i = this.w.globals.dom.Paper.circle(2 * t);
                return null !== e && i.attr(e), i;
            }
        },
        {
            key: "drawPath",
            value: function(t) {
                var e = t.d, i = void 0 === e ? "" : e, a = t.stroke, s = void 0 === a ? "#a8a8a8" : a, r = t.strokeWidth, o = void 0 === r ? 1 : r, n = t.fill, l = t.fillOpacity, h = void 0 === l ? 1 : l, c = t.strokeOpacity, d = void 0 === c ? 1 : c, g = t.classes, u = t.strokeLinecap, p = void 0 === u ? null : u, f = t.strokeDashArray, x = void 0 === f ? 0 : f, b = this.w;
                return null === p && (p = b.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(b.globals.gridHeight)), b.globals.dom.Paper.path(i).attr({
                    fill: n,
                    "fill-opacity": h,
                    stroke: s,
                    "stroke-opacity": d,
                    "stroke-linecap": p,
                    "stroke-width": o,
                    "stroke-dasharray": x,
                    class: g
                });
            }
        },
        {
            key: "group",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w.globals.dom.Paper.group();
                return null !== t && e.attr(t), e;
            }
        },
        {
            key: "move",
            value: function(t, e) {
                var i = [
                    "M",
                    t,
                    e
                ].join(" ");
                return i;
            }
        },
        {
            key: "line",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = null;
                return null === i ? a = [
                    " L",
                    t,
                    e
                ].join(" ") : "H" === i ? a = [
                    " H",
                    t
                ].join(" ") : "V" === i && (a = [
                    " V",
                    e
                ].join(" ")), a;
            }
        },
        {
            key: "curve",
            value: function(t, e, i, a, s, r) {
                var o = [
                    "C",
                    t,
                    e,
                    i,
                    a,
                    s,
                    r
                ].join(" ");
                return o;
            }
        },
        {
            key: "quadraticCurve",
            value: function(t, e, i, a) {
                return [
                    "Q",
                    t,
                    e,
                    i,
                    a
                ].join(" ");
            }
        },
        {
            key: "arc",
            value: function(t, e, i, a, s, r, o) {
                var n = "A";
                arguments.length > 7 && void 0 !== arguments[7] && arguments[7] && (n = "a");
                var l = [
                    n,
                    t,
                    e,
                    i,
                    a,
                    s,
                    r,
                    o
                ].join(" ");
                return l;
            }
        },
        {
            key: "renderPaths",
            value: function(t) {
                var i, a = t.j, s = t.realIndex, r = t.pathFrom, o = t.pathTo, n = t.stroke, l = t.strokeWidth, h = t.strokeLinecap, c = t.fill, d = t.animationDelay, g = t.initialSpeed, u = t.dataChangeSpeed, p = t.className, f = t.shouldClipToGrid, x = void 0 === f || f, m = t.bindEventsOnPaths, y = void 0 === m || m, w = t.drawShadow, k = void 0 === w || w, A = this.w, S = new $d4be73e5731103af$var$v(this.ctx), C = new $d4be73e5731103af$var$b(this.ctx), L = this.w.config.chart.animations.enabled, P = L && this.w.config.chart.animations.dynamicAnimation.enabled, I = !!(L && !A.globals.resized || P && A.globals.dataChanged && A.globals.shouldAnimate);
                I ? i = r : (i = o, A.globals.animationEnded = !0);
                var T = A.config.stroke.dashArray, M = 0;
                M = Array.isArray(T) ? T[s] : A.config.stroke.dashArray;
                var X = this.drawPath({
                    d: i,
                    stroke: n,
                    strokeWidth: l,
                    fill: c,
                    fillOpacity: 1,
                    classes: p,
                    strokeLinecap: h,
                    strokeDashArray: M
                });
                if (X.attr("index", s), x && X.attr({
                    "clip-path": "url(#gridRectMask".concat(A.globals.cuid, ")")
                }), "none" !== A.config.states.normal.filter.type) S.getDefaultFilter(X, s);
                else if (A.config.chart.dropShadow.enabled && k && (!A.config.chart.dropShadow.enabledOnSeries || A.config.chart.dropShadow.enabledOnSeries && -1 !== A.config.chart.dropShadow.enabledOnSeries.indexOf(s))) {
                    var z = A.config.chart.dropShadow;
                    S.dropShadow(X, z, s);
                }
                y && (X.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, X)), X.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, X)), X.node.addEventListener("mousedown", this.pathMouseDown.bind(this, X))), X.attr({
                    pathTo: o,
                    pathFrom: r
                });
                var E = {
                    el: X,
                    j: a,
                    realIndex: s,
                    pathFrom: r,
                    pathTo: o,
                    fill: c,
                    strokeWidth: l,
                    delay: d
                };
                return !L || A.globals.resized || A.globals.dataChanged ? !A.globals.resized && A.globals.dataChanged || C.showDelayedElements() : C.animatePathsGradually($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, E), {}, {
                    speed: g
                })), A.globals.dataChanged && P && I && C.animatePathsGradually($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, E), {}, {
                    speed: u
                })), X;
            }
        },
        {
            key: "drawPattern",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                return this.w.globals.dom.Paper.pattern(e, i, function(r) {
                    "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                        color: a,
                        width: s + 1
                    }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                        color: a,
                        width: s + 1
                    }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                        color: a,
                        width: s
                    }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                        color: a,
                        width: s
                    }) : "circles" === t && r.circle(e).fill("none").stroke({
                        color: a,
                        width: s
                    });
                });
            }
        },
        {
            key: "drawGradient",
            value: function(t, e, i, a, s) {
                var r, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, h = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, c = this.w;
                e.length < 9 && 0 === e.indexOf("#") && (e = $d4be73e5731103af$var$x.hexToRgba(e, a)), i.length < 9 && 0 === i.indexOf("#") && (i = $d4be73e5731103af$var$x.hexToRgba(i, s));
                var d = 0, g = 1, u = 1, p = null;
                null !== n && (d = void 0 !== n[0] ? n[0] / 100 : 0, g = void 0 !== n[1] ? n[1] / 100 : 1, u = void 0 !== n[2] ? n[2] / 100 : 1, p = void 0 !== n[3] ? n[3] / 100 : null);
                var f = !("donut" !== c.config.chart.type && "pie" !== c.config.chart.type && "polarArea" !== c.config.chart.type && "bubble" !== c.config.chart.type);
                if (r = null === l || 0 === l.length ? c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    t.at(d, e, a), t.at(g, i, s), t.at(u, i, s), null !== p && t.at(p, e, a);
                }) : c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    (Array.isArray(l[h]) ? l[h] : l).forEach(function(e) {
                        t.at(e.offset / 100, e.color, e.opacity);
                    });
                }), f) {
                    var b = c.globals.gridWidth / 2, v = c.globals.gridHeight / 2;
                    "bubble" !== c.config.chart.type ? r.attr({
                        gradientUnits: "userSpaceOnUse",
                        cx: b,
                        cy: v,
                        r: o
                    }) : r.attr({
                        cx: .5,
                        cy: .5,
                        r: .8,
                        fx: .2,
                        fy: .2
                    });
                } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                return r;
            }
        },
        {
            key: "getTextBasedOnMaxWidth",
            value: function(t) {
                var e = t.text, i = t.maxWidth, a = t.fontSize, s = t.fontFamily, r = this.getTextRects(e, a, s), o = r.width / e.length, n = Math.floor(i / o);
                return i < r.width ? e.slice(0, n - 3) + "..." : e;
            }
        },
        {
            key: "drawText",
            value: function(t) {
                var i = this, a = t.x, s = t.y, r = t.text, o = t.textAnchor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.foreColor, d = t.opacity, g = t.maxWidth, u = t.cssClass, p = void 0 === u ? "" : u, f = t.isPlainText, x = void 0 === f || f, b = this.w;
                void 0 === r && (r = "");
                var v = r;
                o || (o = "start"), c && c.length || (c = b.config.chart.foreColor), l = l || b.config.chart.fontFamily, h = h || "regular";
                var m, y = {
                    maxWidth: g,
                    fontSize: n = n || "11px",
                    fontFamily: l
                };
                return Array.isArray(r) ? m = b.globals.dom.Paper.text(function(t) {
                    for(var a = 0; a < r.length; a++)v = r[a], g && (v = i.getTextBasedOnMaxWidth($d4be73e5731103af$var$e({
                        text: r[a]
                    }, y))), 0 === a ? t.tspan(v) : t.tspan(v).newLine();
                }) : (g && (v = this.getTextBasedOnMaxWidth($d4be73e5731103af$var$e({
                    text: r
                }, y))), m = x ? b.globals.dom.Paper.plain(r) : b.globals.dom.Paper.text(function(t) {
                    return t.tspan(v);
                })), m.attr({
                    x: a,
                    y: s,
                    "text-anchor": o,
                    "dominant-baseline": "auto",
                    "font-size": n,
                    "font-family": l,
                    "font-weight": h,
                    fill: c,
                    class: "apexcharts-text " + p
                }), m.node.style.fontFamily = l, m.node.style.opacity = d, m;
            }
        },
        {
            key: "drawMarker",
            value: function(t, e, i) {
                t = t || 0;
                var a = i.pSize || 0, s = null;
                if ("square" === i.shape || "rect" === i.shape) {
                    var r = void 0 === i.pRadius ? a / 2 : i.pRadius;
                    null !== e && a || (a = 0, r = 0);
                    var o = 1.2 * a + r, n = this.drawRect(o, o, o, o, r);
                    n.attr({
                        x: t - o / 2,
                        y: e - o / 2,
                        cx: t,
                        cy: e,
                        class: i.class ? i.class : "",
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        stroke: i.pointStrokeColor,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }), s = n;
                } else "circle" !== i.shape && i.shape || ($d4be73e5731103af$var$x.isNumber(e) || (a = 0, e = 0), s = this.drawCircle(a, {
                    cx: t,
                    cy: e,
                    class: i.class ? i.class : "",
                    stroke: i.pointStrokeColor,
                    fill: i.pointFillColor,
                    "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                    "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                    "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                }));
                return s;
            }
        },
        {
            key: "pathMouseEnter",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && !i.globals.isTouchDevice) {
                    var o = i.config.states.hover.filter;
                    a.applyFilter(t, s, o.type, o.value);
                }
            }
        },
        {
            key: "pathMouseLeave",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && a.getDefaultFilter(t, s);
            }
        },
        {
            key: "pathMouseDown",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10), o = "false";
                if ("true" === t.node.getAttribute("selected")) {
                    if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                        var n = i.globals.selectedDataPoints[s].indexOf(r);
                        i.globals.selectedDataPoints[s].splice(n, 1);
                    }
                } else {
                    if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                        i.globals.selectedDataPoints = [];
                        var l = i.globals.dom.Paper.select(".apexcharts-series path").members, h = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, c = function(t) {
                            Array.prototype.forEach.call(t, function(t) {
                                t.node.setAttribute("selected", "false"), a.getDefaultFilter(t, s);
                            });
                        };
                        c(l), c(h);
                    }
                    t.node.setAttribute("selected", "true"), o = "true", void 0 === i.globals.selectedDataPoints[s] && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                }
                if ("true" === o) {
                    var d = i.config.states.active.filter;
                    if ("none" !== d) a.applyFilter(t, s, d.type, d.value);
                    else if ("none" !== i.config.states.hover.filter && !i.globals.isTouchDevice) {
                        var g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                } else if ("none" !== i.config.states.active.filter.type) {
                    if ("none" === i.config.states.hover.filter.type || i.globals.isTouchDevice) a.getDefaultFilter(t, s);
                    else {
                        g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                }
                "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                    selectedDataPoints: i.globals.selectedDataPoints,
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), e && this.ctx.events.fireEvent("dataPointSelection", [
                    e,
                    this.ctx,
                    {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]);
            }
        },
        {
            key: "rotateAroundCenter",
            value: function(t) {
                var e = {};
                return t && "function" == typeof t.getBBox && (e = t.getBBox()), {
                    x: e.x + e.width / 2,
                    y: e.y + e.height / 2
                };
            }
        },
        {
            key: "getTextRects",
            value: function(t, e, i, a) {
                var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = this.w, o = this.drawText({
                    x: -200,
                    y: -200,
                    text: t,
                    textAnchor: "start",
                    fontSize: e,
                    fontFamily: i,
                    foreColor: "#fff",
                    opacity: 0
                });
                a && o.attr("transform", a), r.globals.dom.Paper.add(o);
                var n = o.bbox();
                return s || (n = o.node.getBoundingClientRect()), o.remove(), {
                    width: n.width,
                    height: n.height
                };
            }
        },
        {
            key: "placeTextWithEllipsis",
            value: function(t, e, i) {
                if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                    for(var a = e.length - 3; a > 0; a -= 3)if (t.getSubStringLength(0, a) <= i / 1.1) return void (t.textContent = e.substring(0, a) + "...");
                    t.textContent = ".";
                }
            }
        }
    ], [
        {
            key: "setAttrs",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$y = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getStackedSeriesTotals",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = this.w, i = [];
                if (0 === e.globals.series.length) return i;
                for(var a = 0; a < e.globals.series[e.globals.maxValsInArrayIndex].length; a++){
                    for(var s = 0, r = 0; r < e.globals.series.length; r++)void 0 !== e.globals.series[r][a] && -1 === t.indexOf(r) && (s += e.globals.series[r][a]);
                    i.push(s);
                }
                return i;
            }
        },
        {
            key: "getSeriesTotalByIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return null === t ? this.w.config.series.reduce(function(t, e) {
                    return t + e;
                }, 0) : this.w.globals.series[t].reduce(function(t, e) {
                    return t + e;
                }, 0);
            }
        },
        {
            key: "isSeriesNull",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return 0 === (null === t ? this.w.config.series.filter(function(t) {
                    return null !== t;
                }) : this.w.config.series[t].data.filter(function(t) {
                    return null !== t;
                })).length;
            }
        },
        {
            key: "seriesHaveSameValues",
            value: function(t) {
                return this.w.globals.series[t].every(function(t, e, i) {
                    return t === i[0];
                });
            }
        },
        {
            key: "getCategoryLabels",
            value: function(t) {
                var e = this.w, i = t.slice();
                return e.config.xaxis.convertedCatToNumeric && (i = t.map(function(t, i) {
                    return e.config.xaxis.labels.formatter(t - e.globals.minX + 1);
                })), i;
            }
        },
        {
            key: "getLargestSeries",
            value: function() {
                var t = this.w;
                t.globals.maxValsInArrayIndex = t.globals.series.map(function(t) {
                    return t.length;
                }).indexOf(Math.max.apply(Math, t.globals.series.map(function(t) {
                    return t.length;
                })));
            }
        },
        {
            key: "getLargestMarkerSize",
            value: function() {
                var t = this.w, e = 0;
                return t.globals.markers.size.forEach(function(t) {
                    e = Math.max(e, t);
                }), t.config.markers.discrete && t.config.markers.discrete.length && t.config.markers.discrete.forEach(function(t) {
                    e = Math.max(e, t.size);
                }), e > 0 && (e += t.config.markers.hover.sizeOffset + 1), t.globals.markers.largestSize = e, e;
            }
        },
        {
            key: "getSeriesTotals",
            value: function() {
                var t = this.w;
                t.globals.seriesTotals = t.globals.series.map(function(t, e) {
                    var i = 0;
                    if (Array.isArray(t)) for(var a = 0; a < t.length; a++)i += t[a];
                    else i += t;
                    return i;
                });
            }
        },
        {
            key: "getSeriesTotalsXRange",
            value: function(t, e) {
                var i = this.w;
                return i.globals.series.map(function(a, s) {
                    for(var r = 0, o = 0; o < a.length; o++)i.globals.seriesX[s][o] > t && i.globals.seriesX[s][o] < e && (r += a[o]);
                    return r;
                });
            }
        },
        {
            key: "getPercentSeries",
            value: function() {
                var t = this.w;
                t.globals.seriesPercent = t.globals.series.map(function(e, i) {
                    var a = [];
                    if (Array.isArray(e)) for(var s = 0; s < e.length; s++){
                        var r = t.globals.stackedSeriesTotals[s], o = 0;
                        r && (o = 100 * e[s] / r), a.push(o);
                    }
                    else {
                        var n = 100 * e / t.globals.seriesTotals.reduce(function(t, e) {
                            return t + e;
                        }, 0);
                        a.push(n);
                    }
                    return a;
                });
            }
        },
        {
            key: "getCalculatedRatios",
            value: function() {
                var t, e, i, a, s = this.w.globals, r = [], o = 0, n = [], l = .1, h = 0;
                if (s.yRange = [], s.isMultipleYAxis) for(var c = 0; c < s.minYArr.length; c++)s.yRange.push(Math.abs(s.minYArr[c] - s.maxYArr[c])), n.push(0);
                else s.yRange.push(Math.abs(s.minY - s.maxY));
                s.xRange = Math.abs(s.maxX - s.minX), s.zRange = Math.abs(s.maxZ - s.minZ);
                for(var d = 0; d < s.yRange.length; d++)r.push(s.yRange[d] / s.gridHeight);
                if (e = s.xRange / s.gridWidth, i = Math.abs(s.initialMaxX - s.initialMinX) / s.gridWidth, t = s.yRange / s.gridWidth, a = s.xRange / s.gridHeight, (o = s.zRange / s.gridHeight * 16) || (o = 1), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (s.hasNegs = !0), s.isMultipleYAxis) {
                    n = [];
                    for(var g = 0; g < r.length; g++)n.push(-s.minYArr[g] / r[g]);
                } else n.push(-s.minY / r[0]), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (l = -s.minY / t, h = s.minX / e);
                return {
                    yRatio: r,
                    invertedYRatio: t,
                    zRatio: o,
                    xRatio: e,
                    initialXRatio: i,
                    invertedXRatio: a,
                    baseLineInvertedY: l,
                    baseLineY: n,
                    baseLineX: h
                };
            }
        },
        {
            key: "getLogSeries",
            value: function(t) {
                var e = this, i = this.w;
                return i.globals.seriesLog = t.map(function(t, a) {
                    return i.config.yaxis[a] && i.config.yaxis[a].logarithmic ? t.map(function(t) {
                        return null === t ? null : e.getLogVal(i.config.yaxis[a].logBase, t, a);
                    }) : t;
                }), i.globals.invalidLogScale ? t : i.globals.seriesLog;
            }
        },
        {
            key: "getBaseLog",
            value: function(t, e) {
                return Math.log(e) / Math.log(t);
            }
        },
        {
            key: "getLogVal",
            value: function(t, e, i) {
                if (0 === e) return 0;
                var a = this.w, s = 0 === a.globals.minYArr[i] ? -1 : this.getBaseLog(t, a.globals.minYArr[i]), r = (0 === a.globals.maxYArr[i] ? 0 : this.getBaseLog(t, a.globals.maxYArr[i])) - s;
                return e < 1 ? e / r : (this.getBaseLog(t, e) - s) / r;
            }
        },
        {
            key: "getLogYRatios",
            value: function(t) {
                var e = this, i = this.w, a = this.w.globals;
                return a.yLogRatio = t.slice(), a.logYRange = a.yRange.map(function(t, s) {
                    if (i.config.yaxis[s] && e.w.config.yaxis[s].logarithmic) {
                        var r, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                        return a.seriesLog.forEach(function(t, e) {
                            t.forEach(function(t) {
                                i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (o = Math.max(t, o), n = Math.min(t, n));
                            });
                        }), r = Math.pow(a.yRange[s], Math.abs(n - o) / a.yRange[s]), a.yLogRatio[s] = r / a.gridHeight, r;
                    }
                }), a.invalidLogScale ? t.slice() : a.yLogRatio;
            }
        }
    ], [
        {
            key: "checkComboSeries",
            value: function(t) {
                var e = !1, i = 0, a = 0;
                return t.length && void 0 !== t[0].type && t.forEach(function(t) {
                    "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || i++, void 0 !== t.type && a++;
                }), a > 0 && (e = !0), {
                    comboBarCount: i,
                    comboCharts: e
                };
            }
        },
        {
            key: "extendArrayProps",
            value: function(t, e, i) {
                return e.yaxis && (e = t.extendYAxis(e, i)), e.annotations && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), e.annotations.xaxis && (e = t.extendXAxisAnnotations(e)), e.annotations.points && (e = t.extendPointAnnotations(e))), e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$w = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.annoCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "setOrientations",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                if ("vertical" === t.label.orientation) {
                    var a = null !== e ? e : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                    if (null !== s) {
                        var r = s.getBoundingClientRect();
                        s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4), "top" === t.label.position ? s.setAttribute("y", parseFloat(s.getAttribute("y")) + r.width) : s.setAttribute("y", parseFloat(s.getAttribute("y")) - r.width);
                        var o = this.annoCtx.graphics.rotateAroundCenter(s), n = o.x, l = o.y;
                        s.setAttribute("transform", "rotate(-90 ".concat(n, " ").concat(l, ")"));
                    }
                }
            }
        },
        {
            key: "addBackgroundToAnno",
            value: function(t, e) {
                var i = this.w;
                if (!t || void 0 === e.label.text || void 0 !== e.label.text && !String(e.label.text).trim()) return null;
                var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = t.getBoundingClientRect(), r = e.label.style.padding.left, o = e.label.style.padding.right, n = e.label.style.padding.top, l = e.label.style.padding.bottom;
                "vertical" === e.label.orientation && (n = e.label.style.padding.left, l = e.label.style.padding.right, r = e.label.style.padding.top, o = e.label.style.padding.bottom);
                var h = s.left - a.left - r, c = s.top - a.top - n, d = this.annoCtx.graphics.drawRect(h - i.globals.barPadForNumericAxis, c, s.width + r + o, s.height + n + l, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                return e.id && d.node.classList.add(e.id), d;
            }
        },
        {
            key: "annotationsBackground",
            value: function() {
                var t = this, e = this.w, i = function(i, a, s) {
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(a, "']"));
                    if (r) {
                        var o = r.parentNode, n = t.addBackgroundToAnno(r, i);
                        n && (o.insertBefore(n.node, r), i.label.mouseEnter && n.node.addEventListener("mouseenter", i.label.mouseEnter.bind(t, i)), i.label.mouseLeave && n.node.addEventListener("mouseleave", i.label.mouseLeave.bind(t, i)), i.label.click && n.node.addEventListener("click", i.label.click.bind(t, i)));
                    }
                };
                e.config.annotations.xaxis.map(function(t, e) {
                    i(t, e, "xaxis");
                }), e.config.annotations.yaxis.map(function(t, e) {
                    i(t, e, "yaxis");
                }), e.config.annotations.points.map(function(t, e) {
                    i(t, e, "point");
                });
            }
        },
        {
            key: "getY1Y2",
            value: function(t, e) {
                var i, a = "y1" === t ? e.y : e.y2, s = this.w;
                if (this.annoCtx.invertAxis) {
                    var r = s.globals.labels.indexOf(a);
                    s.config.xaxis.convertedCatToNumeric && (r = s.globals.categoryLabels.indexOf(a));
                    var o = s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                    o && (i = parseFloat(o.getAttribute("y")));
                } else {
                    var n;
                    if (s.config.yaxis[e.yAxisIndex].logarithmic) n = (a = new $d4be73e5731103af$var$y(this.annoCtx.ctx).getLogVal(a, e.yAxisIndex)) / s.globals.yLogRatio[e.yAxisIndex];
                    else n = (a - s.globals.minYArr[e.yAxisIndex]) / (s.globals.yRange[e.yAxisIndex] / s.globals.gridHeight);
                    i = s.globals.gridHeight - n, !e.marker || void 0 !== e.y && null !== e.y || (i = 0), s.config.yaxis[e.yAxisIndex] && s.config.yaxis[e.yAxisIndex].reversed && (i = n);
                }
                return "string" == typeof a && a.indexOf("px") > -1 && (i = parseFloat(a)), i;
            }
        },
        {
            key: "getX1X2",
            value: function(t, e) {
                var i = this.w, a = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, s = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, r = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, o = (e.x - a) / (r / i.globals.gridWidth);
                this.annoCtx.inversedReversedAxis && (o = (s - e.x) / (r / i.globals.gridWidth)), "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (o = this.getStringX(e.x));
                var n = (e.x2 - a) / (r / i.globals.gridWidth);
                return this.annoCtx.inversedReversedAxis && (n = (s - e.x2) / (r / i.globals.gridWidth)), "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (n = this.getStringX(e.x2)), void 0 !== e.x && null !== e.x || !e.marker || (o = i.globals.gridWidth), "x1" === t && "string" == typeof e.x && e.x.indexOf("px") > -1 && (o = parseFloat(e.x)), "x2" === t && "string" == typeof e.x2 && e.x2.indexOf("px") > -1 && (n = parseFloat(e.x2)), "x1" === t ? o : n;
            }
        },
        {
            key: "getStringX",
            value: function(t) {
                var e = this.w, i = t;
                e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                var a = e.globals.labels.indexOf(t), s = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (a + 1) + ")");
                return s && (i = parseFloat(s.getAttribute("x"))), i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$k = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new $d4be73e5731103af$var$w(this.annoCtx);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = this.helpers.getX1X2("x1", t), o = t.label.text, n = t.strokeDashArray;
                if ($d4be73e5731103af$var$x.isNumber(r)) {
                    if (null === t.x2 || void 0 === t.x2) {
                        var l = this.annoCtx.graphics.drawLine(r + t.offsetX, 0 + t.offsetY, r + t.offsetX, s.globals.gridHeight + t.offsetY, t.borderColor, n, t.borderWidth);
                        e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                    } else {
                        if ((a = this.helpers.getX1X2("x2", t)) < r) {
                            var h = r;
                            r = a, a = h;
                        }
                        var c = this.annoCtx.graphics.drawRect(r + t.offsetX, 0 + t.offsetY, a - r, s.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, n);
                        c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                    }
                    var d = this.annoCtx.graphics.getTextRects(o, parseFloat(t.label.style.fontSize)), g = "top" === t.label.position ? 4 : "center" === t.label.position ? s.globals.gridHeight / 2 + ("vertical" === t.label.orientation ? d.width / 2 : 0) : s.globals.gridHeight, u = this.annoCtx.graphics.drawText({
                        x: r + t.label.offsetX,
                        y: g + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? d.width / 2 - 12 : -d.width / 2 : 0),
                        text: o,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    u.attr({
                        rel: i
                    }), e.appendChild(u.node), this.annoCtx.helpers.setOrientations(t, i);
                }
            }
        },
        {
            key: "drawXAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-xaxis-annotations"
                });
                return e.config.annotations.xaxis.map(function(e, a) {
                    t.addXaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$A = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new $d4be73e5731103af$var$w(this.annoCtx);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = t.strokeDashArray, o = this.helpers.getY1Y2("y1", t), n = t.label.text;
                if (null === t.y2 || void 0 === t.y2) {
                    var l = this.annoCtx.graphics.drawLine(0 + t.offsetX, o + t.offsetY, this._getYAxisAnnotationWidth(t), o + t.offsetY, t.borderColor, r, t.borderWidth);
                    e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                } else {
                    if ((a = this.helpers.getY1Y2("y2", t)) > o) {
                        var h = o;
                        o = a, a = h;
                    }
                    var c = this.annoCtx.graphics.drawRect(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), o - a, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                    c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                }
                var d = "right" === t.label.position ? s.globals.gridWidth : "center" === t.label.position ? s.globals.gridWidth / 2 : 0, g = this.annoCtx.graphics.drawText({
                    x: d + t.label.offsetX,
                    y: (null != a ? a : o) + t.label.offsetY - 3,
                    text: n,
                    textAnchor: t.label.textAnchor,
                    fontSize: t.label.style.fontSize,
                    fontFamily: t.label.style.fontFamily,
                    fontWeight: t.label.style.fontWeight,
                    foreColor: t.label.style.color,
                    cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                });
                g.attr({
                    rel: i
                }), e.appendChild(g.node);
            }
        },
        {
            key: "_getYAxisAnnotationWidth",
            value: function(t) {
                var e = this.w;
                e.globals.gridWidth;
                return (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX;
            }
        },
        {
            key: "drawYAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-yaxis-annotations"
                });
                return e.config.annotations.yaxis.map(function(e, a) {
                    t.addYaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$S = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new $d4be73e5731103af$var$w(this.annoCtx);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.w;
                var a = this.helpers.getX1X2("x1", t), s = this.helpers.getY1Y2("y1", t);
                if ($d4be73e5731103af$var$x.isNumber(a)) {
                    var r = {
                        pSize: t.marker.size,
                        pointStrokeWidth: t.marker.strokeWidth,
                        pointFillColor: t.marker.fillColor,
                        pointStrokeColor: t.marker.strokeColor,
                        shape: t.marker.shape,
                        pRadius: t.marker.radius,
                        class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                    }, o = this.annoCtx.graphics.drawMarker(a + t.marker.offsetX, s + t.marker.offsetY, r);
                    e.appendChild(o.node);
                    var n = t.label.text ? t.label.text : "", l = this.annoCtx.graphics.drawText({
                        x: a + t.label.offsetX,
                        y: s + t.label.offsetY - t.marker.size - parseFloat(t.label.style.fontSize) / 1.6,
                        text: n,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    if (l.attr({
                        rel: i
                    }), e.appendChild(l.node), t.customSVG.SVG) {
                        var h = this.annoCtx.graphics.group({
                            class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                        });
                        h.attr({
                            transform: "translate(".concat(a + t.customSVG.offsetX, ", ").concat(s + t.customSVG.offsetY, ")")
                        }), h.node.innerHTML = t.customSVG.SVG, e.appendChild(h.node);
                    }
                    if (t.image.path) {
                        var c = t.image.width ? t.image.width : 20, d = t.image.height ? t.image.height : 20;
                        o = this.annoCtx.addImage({
                            x: a + t.image.offsetX - c / 2,
                            y: s + t.image.offsetY - d / 2,
                            width: c,
                            height: d,
                            path: t.image.path,
                            appendTo: ".apexcharts-point-annotations"
                        });
                    }
                    t.mouseEnter && o.node.addEventListener("mouseenter", t.mouseEnter.bind(this, t)), t.mouseLeave && o.node.addEventListener("mouseleave", t.mouseLeave.bind(this, t)), t.click && o.node.addEventListener("click", t.click.bind(this, t));
                }
            }
        },
        {
            key: "drawPointAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-point-annotations"
                });
                return e.config.annotations.points.map(function(e, a) {
                    t.addPointAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}();
var $d4be73e5731103af$var$C = {
    name: "en",
    options: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        toolbar: {
            exportToSVG: "Download SVG",
            exportToPNG: "Download PNG",
            exportToCSV: "Download CSV",
            menu: "Menu",
            selection: "Selection",
            selectionZoom: "Selection Zoom",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            pan: "Panning",
            reset: "Reset Zoom"
        }
    }
}, $d4be73e5731103af$var$L = function() {
    function t() {
        $d4be73e5731103af$var$a(this, t), this.yAxis = {
            show: !0,
            showAlways: !1,
            showForNullSeries: !0,
            seriesName: void 0,
            opposite: !1,
            reversed: !1,
            logarithmic: !1,
            logBase: 10,
            tickAmount: void 0,
            forceNiceScale: !1,
            max: void 0,
            min: void 0,
            floating: !1,
            decimalsInFloat: void 0,
            labels: {
                show: !0,
                minWidth: 0,
                maxWidth: 160,
                offsetX: 0,
                offsetY: 0,
                align: void 0,
                rotate: 0,
                padding: 20,
                style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    fontFamily: void 0,
                    cssClass: ""
                },
                formatter: void 0
            },
            axisBorder: {
                show: !1,
                color: "#e0e0e0",
                width: 1,
                offsetX: 0,
                offsetY: 0
            },
            axisTicks: {
                show: !1,
                color: "#e0e0e0",
                width: 6,
                offsetX: 0,
                offsetY: 0
            },
            title: {
                text: void 0,
                rotate: -90,
                offsetY: 0,
                offsetX: 0,
                style: {
                    color: void 0,
                    fontSize: "11px",
                    fontWeight: 900,
                    fontFamily: void 0,
                    cssClass: ""
                }
            },
            tooltip: {
                enabled: !1,
                offsetX: 0
            },
            crosshairs: {
                show: !0,
                position: "front",
                stroke: {
                    color: "#b6b6b6",
                    width: 1,
                    dashArray: 0
                }
            }
        }, this.pointAnnotation = {
            id: void 0,
            x: 0,
            y: null,
            yAxisIndex: 0,
            seriesIndex: 0,
            mouseEnter: void 0,
            mouseLeave: void 0,
            click: void 0,
            marker: {
                size: 4,
                fillColor: "#fff",
                strokeWidth: 2,
                strokeColor: "#333",
                shape: "circle",
                offsetX: 0,
                offsetY: 0,
                radius: 2,
                cssClass: ""
            },
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            },
            customSVG: {
                SVG: void 0,
                cssClass: void 0,
                offsetX: 0,
                offsetY: 0
            },
            image: {
                path: void 0,
                width: 20,
                height: 20,
                offsetX: 0,
                offsetY: 0
            }
        }, this.yAxisAnnotation = {
            id: void 0,
            y: 0,
            y2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            width: "100%",
            yAxisIndex: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "end",
                position: "right",
                offsetX: 0,
                offsetY: -3,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.xAxisAnnotation = {
            id: void 0,
            x: 0,
            x2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                orientation: "vertical",
                position: "top",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.text = {
            x: 0,
            y: 0,
            text: "",
            textAnchor: "start",
            foreColor: void 0,
            fontSize: "13px",
            fontFamily: void 0,
            fontWeight: 400,
            appendTo: ".apexcharts-annotations",
            backgroundColor: "transparent",
            borderColor: "#c2c2c2",
            borderRadius: 0,
            borderWidth: 0,
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 2,
            paddingBottom: 2
        };
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "init",
            value: function() {
                return {
                    annotations: {
                        yaxis: [
                            this.yAxisAnnotation
                        ],
                        xaxis: [
                            this.xAxisAnnotation
                        ],
                        points: [
                            this.pointAnnotation
                        ],
                        texts: [],
                        images: [],
                        shapes: []
                    },
                    chart: {
                        animations: {
                            enabled: !0,
                            easing: "easeinout",
                            speed: 800,
                            animateGradually: {
                                delay: 150,
                                enabled: !0
                            },
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 350
                            }
                        },
                        background: "transparent",
                        locales: [
                            $d4be73e5731103af$var$C
                        ],
                        defaultLocale: "en",
                        dropShadow: {
                            enabled: !1,
                            enabledOnSeries: void 0,
                            top: 2,
                            left: 2,
                            blur: 4,
                            color: "#000",
                            opacity: .35
                        },
                        events: {
                            animationEnd: void 0,
                            beforeMount: void 0,
                            mounted: void 0,
                            updated: void 0,
                            click: void 0,
                            mouseMove: void 0,
                            mouseLeave: void 0,
                            xAxisLabelClick: void 0,
                            legendClick: void 0,
                            markerClick: void 0,
                            selection: void 0,
                            dataPointSelection: void 0,
                            dataPointMouseEnter: void 0,
                            dataPointMouseLeave: void 0,
                            beforeZoom: void 0,
                            beforeResetZoom: void 0,
                            zoomed: void 0,
                            scrolled: void 0,
                            brushScrolled: void 0
                        },
                        foreColor: "#373d3f",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: "auto",
                        parentHeightOffset: 15,
                        redrawOnParentResize: !0,
                        redrawOnWindowResize: !0,
                        id: void 0,
                        group: void 0,
                        offsetX: 0,
                        offsetY: 0,
                        selection: {
                            enabled: !1,
                            type: "x",
                            fill: {
                                color: "#24292e",
                                opacity: .1
                            },
                            stroke: {
                                width: 1,
                                color: "#24292e",
                                opacity: .4,
                                dashArray: 3
                            },
                            xaxis: {
                                min: void 0,
                                max: void 0
                            },
                            yaxis: {
                                min: void 0,
                                max: void 0
                            }
                        },
                        sparkline: {
                            enabled: !1
                        },
                        brush: {
                            enabled: !1,
                            autoScaleYaxis: !0,
                            target: void 0,
                            targets: void 0
                        },
                        stacked: !1,
                        stackType: "normal",
                        toolbar: {
                            show: !0,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: !0,
                                selection: !0,
                                zoom: !0,
                                zoomin: !0,
                                zoomout: !0,
                                pan: !0,
                                reset: !0,
                                customIcons: []
                            },
                            export: {
                                csv: {
                                    filename: void 0,
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    dateFormatter: function(t) {
                                        return new Date(t).toDateString();
                                    }
                                },
                                png: {
                                    filename: void 0
                                },
                                svg: {
                                    filename: void 0
                                }
                            },
                            autoSelected: "zoom"
                        },
                        type: "line",
                        width: "100%",
                        zoom: {
                            enabled: !0,
                            type: "x",
                            autoScaleYaxis: !1,
                            zoomedArea: {
                                fill: {
                                    color: "#90CAF9",
                                    opacity: .4
                                },
                                stroke: {
                                    color: "#0D47A1",
                                    opacity: .4,
                                    width: 1
                                }
                            }
                        }
                    },
                    plotOptions: {
                        area: {
                            fillTo: "origin"
                        },
                        bar: {
                            horizontal: !1,
                            columnWidth: "70%",
                            barHeight: "70%",
                            distributed: !1,
                            borderRadius: 0,
                            borderRadiusApplication: "around",
                            borderRadiusWhenStacked: "last",
                            rangeBarOverlap: !0,
                            rangeBarGroupRows: !1,
                            hideZeroBarsWhenGrouped: !1,
                            isDumbbell: !1,
                            dumbbellColors: void 0,
                            isFunnel: !1,
                            isFunnel3d: !0,
                            colors: {
                                ranges: [],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                                backgroundBarRadius: 0
                            },
                            dataLabels: {
                                position: "top",
                                maxItems: 100,
                                hideOverflowingLabels: !0,
                                orientation: "horizontal",
                                total: {
                                    enabled: !1,
                                    formatter: void 0,
                                    offsetX: 0,
                                    offsetY: 0,
                                    style: {
                                        color: "#373d3f",
                                        fontSize: "12px",
                                        fontFamily: void 0,
                                        fontWeight: 600
                                    }
                                }
                            }
                        },
                        bubble: {
                            zScaling: !0,
                            minBubbleRadius: void 0,
                            maxBubbleRadius: void 0
                        },
                        candlestick: {
                            colors: {
                                upward: "#00B746",
                                downward: "#EF403C"
                            },
                            wick: {
                                useFillColor: !0
                            }
                        },
                        boxPlot: {
                            colors: {
                                upper: "#00E396",
                                lower: "#008FFB"
                            }
                        },
                        heatmap: {
                            radius: 2,
                            enableShades: !0,
                            shadeIntensity: .5,
                            reverseNegativeShade: !1,
                            distributed: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        treemap: {
                            enableShades: !0,
                            shadeIntensity: .5,
                            distributed: !1,
                            reverseNegativeShade: !1,
                            useFillColorAsStroke: !1,
                            dataLabels: {
                                format: "scale"
                            },
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        radialBar: {
                            inverseOrder: !1,
                            startAngle: 0,
                            endAngle: 360,
                            offsetX: 0,
                            offsetY: 0,
                            hollow: {
                                margin: 5,
                                size: "50%",
                                background: "transparent",
                                image: void 0,
                                imageWidth: 150,
                                imageHeight: 150,
                                imageOffsetX: 0,
                                imageOffsetY: 0,
                                imageClipped: !0,
                                position: "front",
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            track: {
                                show: !0,
                                startAngle: void 0,
                                endAngle: void 0,
                                background: "#f2f2f2",
                                strokeWidth: "97%",
                                opacity: 1,
                                margin: 5,
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            dataLabels: {
                                show: !0,
                                name: {
                                    show: !0,
                                    fontSize: "16px",
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    color: void 0,
                                    offsetY: 0,
                                    formatter: function(t) {
                                        return t;
                                    }
                                },
                                value: {
                                    show: !0,
                                    fontSize: "14px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    color: void 0,
                                    offsetY: 16,
                                    formatter: function(t) {
                                        return t + "%";
                                    }
                                },
                                total: {
                                    show: !1,
                                    label: "Total",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    fontFamily: void 0,
                                    color: void 0,
                                    formatter: function(t) {
                                        return t.globals.seriesTotals.reduce(function(t, e) {
                                            return t + e;
                                        }, 0) / t.globals.series.length + "%";
                                    }
                                }
                            }
                        },
                        pie: {
                            customScale: 1,
                            offsetX: 0,
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 360,
                            expandOnClick: !0,
                            dataLabels: {
                                offset: 0,
                                minAngleToShowLabel: 10
                            },
                            donut: {
                                size: "65%",
                                background: "transparent",
                                labels: {
                                    show: !1,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: -10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "20px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        showAlways: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(t) {
                                            return t.globals.seriesTotals.reduce(function(t, e) {
                                                return t + e;
                                            }, 0);
                                        }
                                    }
                                }
                            }
                        },
                        polarArea: {
                            rings: {
                                strokeWidth: 1,
                                strokeColor: "#e8e8e8"
                            },
                            spokes: {
                                strokeWidth: 1,
                                connectorColors: "#e8e8e8"
                            }
                        },
                        radar: {
                            size: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            polygons: {
                                strokeWidth: 1,
                                strokeColors: "#e8e8e8",
                                connectorColors: "#e8e8e8",
                                fill: {
                                    colors: void 0
                                }
                            }
                        }
                    },
                    colors: void 0,
                    dataLabels: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        formatter: function(t) {
                            return null !== t ? t : "";
                        },
                        textAnchor: "middle",
                        distributed: !1,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 600,
                            colors: void 0
                        },
                        background: {
                            enabled: !0,
                            foreColor: "#fff",
                            borderRadius: 2,
                            padding: 4,
                            opacity: .9,
                            borderWidth: 1,
                            borderColor: "#fff",
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .45
                            }
                        },
                        dropShadow: {
                            enabled: !1,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: "#000",
                            opacity: .45
                        }
                    },
                    fill: {
                        type: "solid",
                        colors: void 0,
                        opacity: .85,
                        gradient: {
                            shade: "dark",
                            type: "horizontal",
                            shadeIntensity: .5,
                            gradientToColors: void 0,
                            inverseColors: !0,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                0,
                                50,
                                100
                            ],
                            colorStops: []
                        },
                        image: {
                            src: [],
                            width: void 0,
                            height: void 0
                        },
                        pattern: {
                            style: "squares",
                            width: 6,
                            height: 6,
                            strokeWidth: 2
                        }
                    },
                    forecastDataPoints: {
                        count: 0,
                        fillOpacity: .5,
                        strokeWidth: void 0,
                        dashArray: 4
                    },
                    grid: {
                        show: !0,
                        borderColor: "#e0e0e0",
                        strokeDashArray: 0,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: !1
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        row: {
                            colors: void 0,
                            opacity: .5
                        },
                        column: {
                            colors: void 0,
                            opacity: .5
                        },
                        padding: {
                            top: 0,
                            right: 10,
                            bottom: 0,
                            left: 12
                        }
                    },
                    labels: [],
                    legend: {
                        show: !0,
                        showForSingleSeries: !1,
                        showForNullSeries: !0,
                        showForZeroSeries: !0,
                        floating: !1,
                        position: "bottom",
                        horizontalAlign: "center",
                        inverseOrder: !1,
                        fontSize: "12px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        width: void 0,
                        height: void 0,
                        formatter: void 0,
                        tooltipHoverFormatter: void 0,
                        offsetX: -20,
                        offsetY: 4,
                        customLegendItems: [],
                        labels: {
                            colors: void 0,
                            useSeriesColors: !1
                        },
                        markers: {
                            width: 12,
                            height: 12,
                            strokeWidth: 0,
                            fillColors: void 0,
                            strokeColor: "#fff",
                            radius: 12,
                            customHTML: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0
                        },
                        itemMargin: {
                            horizontal: 5,
                            vertical: 2
                        },
                        onItemClick: {
                            toggleDataSeries: !0
                        },
                        onItemHover: {
                            highlightDataSeries: !0
                        }
                    },
                    markers: {
                        discrete: [],
                        size: 0,
                        colors: void 0,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: .9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        shape: "circle",
                        width: 8,
                        height: 8,
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: void 0,
                        onDblClick: void 0,
                        showNullDataPoints: !0,
                        hover: {
                            size: void 0,
                            sizeOffset: 3
                        }
                    },
                    noData: {
                        text: void 0,
                        align: "center",
                        verticalAlign: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: void 0,
                            fontSize: "14px",
                            fontFamily: void 0
                        }
                    },
                    responsive: [],
                    series: void 0,
                    states: {
                        normal: {
                            filter: {
                                type: "none",
                                value: 0
                            }
                        },
                        hover: {
                            filter: {
                                type: "lighten",
                                value: .1
                            }
                        },
                        active: {
                            allowMultipleDataPointsSelection: !1,
                            filter: {
                                type: "darken",
                                value: .5
                            }
                        }
                    },
                    title: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: !1,
                        style: {
                            fontSize: "14px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    subtitle: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 30,
                        floating: !1,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    stroke: {
                        show: !0,
                        curve: "smooth",
                        lineCap: "butt",
                        width: 2,
                        colors: void 0,
                        dashArray: 0,
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: .85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: .5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            }
                        }
                    },
                    tooltip: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        shared: !0,
                        followCursor: !1,
                        intersect: !1,
                        inverseOrder: !1,
                        custom: void 0,
                        fillSeriesColor: !1,
                        theme: "light",
                        cssClass: "",
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0
                        },
                        onDatasetHover: {
                            highlightDataSeries: !1
                        },
                        x: {
                            show: !0,
                            format: "dd MMM",
                            formatter: void 0
                        },
                        y: {
                            formatter: void 0,
                            title: {
                                formatter: function(t) {
                                    return t ? t + ": " : "";
                                }
                            }
                        },
                        z: {
                            formatter: void 0,
                            title: "Size: "
                        },
                        marker: {
                            show: !0,
                            fillColors: void 0
                        },
                        items: {
                            display: "flex"
                        },
                        fixed: {
                            enabled: !1,
                            position: "topRight",
                            offsetX: 0,
                            offsetY: 0
                        }
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        convertedCatToNumeric: !1,
                        offsetX: 0,
                        offsetY: 0,
                        overwriteCategories: void 0,
                        labels: {
                            show: !0,
                            rotate: -45,
                            rotateAlways: !1,
                            hideOverlappingLabels: !0,
                            trim: !1,
                            minHeight: void 0,
                            maxHeight: 120,
                            showDuplicates: !0,
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            },
                            offsetX: 0,
                            offsetY: 0,
                            format: void 0,
                            formatter: void 0,
                            datetimeUTC: !0,
                            datetimeFormatter: {
                                year: "yyyy",
                                month: "MMM 'yy",
                                day: "dd MMM",
                                hour: "HH:mm",
                                minute: "HH:mm:ss",
                                second: "HH:mm:ss"
                            }
                        },
                        group: {
                            groups: [],
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        axisBorder: {
                            show: !0,
                            color: "#e0e0e0",
                            width: "100%",
                            height: 1,
                            offsetX: 0,
                            offsetY: 0
                        },
                        axisTicks: {
                            show: !0,
                            color: "#e0e0e0",
                            height: 6,
                            offsetX: 0,
                            offsetY: 0
                        },
                        tickAmount: void 0,
                        tickPlacement: "on",
                        min: void 0,
                        max: void 0,
                        range: void 0,
                        floating: !1,
                        decimalsInFloat: void 0,
                        position: "bottom",
                        title: {
                            text: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "12px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        crosshairs: {
                            show: !0,
                            width: 1,
                            position: "back",
                            opacity: .9,
                            stroke: {
                                color: "#b6b6b6",
                                width: 1,
                                dashArray: 3
                            },
                            fill: {
                                type: "solid",
                                color: "#B1B9C4",
                                gradient: {
                                    colorFrom: "#D8E3F0",
                                    colorTo: "#BED1E6",
                                    stops: [
                                        0,
                                        100
                                    ],
                                    opacityFrom: .4,
                                    opacityTo: .5
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                left: 0,
                                top: 0,
                                blur: 1,
                                opacity: .4
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            offsetY: 0,
                            formatter: void 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            }
                        }
                    },
                    yaxis: this.yAxis,
                    theme: {
                        mode: "light",
                        palette: "palette1",
                        monochrome: {
                            enabled: !1,
                            color: "#008FFB",
                            shadeTo: "light",
                            shadeIntensity: .65
                        }
                    }
                };
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$P = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.graphics = new $d4be73e5731103af$var$m(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new $d4be73e5731103af$var$w(this), this.xAxisAnnotations = new $d4be73e5731103af$var$k(this), this.yAxisAnnotations = new $d4be73e5731103af$var$A(this), this.pointsAnnotations = new $d4be73e5731103af$var$S(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawAxesAnnotations",
            value: function() {
                var t = this.w;
                if (t.globals.axisCharts) {
                    for(var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = t.config.chart.animations.enabled, r = [
                        e,
                        i,
                        a
                    ], o = [
                        i.node,
                        e.node,
                        a.node
                    ], n = 0; n < 3; n++)t.globals.dom.elGraphical.add(r[n]), !s || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && o[n].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                        el: o[n],
                        index: 0
                    });
                    this.helpers.annotationsBackground();
                }
            }
        },
        {
            key: "drawImageAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.images.map(function(e, i) {
                    t.addImage(e, i);
                });
            }
        },
        {
            key: "drawTextAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.texts.map(function(e, i) {
                    t.addText(e, i);
                });
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                this.xAxisAnnotations.addXaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                this.yAxisAnnotations.addYaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.pointsAnnotations.addPointAnnotation(t, e, i);
            }
        },
        {
            key: "addText",
            value: function(t, e) {
                var i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.foreColor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.cssClass, d = t.backgroundColor, g = t.borderWidth, u = t.strokeDashArray, p = t.borderRadius, f = t.borderColor, x = t.appendTo, b = void 0 === x ? ".apexcharts-annotations" : x, v = t.paddingLeft, m = void 0 === v ? 4 : v, y = t.paddingRight, w = void 0 === y ? 4 : y, k = t.paddingBottom, A = void 0 === k ? 2 : k, S = t.paddingTop, C = void 0 === S ? 2 : S, L = this.w, P = this.graphics.drawText({
                    x: i,
                    y: a,
                    text: s,
                    textAnchor: r || "start",
                    fontSize: n || "12px",
                    fontWeight: h || "regular",
                    fontFamily: l || L.config.chart.fontFamily,
                    foreColor: o || L.config.chart.foreColor,
                    cssClass: c
                }), I = L.globals.dom.baseEl.querySelector(b);
                I && I.appendChild(P.node);
                var T = P.bbox();
                if (s) {
                    var M = this.graphics.drawRect(T.x - m, T.y - C, T.width + m + w, T.height + A + C, p, d || "transparent", 1, g, f, u);
                    I.insertBefore(M.node, P.node);
                }
            }
        },
        {
            key: "addImage",
            value: function(t, e) {
                var i = this.w, a = t.path, s = t.x, r = void 0 === s ? 0 : s, o = t.y, n = void 0 === o ? 0 : o, l = t.width, h = void 0 === l ? 20 : l, c = t.height, d = void 0 === c ? 20 : c, g = t.appendTo, u = void 0 === g ? ".apexcharts-annotations" : g, p = i.globals.dom.Paper.image(a);
                p.size(h, d).move(r, n);
                var f = i.globals.dom.baseEl.querySelector(u);
                return f && f.appendChild(p.node), p;
            }
        },
        {
            key: "addXaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "xaxis",
                    contextMethod: i.addXaxisAnnotation
                }), i;
            }
        },
        {
            key: "addYaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "yaxis",
                    contextMethod: i.addYaxisAnnotation
                }), i;
            }
        },
        {
            key: "addPointAnnotationExternal",
            value: function(t, e, i) {
                return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "point",
                    contextMethod: i.addPointAnnotation
                }), i;
            }
        },
        {
            key: "addAnnotationExternal",
            value: function(t) {
                var e = t.params, i = t.pushToMemory, a = t.context, s = t.type, r = t.contextMethod, o = a, n = o.w, l = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), h = l.childNodes.length + 1, c = new $d4be73e5731103af$var$L, d = Object.assign({}, "xaxis" === s ? c.xAxisAnnotation : "yaxis" === s ? c.yAxisAnnotation : c.pointAnnotation), g = $d4be73e5731103af$var$x.extend(d, e);
                switch(s){
                    case "xaxis":
                        this.addXaxisAnnotation(g, l, h);
                        break;
                    case "yaxis":
                        this.addYaxisAnnotation(g, l, h);
                        break;
                    case "point":
                        this.addPointAnnotation(g, l, h);
                }
                var u = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(h, "']")), p = this.helpers.addBackgroundToAnno(u, g);
                return p && l.insertBefore(p.node, u), i && n.globals.memory.methodsToExec.push({
                    context: o,
                    id: g.id ? g.id : $d4be73e5731103af$var$x.randomId(),
                    method: r,
                    label: "addAnnotation",
                    params: e
                }), a;
            }
        },
        {
            key: "clearAnnotations",
            value: function(t) {
                var e = t.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                e.globals.memory.methodsToExec.map(function(t, i) {
                    "addText" !== t.label && "addAnnotation" !== t.label || e.globals.memory.methodsToExec.splice(i, 1);
                }), i = $d4be73e5731103af$var$x.listToArray(i), Array.prototype.forEach.call(i, function(t) {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                });
            }
        },
        {
            key: "removeAnnotation",
            value: function(t, e) {
                var i = t.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                a && (i.globals.memory.methodsToExec.map(function(t, a) {
                    t.id === e && i.globals.memory.methodsToExec.splice(a, 1);
                }), Array.prototype.forEach.call(a, function(t) {
                    t.parentElement.removeChild(t);
                }));
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$I = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.months31 = [
            1,
            3,
            5,
            7,
            8,
            10,
            12
        ], this.months30 = [
            2,
            4,
            6,
            9,
            11
        ], this.daysCntOfYear = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "isValidDate",
            value: function(t) {
                return !isNaN(this.parseDate(t));
            }
        },
        {
            key: "getTimeStamp",
            value: function(t) {
                return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t;
            }
        },
        {
            key: "getDate",
            value: function(t) {
                return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t);
            }
        },
        {
            key: "parseDate",
            value: function(t) {
                var e = Date.parse(t);
                if (!isNaN(e)) return this.getTimeStamp(t);
                var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                return i = this.getTimeStamp(i);
            }
        },
        {
            key: "parseDateWithTimezone",
            value: function(t) {
                return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
            }
        },
        {
            key: "formatDate",
            value: function(t, e) {
                var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                    "\x00"
                ].concat($d4be73e5731103af$var$u(i.months)), r = [
                    "\x01"
                ].concat($d4be73e5731103af$var$u(i.shortMonths)), o = [
                    "\x02"
                ].concat($d4be73e5731103af$var$u(i.days)), n = [
                    "\x03"
                ].concat($d4be73e5731103af$var$u(i.shortDays));
                function l(t, e) {
                    var i = t + "";
                    for(e = e || 2; i.length < e;)i = "0" + i;
                    return i;
                }
                var h = a ? t.getUTCFullYear() : t.getFullYear();
                e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + h)).replace(/(^|[^\\])yy/g, "$1" + h.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + h);
                var c = (a ? t.getUTCMonth() : t.getMonth()) + 1;
                e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + l(c))).replace(/(^|[^\\])M/g, "$1" + c);
                var d = a ? t.getUTCDate() : t.getDate();
                e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + o[0])).replace(/(^|[^\\])ddd/g, "$1" + n[0])).replace(/(^|[^\\])dd/g, "$1" + l(d))).replace(/(^|[^\\])d/g, "$1" + d);
                var g = a ? t.getUTCHours() : t.getHours(), p = g > 12 ? g - 12 : 0 === g ? 12 : g;
                e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + l(g))).replace(/(^|[^\\])H/g, "$1" + g)).replace(/(^|[^\\])hh+/g, "$1" + l(p))).replace(/(^|[^\\])h/g, "$1" + p);
                var f = a ? t.getUTCMinutes() : t.getMinutes();
                e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + l(f))).replace(/(^|[^\\])m/g, "$1" + f);
                var x = a ? t.getUTCSeconds() : t.getSeconds();
                e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + l(x))).replace(/(^|[^\\])s/g, "$1" + x);
                var b = a ? t.getUTCMilliseconds() : t.getMilliseconds();
                e = e.replace(/(^|[^\\])fff+/g, "$1" + l(b, 3)), b = Math.round(b / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + l(b)), b = Math.round(b / 10);
                var v = g < 12 ? "AM" : "PM";
                e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + b)).replace(/(^|[^\\])TT+/g, "$1" + v)).replace(/(^|[^\\])T/g, "$1" + v.charAt(0));
                var m = v.toLowerCase();
                e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + m)).replace(/(^|[^\\])t/g, "$1" + m.charAt(0));
                var y = -t.getTimezoneOffset(), w = a || !y ? "Z" : y > 0 ? "+" : "-";
                if (!a) {
                    var k = (y = Math.abs(y)) % 60;
                    w += l(Math.floor(y / 60)) + ":" + l(k);
                }
                e = e.replace(/(^|[^\\])K/g, "$1" + w);
                var A = (a ? t.getUTCDay() : t.getDay()) + 1;
                return e = (e = (e = (e = (e = e.replace(new RegExp(o[0], "g"), o[A])).replace(new RegExp(n[0], "g"), n[A])).replace(new RegExp(s[0], "g"), s[c])).replace(new RegExp(r[0], "g"), r[c])).replace(/\\(.)/g, "$1");
            }
        },
        {
            key: "getTimeUnitsfromTimestamp",
            value: function(t, e, i) {
                var a = this.w;
                void 0 !== a.config.xaxis.min && (t = a.config.xaxis.min), void 0 !== a.config.xaxis.max && (e = a.config.xaxis.max);
                var s = this.getDate(t), r = this.getDate(e), o = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), n = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                return {
                    minMillisecond: parseInt(o[6], 10),
                    maxMillisecond: parseInt(n[6], 10),
                    minSecond: parseInt(o[5], 10),
                    maxSecond: parseInt(n[5], 10),
                    minMinute: parseInt(o[4], 10),
                    maxMinute: parseInt(n[4], 10),
                    minHour: parseInt(o[3], 10),
                    maxHour: parseInt(n[3], 10),
                    minDate: parseInt(o[2], 10),
                    maxDate: parseInt(n[2], 10),
                    minMonth: parseInt(o[1], 10) - 1,
                    maxMonth: parseInt(n[1], 10) - 1,
                    minYear: parseInt(o[0], 10),
                    maxYear: parseInt(n[0], 10)
                };
            }
        },
        {
            key: "isLeapYear",
            value: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
            }
        },
        {
            key: "calculcateLastDaysOfMonth",
            value: function(t, e, i) {
                return this.determineDaysOfMonths(t, e) - i;
            }
        },
        {
            key: "determineDaysOfYear",
            value: function(t) {
                var e = 365;
                return this.isLeapYear(t) && (e = 366), e;
            }
        },
        {
            key: "determineRemainingDaysOfYear",
            value: function(t, e, i) {
                var a = this.daysCntOfYear[e] + i;
                return e > 1 && this.isLeapYear() && a++, a;
            }
        },
        {
            key: "determineDaysOfMonths",
            value: function(t, e) {
                var i = 30;
                switch(t = $d4be73e5731103af$var$x.monthMod(t), !0){
                    case this.months30.indexOf(t) > -1:
                        2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                        break;
                    case this.months31.indexOf(t) > -1:
                    default:
                        i = 31;
                }
                return i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$T = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "xLabelFormat",
            value: function(t, e, i, a) {
                var s = this.w;
                if ("datetime" === s.config.xaxis.type && void 0 === s.config.xaxis.labels.formatter && void 0 === s.config.tooltip.x.formatter) {
                    var r = new $d4be73e5731103af$var$I(this.ctx);
                    return r.formatDate(r.getDate(e), s.config.tooltip.x.format);
                }
                return t(e, i, a);
            }
        },
        {
            key: "defaultGeneralFormatter",
            value: function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t;
            }
        },
        {
            key: "defaultYFormatter",
            value: function(t, e, i) {
                var a = this.w;
                return $d4be73e5731103af$var$x.isNumber(t) && (t = 0 !== a.globals.yValueDecimal ? t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : a.globals.yValueDecimal) : a.globals.maxYArr[i] - a.globals.minYArr[i] < 5 ? t.toFixed(1) : t.toFixed(0)), t;
            }
        },
        {
            key: "setLabelFormatters",
            value: function() {
                var t = this, e = this.w;
                return e.globals.xaxisTooltipFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttKeyFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttZFormatter = function(t) {
                    return t;
                }, e.globals.legendFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function(t) {
                    if ($d4be73e5731103af$var$x.isNumber(t)) {
                        if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                            if ($d4be73e5731103af$var$x.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                            var i = e.globals.maxX - e.globals.minX;
                            return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0);
                        }
                        if (e.globals.isBarHorizontal) {
                            if (e.globals.maxY - e.globals.minYArr < 4) return t.toFixed(1);
                        }
                        return t.toFixed(0);
                    }
                    return t;
                }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach(function(i, a) {
                    void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[a] = i.labels.formatter : e.globals.yLabelFormatters[a] = function(s) {
                        return e.globals.xyCharts ? Array.isArray(s) ? s.map(function(e) {
                            return t.defaultYFormatter(e, i, a);
                        }) : t.defaultYFormatter(s, i, a) : s;
                    };
                }), e.globals;
            }
        },
        {
            key: "heatmapLabelFormatters",
            value: function() {
                var t = this.w;
                if ("heatmap" === t.config.chart.type) {
                    t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                    var e = t.globals.seriesNames.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0);
                    t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e;
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$M = function(t) {
    var e, i = t.isTimeline, a = t.ctx, s = t.seriesIndex, r = t.dataPointIndex, o = t.y1, n = t.y2, l = t.w, h = l.globals.seriesRangeStart[s][r], c = l.globals.seriesRangeEnd[s][r], d = l.globals.labels[r], g = l.config.series[s].name ? l.config.series[s].name : "", u = l.globals.ttKeyFormatter, p = l.config.tooltip.y.title.formatter, f = {
        w: l,
        seriesIndex: s,
        dataPointIndex: r,
        start: h,
        end: c
    };
    ("function" == typeof p && (g = p(g, f)), null !== (e = l.config.series[s].data[r]) && void 0 !== e && e.x && (d = l.config.series[s].data[r].x), i) || "datetime" === l.config.xaxis.type && (d = new $d4be73e5731103af$var$T(a).xLabelFormat(l.globals.ttKeyFormatter, d, d, {
        i: void 0,
        dateFormatter: new $d4be73e5731103af$var$I(a).formatDate,
        w: l
    }));
    "function" == typeof u && (d = u(d, f)), Number.isFinite(o) && Number.isFinite(n) && (h = o, c = n);
    var x = "", b = "", v = l.globals.colors[s];
    if (void 0 === l.config.tooltip.x.formatter) {
        if ("datetime" === l.config.xaxis.type) {
            var m = new $d4be73e5731103af$var$I(a);
            x = m.formatDate(m.getDate(h), l.config.tooltip.x.format), b = m.formatDate(m.getDate(c), l.config.tooltip.x.format);
        } else x = h, b = c;
    } else x = l.config.tooltip.x.formatter(h), b = l.config.tooltip.x.formatter(c);
    return {
        start: h,
        end: c,
        startVal: x,
        endVal: b,
        ylabel: d,
        color: v,
        seriesName: g
    };
}, $d4be73e5731103af$var$X = function(t) {
    var e = t.color, i = t.seriesName, a = t.ylabel, s = t.start, r = t.end, o = t.seriesIndex, n = t.dataPointIndex, l = t.ctx.tooltip.tooltipLabels.getFormatters(o);
    s = l.yLbFormatter(s), r = l.yLbFormatter(r);
    var h = l.yLbFormatter(t.w.globals.series[o][n]), c = '<span class="value start-value">\n  '.concat(s, '\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r, "\n  </span>");
    return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (i || "") + '</span></div><div> <span class="category">' + a + ": </span> " + (t.w.globals.comboCharts ? "rangeArea" === t.w.config.series[o].type || "rangeBar" === t.w.config.series[o].type ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
}, $d4be73e5731103af$var$z = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.opts = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "hideYAxis",
            value: function() {
                this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
            }
        },
        {
            key: "line",
            value: function() {
                return {
                    chart: {
                        animations: {
                            easing: "swing"
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "sparkline",
            value: function(t) {
                this.hideYAxis();
                return $d4be73e5731103af$var$x.extend(t, {
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    },
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    }
                });
            }
        },
        {
            key: "bar",
            value: function() {
                return {
                    chart: {
                        stacked: !1,
                        animations: {
                            easing: "swing"
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "round"
                    },
                    fill: {
                        opacity: .85
                    },
                    legend: {
                        markers: {
                            shape: "square",
                            radius: 2,
                            size: 8
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        },
                        tickPlacement: "between",
                        crosshairs: {
                            width: "barWidth",
                            position: "back",
                            fill: {
                                type: "gradient"
                            },
                            dropShadow: {
                                enabled: !1
                            },
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "funnel",
            value: function() {
                return this.hideYAxis(), $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, this.bar()), {}, {
                    chart: {
                        animations: {
                            easing: "linear",
                            speed: 800,
                            animateGradually: {
                                enabled: !1
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: !0,
                            borderRadiusApplication: "around",
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    }
                });
            }
        },
        {
            key: "candlestick",
            value: function() {
                var t = this;
                return {
                    stroke: {
                        width: 1,
                        colors: [
                            "#333"
                        ]
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Open",
                                "High",
                                "",
                                "Low",
                                "Close"
                            ], "candlestick");
                        }
                    },
                    states: {
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "boxPlot",
            value: function() {
                var t = this;
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !1
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: [
                            "#24292e"
                        ]
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Minimum",
                                "Q1",
                                "Median",
                                "Q3",
                                "Maximum"
                            ], "boxPlot");
                        }
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 1,
                        strokeColors: "#111"
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "rangeBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            animateGradually: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        enabled: !1,
                        formatter: function(t, e) {
                            e.ctx;
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w, r = function() {
                                var t = s.globals.seriesRangeStart[i][a];
                                return s.globals.seriesRangeEnd[i][a] - t;
                            };
                            return s.globals.comboCharts ? "rangeBar" === s.config.series[i].type || "rangeArea" === s.config.series[i].type ? r() : t : r();
                        },
                        background: {
                            enabled: !1
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    markers: {
                        size: 10
                    },
                    tooltip: {
                        shared: !1,
                        followCursor: !0,
                        custom: function(t) {
                            return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function(t) {
                                var i = $d4be73e5731103af$var$M($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t), {}, {
                                    isTimeline: !0
                                })), a = i.color, s = i.seriesName, r = i.ylabel, o = i.startVal, n = i.endVal;
                                return $d4be73e5731103af$var$X($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t) : function(t) {
                                var i = $d4be73e5731103af$var$M(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return $d4be73e5731103af$var$X($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t);
                        }
                    },
                    xaxis: {
                        tickPlacement: "between",
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "dumbbell",
            value: function(t) {
                var e, i;
                return null !== (e = t.plotOptions.bar) && void 0 !== e && e.barHeight || (t.plotOptions.bar.barHeight = 2), null !== (i = t.plotOptions.bar) && void 0 !== i && i.columnWidth || (t.plotOptions.bar.columnWidth = 2), t;
            }
        },
        {
            key: "area",
            value: function() {
                return {
                    stroke: {
                        width: 4,
                        fill: {
                            type: "solid",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: .65,
                                opacityTo: .5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        }
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            inverseColors: !1,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: .65,
                            opacityTo: .5,
                            stops: [
                                0,
                                100,
                                100
                            ]
                        }
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    tooltip: {
                        followCursor: !1
                    }
                };
            }
        },
        {
            key: "rangeArea",
            value: function() {
                return {
                    stroke: {
                        curve: "straight",
                        width: 0
                    },
                    fill: {
                        type: "solid",
                        opacity: .6
                    },
                    markers: {
                        size: 0
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "none"
                            }
                        },
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    tooltip: {
                        intersect: !1,
                        shared: !0,
                        followCursor: !0,
                        custom: function(t) {
                            return function(t) {
                                var i = $d4be73e5731103af$var$M(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return $d4be73e5731103af$var$X($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t);
                        }
                    }
                };
            }
        },
        {
            key: "brush",
            value: function(t) {
                return $d4be73e5731103af$var$x.extend(t, {
                    chart: {
                        toolbar: {
                            autoSelected: "selection",
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 1
                    },
                    tooltip: {
                        enabled: !1
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        }
                    }
                });
            }
        },
        {
            key: "stacked100",
            value: function(t) {
                t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                var e = t.dataLabels.formatter;
                return t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }), "bar" === t.chart.type && (t.dataLabels.formatter = e || function(t) {
                    return "number" == typeof t && t ? t.toFixed(0) + "%" : t;
                }), t;
            }
        },
        {
            key: "stackedBars",
            value: function() {
                var t = this.bar();
                return $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t), {}, {
                    plotOptions: $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t.plotOptions), {}, {
                        bar: $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, t.plotOptions.bar), {}, {
                            borderRadiusApplication: "end",
                            borderRadiusWhenStacked: "last"
                        })
                    })
                });
            }
        },
        {
            key: "convertCatToNumeric",
            value: function(t) {
                return t.xaxis.convertedCatToNumeric = !0, t;
            }
        },
        {
            key: "convertCatToNumericXaxis",
            value: function(t, e, i) {
                t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function(t) {
                    return $d4be73e5731103af$var$x.isNumber(t) ? Math.floor(t) : t;
                };
                var a = t.xaxis.labels.formatter, s = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                return i && i.length && (s = i.map(function(t) {
                    return Array.isArray(t) ? t : String(t);
                })), s && s.length && (t.xaxis.labels.formatter = function(t) {
                    return $d4be73e5731103af$var$x.isNumber(t) ? a(s[Math.floor(t) - 1]) : a(t);
                }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t;
            }
        },
        {
            key: "bubble",
            value: function() {
                return {
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        crosshairs: {
                            width: 0
                        }
                    },
                    fill: {
                        type: "solid",
                        gradient: {
                            shade: "light",
                            inverse: !0,
                            shadeIntensity: .55,
                            opacityFrom: .4,
                            opacityTo: .8
                        }
                    }
                };
            }
        },
        {
            key: "scatter",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    markers: {
                        size: 6,
                        strokeWidth: 1,
                        hover: {
                            sizeOffset: 2
                        }
                    }
                };
            }
        },
        {
            key: "heatmap",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    tooltip: {
                        followCursor: !0,
                        marker: {
                            show: !1
                        },
                        x: {
                            show: !1
                        }
                    },
                    legend: {
                        position: "top",
                        markers: {
                            shape: "square",
                            size: 10,
                            offsetY: 2
                        }
                    },
                    grid: {
                        padding: {
                            right: 20
                        }
                    }
                };
            }
        },
        {
            key: "treemap",
            value: function() {
                return {
                    chart: {
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        show: !0,
                        width: 2,
                        colors: [
                            "#fff"
                        ]
                    },
                    legend: {
                        show: !1
                    },
                    fill: {
                        gradient: {
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        followCursor: !0,
                        x: {
                            show: !1
                        }
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        }
                    }
                };
            }
        },
        {
            key: "pie",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: !1
                                }
                            }
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "donut",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            shadeIntensity: .35,
                            stops: [
                                80,
                                100
                            ],
                            opacityFrom: 1,
                            opacityTo: 1
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "polarArea",
            value: function() {
                return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        enabled: !1
                    },
                    stroke: {
                        show: !0,
                        width: 2
                    },
                    fill: {
                        opacity: .7
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "radar",
            value: function() {
                return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                    dataLabels: {
                        enabled: !1,
                        style: {
                            fontSize: "11px"
                        }
                    },
                    stroke: {
                        width: 2
                    },
                    markers: {
                        size: 3,
                        strokeWidth: 1,
                        strokeOpacity: 1
                    },
                    fill: {
                        opacity: .2
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    grid: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            formatter: function(t) {
                                return t;
                            },
                            style: {
                                colors: [
                                    "#a8a8a8"
                                ],
                                fontSize: "11px"
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    }
                };
            }
        },
        {
            key: "radialBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 800
                            }
                        },
                        toolbar: {
                            show: !1
                        }
                    },
                    fill: {
                        gradient: {
                            shade: "dark",
                            shadeIntensity: .4,
                            inverseColors: !1,
                            type: "diagonal2",
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                70,
                                98,
                                100
                            ]
                        }
                    },
                    legend: {
                        show: !1,
                        position: "right"
                    },
                    tooltip: {
                        enabled: !1,
                        fillSeriesColor: !0
                    }
                };
            }
        },
        {
            key: "_getBoxTooltip",
            value: function(t, e, i, a, s) {
                var r = t.globals.seriesCandleO[e][i], o = t.globals.seriesCandleH[e][i], n = t.globals.seriesCandleM[e][i], l = t.globals.seriesCandleL[e][i], h = t.globals.seriesCandleC[e][i];
                return t.config.series[e].type && t.config.series[e].type !== s ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + o + "</span></div>" + (n ? "<div>".concat(a[2], ': <span class="value">') + n + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + l + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + h + "</span></div></div>";
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$E = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.opts = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "init",
            value: function(t) {
                var e = t.responsiveOverride, a = this.opts, s = new $d4be73e5731103af$var$L, r = new $d4be73e5731103af$var$z(a);
                this.chartType = a.chart.type, a = this.extendYAxis(a), a = this.extendAnnotations(a);
                var o = s.init(), n = {};
                if (a && "object" === $d4be73e5731103af$var$i(a)) {
                    var l, h, c, d, g, u, p, f, b = {};
                    b = -1 !== [
                        "line",
                        "area",
                        "bar",
                        "candlestick",
                        "boxPlot",
                        "rangeBar",
                        "rangeArea",
                        "bubble",
                        "scatter",
                        "heatmap",
                        "treemap",
                        "pie",
                        "polarArea",
                        "donut",
                        "radar",
                        "radialBar"
                    ].indexOf(a.chart.type) ? r[a.chart.type]() : r.line(), null !== (l = a.plotOptions) && void 0 !== l && null !== (h = l.bar) && void 0 !== h && h.isFunnel && (b = r.funnel()), a.chart.stacked && "bar" === a.chart.type && (b = r.stackedBars()), null !== (c = a.chart.brush) && void 0 !== c && c.enabled && (b = r.brush(b)), a.chart.stacked && "100%" === a.chart.stackType && (a = r.stacked100(a)), null !== (d = a.plotOptions) && void 0 !== d && null !== (g = d.bar) && void 0 !== g && g.isDumbbell && (a = r.dumbbell(a)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(a), a.xaxis = a.xaxis || window.Apex.xaxis || {}, e || (a.xaxis.convertedCatToNumeric = !1), (null !== (u = (a = this.checkForCatToNumericXAxis(this.chartType, b, a)).chart.sparkline) && void 0 !== u && u.enabled || null !== (p = window.Apex.chart) && void 0 !== p && null !== (f = p.sparkline) && void 0 !== f && f.enabled) && (b = r.sparkline(b)), n = $d4be73e5731103af$var$x.extend(o, b);
                }
                var v = $d4be73e5731103af$var$x.extend(n, window.Apex);
                return o = $d4be73e5731103af$var$x.extend(v, a), o = this.handleUserInputErrors(o);
            }
        },
        {
            key: "checkForCatToNumericXAxis",
            value: function(t, e, i) {
                var a, s, r = new $d4be73e5731103af$var$z(i), o = ("bar" === t || "boxPlot" === t) && (null === (a = i.plotOptions) || void 0 === a || null === (s = a.bar) || void 0 === s ? void 0 : s.horizontal), n = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t, l = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type, h = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                return o || n || !l || "between" === h || (i = r.convertCatToNumeric(i)), i;
            }
        },
        {
            key: "extendYAxis",
            value: function(t, e) {
                var i = new $d4be73e5731103af$var$L;
                (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = $d4be73e5731103af$var$x.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [
                    $d4be73e5731103af$var$x.extend(i.yAxis, t.yaxis)
                ] : t.yaxis = $d4be73e5731103af$var$x.extendArray(t.yaxis, i.yAxis);
                var a = !1;
                t.yaxis.forEach(function(t) {
                    t.logarithmic && (a = !0);
                });
                var s = t.series;
                return e && !s && (s = e.config.series), a && s.length !== t.yaxis.length && s.length && (t.yaxis = s.map(function(e, a) {
                    if (e.name || (s[a].name = "series-".concat(a + 1)), t.yaxis[a]) return t.yaxis[a].seriesName = s[a].name, t.yaxis[a];
                    var r = $d4be73e5731103af$var$x.extend(i.yAxis, t.yaxis[0]);
                    return r.show = !1, r;
                })), a && s.length > 1 && s.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes. Please make sure to equalize both."), t;
            }
        },
        {
            key: "extendAnnotations",
            value: function(t) {
                return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), t = this.extendPointAnnotations(t);
            }
        },
        {
            key: "extendYAxisAnnotations",
            value: function(t) {
                var e = new $d4be73e5731103af$var$L;
                return t.annotations.yaxis = $d4be73e5731103af$var$x.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t;
            }
        },
        {
            key: "extendXAxisAnnotations",
            value: function(t) {
                var e = new $d4be73e5731103af$var$L;
                return t.annotations.xaxis = $d4be73e5731103af$var$x.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t;
            }
        },
        {
            key: "extendPointAnnotations",
            value: function(t) {
                var e = new $d4be73e5731103af$var$L;
                return t.annotations.points = $d4be73e5731103af$var$x.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t;
            }
        },
        {
            key: "checkForDarkTheme",
            value: function(t) {
                t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.chart.background || (t.chart.background = "#424242"), t.theme.palette || (t.theme.palette = "palette4"));
            }
        },
        {
            key: "handleUserInputErrors",
            value: function(t) {
                var e = t;
                if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                    if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                    e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1;
                }
                return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Y = function() {
    function t() {
        $d4be73e5731103af$var$a(this, t);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "initGlobalVars",
            value: function(t) {
                t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRange = [], t.seriesPercent = [], t.seriesGoals = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.hasXaxisGroups = !1, t.groups = [], t.hasSeriesGroups = !1, t.seriesGroups = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0;
            }
        },
        {
            key: "globalVars",
            value: function(t) {
                return {
                    chartID: null,
                    cuid: null,
                    events: {
                        beforeMount: [],
                        mounted: [],
                        updated: [],
                        clicked: [],
                        selection: [],
                        dataPointSelection: [],
                        zoomed: [],
                        scrolled: []
                    },
                    colors: [],
                    clientX: null,
                    clientY: null,
                    fill: {
                        colors: []
                    },
                    stroke: {
                        colors: []
                    },
                    dataLabels: {
                        style: {
                            colors: []
                        }
                    },
                    radarPolygons: {
                        fill: {
                            colors: []
                        }
                    },
                    markers: {
                        colors: [],
                        size: t.markers.size,
                        largestSize: 0
                    },
                    animationEnded: !1,
                    isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                    isDirty: !1,
                    isExecCalled: !1,
                    initialConfig: null,
                    initialSeries: [],
                    lastXAxis: [],
                    lastYAxis: [],
                    columnSeries: null,
                    labels: [],
                    timescaleLabels: [],
                    noLabelsProvided: !1,
                    allSeriesCollapsed: !1,
                    collapsedSeries: [],
                    collapsedSeriesIndices: [],
                    ancillaryCollapsedSeries: [],
                    ancillaryCollapsedSeriesIndices: [],
                    risingSeries: [],
                    dataFormatXNumeric: !1,
                    capturedSeriesIndex: -1,
                    capturedDataPointIndex: -1,
                    selectedDataPoints: [],
                    goldenPadding: 35,
                    invalidLogScale: !1,
                    ignoreYAxisIndexes: [],
                    yAxisSameScaleIndices: [],
                    maxValsInArrayIndex: 0,
                    radialSize: 0,
                    selection: void 0,
                    zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                    panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                    selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                    yaxis: null,
                    mousedown: !1,
                    lastClientPosition: {},
                    visibleXRange: void 0,
                    yValueDecimal: 0,
                    total: 0,
                    SVGNS: "http://www.w3.org/2000/svg",
                    svgWidth: 0,
                    svgHeight: 0,
                    noData: !1,
                    locale: {},
                    dom: {},
                    memory: {
                        methodsToExec: []
                    },
                    shouldAnimate: !0,
                    skipLastTimelinelabel: !1,
                    skipFirstTimelinelabel: !1,
                    delayedElements: [],
                    axisCharts: !0,
                    isDataXYZ: !1,
                    resized: !1,
                    resizeTimer: null,
                    comboCharts: !1,
                    dataChanged: !1,
                    previousPaths: [],
                    allSeriesHasEqualX: !0,
                    pointsArray: [],
                    dataLabelsRects: [],
                    lastDrawnDataLabelsIndexes: [],
                    hasNullValues: !1,
                    easing: null,
                    zoomed: !1,
                    gridWidth: 0,
                    gridHeight: 0,
                    rotateXLabels: !1,
                    defaultLabels: !1,
                    xLabelFormatter: void 0,
                    yLabelFormatters: [],
                    xaxisTooltipFormatter: void 0,
                    ttKeyFormatter: void 0,
                    ttVal: void 0,
                    ttZFormatter: void 0,
                    LINE_HEIGHT_RATIO: 1.618,
                    xAxisLabelsHeight: 0,
                    xAxisGroupLabelsHeight: 0,
                    xAxisLabelsWidth: 0,
                    yAxisLabelsWidth: 0,
                    scaleX: 1,
                    scaleY: 1,
                    translateX: 0,
                    translateY: 0,
                    translateYAxisX: [],
                    yAxisWidths: [],
                    translateXAxisY: 0,
                    translateXAxisX: 0,
                    tooltip: null
                };
            }
        },
        {
            key: "init",
            value: function(t) {
                var e = this.globalVars(t);
                return this.initGlobalVars(e), e.initialConfig = $d4be73e5731103af$var$x.extend({}, t), e.initialSeries = $d4be73e5731103af$var$x.clone(t.series), e.lastXAxis = $d4be73e5731103af$var$x.clone(e.initialConfig.xaxis), e.lastYAxis = $d4be73e5731103af$var$x.clone(e.initialConfig.yaxis), e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$F = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.opts = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "init",
            value: function() {
                var t = new $d4be73e5731103af$var$E(this.opts).init({
                    responsiveOverride: !1
                });
                return {
                    config: t,
                    globals: (new $d4be73e5731103af$var$Y).init(t)
                };
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$R = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "clippedImgArea",
            value: function(t) {
                var e = this.w, i = e.config, a = parseInt(e.globals.gridWidth, 10), s = parseInt(e.globals.gridHeight, 10), r = a > s ? a : s, o = t.image, n = 0, l = 0;
                void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (n = i.fill.image.width + 1, l = i.fill.image.height) : (n = r + 1, l = r) : (n = t.width, l = t.height);
                var h = document.createElementNS(e.globals.SVGNS, "pattern");
                $d4be73e5731103af$var$m.setAttrs(h, {
                    id: t.patternID,
                    patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                    width: n + "px",
                    height: l + "px"
                });
                var c = document.createElementNS(e.globals.SVGNS, "image");
                h.appendChild(c), c.setAttributeNS(window.SVG.xlink, "href", o), $d4be73e5731103af$var$m.setAttrs(c, {
                    x: 0,
                    y: 0,
                    preserveAspectRatio: "none",
                    width: n + "px",
                    height: l + "px"
                }), c.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(h);
            }
        },
        {
            key: "getSeriesIndex",
            value: function(t) {
                var e = this.w, i = e.config.chart.type;
                return ("bar" === i || "rangeBar" === i) && e.config.plotOptions.bar.distributed || "heatmap" === i || "treemap" === i ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex;
            }
        },
        {
            key: "fillPath",
            value: function(t) {
                var e = this.w;
                this.opts = t;
                var i, a, s, r = this.w.config;
                this.seriesIndex = this.getSeriesIndex(t);
                var o = this.getFillColors()[this.seriesIndex];
                void 0 !== e.globals.seriesColors[this.seriesIndex] && (o = e.globals.seriesColors[this.seriesIndex]), "function" == typeof o && (o = o({
                    seriesIndex: this.seriesIndex,
                    dataPointIndex: t.dataPointIndex,
                    value: t.value,
                    w: e
                }));
                var n = t.fillType ? t.fillType : this.getFillType(this.seriesIndex), l = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                t.color && (o = t.color);
                var h = o;
                if (-1 === o.indexOf("rgb") ? o.length < 9 && (h = $d4be73e5731103af$var$x.hexToRgba(o, l)) : o.indexOf("rgba") > -1 && (l = $d4be73e5731103af$var$x.getOpacityFromRGBA(o)), t.opacity && (l = t.opacity), "pattern" === n && (a = this.handlePatternFill({
                    fillConfig: t.fillConfig,
                    patternFill: a,
                    fillColor: o,
                    fillOpacity: l,
                    defaultColor: h
                })), "gradient" === n && (s = this.handleGradientFill({
                    fillConfig: t.fillConfig,
                    fillColor: o,
                    fillOpacity: l,
                    i: this.seriesIndex
                })), "image" === n) {
                    var c = r.fill.image.src, d = t.patternID ? t.patternID : "";
                    this.clippedImgArea({
                        opacity: l,
                        image: Array.isArray(c) ? t.seriesNumber < c.length ? c[t.seriesNumber] : c[0] : c,
                        width: t.width ? t.width : void 0,
                        height: t.height ? t.height : void 0,
                        patternUnits: t.patternUnits,
                        patternID: "pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d)
                    }), i = "url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d, ")");
                } else i = "gradient" === n ? s : "pattern" === n ? a : h;
                return t.solid && (i = h), i;
            }
        },
        {
            key: "getFillType",
            value: function(t) {
                var e = this.w;
                return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type;
            }
        },
        {
            key: "getFillColors",
            value: function() {
                var t = this.w, e = t.config, i = this.opts, a = [];
                return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors), void 0 !== i.fillColors && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
            }
        },
        {
            key: "handlePatternFill",
            value: function(t) {
                var e = t.fillConfig, i = t.patternFill, a = t.fillColor, s = t.fillOpacity, r = t.defaultColor, o = this.w.config.fill;
                e && (o = e);
                var n = this.opts, l = new $d4be73e5731103af$var$m(this.ctx), h = Array.isArray(o.pattern.strokeWidth) ? o.pattern.strokeWidth[this.seriesIndex] : o.pattern.strokeWidth, c = a;
                Array.isArray(o.pattern.style) ? i = void 0 !== o.pattern.style[n.seriesNumber] ? l.drawPattern(o.pattern.style[n.seriesNumber], o.pattern.width, o.pattern.height, c, h, s) : r : i = l.drawPattern(o.pattern.style, o.pattern.width, o.pattern.height, c, h, s);
                return i;
            }
        },
        {
            key: "handleGradientFill",
            value: function(t) {
                var i = t.fillColor, a = t.fillOpacity, s = t.fillConfig, r = t.i, o = this.w.config.fill;
                s && (o = $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, o), s));
                var n, l = this.opts, h = new $d4be73e5731103af$var$m(this.ctx), c = new $d4be73e5731103af$var$x, d = o.gradient.type, g = i, u = void 0 === o.gradient.opacityFrom ? a : Array.isArray(o.gradient.opacityFrom) ? o.gradient.opacityFrom[r] : o.gradient.opacityFrom;
                g.indexOf("rgba") > -1 && (u = $d4be73e5731103af$var$x.getOpacityFromRGBA(g));
                var p = void 0 === o.gradient.opacityTo ? a : Array.isArray(o.gradient.opacityTo) ? o.gradient.opacityTo[r] : o.gradient.opacityTo;
                if (void 0 === o.gradient.gradientToColors || 0 === o.gradient.gradientToColors.length) n = "dark" === o.gradient.shade ? c.shadeColor(-1 * parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? $d4be73e5731103af$var$x.rgb2hex(i) : i) : c.shadeColor(parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? $d4be73e5731103af$var$x.rgb2hex(i) : i);
                else if (o.gradient.gradientToColors[l.seriesNumber]) {
                    var f = o.gradient.gradientToColors[l.seriesNumber];
                    n = f, f.indexOf("rgba") > -1 && (p = $d4be73e5731103af$var$x.getOpacityFromRGBA(f));
                } else n = i;
                if (o.gradient.gradientFrom && (g = o.gradient.gradientFrom), o.gradient.gradientTo && (n = o.gradient.gradientTo), o.gradient.inverseColors) {
                    var b = g;
                    g = n, n = b;
                }
                return g.indexOf("rgb") > -1 && (g = $d4be73e5731103af$var$x.rgb2hex(g)), n.indexOf("rgb") > -1 && (n = $d4be73e5731103af$var$x.rgb2hex(n)), h.drawGradient(d, g, n, u, p, l.size, o.gradient.stops, o.gradient.colorStops, r);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$H = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "setGlobalMarkerSize",
            value: function() {
                var t = this.w;
                if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [
                    t.config.markers.size
                ], t.globals.markers.size.length > 0) {
                    if (t.globals.markers.size.length < t.globals.series.length + 1) for(var e = 0; e <= t.globals.series.length; e++)void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0]);
                } else t.globals.markers.size = t.config.series.map(function(e) {
                    return t.config.markers.size;
                });
            }
        },
        {
            key: "plotChartMarkers",
            value: function(t, e, i, a) {
                var s, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = this.w, n = e, l = t, h = null, c = new $d4be73e5731103af$var$m(this.ctx), d = o.config.markers.discrete && o.config.markers.discrete.length;
                if ((o.globals.markers.size[e] > 0 || r || d) && (h = c.group({
                    class: r || d ? "" : "apexcharts-series-markers"
                })).attr("clip-path", "url(#gridRectMarkerMask".concat(o.globals.cuid, ")")), Array.isArray(l.x)) for(var g = 0; g < l.x.length; g++){
                    var u = i;
                    1 === i && 0 === g && (u = 0), 1 === i && 1 === g && (u = 1);
                    var p = "apexcharts-marker";
                    if ("line" !== o.config.chart.type && "area" !== o.config.chart.type || o.globals.comboCharts || o.config.tooltip.intersect || (p += " no-pointer-events"), (Array.isArray(o.config.markers.size) ? o.globals.markers.size[e] > 0 : o.config.markers.size > 0) || r || d) {
                        $d4be73e5731103af$var$x.isNumber(l.y[g]) ? p += " w".concat($d4be73e5731103af$var$x.randomId()) : p = "apexcharts-nullpoint";
                        var f = this.getMarkerConfig({
                            cssClass: p,
                            seriesIndex: e,
                            dataPointIndex: u
                        });
                        o.config.series[n].data[u] && (o.config.series[n].data[u].fillColor && (f.pointFillColor = o.config.series[n].data[u].fillColor), o.config.series[n].data[u].strokeColor && (f.pointStrokeColor = o.config.series[n].data[u].strokeColor)), a && (f.pSize = a), (l.x[g] < 0 || l.x[g] > o.globals.gridWidth || l.y[g] < 0 || l.y[g] > o.globals.gridHeight) && (f.pSize = 0), (s = c.drawMarker(l.x[g], l.y[g], f)).attr("rel", u), s.attr("j", u), s.attr("index", e), s.node.setAttribute("default-marker-size", f.pSize), new $d4be73e5731103af$var$v(this.ctx).setSelectionFilter(s, e, u), this.addEvents(s), h && h.add(s);
                    } else void 0 === o.globals.pointsArray[e] && (o.globals.pointsArray[e] = []), o.globals.pointsArray[e].push([
                        l.x[g],
                        l.y[g]
                    ]);
                }
                return h;
            }
        },
        {
            key: "getMarkerConfig",
            value: function(t) {
                var e = t.cssClass, i = t.seriesIndex, a = t.dataPointIndex, s = void 0 === a ? null : a, r = t.finishRadius, o = void 0 === r ? null : r, n = this.w, l = this.getMarkerStyle(i), h = n.globals.markers.size[i], c = n.config.markers;
                return null !== s && c.discrete.length && c.discrete.map(function(t) {
                    t.seriesIndex === i && t.dataPointIndex === s && (l.pointStrokeColor = t.strokeColor, l.pointFillColor = t.fillColor, h = t.size, l.pointShape = t.shape);
                }), {
                    pSize: null === o ? h : o,
                    pRadius: c.radius,
                    width: Array.isArray(c.width) ? c.width[i] : c.width,
                    height: Array.isArray(c.height) ? c.height[i] : c.height,
                    pointStrokeWidth: Array.isArray(c.strokeWidth) ? c.strokeWidth[i] : c.strokeWidth,
                    pointStrokeColor: l.pointStrokeColor,
                    pointFillColor: l.pointFillColor,
                    shape: l.pointShape || (Array.isArray(c.shape) ? c.shape[i] : c.shape),
                    class: e,
                    pointStrokeOpacity: Array.isArray(c.strokeOpacity) ? c.strokeOpacity[i] : c.strokeOpacity,
                    pointStrokeDashArray: Array.isArray(c.strokeDashArray) ? c.strokeDashArray[i] : c.strokeDashArray,
                    pointFillOpacity: Array.isArray(c.fillOpacity) ? c.fillOpacity[i] : c.fillOpacity,
                    seriesIndex: i
                };
            }
        },
        {
            key: "addEvents",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                    passive: !0
                });
            }
        },
        {
            key: "getMarkerStyle",
            value: function(t) {
                var e = this.w, i = e.globals.markers.colors, a = e.config.markers.strokeColor || e.config.markers.strokeColors;
                return {
                    pointStrokeColor: Array.isArray(a) ? a[t] : a,
                    pointFillColor: Array.isArray(i) ? i[t] : i
                };
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$D = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new $d4be73e5731103af$var$m(this.ctx), r = i.realIndex, o = i.pointsPos, n = i.zRatio, l = i.elParent, h = s.group({
                    class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                });
                if (h.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(o.x)) for(var c = 0; c < o.x.length; c++){
                    var d = e + 1, g = !0;
                    0 === e && 0 === c && (d = 0), 0 === e && 1 === c && (d = 1);
                    var u = 0, p = a.globals.markers.size[r];
                    if (n !== 1 / 0) {
                        var f = a.config.plotOptions.bubble;
                        p = a.globals.seriesZ[r][d], f.zScaling && (p /= n), f.minBubbleRadius && p < f.minBubbleRadius && (p = f.minBubbleRadius), f.maxBubbleRadius && p > f.maxBubbleRadius && (p = f.maxBubbleRadius);
                    }
                    a.config.chart.animations.enabled || (u = p);
                    var x = o.x[c], b = o.y[c];
                    if (u = u || 0, null !== b && void 0 !== a.globals.series[r][d] || (g = !1), g) {
                        var v = this.drawPoint(x, b, u, p, r, d, e);
                        h.add(v);
                    }
                    l.add(h);
                }
            }
        },
        {
            key: "drawPoint",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = s, h = new $d4be73e5731103af$var$b(this.ctx), c = new $d4be73e5731103af$var$v(this.ctx), d = new $d4be73e5731103af$var$R(this.ctx), g = new $d4be73e5731103af$var$H(this.ctx), u = new $d4be73e5731103af$var$m(this.ctx), p = g.getMarkerConfig({
                    cssClass: "apexcharts-marker",
                    seriesIndex: l,
                    dataPointIndex: r,
                    finishRadius: "bubble" === n.config.chart.type || n.globals.comboCharts && n.config.series[s] && "bubble" === n.config.series[s].type ? a : null
                });
                a = p.pSize;
                var f, x = d.fillPath({
                    seriesNumber: s,
                    dataPointIndex: r,
                    color: p.pointFillColor,
                    patternUnits: "objectBoundingBox",
                    value: n.globals.series[s][o]
                });
                if ("circle" === p.shape ? f = u.drawCircle(i) : "square" !== p.shape && "rect" !== p.shape || (f = u.drawRect(0, 0, p.width - p.pointStrokeWidth / 2, p.height - p.pointStrokeWidth / 2, p.pRadius)), n.config.series[l].data[r] && n.config.series[l].data[r].fillColor && (x = n.config.series[l].data[r].fillColor), f.attr({
                    x: t - p.width / 2 - p.pointStrokeWidth / 2,
                    y: e - p.height / 2 - p.pointStrokeWidth / 2,
                    cx: t,
                    cy: e,
                    fill: x,
                    "fill-opacity": p.pointFillOpacity,
                    stroke: p.pointStrokeColor,
                    r: a,
                    "stroke-width": p.pointStrokeWidth,
                    "stroke-dasharray": p.pointStrokeDashArray,
                    "stroke-opacity": p.pointStrokeOpacity
                }), n.config.chart.dropShadow.enabled) {
                    var y = n.config.chart.dropShadow;
                    c.dropShadow(f, y, s);
                }
                if (!this.initialAnim || n.globals.dataChanged || n.globals.resized) n.globals.animationEnded = !0;
                else {
                    var w = n.config.chart.animations.speed;
                    h.animateMarker(f, 0, "circle" === p.shape ? a : {
                        width: p.width,
                        height: p.height
                    }, w, n.globals.easing, function() {
                        window.setTimeout(function() {
                            h.animationCompleted(f);
                        }, 100);
                    });
                }
                if (n.globals.dataChanged && "circle" === p.shape) {
                    if (this.dynamicAnim) {
                        var k, A, S, C, L = n.config.chart.animations.dynamicAnimation.speed;
                        null != (C = n.globals.previousPaths[s] && n.globals.previousPaths[s][o]) && (k = C.x, A = C.y, S = void 0 !== C.r ? C.r : a);
                        for(var P = 0; P < n.globals.collapsedSeries.length; P++)n.globals.collapsedSeries[P].index === s && (L = 1, a = 0);
                        0 === t && 0 === e && (a = 0), h.animateCircle(f, {
                            cx: k,
                            cy: A,
                            r: S
                        }, {
                            cx: t,
                            cy: e,
                            r: a
                        }, L, n.globals.easing);
                    } else f.attr({
                        r: a
                    });
                }
                return f.attr({
                    rel: r,
                    j: r,
                    index: s,
                    "default-marker-size": a
                }), c.setSelectionFilter(f, s, r), g.addEvents(f), f.node.classList.add("apexcharts-marker"), f;
            }
        },
        {
            key: "centerTextInBubble",
            value: function(t) {
                var e = this.w;
                return {
                    y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                };
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$O = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "dataLabelsCorrection",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = !1, h = new $d4be73e5731103af$var$m(this.ctx).getTextRects(i, o), c = h.width, d = h.height;
                e < 0 && (e = 0), e > n.globals.gridHeight + d && (e = n.globals.gridHeight + d / 2), void 0 === n.globals.dataLabelsRects[a] && (n.globals.dataLabelsRects[a] = []), n.globals.dataLabelsRects[a].push({
                    x: t,
                    y: e,
                    width: c,
                    height: d
                });
                var g = n.globals.dataLabelsRects[a].length - 2, u = void 0 !== n.globals.lastDrawnDataLabelsIndexes[a] ? n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                if (void 0 !== n.globals.dataLabelsRects[a][g]) {
                    var p = n.globals.dataLabelsRects[a][u];
                    (t > p.x + p.width + 2 || e > p.y + p.height + 2 || t + c < p.x) && (l = !0);
                }
                return (0 === s || r) && (l = !0), {
                    x: t,
                    y: e,
                    textRects: h,
                    drawnextLabel: l
                };
            }
        },
        {
            key: "drawDataLabel",
            value: function(t) {
                var e = this, i = t.type, a = t.pos, s = t.i, r = t.j, o = t.isRangeStart, n = t.strokeWidth, l = void 0 === n ? 2 : n, h = this.w, c = new $d4be73e5731103af$var$m(this.ctx), d = h.config.dataLabels, g = 0, u = 0, p = r, f = null;
                if (!d.enabled || !Array.isArray(a.x)) return f;
                f = c.group({
                    class: "apexcharts-data-labels"
                });
                for(var x = 0; x < a.x.length; x++)if (g = a.x[x] + d.offsetX, u = a.y[x] + d.offsetY + l, !isNaN(g)) {
                    1 === r && 0 === x && (p = 0), 1 === r && 1 === x && (p = 1);
                    var b = h.globals.series[s][p];
                    "rangeArea" === i && (b = o ? h.globals.seriesRangeStart[s][p] : h.globals.seriesRangeEnd[s][p]);
                    var v = "", y = function(t) {
                        return h.config.dataLabels.formatter(t, {
                            ctx: e.ctx,
                            seriesIndex: s,
                            dataPointIndex: p,
                            w: h
                        });
                    };
                    if ("bubble" === h.config.chart.type) v = y(b = h.globals.seriesZ[s][p]), u = a.y[x], u = new $d4be73e5731103af$var$D(this.ctx).centerTextInBubble(u, s, p).y;
                    else void 0 !== b && (v = y(b));
                    this.plotDataLabelsText({
                        x: g,
                        y: u,
                        text: v,
                        i: s,
                        j: p,
                        parent: f,
                        offsetCorrection: !0,
                        dataLabelsConfig: h.config.dataLabels
                    });
                }
                return f;
            }
        },
        {
            key: "plotDataLabelsText",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = t.x, s = t.y, r = t.i, o = t.j, n = t.text, l = t.textAnchor, h = t.fontSize, c = t.parent, d = t.dataLabelsConfig, g = t.color, u = t.alwaysDrawDataLabel, p = t.offsetCorrection;
                if (!(Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                    var f = {
                        x: a,
                        y: s,
                        drawnextLabel: !0,
                        textRects: null
                    };
                    p && (f = this.dataLabelsCorrection(a, s, n, r, o, u, parseInt(d.style.fontSize, 10))), e.globals.zoomed || (a = f.x, s = f.y), f.textRects && (a < -10 - f.textRects.width || a > e.globals.gridWidth + f.textRects.width + 10) && (n = "");
                    var x = e.globals.dataLabels.style.colors[r];
                    (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (x = e.globals.dataLabels.style.colors[o]), "function" == typeof x && (x = x({
                        series: e.globals.series,
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: e
                    })), g && (x = g);
                    var b = d.offsetX, y = d.offsetY;
                    if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (b = 0, y = 0), f.drawnextLabel) {
                        var w = i.drawText({
                            width: 100,
                            height: parseInt(d.style.fontSize, 10),
                            x: a + b,
                            y: s + y,
                            foreColor: x,
                            textAnchor: l || d.textAnchor,
                            text: n,
                            fontSize: h || d.style.fontSize,
                            fontFamily: d.style.fontFamily,
                            fontWeight: d.style.fontWeight || "normal"
                        });
                        if (w.attr({
                            class: "apexcharts-datalabel",
                            cx: a,
                            cy: s
                        }), d.dropShadow.enabled) {
                            var k = d.dropShadow;
                            new $d4be73e5731103af$var$v(this.ctx).dropShadow(w, k);
                        }
                        c.add(w), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(o);
                    }
                }
            }
        },
        {
            key: "addBackgroundToDataLabel",
            value: function(t, e) {
                var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, o = e.width, n = e.height, l = new $d4be73e5731103af$var$m(this.ctx).drawRect(e.x - s, e.y - r / 2, o + 2 * s, n + r, a.borderRadius, "transparent" === i.config.chart.background ? "#fff" : i.config.chart.background, a.opacity, a.borderWidth, a.borderColor);
                a.dropShadow.enabled && new $d4be73e5731103af$var$v(this.ctx).dropShadow(l, a.dropShadow);
                return l;
            }
        },
        {
            key: "dataLabelsBackground",
            value: function() {
                var t = this.w;
                if ("bubble" !== t.config.chart.type) for(var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++){
                    var a = e[i], s = a.getBBox(), r = null;
                    if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                        a.parentNode.insertBefore(r.node, a);
                        var o = a.getAttribute("fill");
                        t.config.chart.animations.enabled && !t.globals.resized && !t.globals.dataChanged ? r.animate().attr({
                            fill: o
                        }) : r.attr({
                            fill: o
                        }), a.setAttribute("fill", t.config.dataLabels.background.foreColor);
                    }
                }
            }
        },
        {
            key: "bringForward",
            value: function() {
                for(var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < e.length; a++)i && i.insertBefore(e[a], i.nextSibling);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$N = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getAllSeriesEls",
            value: function() {
                return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
            }
        },
        {
            key: "getSeriesByName",
            value: function(t) {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat($d4be73e5731103af$var$x.escapeString(t), "']"));
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                var e = this.getSeriesByName(t), i = parseInt(e.getAttribute("data:realIndex"), 10);
                return {
                    isHidden: e.classList.contains("apexcharts-series-collapsed"),
                    realIndex: i
                };
            }
        },
        {
            key: "addCollapsedClassToSeries",
            value: function(t, e) {
                var i = this.w;
                function a(i) {
                    for(var a = 0; a < i.length; a++)i[a].index === e && t.node.classList.add("apexcharts-series-collapsed");
                }
                a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden;
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w, s = $d4be73e5731103af$var$x.clone(a.globals.initialSeries);
                a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, t && (e && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
            }
        },
        {
            key: "emptyCollapsedSeries",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                return t;
            }
        },
        {
            key: "toggleSeriesOnHover",
            value: function(t, e) {
                var i = this.w;
                e || (e = t.target);
                var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                if ("mousemove" === t.type) {
                    var s = parseInt(e.getAttribute("rel"), 10) - 1, r = null, o = null;
                    i.globals.axisCharts || "radialBar" === i.config.chart.type ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s, "']")), o = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "'] path"));
                    for(var n = 0; n < a.length; n++)a[n].classList.add(this.legendInactiveClass);
                    null !== r && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== o && o.classList.remove(this.legendInactiveClass));
                } else if ("mouseout" === t.type) for(var l = 0; l < a.length; l++)a[l].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "highlightRangeInSeries",
            value: function(t, e) {
                var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(t) {
                    for(var e = 0; e < s.length; e++)s[e].classList[t](i.legendInactiveClass);
                };
                if ("mousemove" === t.type) {
                    var o = parseInt(e.getAttribute("rel"), 10) - 1;
                    r("add"), function(t) {
                        for(var e = 0; e < s.length; e++){
                            var a = parseInt(s[e].getAttribute("val"), 10);
                            a >= t.from && a <= t.to && s[e].classList.remove(i.legendInactiveClass);
                        }
                    }(a.config.plotOptions.heatmap.colorScale.ranges[o]);
                } else "mouseout" === t.type && r("remove");
            }
        },
        {
            key: "getActiveConfigSeriesIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "asc", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i = this.w, a = 0;
                if (i.config.series.length > 1) {
                    for(var s = i.config.series.map(function(t, a) {
                        return t.data && t.data.length > 0 && -1 === i.globals.collapsedSeriesIndices.indexOf(a) && (!i.globals.comboCharts || 0 === e.length || e.length && e.indexOf(i.config.series[a].type) > -1) ? a : -1;
                    }), r = "asc" === t ? 0 : s.length - 1; "asc" === t ? r < s.length : r >= 0; "asc" === t ? r++ : r--)if (-1 !== s[r]) {
                        a = s[r];
                        break;
                    }
                }
                return a;
            }
        },
        {
            key: "getBarSeriesIndices",
            value: function() {
                return this.w.globals.comboCharts ? this.w.config.series.map(function(t, e) {
                    return "bar" === t.type || "column" === t.type ? e : -1;
                }).filter(function(t) {
                    return -1 !== t;
                }) : this.w.config.series.map(function(t, e) {
                    return e;
                });
            }
        },
        {
            key: "getPreviousPaths",
            value: function() {
                var t = this.w;
                function e(e, i, a) {
                    for(var s = e[i].childNodes, r = {
                        type: a,
                        paths: [],
                        realIndex: e[i].getAttribute("data:realIndex")
                    }, o = 0; o < s.length; o++)if (s[o].hasAttribute("pathTo")) {
                        var n = s[o].getAttribute("pathTo");
                        r.paths.push({
                            d: n
                        });
                    }
                    t.globals.previousPaths.push(r);
                }
                t.globals.previousPaths = [];
                [
                    "line",
                    "area",
                    "bar",
                    "rangebar",
                    "rangeArea",
                    "candlestick",
                    "radar"
                ].forEach(function(i) {
                    for(var a, s = (a = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a, "-series .apexcharts-series"))), r = 0; r < s.length; r++)e(s, r, i);
                }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                if (i.length > 0) for(var a = function(e) {
                    for(var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), a = [], s = function(t) {
                        var e = function(e) {
                            return i[t].getAttribute(e);
                        }, s = {
                            x: parseFloat(e("x")),
                            y: parseFloat(e("y")),
                            width: parseFloat(e("width")),
                            height: parseFloat(e("height"))
                        };
                        a.push({
                            rect: s,
                            color: i[t].getAttribute("color")
                        });
                    }, r = 0; r < i.length; r++)s(r);
                    t.globals.previousPaths.push(a);
                }, s = 0; s < i.length; s++)a(s);
                t.globals.axisCharts || (t.globals.previousPaths = t.globals.series);
            }
        },
        {
            key: "handlePrevBubbleScatterPaths",
            value: function(t) {
                var e = this.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series"));
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    for(var s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], o = 0; o < s.length; o++)r.push({
                        x: s[o].getAttribute("cx"),
                        y: s[o].getAttribute("cy"),
                        r: s[o].getAttribute("r")
                    });
                    e.globals.previousPaths.push(r);
                }
            }
        },
        {
            key: "clearPreviousPaths",
            value: function() {
                var t = this.w;
                t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1;
            }
        },
        {
            key: "handleNoData",
            value: function() {
                var t = this.w, e = t.config.noData, i = new $d4be73e5731103af$var$m(this.ctx), a = t.globals.svgWidth / 2, s = t.globals.svgHeight / 2, r = "middle";
                if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (a = 10, r = "start") : "right" === e.align && (a = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? s = 50 : "bottom" === e.verticalAlign && (s = t.globals.svgHeight - 50), a += e.offsetX, s = s + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                    var o = i.drawText({
                        x: a,
                        y: s,
                        text: e.text,
                        textAnchor: r,
                        fontSize: e.style.fontSize,
                        fontFamily: e.style.fontFamily,
                        foreColor: e.style.color,
                        opacity: 1,
                        class: "apexcharts-text-nodata"
                    });
                    t.globals.dom.Paper.add(o);
                }
            }
        },
        {
            key: "setNullSeriesToZeroValues",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)if (0 === t[i].length) for(var a = 0; a < t[e.globals.maxValsInArrayIndex].length; a++)t[i].push(0);
                return t;
            }
        },
        {
            key: "hasAllSeriesEqualX",
            value: function() {
                for(var t = !0, e = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                    t = !1;
                    break;
                }
                return e.globals.allSeriesHasEqualX = t, t;
            }
        },
        {
            key: "filteredSeriesX",
            value: function() {
                var t = this.w.globals.seriesX.map(function(t) {
                    return t.length > 0 ? t : [];
                });
                return t;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$W = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new $d4be73e5731103af$var$y(this.ctx);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "isMultiFormat",
            value: function() {
                return this.isFormatXY() || this.isFormat2DArray();
            }
        },
        {
            key: "isFormatXY",
            value: function() {
                var t = this.w.config.series.slice(), e = new $d4be73e5731103af$var$N(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0;
            }
        },
        {
            key: "isFormat2DArray",
            value: function() {
                var t = this.w.config.series.slice(), e = new $d4be73e5731103af$var$N(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0;
            }
        },
        {
            key: "handleFormat2DArray",
            value: function(t, e) {
                for(var i = this.w.config, a = this.w.globals, s = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !s ? this.twoDSeries.push($d4be73e5731103af$var$x.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push($d4be73e5731103af$var$x.parseNumber(t[e].data[r][4])) : this.twoDSeries.push($d4be73e5731103af$var$x.parseNumber(t[e].data[r][1])), a.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                    var o = new Date(t[e].data[r][0]);
                    o = new Date(o).getTime(), this.twoDSeriesX.push(o);
                } else this.twoDSeriesX.push(t[e].data[r][0]);
                for(var n = 0; n < t[e].data.length; n++)void 0 !== t[e].data[n][2] && (this.threeDSeries.push(t[e].data[n][2]), a.isDataXYZ = !0);
            }
        },
        {
            key: "handleFormatXY",
            value: function(t, e) {
                var i = this.w.config, a = this.w.globals, s = new $d4be73e5731103af$var$I(this.ctx), r = e;
                a.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                for(var o = 0; o < t[e].data.length; o++)void 0 !== t[e].data[o].y && (Array.isArray(t[e].data[o].y) ? this.twoDSeries.push($d4be73e5731103af$var$x.parseNumber(t[e].data[o].y[t[e].data[o].y.length - 1])) : this.twoDSeries.push($d4be73e5731103af$var$x.parseNumber(t[e].data[o].y))), void 0 !== t[e].data[o].goals && Array.isArray(t[e].data[o].goals) ? (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(t[e].data[o].goals)) : (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(null));
                for(var n = 0; n < t[r].data.length; n++){
                    var l = "string" == typeof t[r].data[n].x, h = Array.isArray(t[r].data[n].x), c = !h && !!s.isValidDate(t[r].data[n].x.toString());
                    if (l || c) {
                        if (l || i.xaxis.convertedCatToNumeric) {
                            var d = a.isBarHorizontal && a.isRangeData;
                            "datetime" !== i.xaxis.type || d ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : this.twoDSeriesX.push(s.parseDate(t[r].data[n].x));
                        } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));
                    } else h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[n].x));
                }
                if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                    for(var g = 0; g < t[e].data.length; g++)this.threeDSeries.push(t[e].data[g].z);
                    a.isDataXYZ = !0;
                }
            }
        },
        {
            key: "handleRangeData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", t, e)), i.seriesRangeStart.push(a.start), i.seriesRangeEnd.push(a.end), i.seriesRange.push(a.rangeUniques), i.seriesRange.forEach(function(t, e) {
                    t && t.forEach(function(t, e) {
                        t.y.forEach(function(e, i) {
                            for(var a = 0; a < t.y.length; a++)if (i !== a) {
                                var s = e.y1, r = e.y2, o = t.y[a].y1;
                                s <= t.y[a].y2 && o <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[a].rangeName) < 0 && t.overlaps.push(t.y[a].rangeName));
                            }
                        });
                    });
                }), a;
            }
        },
        {
            key: "handleCandleStickBoxData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = a.o, i.seriesCandleH[e] = a.h, i.seriesCandleM[e] = a.m, i.seriesCandleL[e] = a.l, i.seriesCandleC[e] = a.c, a;
            }
        },
        {
            key: "handleRangeDataFormat",
            value: function(t, e, i) {
                var a = [], s = [], r = e[i].data.filter(function(t, e, i) {
                    return e === i.findIndex(function(e) {
                        return e.x === t.x;
                    });
                }).map(function(t, e) {
                    return {
                        x: t.x,
                        overlaps: [],
                        y: []
                    };
                });
                if ("array" === t) for(var o = 0; o < e[i].data.length; o++)Array.isArray(e[i].data[o]) ? (a.push(e[i].data[o][1][0]), s.push(e[i].data[o][1][1])) : (a.push(e[i].data[o]), s.push(e[i].data[o]));
                else if ("xy" === t) for(var n = function(t) {
                    var o = Array.isArray(e[i].data[t].y), n = $d4be73e5731103af$var$x.randomId(), l = e[i].data[t].x, h = {
                        y1: o ? e[i].data[t].y[0] : e[i].data[t].y,
                        y2: o ? e[i].data[t].y[1] : e[i].data[t].y,
                        rangeName: n
                    };
                    e[i].data[t].rangeName = n;
                    var c = r.findIndex(function(t) {
                        return t.x === l;
                    });
                    r[c].y.push(h), a.push(h.y1), s.push(h.y2);
                }, l = 0; l < e[i].data.length; l++)n(l);
                return {
                    start: a,
                    end: s,
                    rangeUniques: r
                };
            }
        },
        {
            key: "handleCandleStickBoxDataFormat",
            value: function(t, e, i) {
                var a = this.w, s = "boxPlot" === a.config.chart.type || "boxPlot" === a.config.series[i].type, r = [], o = [], n = [], l = [], h = [];
                if ("array" === t) {
                    if (s && 6 === e[i].data[0].length || !s && 5 === e[i].data[0].length) for(var c = 0; c < e[i].data.length; c++)r.push(e[i].data[c][1]), o.push(e[i].data[c][2]), s ? (n.push(e[i].data[c][3]), l.push(e[i].data[c][4]), h.push(e[i].data[c][5])) : (l.push(e[i].data[c][3]), h.push(e[i].data[c][4]));
                    else for(var d = 0; d < e[i].data.length; d++)Array.isArray(e[i].data[d][1]) && (r.push(e[i].data[d][1][0]), o.push(e[i].data[d][1][1]), s ? (n.push(e[i].data[d][1][2]), l.push(e[i].data[d][1][3]), h.push(e[i].data[d][1][4])) : (l.push(e[i].data[d][1][2]), h.push(e[i].data[d][1][3])));
                } else if ("xy" === t) for(var g = 0; g < e[i].data.length; g++)Array.isArray(e[i].data[g].y) && (r.push(e[i].data[g].y[0]), o.push(e[i].data[g].y[1]), s ? (n.push(e[i].data[g].y[2]), l.push(e[i].data[g].y[3]), h.push(e[i].data[g].y[4])) : (l.push(e[i].data[g].y[2]), h.push(e[i].data[g].y[3])));
                return {
                    o: r,
                    h: o,
                    m: n,
                    l: l,
                    c: h
                };
            }
        },
        {
            key: "parseDataAxisCharts",
            value: function(t) {
                var e, i = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx, s = this.w.config, r = this.w.globals, o = new $d4be73e5731103af$var$I(a), n = s.labels.length > 0 ? s.labels.slice() : s.xaxis.categories.slice();
                if (r.isRangeBar = "rangeBar" === s.chart.type && r.isBarHorizontal, r.hasXaxisGroups = "category" === s.xaxis.type && s.xaxis.group.groups.length > 0, r.hasXaxisGroups && (r.groups = s.xaxis.group.groups), r.hasSeriesGroups = null === (e = t[0]) || void 0 === e ? void 0 : e.group, r.hasSeriesGroups) {
                    var l = [], h = $d4be73e5731103af$var$u(new Set(t.map(function(t) {
                        return t.group;
                    })));
                    t.forEach(function(t, e) {
                        var i = h.indexOf(t.group);
                        l[i] || (l[i] = []), l[i].push(t.name);
                    }), r.seriesGroups = l;
                }
                for(var c = function() {
                    for(var t = 0; t < n.length; t++)if ("string" == typeof n[t]) {
                        if (!o.isValidDate(n[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                        i.twoDSeriesX.push(o.parseDate(n[t]));
                    } else i.twoDSeriesX.push(n[t]);
                }, d = 0; d < t.length; d++){
                    if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[d].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                    if ("rangeBar" !== s.chart.type && "rangeArea" !== s.chart.type && "rangeBar" !== t[d].type && "rangeArea" !== t[d].type || (r.isRangeData = !0, r.isComboCharts ? "rangeBar" !== t[d].type && "rangeArea" !== t[d].type || this.handleRangeData(t, d) : "rangeBar" !== s.chart.type && "rangeArea" !== s.chart.type || this.handleRangeData(t, d)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, d) : this.isFormatXY() && this.handleFormatXY(t, d), "candlestick" !== s.chart.type && "candlestick" !== t[d].type && "boxPlot" !== s.chart.type && "boxPlot" !== t[d].type || this.handleCandleStickBoxData(t, d), r.series.push(this.twoDSeries), r.labels.push(this.twoDSeriesX), r.seriesX.push(this.twoDSeriesX), r.seriesGoals = this.seriesGoals, d !== this.activeSeriesIndex || this.fallbackToCategory || (r.isXNumeric = !0);
                    else {
                        "datetime" === s.xaxis.type ? (r.isXNumeric = !0, c(), r.seriesX.push(this.twoDSeriesX)) : "numeric" === s.xaxis.type && (r.isXNumeric = !0, n.length > 0 && (this.twoDSeriesX = n, r.seriesX.push(this.twoDSeriesX))), r.labels.push(this.twoDSeriesX);
                        var g = t[d].data.map(function(t) {
                            return $d4be73e5731103af$var$x.parseNumber(t);
                        });
                        r.series.push(g);
                    }
                    r.seriesZ.push(this.threeDSeries), void 0 !== t[d].name ? r.seriesNames.push(t[d].name) : r.seriesNames.push("series-" + parseInt(d + 1, 10)), void 0 !== t[d].color ? r.seriesColors.push(t[d].color) : r.seriesColors.push(void 0);
                }
                return this.w;
            }
        },
        {
            key: "parseDataNonAxisCharts",
            value: function(t) {
                var e = this.w.globals, i = this.w.config;
                e.series = t.slice(), e.seriesNames = i.labels.slice();
                for(var a = 0; a < e.series.length; a++)void 0 === e.seriesNames[a] && e.seriesNames.push("series-" + (a + 1));
                return this.w;
            }
        },
        {
            key: "handleExternalLabelsData",
            value: function(t) {
                var e = this.w.config, i = this.w.globals;
                if (e.xaxis.categories.length > 0) i.labels = e.xaxis.categories;
                else if (e.labels.length > 0) i.labels = e.labels.slice();
                else if (this.fallbackToCategory) {
                    if (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(t) {
                        t.forEach(function(t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), e.xaxis.convertedCatToNumeric) new $d4be73e5731103af$var$z(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t);
                } else this._generateExternalLabels(t);
            }
        },
        {
            key: "_generateExternalLabels",
            value: function(t) {
                var e = this.w.globals, i = this.w.config, a = [];
                if (e.axisCharts) {
                    if (e.series.length > 0) {
                        if (this.isFormatXY()) for(var s = i.series.map(function(t, e) {
                            return t.data.filter(function(t, e, i) {
                                return i.findIndex(function(e) {
                                    return e.x === t.x;
                                }) === e;
                            });
                        }), r = s.reduce(function(t, e, i, a) {
                            return a[t].length > e.length ? t : i;
                        }, 0), o = 0; o < s[r].length; o++)a.push(o + 1);
                        else for(var n = 0; n < e.series[e.maxValsInArrayIndex].length; n++)a.push(n + 1);
                    }
                    e.seriesX = [];
                    for(var l = 0; l < t.length; l++)e.seriesX.push(a);
                    this.w.globals.isBarHorizontal || (e.isXNumeric = !0);
                }
                if (0 === a.length) {
                    a = e.axisCharts ? [] : e.series.map(function(t, e) {
                        return e + 1;
                    });
                    for(var h = 0; h < t.length; h++)e.seriesX.push(a);
                }
                e.labels = a, i.xaxis.convertedCatToNumeric && (e.categoryLabels = a.map(function(t) {
                    return i.xaxis.labels.formatter(t);
                })), e.noLabelsProvided = !0;
            }
        },
        {
            key: "parseData",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(t), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(t), i.chart.stacked) {
                    var s = new $d4be73e5731103af$var$N(this.ctx);
                    a.series = s.setNullSeriesToZeroValues(a.series);
                }
                this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                for(var r = this.coreUtils.getCategoryLabels(a.labels), o = 0; o < r.length; o++)if (Array.isArray(r[o])) {
                    a.isMultiLineX = !0;
                    break;
                }
            }
        },
        {
            key: "excludeCollapsedSeriesInYAxis",
            value: function() {
                var t = this, e = this.w;
                e.globals.ignoreYAxisIndexes = e.globals.collapsedSeries.map(function(i, a) {
                    if (t.w.globals.isMultipleYAxis && !e.config.chart.stacked) return i.index;
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$B = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getLabel",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px", o = !(arguments.length > 6 && void 0 !== arguments[6]) || arguments[6], n = this.w, l = void 0 === t[a] ? "" : t[a], h = l, c = n.globals.xLabelFormatter, d = n.config.xaxis.labels.formatter, g = !1, u = new $d4be73e5731103af$var$T(this.ctx), p = l;
                o && (h = u.xLabelFormat(c, l, p, {
                    i: a,
                    dateFormatter: new $d4be73e5731103af$var$I(this.ctx).formatDate,
                    w: n
                }), void 0 !== d && (h = d(l, t[a], {
                    i: a,
                    dateFormatter: new $d4be73e5731103af$var$I(this.ctx).formatDate,
                    w: n
                })));
                var f, x;
                e.length > 0 ? (f = e[a].unit, x = null, e.forEach(function(t) {
                    "month" === t.unit ? x = "year" : "day" === t.unit ? x = "month" : "hour" === t.unit ? x = "day" : "minute" === t.unit && (x = "hour");
                }), g = x === f, i = e[a].position, h = e[a].value) : "datetime" === n.config.xaxis.type && void 0 === d && (h = ""), void 0 === h && (h = ""), h = Array.isArray(h) ? h : h.toString();
                var b = new $d4be73e5731103af$var$m(this.ctx), v = {};
                v = n.globals.rotateXLabels && o ? b.getTextRects(h, parseInt(r, 10), null, "rotate(".concat(n.config.xaxis.labels.rotate, " 0 0)"), !1) : b.getTextRects(h, parseInt(r, 10));
                var y = !n.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                return !Array.isArray(h) && (0 === h.indexOf("NaN") || 0 === h.toLowerCase().indexOf("invalid") || h.toLowerCase().indexOf("infinity") >= 0 || s.indexOf(h) >= 0 && y) && (h = ""), {
                    x: i,
                    text: h,
                    textRect: v,
                    isBold: g
                };
            }
        },
        {
            key: "checkLabelBasedOnTickamount",
            value: function(t, e, i) {
                var a = this.w, s = a.config.xaxis.tickAmount;
                return "dataPoints" === s && (s = Math.round(a.globals.gridWidth / 120)), s > i || t % Math.round(i / (s + 1)) == 0 || (e.text = ""), e;
            }
        },
        {
            key: "checkForOverflowingLabels",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                    var o = s[s.length - 1];
                    e.x < o.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + o.x && (e.text = "");
                }
                return e;
            }
        },
        {
            key: "checkForReversedLabels",
            value: function(t, e) {
                var i = this.w;
                return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e;
            }
        },
        {
            key: "isYAxisHidden",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$y(this.ctx);
                return !e.config.yaxis[t].show || !e.config.yaxis[t].showForNullSeries && i.isSeriesNull(t) && -1 === e.globals.collapsedSeriesIndices.indexOf(t);
            }
        },
        {
            key: "getYAxisForeColor",
            value: function(t, e) {
                var i = this.w;
                return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t;
            }
        },
        {
            key: "drawYAxisTicks",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = new $d4be73e5731103af$var$m(this.ctx), h = n.globals.translateY;
                if (a.show && e > 0) {
                    !0 === n.config.yaxis[s].opposite && (t += a.width);
                    for(var c = e; c >= 0; c--){
                        var d = h + e / 10 + n.config.yaxis[s].labels.offsetY - 1;
                        n.globals.isBarHorizontal && (d = r * c), "heatmap" === n.config.chart.type && (d += r / 2);
                        var g = l.drawLine(t + i.offsetX - a.width + a.offsetX, d + a.offsetY, t + i.offsetX + a.offsetX, d + a.offsetY, a.color);
                        o.add(g), h += r;
                    }
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$G = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "scaleSvgNode",
            value: function(t, e) {
                var i = parseFloat(t.getAttributeNS(null, "width")), a = parseFloat(t.getAttributeNS(null, "height"));
                t.setAttributeNS(null, "width", i * e), t.setAttributeNS(null, "height", a * e), t.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
            }
        },
        {
            key: "fixSvgStringForIe11",
            value: function(t) {
                if (!$d4be73e5731103af$var$x.isIE11()) return t.replace(/&nbsp;/g, "&#160;");
                var e = 0, i = t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, function(t) {
                    return 2 === ++e ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"' : t;
                });
                return i = (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1");
            }
        },
        {
            key: "getSvgString",
            value: function(t) {
                null == t && (t = 1);
                var e = this.w.globals.dom.Paper.svg();
                if (1 !== t) {
                    var i = this.w.globals.dom.Paper.node.cloneNode(!0);
                    this.scaleSvgNode(i, t), e = (new XMLSerializer).serializeToString(i);
                }
                return this.fixSvgStringForIe11(e);
            }
        },
        {
            key: "cleanup",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                Array.prototype.forEach.call(a, function(t) {
                    t.setAttribute("width", 0);
                }), e && e[0] && (e[0].setAttribute("x", -500), e[0].setAttribute("x1", -500), e[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
            }
        },
        {
            key: "svgUrl",
            value: function() {
                this.cleanup();
                var t = this.getSvgString(), e = new Blob([
                    t
                ], {
                    type: "image/svg+xml;charset=utf-8"
                });
                return URL.createObjectURL(e);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t ? t.scale || t.width / a.globals.svgWidth : 1;
                    e.cleanup();
                    var r = document.createElement("canvas");
                    r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                    var o = "transparent" === a.config.chart.background ? "#fff" : a.config.chart.background, n = r.getContext("2d");
                    n.fillStyle = o, n.fillRect(0, 0, r.width * s, r.height * s);
                    var l = e.getSvgString(s);
                    if (window.canvg && $d4be73e5731103af$var$x.isIE11()) {
                        var h = window.canvg.Canvg.fromString(n, l, {
                            ignoreClear: !0,
                            ignoreDimensions: !0
                        });
                        h.start();
                        var c = r.msToBlob();
                        h.stop(), i({
                            blob: c
                        });
                    } else {
                        var d = "data:image/svg+xml," + encodeURIComponent(l), g = new Image;
                        g.crossOrigin = "anonymous", g.onload = function() {
                            if (n.drawImage(g, 0, 0), r.msToBlob) {
                                var t = r.msToBlob();
                                i({
                                    blob: t
                                });
                            } else {
                                var e = r.toDataURL("image/png");
                                i({
                                    imgURI: e
                                });
                            }
                        }, g.src = d;
                    }
                });
            }
        },
        {
            key: "exportToSVG",
            value: function() {
                this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg");
            }
        },
        {
            key: "exportToPng",
            value: function() {
                var t = this;
                this.dataURI().then(function(e) {
                    var i = e.imgURI, a = e.blob;
                    a ? navigator.msSaveOrOpenBlob(a, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png");
                });
            }
        },
        {
            key: "exportToCSV",
            value: function(t) {
                var e = this, i = t.series, a = t.fileName, s = t.columnDelimiter, r = void 0 === s ? "," : s, o = t.lineDelimiter, n = void 0 === o ? "\n" : o, l = this.w;
                i || (i = l.config.series);
                var h = [], c = [], d = "", g = l.globals.series.map(function(t, e) {
                    return -1 === l.globals.collapsedSeriesIndices.indexOf(e) ? t : [];
                }), p = Math.max.apply(Math, $d4be73e5731103af$var$u(i.map(function(t) {
                    return t.data ? t.data.length : 0;
                }))), f = new $d4be73e5731103af$var$W(this.ctx), b = new $d4be73e5731103af$var$B(this.ctx), v = function(t) {
                    var i = "";
                    if (l.globals.axisCharts) {
                        if ("category" === l.config.xaxis.type || l.config.xaxis.convertedCatToNumeric) {
                            if (l.globals.isBarHorizontal) {
                                var a = l.globals.yLabelFormatters[0], s = new $d4be73e5731103af$var$N(e.ctx).getActiveConfigSeriesIndex();
                                i = a(l.globals.labels[t], {
                                    seriesIndex: s,
                                    dataPointIndex: t,
                                    w: l
                                });
                            } else i = b.getLabel(l.globals.labels, l.globals.timescaleLabels, 0, t).text;
                        }
                        "datetime" === l.config.xaxis.type && (l.config.xaxis.categories.length ? i = l.config.xaxis.categories[t] : l.config.labels.length && (i = l.config.labels[t]));
                    } else i = l.config.labels[t];
                    return Array.isArray(i) && (i = i.join(" ")), $d4be73e5731103af$var$x.isNumber(i) ? i : i.split(r).join("");
                }, m = function(t, e) {
                    if (h.length && 0 === e && c.push(h.join(r)), t.data) {
                        t.data = t.data.length && t.data || $d4be73e5731103af$var$u(Array(p)).map(function() {
                            return "";
                        });
                        for(var a = 0; a < t.data.length; a++){
                            h = [];
                            var s = v(a);
                            if (s || (f.isFormatXY() ? s = i[e].data[a].x : f.isFormat2DArray() && (s = i[e].data[a] ? i[e].data[a][0] : "")), 0 === e) {
                                h.push((d = s, "datetime" === l.config.xaxis.type && String(d).length >= 10 ? l.config.chart.toolbar.export.csv.dateFormatter(s) : $d4be73e5731103af$var$x.isNumber(s) ? s : s.split(r).join("")));
                                for(var o = 0; o < l.globals.series.length; o++){
                                    var n;
                                    if (f.isFormatXY()) h.push(null === (n = i[o].data[a]) || void 0 === n ? void 0 : n.y);
                                    else h.push(g[o][a]);
                                }
                            }
                            ("candlestick" === l.config.chart.type || t.type && "candlestick" === t.type) && (h.pop(), h.push(l.globals.seriesCandleO[e][a]), h.push(l.globals.seriesCandleH[e][a]), h.push(l.globals.seriesCandleL[e][a]), h.push(l.globals.seriesCandleC[e][a])), ("boxPlot" === l.config.chart.type || t.type && "boxPlot" === t.type) && (h.pop(), h.push(l.globals.seriesCandleO[e][a]), h.push(l.globals.seriesCandleH[e][a]), h.push(l.globals.seriesCandleM[e][a]), h.push(l.globals.seriesCandleL[e][a]), h.push(l.globals.seriesCandleC[e][a])), "rangeBar" === l.config.chart.type && (h.pop(), h.push(l.globals.seriesRangeStart[e][a]), h.push(l.globals.seriesRangeEnd[e][a])), h.length && c.push(h.join(r));
                        }
                    }
                    var d;
                };
                h.push(l.config.chart.toolbar.export.csv.headerCategory), "boxPlot" === l.config.chart.type ? (h.push("minimum"), h.push("q1"), h.push("median"), h.push("q3"), h.push("maximum")) : "candlestick" === l.config.chart.type ? (h.push("open"), h.push("high"), h.push("low"), h.push("close")) : "rangeBar" === l.config.chart.type ? (h.push("minimum"), h.push("maximum")) : i.map(function(t, e) {
                    var i = (t.name ? t.name : "series-".concat(e)) + "";
                    l.globals.axisCharts && h.push(i.split(r).join("") ? i.split(r).join("") : "series-".concat(e));
                }), l.globals.axisCharts || (h.push(l.config.chart.toolbar.export.csv.headerValue), c.push(h.join(r))), i.map(function(t, e) {
                    l.globals.axisCharts ? m(t, e) : ((h = []).push(l.globals.labels[e].split(r).join("")), h.push(g[e]), c.push(h.join(r)));
                }), d += c.join(n), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\uFEFF" + d), a || l.config.chart.toolbar.export.csv.filename, ".csv");
            }
        },
        {
            key: "triggerDownload",
            value: function(t, e, i) {
                var a = document.createElement("a");
                a.href = t, a.download = (e || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$V = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.elgrid = i, this.w = e.w;
        var s = this.w;
        this.axesUtils = new $d4be73e5731103af$var$B(e), this.xaxisLabels = s.globals.labels.slice(), s.globals.timescaleLabels.length > 0 && !s.globals.isBarHorizontal && (this.xaxisLabels = s.globals.timescaleLabels.slice()), s.config.xaxis.overwriteCategories && (this.xaxisLabels = s.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === s.config.xaxis.position ? this.offY = 0 : this.offY = s.globals.gridHeight + 1, this.offY = this.offY + s.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.xaxisBorderWidth = s.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = s.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = s.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = s.config.xaxis.axisBorder.height, this.yaxis = s.config.yaxis[0];
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawXaxis",
            value: function() {
                var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx), i = e.group({
                    class: "apexcharts-xaxis",
                    transform: "translate(".concat(t.config.xaxis.offsetX, ", ").concat(t.config.xaxis.offsetY, ")")
                }), a = e.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                });
                i.add(a);
                for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                if (this.drawXAxisLabelAndGroup(!0, e, a, s, t.globals.isXNumeric, function(t, e) {
                    return e;
                }), t.globals.hasXaxisGroups) {
                    var o = t.globals.groups;
                    s = [];
                    for(var n = 0; n < o.length; n++)s.push(o[n].title);
                    var l = {};
                    t.config.xaxis.group.style && (l.xaxisFontSize = t.config.xaxis.group.style.fontSize, l.xaxisFontFamily = t.config.xaxis.group.style.fontFamily, l.xaxisForeColors = t.config.xaxis.group.style.colors, l.fontWeight = t.config.xaxis.group.style.fontWeight, l.cssClass = t.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, e, a, s, !1, function(t, e) {
                        return o[t].cols * e;
                    }, l);
                }
                if (void 0 !== t.config.xaxis.title.text) {
                    var h = e.group({
                        class: "apexcharts-xaxis-title"
                    }), c = e.drawText({
                        x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                        y: this.offY + parseFloat(this.xaxisFontSize) + ("bottom" === t.config.xaxis.position ? t.globals.xAxisLabelsHeight : -t.globals.xAxisLabelsHeight - 10) + t.config.xaxis.title.offsetY,
                        text: t.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: t.config.xaxis.title.style.fontSize,
                        fontFamily: t.config.xaxis.title.style.fontFamily,
                        fontWeight: t.config.xaxis.title.style.fontWeight,
                        foreColor: t.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                    });
                    h.add(c), i.add(h);
                }
                if (t.config.xaxis.axisBorder.show) {
                    var d = t.globals.barPadForNumericAxis, g = e.drawLine(t.globals.padHorizontal + t.config.xaxis.axisBorder.offsetX - d, this.offY, this.xaxisBorderWidth + d, this.offY, t.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                    this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(g) : i.add(g);
                }
                return i;
            }
        },
        {
            key: "drawXAxisLabelAndGroup",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {}, h = [], c = [], d = this.w, g = l.xaxisFontSize || this.xaxisFontSize, u = l.xaxisFontFamily || this.xaxisFontFamily, p = l.xaxisForeColors || this.xaxisForeColors, f = l.fontWeight || d.config.xaxis.labels.style.fontWeight, x = l.cssClass || d.config.xaxis.labels.style.cssClass, b = d.globals.padHorizontal, v = a.length, m = "category" === d.config.xaxis.type ? d.globals.dataPoints : v;
                if (0 === m && v > m && (m = v), s) {
                    var y = m > 1 ? m - 1 : m;
                    o = d.globals.gridWidth / y, b = b + r(0, o) / 2 + d.config.xaxis.labels.offsetX;
                } else o = d.globals.gridWidth / m, b = b + r(0, o) + d.config.xaxis.labels.offsetX;
                for(var w = function(s) {
                    var l = b - r(s, o) / 2 + d.config.xaxis.labels.offsetX;
                    0 === s && 1 === v && o / 2 === b && 1 === m && (l = d.globals.gridWidth / 2);
                    var y = n.axesUtils.getLabel(a, d.globals.timescaleLabels, l, s, h, g, t), w = 28;
                    d.globals.rotateXLabels && t && (w = 22), d.config.xaxis.title.text && "top" === d.config.xaxis.position && (w += parseFloat(d.config.xaxis.title.style.fontSize) + 2), t || (w = w + parseFloat(g) + (d.globals.xAxisLabelsHeight - d.globals.xAxisGroupLabelsHeight) + (d.globals.rotateXLabels ? 10 : 0)), y = void 0 !== d.config.xaxis.tickAmount && "dataPoints" !== d.config.xaxis.tickAmount && "datetime" !== d.config.xaxis.type ? n.axesUtils.checkLabelBasedOnTickamount(s, y, v) : n.axesUtils.checkForOverflowingLabels(s, y, v, h, c);
                    if (d.config.xaxis.labels.show) {
                        var k = e.drawText({
                            x: y.x,
                            y: n.offY + d.config.xaxis.labels.offsetY + w - ("top" === d.config.xaxis.position ? d.globals.xAxisHeight + d.config.xaxis.axisTicks.height - 2 : 0),
                            text: y.text,
                            textAnchor: "middle",
                            fontWeight: y.isBold ? 600 : f,
                            fontSize: g,
                            fontFamily: u,
                            foreColor: Array.isArray(p) ? t && d.config.xaxis.convertedCatToNumeric ? p[d.globals.minX + s - 1] : p[s] : p,
                            isPlainText: !1,
                            cssClass: (t ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + x
                        });
                        if (i.add(k), k.on("click", function(t) {
                            if ("function" == typeof d.config.chart.events.xAxisLabelClick) {
                                var e = Object.assign({}, d, {
                                    labelIndex: s
                                });
                                d.config.chart.events.xAxisLabelClick(t, n.ctx, e);
                            }
                        }), t) {
                            var A = document.createElementNS(d.globals.SVGNS, "title");
                            A.textContent = Array.isArray(y.text) ? y.text.join(" ") : y.text, k.node.appendChild(A), "" !== y.text && (h.push(y.text), c.push(y));
                        }
                    }
                    s < v - 1 && (b += r(s + 1, o));
                }, k = 0; k <= v - 1; k++)w(k);
            }
        },
        {
            key: "drawXaxisInversed",
            value: function(t) {
                var e, i, a = this, s = this.w, r = new $d4be73e5731103af$var$m(this.ctx), o = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[t] : 0, n = r.group({
                    class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                    rel: t
                }), l = r.group({
                    class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                    transform: "translate(" + o + ", 0)"
                });
                n.add(l);
                var h = [];
                if (s.config.yaxis[t].show) for(var c = 0; c < this.xaxisLabels.length; c++)h.push(this.xaxisLabels[c]);
                e = s.globals.gridHeight / h.length, i = -e / 2.2;
                var d = s.globals.yLabelFormatters[0], g = s.config.yaxis[0].labels;
                if (g.show) for(var u = function(o) {
                    var n = void 0 === h[o] ? "" : h[o];
                    n = d(n, {
                        seriesIndex: t,
                        dataPointIndex: o,
                        w: s
                    });
                    var c = a.axesUtils.getYAxisForeColor(g.style.colors, t), u = 0;
                    Array.isArray(n) && (u = n.length / 2 * parseInt(g.style.fontSize, 10));
                    var p = g.offsetX - 15, f = "end";
                    a.yaxis.opposite && (f = "start"), "left" === s.config.yaxis[0].labels.align ? (p = g.offsetX, f = "start") : "center" === s.config.yaxis[0].labels.align ? (p = g.offsetX, f = "middle") : "right" === s.config.yaxis[0].labels.align && (f = "end");
                    var x = r.drawText({
                        x: p,
                        y: i + e + g.offsetY - u,
                        text: n,
                        textAnchor: f,
                        foreColor: Array.isArray(c) ? c[o] : c,
                        fontSize: g.style.fontSize,
                        fontFamily: g.style.fontFamily,
                        fontWeight: g.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + g.style.cssClass,
                        maxWidth: g.maxWidth
                    });
                    l.add(x), x.on("click", function(t) {
                        if ("function" == typeof s.config.chart.events.xAxisLabelClick) {
                            var e = Object.assign({}, s, {
                                labelIndex: o
                            });
                            s.config.chart.events.xAxisLabelClick(t, a.ctx, e);
                        }
                    });
                    var b = document.createElementNS(s.globals.SVGNS, "title");
                    if (b.textContent = Array.isArray(n) ? n.join(" ") : n, x.node.appendChild(b), 0 !== s.config.yaxis[t].labels.rotate) {
                        var v = r.rotateAroundCenter(x.node);
                        x.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[t].labels.rotate, " 0 ").concat(v.y, ")"));
                    }
                    i += e;
                }, p = 0; p <= h.length - 1; p++)u(p);
                if (void 0 !== s.config.yaxis[0].title.text) {
                    var f = r.group({
                        class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                        transform: "translate(" + o + ", 0)"
                    }), x = r.drawText({
                        x: s.config.yaxis[0].title.offsetX,
                        y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                        text: s.config.yaxis[0].title.text,
                        textAnchor: "middle",
                        foreColor: s.config.yaxis[0].title.style.color,
                        fontSize: s.config.yaxis[0].title.style.fontSize,
                        fontWeight: s.config.yaxis[0].title.style.fontWeight,
                        fontFamily: s.config.yaxis[0].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                    });
                    f.add(x), n.add(f);
                }
                var b = 0;
                this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (b = s.globals.gridWidth);
                var v = s.config.xaxis.axisBorder;
                if (v.show) {
                    var y = r.drawLine(s.globals.padHorizontal + v.offsetX + b, 1 + v.offsetY, s.globals.padHorizontal + v.offsetX + b, s.globals.gridHeight + v.offsetY, v.color, 0);
                    this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(y) : n.add(y);
                }
                return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(b, h.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, e, n), n;
            }
        },
        {
            key: "drawXaxisTicks",
            value: function(t, e, i) {
                var a = this.w, s = t;
                if (!(t < 0 || t - 2 > a.globals.gridWidth)) {
                    var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                    if (e = e + r + a.config.xaxis.axisTicks.height, "top" === a.config.xaxis.position && (e = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                        var o = new $d4be73e5731103af$var$m(this.ctx).drawLine(t + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, e + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                        i.add(o), o.node.classList.add("apexcharts-xaxis-tick");
                    }
                }
            }
        },
        {
            key: "getXAxisTicksPositions",
            value: function() {
                var t = this.w, e = [], i = this.xaxisLabels.length, a = t.globals.padHorizontal;
                if (t.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, e.push(a);
                else for(var r = i, o = 0; o < r; o++){
                    var n = r;
                    t.globals.isXNumeric && "bar" !== t.config.chart.type && (n -= 1), a += t.globals.gridWidth / n, e.push(a);
                }
                return e;
            }
        },
        {
            key: "xAxisLabelCorrections",
            value: function() {
                var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways) for(var o = 0; o < a.length; o++){
                    var n = e.rotateAroundCenter(a[o]);
                    n.y = n.y - 1, n.x = n.x + 1, a[o].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(n.x, " ").concat(n.y, ")")), a[o].setAttribute("text-anchor", "end");
                    i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                    var l = a[o].childNodes;
                    t.config.xaxis.labels.trim && Array.prototype.forEach.call(l, function(i) {
                        e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10));
                    });
                }
                else !function() {
                    for(var i = t.globals.gridWidth / (t.globals.labels.length + 1), s = 0; s < a.length; s++){
                        var r = a[s].childNodes;
                        t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, function(t) {
                            e.placeTextWithEllipsis(t, t.textContent, i);
                        });
                    }
                }();
                if (s.length > 0) {
                    var h = s[s.length - 1].getBBox(), c = s[0].getBBox();
                    h.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), c.x + c.width > t.globals.gridWidth && !t.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                    for(var d = 0; d < r.length; d++)e.placeTextWithEllipsis(r[d], r[d].textContent, t.config.yaxis[0].labels.maxWidth - (t.config.yaxis[0].title.text ? 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) : 0) - 15);
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$j = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.xaxisLabels = i.globals.labels.slice(), this.axesUtils = new $d4be73e5731103af$var$B(e), this.isRangeBar = i.globals.seriesRange.length && i.globals.isBarHorizontal, i.globals.timescaleLabels.length > 0 && (this.xaxisLabels = i.globals.timescaleLabels.slice());
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawGridArea",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = new $d4be73e5731103af$var$m(this.ctx);
                null === t && (t = i.group({
                    class: "apexcharts-grid"
                }));
                var a = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"), s = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                return t.add(s), t.add(a), t;
            }
        },
        {
            key: "drawGrid",
            value: function() {
                var t = null;
                return this.w.globals.axisCharts && (t = this.renderGrid(), this.drawGridArea(t.el)), t;
            }
        },
        {
            key: "createGridMask",
            value: function() {
                var t = this.w, e = t.globals, i = new $d4be73e5731103af$var$m(this.ctx), a = Array.isArray(t.config.stroke.width) ? 0 : t.config.stroke.width;
                if (Array.isArray(t.config.stroke.width)) {
                    var s = 0;
                    t.config.stroke.width.forEach(function(t) {
                        s = Math.max(s, t);
                    }), a = s;
                }
                e.dom.elGridRectMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(e.cuid)), e.dom.elForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elForecastMask.setAttribute("id", "forecastMask".concat(e.cuid)), e.dom.elNonForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elNonForecastMask.setAttribute("id", "nonForecastMask".concat(e.cuid));
                var r = t.config.chart.type, o = 0, n = 0;
                ("bar" === r || "rangeBar" === r || "candlestick" === r || "boxPlot" === r || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (o = t.config.grid.padding.left, n = t.config.grid.padding.right, e.barPadForNumericAxis > o && (o = e.barPadForNumericAxis, n = e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(-a / 2 - o - 2, -a / 2, e.gridWidth + a + n + o + 4, e.gridHeight + a, 0, "#fff");
                var l = t.globals.markers.largestSize + 1;
                e.dom.elGridRectMarker = i.drawRect(2 * -l, 2 * -l, e.gridWidth + 4 * l, e.gridHeight + 4 * l, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                var h = e.dom.baseEl.querySelector("defs");
                h.appendChild(e.dom.elGridRectMask), h.appendChild(e.dom.elForecastMask), h.appendChild(e.dom.elNonForecastMask), h.appendChild(e.dom.elGridRectMarkerMask);
            }
        },
        {
            key: "_drawGridLines",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w;
                if (!(0 === e && l.globals.skipFirstTimelinelabel || e === o - 1 && l.globals.skipLastTimelinelabel && !l.config.xaxis.labels.formatter || "radar" === l.config.chart.type)) {
                    l.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: e,
                        x1: i,
                        y1: a,
                        x2: s,
                        y2: r,
                        xCount: o,
                        parent: n
                    });
                    var h = 0;
                    if (l.globals.hasXaxisGroups && "between" === l.config.xaxis.tickPlacement) {
                        var c = l.globals.groups;
                        if (c) {
                            for(var d = 0, g = 0; d < e && g < c.length; g++)d += c[g].cols;
                            d === e && (h = .6 * l.globals.xAxisLabelsHeight);
                        }
                    }
                    new $d4be73e5731103af$var$V(this.ctx).drawXaxisTicks(i, h, l.globals.dom.elGraphical);
                }
            }
        },
        {
            key: "_drawGridLine",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w, h = !1, c = n.node.classList.contains("apexcharts-gridlines-horizontal"), d = l.config.grid.strokeDashArray, g = l.globals.barPadForNumericAxis;
                (0 === a && 0 === r || 0 === i && 0 === s) && (h = !0), a === l.globals.gridHeight && r === l.globals.gridHeight && (h = !0), !l.globals.isBarHorizontal || 0 !== e && e !== o - 1 || (h = !0);
                var u = new $d4be73e5731103af$var$m(this).drawLine(i - (c ? g : 0), a, s + (c ? g : 0), r, l.config.grid.borderColor, d);
                u.node.classList.add("apexcharts-gridline"), h && l.config.grid.show ? this.elGridBorders.add(u) : n.add(u);
            }
        },
        {
            key: "_drawGridBandRect",
            value: function(t) {
                var e = t.c, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.type, n = this.w, l = new $d4be73e5731103af$var$m(this.ctx), h = n.globals.barPadForNumericAxis;
                if ("column" !== o || "datetime" !== n.config.xaxis.type) {
                    var c = n.config.grid[o].colors[e], d = l.drawRect(i - ("row" === o ? h : 0), a, s + ("row" === o ? 2 * h : 0), r, 0, c, n.config.grid[o].opacity);
                    this.elg.add(d), d.attr("clip-path", "url(#gridRectMask".concat(n.globals.cuid, ")")), d.node.classList.add("apexcharts-grid-".concat(o));
                }
            }
        },
        {
            key: "_drawXYLines",
            value: function(t) {
                var e = this, i = t.xCount, a = t.tickAmount, s = this.w;
                if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                    var r, o = s.globals.padHorizontal, n = s.globals.gridHeight;
                    s.globals.timescaleLabels.length ? function(t) {
                        for(var a = t.xC, s = t.x1, r = t.y1, o = t.x2, n = t.y2, l = 0; l < a; l++)s = e.xaxisLabels[l].position, o = e.xaxisLabels[l].position, e._drawGridLines({
                            i: l,
                            x1: s,
                            y1: r,
                            x2: o,
                            y2: n,
                            xCount: i,
                            parent: e.elgridLinesV
                        });
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(t) {
                        for(var a = t.xC, r = t.x1, o = t.y1, n = t.x2, l = t.y2, h = 0; h < a + (s.globals.isXNumeric ? 0 : 1); h++)0 === h && 1 === a && 1 === s.globals.dataPoints && (n = r = s.globals.gridWidth / 2), e._drawGridLines({
                            i: h,
                            x1: r,
                            y1: o,
                            x2: n,
                            y2: l,
                            xCount: i,
                            parent: e.elgridLinesV
                        }), n = r += s.globals.gridWidth / (s.globals.isXNumeric ? a - 1 : a);
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }));
                }
                if (s.config.grid.yaxis.lines.show) {
                    var l = 0, h = 0, c = s.globals.gridWidth, d = a + 1;
                    this.isRangeBar && (d = s.globals.labels.length);
                    for(var g = 0; g < d + (this.isRangeBar ? 1 : 0); g++)this._drawGridLine({
                        i: g,
                        xCount: d + (this.isRangeBar ? 1 : 0),
                        x1: 0,
                        y1: l,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = l += s.globals.gridHeight / (this.isRangeBar ? d : a);
                }
            }
        },
        {
            key: "_drawInvertedXYLines",
            value: function(t) {
                var e = t.xCount, i = this.w;
                if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, o = 0; o < e + 1; o++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                    i: o,
                    xCount: e + 1,
                    x1: s,
                    y1: 0,
                    x2: a,
                    y2: r,
                    parent: this.elgridLinesV
                }), new $d4be73e5731103af$var$V(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s = s + i.globals.gridWidth / e + .3;
                if (i.config.grid.yaxis.lines.show) for(var n = 0, l = 0, h = i.globals.gridWidth, c = 0; c < i.globals.dataPoints + 1; c++)this._drawGridLine({
                    i: c,
                    xCount: i.globals.dataPoints + 1,
                    x1: 0,
                    y1: n,
                    x2: h,
                    y2: l,
                    parent: this.elgridLinesH
                }), l = n += i.globals.gridHeight / i.globals.dataPoints;
            }
        },
        {
            key: "renderGrid",
            value: function() {
                var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx);
                this.elg = e.group({
                    class: "apexcharts-grid"
                }), this.elgridLinesH = e.group({
                    class: "apexcharts-gridlines-horizontal"
                }), this.elgridLinesV = e.group({
                    class: "apexcharts-gridlines-vertical"
                }), this.elGridBorders = e.group({
                    class: "apexcharts-grid-borders"
                }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                for(var i, a = t.globals.yAxisScale.length ? t.globals.yAxisScale[0].result.length - 1 : 5, s = 0; s < t.globals.series.length && (void 0 !== t.globals.yAxisScale[s] && (a = t.globals.yAxisScale[s].result.length - 1), !(a > 2)); s++);
                return !t.globals.isBarHorizontal || this.isRangeBar ? (i = this.xaxisLabels.length, this.isRangeBar && (i--, a = t.globals.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (i = t.config.xaxis.tickAmount)), this._drawXYLines({
                    xCount: i,
                    tickAmount: a
                })) : (i = a, a = t.globals.xTickAmount, this._drawInvertedXYLines({
                    xCount: i,
                    tickAmount: a
                })), this.drawGridBands(i, a), {
                    el: this.elg,
                    elGridBorders: this.elGridBorders,
                    xAxisTickWidth: t.globals.gridWidth / i
                };
            }
        },
        {
            key: "drawGridBands",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== i.config.grid.row.colors && i.config.grid.row.colors.length > 0) for(var a = 0, s = i.globals.gridHeight / e, r = i.globals.gridWidth, o = 0, n = 0; o < e; o++, n++)n >= i.config.grid.row.colors.length && (n = 0), this._drawGridBandRect({
                    c: n,
                    x1: 0,
                    y1: a,
                    x2: r,
                    y2: s,
                    type: "row"
                }), a += i.globals.gridHeight / e;
                if (void 0 !== i.config.grid.column.colors && i.config.grid.column.colors.length > 0) for(var l = i.globals.isBarHorizontal || "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric ? t : t - 1, h = i.globals.padHorizontal, c = i.globals.padHorizontal + i.globals.gridWidth / l, d = i.globals.gridHeight, g = 0, u = 0; g < t; g++, u++)u >= i.config.grid.column.colors.length && (u = 0), this._drawGridBandRect({
                    c: u,
                    x1: h,
                    y1: 0,
                    x2: c,
                    y2: d,
                    type: "column"
                }), h += i.globals.gridWidth / l;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$_ = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "niceScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 ? arguments[4] : void 0, r = this.w, o = Math.abs(e - t);
                if ("dataPoints" === (i = this._adjustTicksForSmallRange(i, a, o)) && (i = r.globals.dataPoints - 1), t === Number.MIN_VALUE && 0 === e || !$d4be73e5731103af$var$x.isNumber(t) && !$d4be73e5731103af$var$x.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) return t = 0, e = i, this.linearScale(t, e, i);
                t > e ? (console.warn("axis.min cannot be greater than axis.max"), e = t + .1) : t === e && (t = 0 === t ? 0 : t - .5, e = 0 === e ? 2 : e + .5);
                var n = [];
                o < 1 && s && ("candlestick" === r.config.chart.type || "candlestick" === r.config.series[a].type || "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[a].type || r.globals.isRangeData) && (e *= 1.01);
                var l = i + 1;
                l < 2 ? l = 2 : l > 2 && (l -= 2);
                var h = o / l, c = Math.floor($d4be73e5731103af$var$x.log10(h)), d = Math.pow(10, c), g = Math.round(h / d);
                g < 1 && (g = 1);
                var u = g * d, p = u * Math.floor(t / u), f = u * Math.ceil(e / u), b = p;
                if (s && o > 2) {
                    for(; n.push($d4be73e5731103af$var$x.stripNumber(b, 7)), !((b += u) > f););
                    return {
                        result: n,
                        niceMin: n[0],
                        niceMax: n[n.length - 1]
                    };
                }
                var v = t;
                (n = []).push($d4be73e5731103af$var$x.stripNumber(v, 7));
                for(var m = Math.abs(e - t) / i, y = 0; y <= i; y++)v += m, n.push(v);
                return n[n.length - 2] >= e && n.pop(), {
                    result: n,
                    niceMin: n[0],
                    niceMax: n[n.length - 1]
                };
            }
        },
        {
            key: "linearScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 ? arguments[3] : void 0, s = Math.abs(e - t);
                "dataPoints" === (i = this._adjustTicksForSmallRange(i, a, s)) && (i = this.w.globals.dataPoints - 1);
                var r = s / i;
                i === Number.MAX_VALUE && (i = 10, r = 1);
                for(var o = [], n = t; i >= 0;)o.push(n), n += r, i -= 1;
                return {
                    result: o,
                    niceMin: o[0],
                    niceMax: o[o.length - 1]
                };
            }
        },
        {
            key: "logarithmicScaleNice",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.ceil(Math.log(e) / Math.log(i) + 1), r = Math.floor(Math.log(t) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                return {
                    result: a,
                    niceMin: a[0],
                    niceMax: a[a.length - 1]
                };
            }
        },
        {
            key: "logarithmicScale",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.log(e) / Math.log(i), r = Math.log(t) / Math.log(i), o = s - r, n = Math.round(o), l = o / n, h = 0, c = r; h < n; h++, c += l)a.push(Math.pow(i, c));
                return a.push(Math.pow(i, s)), {
                    result: a,
                    niceMin: t,
                    niceMax: e
                };
            }
        },
        {
            key: "_adjustTicksForSmallRange",
            value: function(t, e, i) {
                var a = t;
                if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                    var s = Number(this.w.config.yaxis[e].labels.formatter(1));
                    $d4be73e5731103af$var$x.isNumber(s) && 0 === this.w.globals.yValueDecimal && (a = Math.ceil(i));
                }
                return a < t ? a : t;
            }
        },
        {
            key: "setYScaleForIndex",
            value: function(t, e, i) {
                var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[t];
                void 0 === a.yAxisScale[t] && (a.yAxisScale[t] = []);
                var o = Math.abs(i - e);
                if (r.logarithmic && o <= 5 && (a.invalidLogScale = !0), r.logarithmic && o > 5) a.allSeriesCollapsed = !1, a.yAxisScale[t] = this.logarithmicScale(e, i, r.logBase), a.yAxisScale[t] = r.forceNiceScale ? this.logarithmicScaleNice(e, i, r.logBase) : this.logarithmicScale(e, i, r.logBase);
                else if (i !== -Number.MAX_VALUE && $d4be73e5731103af$var$x.isNumber(i)) {
                    if (a.allSeriesCollapsed = !1, void 0 === r.min && void 0 === r.max || r.forceNiceScale) {
                        var n = void 0 === s.yaxis[t].max && void 0 === s.yaxis[t].min || s.yaxis[t].forceNiceScale;
                        a.yAxisScale[t] = this.niceScale(e, i, r.tickAmount ? r.tickAmount : o < 5 && o > 1 ? o + 1 : 5, t, n);
                    } else a.yAxisScale[t] = this.linearScale(e, i, r.tickAmount, t);
                } else a.yAxisScale[t] = this.linearScale(0, 5, 5);
            }
        },
        {
            key: "setXScale",
            value: function(t, e) {
                var i = this.w, a = i.globals, s = i.config.xaxis, r = Math.abs(e - t);
                return e !== -Number.MAX_VALUE && $d4be73e5731103af$var$x.isNumber(e) ? a.xAxisScale = this.linearScale(t, e, s.tickAmount ? s.tickAmount : r < 5 && r > 1 ? r + 1 : 5, 0) : a.xAxisScale = this.linearScale(0, 5, 5), a.xAxisScale;
            }
        },
        {
            key: "setMultipleYScales",
            value: function() {
                var t = this, e = this.w.globals, i = this.w.config, a = e.minYArr.concat([]), s = e.maxYArr.concat([]), r = [];
                i.yaxis.forEach(function(e, o) {
                    var n = o;
                    i.series.forEach(function(t, i) {
                        t.name === e.seriesName && (n = i, o !== i ? r.push({
                            index: i,
                            similarIndex: o,
                            alreadyExists: !0
                        }) : r.push({
                            index: i
                        }));
                    });
                    var l = a[n], h = s[n];
                    t.setYScaleForIndex(o, l, h);
                }), this.sameScaleInMultipleAxes(a, s, r);
            }
        },
        {
            key: "sameScaleInMultipleAxes",
            value: function(t, e, i) {
                var a = this, s = this.w.config, r = this.w.globals, o = [];
                i.forEach(function(t) {
                    t.alreadyExists && (void 0 === o[t.index] && (o[t.index] = []), o[t.index].push(t.index), o[t.index].push(t.similarIndex));
                }), r.yAxisSameScaleIndices = o, o.forEach(function(t, e) {
                    o.forEach(function(i, a) {
                        var s, r;
                        e !== a && (s = t, r = i, s.filter(function(t) {
                            return -1 !== r.indexOf(t);
                        })).length > 0 && (o[e] = o[e].concat(o[a]));
                    });
                });
                var n = o.map(function(t) {
                    return t.filter(function(e, i) {
                        return t.indexOf(e) === i;
                    });
                }).map(function(t) {
                    return t.sort();
                });
                o = o.filter(function(t) {
                    return !!t;
                });
                var l = n.slice(), h = l.map(function(t) {
                    return JSON.stringify(t);
                });
                l = l.filter(function(t, e) {
                    return h.indexOf(JSON.stringify(t)) === e;
                });
                var c = [], d = [];
                t.forEach(function(t, i) {
                    l.forEach(function(a, s) {
                        a.indexOf(i) > -1 && (void 0 === c[s] && (c[s] = [], d[s] = []), c[s].push({
                            key: i,
                            value: t
                        }), d[s].push({
                            key: i,
                            value: e[i]
                        }));
                    });
                });
                var g = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, Number.MIN_VALUE), u = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                c.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        g[e] = Math.min(t.value, g[e]);
                    });
                }), d.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        u[e] = Math.max(t.value, u[e]);
                    });
                }), t.forEach(function(t, e) {
                    d.forEach(function(t, i) {
                        var o = g[i], n = u[i];
                        s.chart.stacked && (n = 0, t.forEach(function(t, e) {
                            t.value !== -Number.MAX_VALUE && (n += t.value), o !== Number.MIN_VALUE && (o += c[i][e].value);
                        })), t.forEach(function(i, l) {
                            t[l].key === e && (void 0 !== s.yaxis[e].min && (o = "function" == typeof s.yaxis[e].min ? s.yaxis[e].min(r.minY) : s.yaxis[e].min), void 0 !== s.yaxis[e].max && (n = "function" == typeof s.yaxis[e].max ? s.yaxis[e].max(r.maxY) : s.yaxis[e].max), a.setYScaleForIndex(e, o, n));
                        });
                    });
                });
            }
        },
        {
            key: "autoScaleY",
            value: function(t, e, i) {
                t || (t = this);
                var a = t.w;
                if (a.globals.isMultipleYAxis || a.globals.collapsedSeries.length) return console.warn("autoScaleYaxis is not supported in a multi-yaxis chart."), e;
                var s = a.globals.seriesX[0], r = a.config.chart.stacked;
                return e.forEach(function(t, o) {
                    for(var n = 0, l = 0; l < s.length; l++)if (s[l] >= i.xaxis.min) {
                        n = l;
                        break;
                    }
                    var h, c, d = a.globals.minYArr[o], g = a.globals.maxYArr[o], u = a.globals.stackedSeriesTotals;
                    a.globals.series.forEach(function(o, l) {
                        var p = o[n];
                        r ? (p = u[n], h = c = p, u.forEach(function(t, e) {
                            s[e] <= i.xaxis.max && s[e] >= i.xaxis.min && (t > c && null !== t && (c = t), o[e] < h && null !== o[e] && (h = o[e]));
                        })) : (h = c = p, o.forEach(function(t, e) {
                            if (s[e] <= i.xaxis.max && s[e] >= i.xaxis.min) {
                                var r = t, o = t;
                                a.globals.series.forEach(function(i, a) {
                                    null !== t && (r = Math.min(i[e], r), o = Math.max(i[e], o));
                                }), o > c && null !== o && (c = o), r < h && null !== r && (h = r);
                            }
                        })), void 0 === h && void 0 === c && (h = d, c = g), c *= c < 0 ? .9 : 1.1, 0 === (h *= h < 0 ? 1.1 : .9) && 0 === c && (h = -1, c = 1), c < 0 && c < g && (c = g), h < 0 && h > d && (h = d), e.length > 1 ? (e[l].min = void 0 === t.min ? h : t.min, e[l].max = void 0 === t.max ? c : t.max) : (e[0].min = void 0 === t.min ? h : t.min, e[0].max = void 0 === t.max ? c : t.max);
                    });
                }), e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$U = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.scales = new $d4be73e5731103af$var$_(e);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "init",
            value: function() {
                this.setYRange(), this.setXRange(), this.setZRange();
            }
        },
        {
            key: "getMinYMaxY",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w.config, r = this.w.globals, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                null === a && (a = t + 1);
                var l = r.series, h = l, c = l;
                "candlestick" === s.chart.type ? (h = r.seriesCandleL, c = r.seriesCandleH) : "boxPlot" === s.chart.type ? (h = r.seriesCandleO, c = r.seriesCandleC) : r.isRangeData && (h = r.seriesRangeStart, c = r.seriesRangeEnd);
                for(var d = t; d < a; d++){
                    r.dataPoints = Math.max(r.dataPoints, l[d].length), r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(t) {
                        return void 0 !== t;
                    }).length), r.labels.length && "datetime" !== s.xaxis.type && 0 !== r.series.reduce(function(t, e) {
                        return t + e.length;
                    }, 0) && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                    for(var g = 0; g < r.series[d].length; g++){
                        var u = l[d][g];
                        null !== u && $d4be73e5731103af$var$x.isNumber(u) ? (void 0 !== c[d][g] && (o = Math.max(o, c[d][g]), e = Math.min(e, c[d][g])), void 0 !== h[d][g] && (e = Math.min(e, h[d][g]), i = Math.max(i, h[d][g])), "candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type && "rangeArea" === this.w.config.chart.type && "rangeBar" === this.w.config.chart.type || ("candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type || void 0 !== r.seriesCandleC[d][g] && (o = Math.max(o, r.seriesCandleO[d][g]), o = Math.max(o, r.seriesCandleH[d][g]), o = Math.max(o, r.seriesCandleL[d][g]), o = Math.max(o, r.seriesCandleC[d][g]), "boxPlot" === this.w.config.chart.type && (o = Math.max(o, r.seriesCandleM[d][g]))), !s.series[d].type || "candlestick" === s.series[d].type && "boxPlot" === s.series[d].type && "rangeArea" === s.series[d].type && "rangeBar" === s.series[d].type || (o = Math.max(o, r.series[d][g]), e = Math.min(e, r.series[d][g])), i = o), r.seriesGoals[d] && r.seriesGoals[d][g] && Array.isArray(r.seriesGoals[d][g]) && r.seriesGoals[d][g].forEach(function(t) {
                            n !== Number.MIN_VALUE && (n = Math.min(n, t.value), e = n), o = Math.max(o, t.value), i = o;
                        }), $d4be73e5731103af$var$x.isFloat(u) && (u = $d4be73e5731103af$var$x.noExponents(u), r.yValueDecimal = Math.max(r.yValueDecimal, u.toString().split(".")[1].length)), n > h[d][g] && h[d][g] < 0 && (n = h[d][g])) : r.hasNullValues = !0;
                    }
                }
                return "rangeBar" === s.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && (n = e), "bar" === s.chart.type && (n < 0 && o < 0 && (o = 0), n === Number.MIN_VALUE && (n = 0)), {
                    minY: n,
                    maxY: o,
                    lowestY: e,
                    highestY: i
                };
            }
        },
        {
            key: "setYRange",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                var i = Number.MAX_VALUE;
                if (t.isMultipleYAxis) for(var a = 0; a < t.series.length; a++){
                    var s = this.getMinYMaxY(a, i, null, a + 1);
                    t.minYArr.push(s.minY), t.maxYArr.push(s.maxY), i = s.lowestY;
                }
                var r = this.getMinYMaxY(0, i, null, t.series.length);
                if (t.minY = r.minY, t.maxY = r.maxY, i = r.lowestY, e.chart.stacked && this._setStackedMinMax(), ("line" === e.chart.type || "area" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal) && t.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== t.maxY) {
                    var o = t.maxY - i;
                    (i >= 0 && i <= 10 || void 0 !== e.yaxis[0].min || void 0 !== e.yaxis[0].max) && (o = 0), t.minY = i - 5 * o / 100, i > 0 && t.minY < 0 && (t.minY = 0), t.maxY = t.maxY + 5 * o / 100;
                }
                if (e.yaxis.forEach(function(e, i) {
                    void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i]);
                }), t.isBarHorizontal) [
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i]);
                });
                return t.isMultipleYAxis ? (this.scales.setMultipleYScales(), t.minY = i, t.yAxisScale.forEach(function(e, i) {
                    t.minYArr[i] = e.niceMin, t.maxYArr[i] = e.niceMax;
                })) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.yAxisScale[0].niceMin, t.maxYArr[0] = t.yAxisScale[0].niceMax), {
                    minY: t.minY,
                    maxY: t.maxY,
                    minYArr: t.minYArr,
                    maxYArr: t.maxYArr,
                    yAxisScale: t.yAxisScale
                };
            }
        },
        {
            key: "setXRange",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                if (t.isXNumeric && function() {
                    for(var e = 0; e < t.series.length; e++)if (t.labels[e]) for(var i = 0; i < t.labels[e].length; i++)null !== t.labels[e][i] && $d4be73e5731103af$var$x.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]));
                }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                    var a;
                    if (void 0 === e.xaxis.tickAmount ? (a = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (a = t.dataPoints - 1), a > t.dataPoints && 0 !== t.dataPoints && (a = t.dataPoints - 1)) : "dataPoints" === e.xaxis.tickAmount ? (t.series.length > 1 && (a = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric && (a = t.maxX - t.minX - 1)) : a = e.xaxis.tickAmount, t.xTickAmount = a, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE) {
                        if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                            for(var s = [], r = t.minX - 1; r < t.maxX; r++)s.push(r + 1);
                            t.xAxisScale = {
                                result: s,
                                niceMin: s[0],
                                niceMax: s[s.length - 1]
                            };
                        } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                    } else t.xAxisScale = this.scales.linearScale(1, a, a), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, a - 1), t.seriesX = t.labels.slice());
                    i && (t.labels = t.xAxisScale.result.slice());
                }
                return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                    minX: t.minX,
                    maxX: t.maxX
                };
            }
        },
        {
            key: "setZRange",
            value: function() {
                var t = this.w.globals;
                if (t.isDataXYZ) {
                    for(var e = 0; e < t.series.length; e++)if (void 0 !== t.seriesZ[e]) for(var i = 0; i < t.seriesZ[e].length; i++)null !== t.seriesZ[e][i] && $d4be73e5731103af$var$x.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]));
                }
            }
        },
        {
            key: "_handleSingleDataPoint",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                if (t.minX === t.maxX) {
                    var i = new $d4be73e5731103af$var$I(this.ctx);
                    if ("datetime" === e.xaxis.type) {
                        var a = i.getDate(t.minX);
                        e.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), t.minX = new Date(a).getTime();
                        var s = i.getDate(t.maxX);
                        e.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), t.maxX = new Date(s).getTime();
                    } else ("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX);
                }
            }
        },
        {
            key: "_getMinXDiff",
            value: function() {
                var t = this.w.globals;
                t.isXNumeric && t.seriesX.forEach(function(e, i) {
                    1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                    var a = e.slice();
                    a.sort(function(t, e) {
                        return t - e;
                    }), a.forEach(function(e, i) {
                        if (i > 0) {
                            var s = e - a[i - 1];
                            s > 0 && (t.minXDiff = Math.min(s, t.minXDiff));
                        }
                    }), 1 !== t.dataPoints && t.minXDiff !== Number.MAX_VALUE || (t.minXDiff = .5);
                });
            }
        },
        {
            key: "_setStackedMinMax",
            value: function() {
                var t = this, e = this.w.globals;
                if (e.series.length) {
                    var i = e.seriesGroups;
                    i.length || (i = [
                        this.w.config.series.map(function(t) {
                            return t.name;
                        })
                    ]);
                    var a = {}, s = {};
                    i.forEach(function(i) {
                        a[i] = [], s[i] = [], t.w.config.series.map(function(t, e) {
                            return i.indexOf(t.name) > -1 ? e : null;
                        }).filter(function(t) {
                            return null !== t;
                        }).forEach(function(t) {
                            for(var r = 0; r < e.series[e.maxValsInArrayIndex].length; r++)void 0 === a[i][r] && (a[i][r] = 0, s[i][r] = 0), null !== e.series[t][r] && $d4be73e5731103af$var$x.isNumber(e.series[t][r]) && (e.series[t][r] > 0 ? a[i][r] += parseFloat(e.series[t][r]) + 1e-4 : s[i][r] += parseFloat(e.series[t][r]));
                        });
                    }), Object.entries(a).forEach(function(t) {
                        var i = $d4be73e5731103af$var$g(t, 1)[0];
                        a[i].forEach(function(t, r) {
                            e.maxY = Math.max(e.maxY, a[i][r]), e.minY = Math.min(e.minY, s[i][r]);
                        });
                    });
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$q = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.elgrid = i, this.w = e.w;
        var s = this.w;
        this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.axisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, "bottom" === s.config.xaxis.position && (this.xAxisoffX = s.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new $d4be73e5731103af$var$B(e);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawYaxis",
            value: function(t) {
                var e = this, i = this.w, a = new $d4be73e5731103af$var$m(this.ctx), s = i.config.yaxis[t].labels.style, r = s.fontSize, o = s.fontFamily, n = s.fontWeight, l = a.group({
                    class: "apexcharts-yaxis",
                    rel: t,
                    transform: "translate(" + i.globals.translateYAxisX[t] + ", 0)"
                });
                if (this.axesUtils.isYAxisHidden(t)) return l;
                var h = a.group({
                    class: "apexcharts-yaxis-texts-g"
                });
                l.add(h);
                var c = i.globals.yAxisScale[t].result.length - 1, d = i.globals.gridHeight / c, g = i.globals.translateY, u = i.globals.yLabelFormatters[t], p = i.globals.yAxisScale[t].result.slice();
                p = this.axesUtils.checkForReversedLabels(t, p);
                var f = "";
                if (i.config.yaxis[t].labels.show) for(var x = function(l) {
                    var x = p[l];
                    x = u(x, l, i);
                    var b = i.config.yaxis[t].labels.padding;
                    i.config.yaxis[t].opposite && 0 !== i.config.yaxis.length && (b *= -1);
                    var v = "end";
                    i.config.yaxis[t].opposite && (v = "start"), "left" === i.config.yaxis[t].labels.align ? v = "start" : "center" === i.config.yaxis[t].labels.align ? v = "middle" : "right" === i.config.yaxis[t].labels.align && (v = "end");
                    var m = e.axesUtils.getYAxisForeColor(s.colors, t), y = a.drawText({
                        x: b,
                        y: g + c / 10 + i.config.yaxis[t].labels.offsetY + 1,
                        text: x,
                        textAnchor: v,
                        fontSize: r,
                        fontFamily: o,
                        fontWeight: n,
                        maxWidth: i.config.yaxis[t].labels.maxWidth,
                        foreColor: Array.isArray(m) ? m[l] : m,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + s.cssClass
                    });
                    l === c && (f = y), h.add(y);
                    var w = document.createElementNS(i.globals.SVGNS, "title");
                    if (w.textContent = Array.isArray(x) ? x.join(" ") : x, y.node.appendChild(w), 0 !== i.config.yaxis[t].labels.rotate) {
                        var k = a.rotateAroundCenter(f.node), A = a.rotateAroundCenter(y.node);
                        y.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[t].labels.rotate, " ").concat(k.x, " ").concat(A.y, ")"));
                    }
                    g += d;
                }, b = c; b >= 0; b--)x(b);
                if (void 0 !== i.config.yaxis[t].title.text) {
                    var v = a.group({
                        class: "apexcharts-yaxis-title"
                    }), y = 0;
                    i.config.yaxis[t].opposite && (y = i.globals.translateYAxisX[t]);
                    var w = a.drawText({
                        x: y,
                        y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[t].title.offsetY,
                        text: i.config.yaxis[t].title.text,
                        textAnchor: "end",
                        foreColor: i.config.yaxis[t].title.style.color,
                        fontSize: i.config.yaxis[t].title.style.fontSize,
                        fontWeight: i.config.yaxis[t].title.style.fontWeight,
                        fontFamily: i.config.yaxis[t].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[t].title.style.cssClass
                    });
                    v.add(w), l.add(v);
                }
                var k = i.config.yaxis[t].axisBorder, A = 31 + k.offsetX;
                if (i.config.yaxis[t].opposite && (A = -31 - k.offsetX), k.show) {
                    var S = a.drawLine(A, i.globals.translateY + k.offsetY - 2, A, i.globals.gridHeight + i.globals.translateY + k.offsetY + 2, k.color, 0, k.width);
                    l.add(S);
                }
                return i.config.yaxis[t].axisTicks.show && this.axesUtils.drawYAxisTicks(A, c, k, i.config.yaxis[t].axisTicks, t, d, l), l;
            }
        },
        {
            key: "drawYaxisInversed",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = i.group({
                    class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                }), s = i.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                });
                a.add(s);
                var r = e.globals.yAxisScale[t].result.length - 1, o = e.globals.gridWidth / r + .1, n = o + e.config.xaxis.labels.offsetX, l = e.globals.xLabelFormatter, h = e.globals.yAxisScale[t].result.slice(), c = e.globals.timescaleLabels;
                c.length > 0 && (this.xaxisLabels = c.slice(), r = (h = c.slice()).length), h = this.axesUtils.checkForReversedLabels(t, h);
                var d = c.length;
                if (e.config.xaxis.labels.show) for(var g = d ? 0 : r; d ? g < d : g >= 0; d ? g++ : g--){
                    var u = h[g];
                    u = l(u, g, e);
                    var p = e.globals.gridWidth + e.globals.padHorizontal - (n - o + e.config.xaxis.labels.offsetX);
                    if (c.length) {
                        var f = this.axesUtils.getLabel(h, c, p, g, this.drawnLabels, this.xaxisFontSize);
                        p = f.x, u = f.text, this.drawnLabels.push(f.text), 0 === g && e.globals.skipFirstTimelinelabel && (u = ""), g === h.length - 1 && e.globals.skipLastTimelinelabel && (u = "");
                    }
                    var x = i.drawText({
                        x: p,
                        y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                        text: u,
                        textAnchor: "middle",
                        foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                        fontSize: this.xaxisFontSize,
                        fontFamily: this.xaxisFontFamily,
                        fontWeight: e.config.xaxis.labels.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-xaxis-label " + e.config.xaxis.labels.style.cssClass
                    });
                    s.add(x), x.tspan(u);
                    var b = document.createElementNS(e.globals.SVGNS, "title");
                    b.textContent = u, x.node.appendChild(b), n += o;
                }
                return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
            }
        },
        {
            key: "inversedYAxisBorder",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = e.config.xaxis.axisBorder;
                if (a.show) {
                    var s = 0;
                    "bar" === e.config.chart.type && e.globals.isXNumeric && (s -= 15);
                    var r = i.drawLine(e.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                    this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(r) : t.add(r);
                }
            }
        },
        {
            key: "inversedYAxisTitleText",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx);
                if (void 0 !== e.config.xaxis.title.text) {
                    var a = i.group({
                        class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                    }), s = i.drawText({
                        x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                        y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                        text: e.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: e.config.xaxis.title.style.fontSize,
                        fontFamily: e.config.xaxis.title.style.fontFamily,
                        fontWeight: e.config.xaxis.title.style.fontWeight,
                        foreColor: e.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                    });
                    a.add(s), t.add(a);
                }
            }
        },
        {
            key: "yAxisTitleRotate",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$m(this.ctx), s = {
                    width: 0,
                    height: 0
                }, r = {
                    width: 0,
                    height: 0
                }, o = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g"));
                null !== o && (s = o.getBoundingClientRect());
                var n = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text"));
                if (null !== n && (r = n.getBoundingClientRect()), null !== n) {
                    var l = this.xPaddingForYAxisTitle(t, s, r, e);
                    n.setAttribute("x", l.xPos - (e ? 10 : 0));
                }
                if (null !== n) {
                    var h = a.rotateAroundCenter(n);
                    n.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(h.x, " ").concat(h.y, ")"));
                }
            }
        },
        {
            key: "xPaddingForYAxisTitle",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = 0, n = 10;
                return void 0 === s.config.yaxis[t].title.text || t < 0 ? {
                    xPos: o,
                    padd: 0
                } : (a ? (o = e.width + s.config.yaxis[t].title.offsetX + i.width / 2 + n / 2, 0 === (r += 1) && (o -= n / 2)) : (o = -1 * e.width + s.config.yaxis[t].title.offsetX + n / 2 + i.width / 2, s.globals.isBarHorizontal && (n = 25, o = -1 * e.width - s.config.yaxis[t].title.offsetX - n)), {
                    xPos: o,
                    padd: n
                });
            }
        },
        {
            key: "setYAxisXPosition",
            value: function(t, e) {
                var i = this.w, a = 0, s = 0, r = 18, o = 1;
                i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map(function(n, l) {
                    var h = i.globals.ignoreYAxisIndexes.indexOf(l) > -1 || !n.show || n.floating || 0 === t[l].width, c = t[l].width + e[l].width;
                    n.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[l] = s - n.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + o, h || (o = o + c + 20), i.globals.translateYAxisX[l] = s - n.labels.offsetX + 20) : (a = i.globals.translateX - r, h || (r = r + c + 20), i.globals.translateYAxisX[l] = a + n.labels.offsetX);
                });
            }
        },
        {
            key: "setYAxisTextAlignments",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                (e = $d4be73e5731103af$var$x.listToArray(e)).forEach(function(e, i) {
                    var a = t.config.yaxis[i];
                    if (a && !a.floating && void 0 !== a.labels.align) {
                        var s = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"));
                        r = $d4be73e5731103af$var$x.listToArray(r);
                        var o = s.getBoundingClientRect();
                        "left" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "start");
                        }), a.opposite || s.setAttribute("transform", "translate(-".concat(o.width, ", 0)"))) : "center" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "middle");
                        }), s.setAttribute("transform", "translate(".concat(o.width / 2 * (a.opposite ? 1 : -1), ", 0)"))) : "right" === a.labels.align && (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "end");
                        }), a.opposite && s.setAttribute("transform", "translate(".concat(o.width, ", 0)")));
                    }
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Z = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.documentEvent = $d4be73e5731103af$var$x.bind(this.documentEvent, this);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "addEventListener",
            value: function(t, e) {
                var i = this.w;
                i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [
                    e
                ];
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    var a = i.globals.events[t].indexOf(e);
                    -1 !== a && i.globals.events[t].splice(a, 1);
                }
            }
        },
        {
            key: "fireEvent",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    e && e.length || (e = []);
                    for(var a = i.globals.events[t], s = a.length, r = 0; r < s; r++)a[r].apply(null, e);
                }
            }
        },
        {
            key: "setupEventHandlers",
            value: function() {
                var t = this, e = this.w, i = this.ctx, a = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                this.ctx.eventList.forEach(function(t) {
                    a.addEventListener(t, function(t) {
                        var a = Object.assign({}, e, {
                            seriesIndex: e.globals.capturedSeriesIndex,
                            dataPointIndex: e.globals.capturedDataPointIndex
                        });
                        "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, a) : "mouseleave" === t.type || "touchleave" === t.type ? "function" == typeof e.config.chart.events.mouseLeave && e.config.chart.events.mouseLeave(t, i, a) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, a), i.ctx.events.fireEvent("click", [
                            t,
                            i,
                            a
                        ]));
                    }, {
                        capture: !1,
                        passive: !0
                    });
                }), this.ctx.eventList.forEach(function(i) {
                    e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                        passive: !0
                    });
                }), this.ctx.core.setupBrushHandler();
            }
        },
        {
            key: "documentEvent",
            value: function(t) {
                var e = this.w, i = t.target.className;
                if ("click" === t.type) {
                    var a = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                    a && a.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && a.classList.remove("apexcharts-menu-open");
                }
                e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$$ = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "setCurrentLocaleValues",
            value: function(t) {
                var e = this.w.config.chart.locales;
                window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                var i = e.filter(function(e) {
                    return e.name === t;
                })[0];
                if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                var a = $d4be73e5731103af$var$x.extend($d4be73e5731103af$var$C, i);
                this.w.globals.locale = a.options;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$J = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawAxis",
            value: function(t, e) {
                var i, a, s = this, r = this.w.globals, o = this.w.config, n = new $d4be73e5731103af$var$V(this.ctx, e), l = new $d4be73e5731103af$var$q(this.ctx, e);
                r.axisCharts && "radar" !== t && (r.isBarHorizontal ? (a = l.drawYaxisInversed(0), i = n.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = n.drawXaxis(), r.dom.elGraphical.add(i), o.yaxis.map(function(t, e) {
                    if (-1 === r.ignoreYAxisIndexes.indexOf(e) && (a = l.drawYaxis(e), r.dom.Paper.add(a), "back" === s.w.config.grid.position)) {
                        var i = r.dom.Paper.children()[1];
                        i.remove(), r.dom.Paper.add(i);
                    }
                })));
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Q = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawXCrosshairs",
            value: function() {
                var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx), i = new $d4be73e5731103af$var$v(this.ctx), a = t.config.xaxis.crosshairs.fill.gradient, s = t.config.xaxis.crosshairs.dropShadow, r = t.config.xaxis.crosshairs.fill.type, o = a.colorFrom, n = a.colorTo, l = a.opacityFrom, h = a.opacityTo, c = a.stops, d = s.enabled, g = s.left, u = s.top, p = s.blur, f = s.color, b = s.opacity, y = t.config.xaxis.crosshairs.fill.color;
                if (t.config.xaxis.crosshairs.show) {
                    "gradient" === r && (y = e.drawGradient("vertical", o, n, l, h, null, c, null));
                    var w = e.drawRect();
                    1 === t.config.xaxis.crosshairs.width && (w = e.drawLine());
                    var k = t.globals.gridHeight;
                    (!$d4be73e5731103af$var$x.isNumber(k) || k < 0) && (k = 0);
                    var A = t.config.xaxis.crosshairs.width;
                    (!$d4be73e5731103af$var$x.isNumber(A) || A < 0) && (A = 0), w.attr({
                        class: "apexcharts-xcrosshairs",
                        x: 0,
                        y: 0,
                        y2: k,
                        width: A,
                        height: k,
                        fill: y,
                        filter: "none",
                        "fill-opacity": t.config.xaxis.crosshairs.opacity,
                        stroke: t.config.xaxis.crosshairs.stroke.color,
                        "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                        "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                    }), d && (w = i.dropShadow(w, {
                        left: g,
                        top: u,
                        blur: p,
                        color: f,
                        opacity: b
                    })), t.globals.dom.elGraphical.add(w);
                }
            }
        },
        {
            key: "drawYCrosshairs",
            value: function() {
                var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx), i = t.config.yaxis[0].crosshairs, a = t.globals.barPadForNumericAxis;
                if (t.config.yaxis[0].crosshairs.show) {
                    var s = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                    s.attr({
                        class: "apexcharts-ycrosshairs"
                    }), t.globals.dom.elGraphical.add(s);
                }
                var r = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                r.attr({
                    class: "apexcharts-ycrosshairs-hidden"
                }), t.globals.dom.elGraphical.add(r);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$K = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "checkResponsiveConfig",
            value: function(t) {
                var e = this, i = this.w, a = i.config;
                if (0 !== a.responsive.length) {
                    var s = a.responsive.slice();
                    s.sort(function(t, e) {
                        return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0;
                    }).reverse();
                    var r = new $d4be73e5731103af$var$E({}), o = function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = s[0].breakpoint, o = window.innerWidth > 0 ? window.innerWidth : screen.width;
                        if (o > a) {
                            var n = $d4be73e5731103af$var$y.extendArrayProps(r, i.globals.initialConfig, i);
                            t = $d4be73e5731103af$var$x.extend(n, t), t = $d4be73e5731103af$var$x.extend(i.config, t), e.overrideResponsiveOptions(t);
                        } else for(var l = 0; l < s.length; l++)o < s[l].breakpoint && (t = $d4be73e5731103af$var$y.extendArrayProps(r, s[l].options, i), t = $d4be73e5731103af$var$x.extend(i.config, t), e.overrideResponsiveOptions(t));
                    };
                    if (t) {
                        var n = $d4be73e5731103af$var$y.extendArrayProps(r, t, i);
                        n = $d4be73e5731103af$var$x.extend(i.config, n), o(n = $d4be73e5731103af$var$x.extend(n, t));
                    } else o({});
                }
            }
        },
        {
            key: "overrideResponsiveOptions",
            value: function(t) {
                var e = new $d4be73e5731103af$var$E(t).init({
                    responsiveOverride: !0
                });
                this.w.config = e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$tt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.colors = [], this.w = e.w;
        var i = this.w;
        this.isColorFn = !1, this.isHeatmapDistributed = "treemap" === i.config.chart.type && i.config.plotOptions.treemap.distributed || "heatmap" === i.config.chart.type && i.config.plotOptions.heatmap.distributed, this.isBarDistributed = i.config.plotOptions.bar.distributed && ("bar" === i.config.chart.type || "rangeBar" === i.config.chart.type);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "init",
            value: function() {
                this.setDefaultColors();
            }
        },
        {
            key: "setDefaultColors",
            value: function() {
                var t, e = this, i = this.w, a = new $d4be73e5731103af$var$x;
                if (i.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(i.config.theme.mode)), void 0 === i.config.colors || 0 === (null === (t = i.config.colors) || void 0 === t ? void 0 : t.length) ? i.globals.colors = this.predefined() : (i.globals.colors = i.config.colors, Array.isArray(i.config.colors) && i.config.colors.length > 0 && "function" == typeof i.config.colors[0] && (i.globals.colors = i.config.series.map(function(t, a) {
                    var s = i.config.colors[a];
                    return s || (s = i.config.colors[0]), "function" == typeof s ? (e.isColorFn = !0, s({
                        value: i.globals.axisCharts ? i.globals.series[a][0] ? i.globals.series[a][0] : 0 : i.globals.series[a],
                        seriesIndex: a,
                        dataPointIndex: a,
                        w: i
                    })) : s;
                }))), i.globals.seriesColors.map(function(t, e) {
                    t && (i.globals.colors[e] = t);
                }), i.config.theme.monochrome.enabled) {
                    var s = [], r = i.globals.series.length;
                    (this.isBarDistributed || this.isHeatmapDistributed) && (r = i.globals.series[0].length * i.globals.series.length);
                    for(var o = i.config.theme.monochrome.color, n = 1 / (r / i.config.theme.monochrome.shadeIntensity), l = i.config.theme.monochrome.shadeTo, h = 0, c = 0; c < r; c++){
                        var d = void 0;
                        "dark" === l ? (d = a.shadeColor(-1 * h, o), h += n) : (d = a.shadeColor(h, o), h += n), s.push(d);
                    }
                    i.globals.colors = s.slice();
                }
                var g = i.globals.colors.slice();
                this.pushExtraColors(i.globals.colors);
                [
                    "fill",
                    "stroke"
                ].forEach(function(t) {
                    void 0 === i.config[t].colors ? i.globals[t].colors = e.isColorFn ? i.config.colors : g : i.globals[t].colors = i.config[t].colors.slice(), e.pushExtraColors(i.globals[t].colors);
                }), void 0 === i.config.dataLabels.style.colors ? i.globals.dataLabels.style.colors = g : i.globals.dataLabels.style.colors = i.config.dataLabels.style.colors.slice(), this.pushExtraColors(i.globals.dataLabels.style.colors, 50), void 0 === i.config.plotOptions.radar.polygons.fill.colors ? i.globals.radarPolygons.fill.colors = [
                    "dark" === i.config.theme.mode ? "#424242" : "none"
                ] : i.globals.radarPolygons.fill.colors = i.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(i.globals.radarPolygons.fill.colors, 20), void 0 === i.config.markers.colors ? i.globals.markers.colors = g : i.globals.markers.colors = i.config.markers.colors.slice(), this.pushExtraColors(i.globals.markers.colors);
            }
        },
        {
            key: "pushExtraColors",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = e || a.globals.series.length;
                if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === a.config.chart.type && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), t.length < s) for(var r = s - t.length, o = 0; o < r; o++)t.push(t[o]);
            }
        },
        {
            key: "updateThemeOptions",
            value: function(t) {
                t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                var e = t.theme.mode || "light", i = t.theme.palette ? t.theme.palette : "dark" === e ? "palette4" : "palette1", a = t.chart.foreColor ? t.chart.foreColor : "dark" === e ? "#f6f7f8" : "#373d3f";
                return t.tooltip.theme = e, t.chart.foreColor = a, t.theme.palette = i, t;
            }
        },
        {
            key: "predefined",
            value: function() {
                switch(this.w.config.theme.palette){
                    case "palette1":
                    default:
                        this.colors = [
                            "#008FFB",
                            "#00E396",
                            "#FEB019",
                            "#FF4560",
                            "#775DD0"
                        ];
                        break;
                    case "palette2":
                        this.colors = [
                            "#3f51b5",
                            "#03a9f4",
                            "#4caf50",
                            "#f9ce1d",
                            "#FF9800"
                        ];
                        break;
                    case "palette3":
                        this.colors = [
                            "#33b2df",
                            "#546E7A",
                            "#d4526e",
                            "#13d8aa",
                            "#A5978B"
                        ];
                        break;
                    case "palette4":
                        this.colors = [
                            "#4ecdc4",
                            "#c7f464",
                            "#81D4FA",
                            "#fd6a6a",
                            "#546E7A"
                        ];
                        break;
                    case "palette5":
                        this.colors = [
                            "#2b908f",
                            "#f9a3a4",
                            "#90ee7e",
                            "#fa4443",
                            "#69d2e7"
                        ];
                        break;
                    case "palette6":
                        this.colors = [
                            "#449DD1",
                            "#F86624",
                            "#EA3546",
                            "#662E9B",
                            "#C5D86D"
                        ];
                        break;
                    case "palette7":
                        this.colors = [
                            "#D7263D",
                            "#1B998B",
                            "#2E294E",
                            "#F46036",
                            "#E2C044"
                        ];
                        break;
                    case "palette8":
                        this.colors = [
                            "#662E9B",
                            "#F86624",
                            "#F9C80E",
                            "#EA3546",
                            "#43BCCD"
                        ];
                        break;
                    case "palette9":
                        this.colors = [
                            "#5C4742",
                            "#A5978B",
                            "#8D5B4C",
                            "#5A2A27",
                            "#C4BBAF"
                        ];
                        break;
                    case "palette10":
                        this.colors = [
                            "#A300D6",
                            "#7D02EB",
                            "#5653FE",
                            "#2983FF",
                            "#00B1F2"
                        ];
                }
                return this.colors;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$et = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function() {
                this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
            }
        },
        {
            key: "drawTitleSubtitle",
            value: function(t) {
                var e = this.w, i = "title" === t ? e.config.title : e.config.subtitle, a = e.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                if ("left" === i.align ? (a = 10, r = "start") : "right" === i.align && (a = e.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                    var o = new $d4be73e5731103af$var$m(this.ctx).drawText({
                        x: a,
                        y: s,
                        text: i.text,
                        textAnchor: r,
                        fontSize: i.style.fontSize,
                        fontFamily: i.style.fontFamily,
                        fontWeight: i.style.fontWeight,
                        foreColor: i.style.color,
                        opacity: 1
                    });
                    o.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(o);
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$it = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getTitleSubtitleCoords",
            value: function(t) {
                var e = this.w, i = 0, a = 0, s = "title" === t ? e.config.title.floating : e.config.subtitle.floating, r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                if (null !== r && !s) {
                    var o = r.getBoundingClientRect();
                    i = o.width, a = e.globals.axisCharts ? o.height + 5 : o.height;
                }
                return {
                    width: i,
                    height: a
                };
            }
        },
        {
            key: "getLegendsRect",
            value: function() {
                var t = this.w, e = t.globals.dom.elLegendWrap;
                t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                var i = Object.assign({}, $d4be73e5731103af$var$x.getBoundingClientRect(e));
                return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                    x: i.x,
                    y: i.y,
                    height: i.height,
                    width: 0 === i.height ? 0 : i.width
                } : this.dCtx.lgRect = {
                    x: 0,
                    y: 0,
                    height: 0,
                    width: 0
                }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect;
            }
        },
        {
            key: "getLargestStringFromMultiArr",
            value: function(t, e) {
                var i = t;
                if (this.w.globals.isMultiLineX) {
                    var a = e.map(function(t, e) {
                        return Array.isArray(t) ? t.length : 1;
                    }), s = Math.max.apply(Math, $d4be73e5731103af$var$u(a));
                    i = e[a.indexOf(s)];
                }
                return i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$at = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getxAxisLabelsCoords",
            value: function() {
                var t, e = this.w, i = e.globals.labels.slice();
                if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                    var a = this.getxAxisTimeScaleLabelsCoords();
                    t = {
                        width: a.width,
                        height: a.height
                    }, e.globals.rotateXLabels = !1;
                } else {
                    this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                    var s = e.globals.xLabelFormatter, r = $d4be73e5731103af$var$x.getLargestStringFromArr(i), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                    e.globals.isBarHorizontal && (o = r = e.globals.yAxisScale[0].result.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0));
                    var n = new $d4be73e5731103af$var$T(this.dCtx.ctx), l = r;
                    r = n.xLabelFormat(s, r, l, {
                        i: void 0,
                        dateFormatter: new $d4be73e5731103af$var$I(this.dCtx.ctx).formatDate,
                        w: e
                    }), o = n.xLabelFormat(s, o, l, {
                        i: void 0,
                        dateFormatter: new $d4be73e5731103af$var$I(this.dCtx.ctx).formatDate,
                        w: e
                    }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (o = r = "1");
                    var h = new $d4be73e5731103af$var$m(this.dCtx.ctx), c = h.getTextRects(r, e.config.xaxis.labels.style.fontSize), d = c;
                    if (r !== o && (d = h.getTextRects(o, e.config.xaxis.labels.style.fontSize)), (t = {
                        width: c.width >= d.width ? c.width : d.width,
                        height: c.height >= d.height ? c.height : d.height
                    }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                        if (!e.globals.isBarHorizontal) {
                            e.globals.rotateXLabels = !0;
                            var g = function(t) {
                                return h.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1);
                            };
                            c = g(r), r !== o && (d = g(o)), t.height = (c.height > d.height ? c.height : d.height) / 1.5, t.width = c.width > d.width ? c.width : d.width;
                        }
                    } else e.globals.rotateXLabels = !1;
                }
                return e.config.xaxis.labels.show || (t = {
                    width: 0,
                    height: 0
                }), {
                    width: t.width,
                    height: t.height
                };
            }
        },
        {
            key: "getxAxisGroupLabelsCoords",
            value: function() {
                var t, e = this.w;
                if (!e.globals.hasXaxisGroups) return {
                    width: 0,
                    height: 0
                };
                var i, a = (null === (t = e.config.xaxis.group.style) || void 0 === t ? void 0 : t.fontSize) || e.config.xaxis.labels.style.fontSize, s = e.globals.groups.map(function(t) {
                    return t.title;
                }), r = $d4be73e5731103af$var$x.getLargestStringFromArr(s), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), n = new $d4be73e5731103af$var$m(this.dCtx.ctx), l = n.getTextRects(r, a), h = l;
                return r !== o && (h = n.getTextRects(o, a)), i = {
                    width: l.width >= h.width ? l.width : h.width,
                    height: l.height >= h.height ? l.height : h.height
                }, e.config.xaxis.labels.show || (i = {
                    width: 0,
                    height: 0
                }), {
                    width: i.width,
                    height: i.height
                };
            }
        },
        {
            key: "getxAxisTitleCoords",
            value: function() {
                var t = this.w, e = 0, i = 0;
                if (void 0 !== t.config.xaxis.title.text) {
                    var a = new $d4be73e5731103af$var$m(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                    e = a.width, i = a.height;
                }
                return {
                    width: e,
                    height: i
                };
            }
        },
        {
            key: "getxAxisTimeScaleLabelsCoords",
            value: function() {
                var t, e = this.w;
                this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                var i = this.dCtx.timescaleLabels.map(function(t) {
                    return t.value;
                }), a = i.reduce(function(t, e) {
                    return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e;
                }, 0);
                return 1.05 * (t = new $d4be73e5731103af$var$m(this.dCtx.ctx).getTextRects(a, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t;
            }
        },
        {
            key: "additionalPaddingXLabels",
            value: function(t) {
                var e = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, o = t.width;
                a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                var n = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, l = function(t, n) {
                    s.yaxis.length > 1 && function(t) {
                        return -1 !== a.collapsedSeriesIndices.indexOf(t);
                    }(n) || function(t) {
                        if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                            var n = e.dCtx.timescaleLabels[0], l = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + o / 1.75 - e.dCtx.yAxisWidthRight, h = n.position - o / 1.75 + e.dCtx.yAxisWidthLeft, c = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                            l > a.svgWidth - a.translateX - c && (a.skipLastTimelinelabel = !0), h < -(t.show && !t.floating || "bar" !== s.chart.type && "candlestick" !== s.chart.type && "rangeBar" !== s.chart.type && "boxPlot" !== s.chart.type ? 10 : o / 1.75) && (a.skipFirstTimelinelabel = !0);
                        } else "datetime" === r ? e.dCtx.gridPad.right < o && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < o / 2 - e.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && ("between" !== i.config.xaxis.tickPlacement || i.globals.isBarHorizontal) && (e.dCtx.xPadRight = o / 2 + 1);
                    }(t);
                };
                s.yaxis.forEach(function(t, i) {
                    n ? (e.dCtx.gridPad.left < o && (e.dCtx.xPadLeft = o / 2 + 1), e.dCtx.xPadRight = o / 2 + 1) : l(t, i);
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$st = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getyAxisLabelsCoords",
            value: function() {
                var t = this, e = this.w, i = [], a = 10, s = new $d4be73e5731103af$var$B(this.dCtx.ctx);
                return e.config.yaxis.map(function(r, o) {
                    var n = e.globals.yAxisScale[o], l = 0;
                    if (!s.isYAxisHidden(o) && r.labels.show && void 0 !== r.labels.minWidth && (l = r.labels.minWidth), !s.isYAxisHidden(o) && r.labels.show && n.result.length) {
                        var h = e.globals.yLabelFormatters[o], c = n.niceMin === Number.MIN_VALUE ? 0 : n.niceMin, d = String(c).length > String(n.niceMax).length ? c : n.niceMax, g = h(d, {
                            seriesIndex: o,
                            dataPointIndex: -1,
                            w: e
                        }), u = g;
                        if (void 0 !== g && 0 !== g.length || (g = d), e.globals.isBarHorizontal) {
                            a = 0;
                            var p = e.globals.labels.slice();
                            g = h(g = $d4be73e5731103af$var$x.getLargestStringFromArr(p), {
                                seriesIndex: o,
                                dataPointIndex: -1,
                                w: e
                            }), u = t.dCtx.dimHelpers.getLargestStringFromMultiArr(g, p);
                        }
                        var f = new $d4be73e5731103af$var$m(t.dCtx.ctx), b = "rotate(".concat(r.labels.rotate, " 0 0)"), v = f.getTextRects(g, r.labels.style.fontSize, r.labels.style.fontFamily, b, !1), y = v;
                        g !== u && (y = f.getTextRects(u, r.labels.style.fontSize, r.labels.style.fontFamily, b, !1)), i.push({
                            width: (l > y.width || l > v.width ? l : y.width > v.width ? y.width : v.width) + a,
                            height: y.height > v.height ? y.height : v.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getyAxisTitleCoords",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.config.yaxis.map(function(e, a) {
                    if (e.show && void 0 !== e.title.text) {
                        var s = new $d4be73e5731103af$var$m(t.dCtx.ctx), r = "rotate(".concat(e.title.rotate, " 0 0)"), o = s.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                        i.push({
                            width: o.width,
                            height: o.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getTotalYAxisWidth",
            value: function() {
                var t = this.w, e = 0, i = 0, a = 0, s = t.globals.yAxisScale.length > 1 ? 10 : 0, r = new $d4be73e5731103af$var$B(this.dCtx.ctx), o = function(o, n) {
                    var l = t.config.yaxis[n].floating, h = 0;
                    o.width > 0 && !l ? (h = o.width + s, function(e) {
                        return t.globals.ignoreYAxisIndexes.indexOf(e) > -1;
                    }(n) && (h = h - o.width - s)) : h = l || r.isYAxisHidden(n) ? 0 : 5, t.config.yaxis[n].opposite ? a += h : i += h, e += h;
                };
                return t.globals.yLabelsCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.yTitleCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$rt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "gridPadForColumnsInNumericAxis",
            value: function(t) {
                var e = this.w;
                if (e.globals.noData || e.globals.allSeriesCollapsed) return 0;
                var i = function(t) {
                    return "bar" === t || "rangeBar" === t || "candlestick" === t || "boxPlot" === t;
                }, a = e.config.chart.type, s = 0, r = i(a) ? e.config.series.length : 1;
                if (e.globals.comboBarCount > 0 && (r = e.globals.comboBarCount), e.globals.collapsedSeries.forEach(function(t) {
                    i(t.type) && (r -= 1);
                }), e.config.chart.stacked && (r = 1), (i(a) || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && r > 0) {
                    var o, n, l = Math.abs(e.globals.initialMaxX - e.globals.initialMinX);
                    l <= 3 && (l = e.globals.dataPoints), o = l / t, e.globals.minXDiff && e.globals.minXDiff / o > 0 && (n = e.globals.minXDiff / o), n > t / 2 && (n /= 2), (s = n / r * parseInt(e.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), s = s / (r > 1 ? 1 : 1.5) + 5, e.globals.barPadForNumericAxis = s;
                }
                return s;
            }
        },
        {
            key: "gridPadFortitleSubtitle",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 10;
                [
                    "title",
                    "subtitle"
                ].forEach(function(i) {
                    void 0 !== e.config[i].text ? a += e.config[i].margin : a += t.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 5;
                }), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || e.globals.axisCharts || (a += 10);
                var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                i.gridHeight = i.gridHeight - s.height - r.height - a, i.translateY = i.translateY + s.height + r.height + a;
            }
        },
        {
            key: "setGridXPosForDualYAxis",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$B(this.dCtx.ctx);
                i.config.yaxis.map(function(s, r) {
                    -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX = i.globals.translateX - (e[r].width + t[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$ot = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new $d4be73e5731103af$var$it(this), this.dimYAxis = new $d4be73e5731103af$var$st(this), this.dimXAxis = new $d4be73e5731103af$var$at(this), this.dimGrid = new $d4be73e5731103af$var$rt(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "plotCoords",
            value: function() {
                var t = this, e = this.w, i = e.globals;
                this.lgRect = this.dimHelpers.getLegendsRect(), this.isSparkline && (e.config.markers.discrete.length > 0 || e.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(e) {
                    var i = $d4be73e5731103af$var$g(e, 2), a = i[0], s = i[1];
                    t.gridPad[a] = Math.max(s, t.w.globals.markers.largestSize / 1.5);
                }), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                var a = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                i.gridWidth = i.gridWidth - 2 * a, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (a > 0 ? a + 4 : 0), i.translateY = i.translateY + this.gridPad.top;
            }
        },
        {
            key: "setDimensionsForAxisCharts",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map(function(t, i) {
                    e.globals.yLabelsCoords.push({
                        width: a[i].width,
                        index: i
                    }), e.globals.yTitleCoords.push({
                        width: s[i].width,
                        index: i
                    });
                }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                var r = this.dimXAxis.getxAxisLabelsCoords(), o = this.dimXAxis.getxAxisGroupLabelsCoords(), n = this.dimXAxis.getxAxisTitleCoords();
                this.conditionalChecksForAxisCoords(r, n, o), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                var l = this.yAxisWidth, h = this.xAxisHeight;
                i.xAxisLabelsHeight = this.xAxisHeight - n.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                var c = 10;
                ("radar" === e.config.chart.type || this.isSparkline) && (l = 0, h = i.goldenPadding), this.isSparkline && (this.lgRect = {
                    height: 0,
                    width: 0
                }), (this.isSparkline || "treemap" === e.config.chart.type) && (l = 0, h = 0, c = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                var d = function() {
                    i.translateX = l, i.gridHeight = i.svgHeight - t.lgRect.height - h - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - l;
                };
                switch("top" === e.config.xaxis.position && (c = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position){
                    case "bottom":
                        i.translateY = c, d();
                        break;
                    case "top":
                        i.translateY = this.lgRect.height + c, d();
                        break;
                    case "left":
                        i.translateY = c, i.translateX = this.lgRect.width + l, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l;
                        break;
                    case "right":
                        i.translateY = c, i.translateX = l, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 5;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
                this.dimGrid.setGridXPosForDualYAxis(s, a), new $d4be73e5731103af$var$q(this.ctx).setYAxisXPosition(a, s);
            }
        },
        {
            key: "setDimensionsForNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = 0;
                t.config.legend.show && !t.config.legend.floating && (a = 20);
                var s = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, o = i.plotOptions[s].offsetX;
                if (!i.legend.show || i.legend.floating) return e.gridHeight = e.svgHeight - i.grid.padding.left + i.grid.padding.right, e.gridWidth = e.gridHeight, e.translateY = r, void (e.translateX = o + (e.svgWidth - e.gridWidth) / 2);
                switch(i.legend.position){
                    case "bottom":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "top":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "left":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + this.lgRect.width + a;
                        break;
                    case "right":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + 10;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
            }
        },
        {
            key: "conditionalChecksForAxisCoords",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + t.height + e.height, o = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, n = a.globals.rotateXLabels ? 22 : 10, l = a.globals.rotateXLabels && "bottom" === a.config.legend.position ? 10 : 0;
                this.xAxisHeight = r * o + s * n + l, this.xAxisWidth = t.width, this.xAxisHeight - e.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                var h = 0, c = 0;
                a.config.yaxis.forEach(function(t) {
                    h += t.labels.minWidth, c += t.labels.maxWidth;
                }), this.yAxisWidth < h && (this.yAxisWidth = h), this.yAxisWidth > c && (this.yAxisWidth = c);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$nt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.lgCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getLegendStyles",
            value: function() {
                var t = document.createElement("style");
                t.setAttribute("type", "text/css");
                var e = document.createTextNode("	\n    	\n      .apexcharts-legend {	\n        display: flex;	\n        overflow: auto;	\n        padding: 0 10px;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {	\n        flex-wrap: wrap	\n      }	\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	\n        flex-direction: column;	\n        bottom: 0;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	\n        justify-content: flex-start;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {	\n        justify-content: center;  	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {	\n        justify-content: flex-end;	\n      }	\n      .apexcharts-legend-series {	\n        cursor: pointer;	\n        line-height: normal;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{	\n        display: flex;	\n        align-items: center;	\n      }	\n      .apexcharts-legend-text {	\n        position: relative;	\n        font-size: 14px;	\n      }	\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {	\n        pointer-events: none;	\n      }	\n      .apexcharts-legend-marker {	\n        position: relative;	\n        display: inline-block;	\n        cursor: pointer;	\n        margin-right: 3px;	\n        border-style: solid;\n      }	\n      	\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{	\n        display: inline-block;	\n      }	\n      .apexcharts-legend-series.apexcharts-no-click {	\n        cursor: auto;	\n      }	\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {	\n        display: none !important;	\n      }	\n      .apexcharts-inactive-legend {	\n        opacity: 0.45;	\n      }");
                return t.appendChild(e), t;
            }
        },
        {
            key: "getLegendBBox",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), e = t.width;
                return {
                    clwh: t.height,
                    clww: e
                };
            }
        },
        {
            key: "appendToForeignObject",
            value: function() {
                this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
            }
        },
        {
            key: "toggleDataSeries",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.axisCharts || "radialBar" === a.config.chart.type) {
                    a.globals.resized = !0;
                    var s = null, r = null;
                    if (a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), e) [
                        {
                            cs: a.globals.collapsedSeries,
                            csi: a.globals.collapsedSeriesIndices
                        },
                        {
                            cs: a.globals.ancillaryCollapsedSeries,
                            csi: a.globals.ancillaryCollapsedSeriesIndices
                        }
                    ].forEach(function(t) {
                        i.riseCollapsedSeries(t.cs, t.csi, r);
                    });
                    else this.hideSeries({
                        seriesEl: s,
                        realIndex: r
                    });
                } else {
                    var o = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t + 1, "'] path")), n = a.config.chart.type;
                    if ("pie" === n || "polarArea" === n || "donut" === n) {
                        var l = a.config.plotOptions.pie.donut.labels;
                        new $d4be73e5731103af$var$m(this.lgCtx.ctx).pathMouseDown(o.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node, l);
                    }
                    o.fire("click");
                }
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = t.seriesEl, i = t.realIndex, a = this.w, s = $d4be73e5731103af$var$x.clone(a.config.series);
                if (a.globals.axisCharts) {
                    var r = !1;
                    if (a.config.yaxis[i] && a.config.yaxis[i].show && a.config.yaxis[i].showAlways && (r = !0, a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (a.globals.ancillaryCollapsedSeries.push({
                        index: i,
                        data: s[i].data.slice(),
                        type: e.parentNode.className.baseVal.split("-")[1]
                    }), a.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                        a.globals.collapsedSeries.push({
                            index: i,
                            data: s[i].data.slice(),
                            type: e.parentNode.className.baseVal.split("-")[1]
                        }), a.globals.collapsedSeriesIndices.push(i);
                        var o = a.globals.risingSeries.indexOf(i);
                        a.globals.risingSeries.splice(o, 1);
                    }
                } else a.globals.collapsedSeries.push({
                    index: i,
                    data: s[i]
                }), a.globals.collapsedSeriesIndices.push(i);
                for(var n = e.childNodes, l = 0; l < n.length; l++)n[l].classList.contains("apexcharts-series-markers-wrap") && (n[l].classList.contains("apexcharts-hide") ? n[l].classList.remove("apexcharts-hide") : n[l].classList.add("apexcharts-hide"));
                a.globals.allSeriesCollapsed = a.globals.collapsedSeries.length === a.config.series.length, s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
            }
        },
        {
            key: "riseCollapsedSeries",
            value: function(t, e, i) {
                var a = this.w, s = $d4be73e5731103af$var$x.clone(a.config.series);
                if (t.length > 0) {
                    for(var r = 0; r < t.length; r++)t[r].index === i && (a.globals.axisCharts ? (s[i].data = t[r].data.slice(), t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)) : (s[i] = t[r].data, t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)));
                    s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            }
        },
        {
            key: "_getSeriesBasedOnCollapsedState",
            value: function(t) {
                var e = this.w;
                return e.globals.axisCharts ? t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a].data = []);
                }) : t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a] = 0);
                }), t;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$lt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new $d4be73e5731103af$var$nt(this);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "init",
            value: function() {
                var t = this.w, e = t.globals, i = t.config;
                if ((i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1 || !e.axisCharts) && i.legend.show) {
                    for(; e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                    this.drawLegends(), $d4be73e5731103af$var$x.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical();
                }
            }
        },
        {
            key: "drawLegends",
            value: function() {
                var t = this, e = this.w, i = e.config.legend.fontFamily, a = e.globals.seriesNames, s = e.globals.colors.slice();
                if ("heatmap" === e.config.chart.type) {
                    var r = e.config.plotOptions.heatmap.colorScale.ranges;
                    a = r.map(function(t) {
                        return t.name ? t.name : t.from + " - " + t.to;
                    }), s = r.map(function(t) {
                        return t.color;
                    });
                } else this.isBarsDistributed && (a = e.globals.labels.slice());
                e.config.legend.customLegendItems.length && (a = e.config.legend.customLegendItems);
                for(var o = e.globals.legendFormatter, n = e.config.legend.inverseOrder, l = n ? a.length - 1 : 0; n ? l >= 0 : l <= a.length - 1; n ? l-- : l++){
                    var h, c = o(a[l], {
                        seriesIndex: l,
                        w: e
                    }), d = !1, g = !1;
                    if (e.globals.collapsedSeries.length > 0) for(var u = 0; u < e.globals.collapsedSeries.length; u++)e.globals.collapsedSeries[u].index === l && (d = !0);
                    if (e.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var p = 0; p < e.globals.ancillaryCollapsedSeriesIndices.length; p++)e.globals.ancillaryCollapsedSeriesIndices[p] === l && (g = !0);
                    var f = document.createElement("span");
                    f.classList.add("apexcharts-legend-marker");
                    var b = e.config.legend.markers.offsetX, v = e.config.legend.markers.offsetY, w = e.config.legend.markers.height, k = e.config.legend.markers.width, A = e.config.legend.markers.strokeWidth, S = e.config.legend.markers.strokeColor, C = e.config.legend.markers.radius, L = f.style;
                    L.background = s[l], L.color = s[l], L.setProperty("background", s[l], "important"), e.config.legend.markers.fillColors && e.config.legend.markers.fillColors[l] && (L.background = e.config.legend.markers.fillColors[l]), void 0 !== e.globals.seriesColors[l] && (L.background = e.globals.seriesColors[l], L.color = e.globals.seriesColors[l]), L.height = Array.isArray(w) ? parseFloat(w[l]) + "px" : parseFloat(w) + "px", L.width = Array.isArray(k) ? parseFloat(k[l]) + "px" : parseFloat(k) + "px", L.left = (Array.isArray(b) ? parseFloat(b[l]) : parseFloat(b)) + "px", L.top = (Array.isArray(v) ? parseFloat(v[l]) : parseFloat(v)) + "px", L.borderWidth = Array.isArray(A) ? A[l] : A, L.borderColor = Array.isArray(S) ? S[l] : S, L.borderRadius = Array.isArray(C) ? parseFloat(C[l]) + "px" : parseFloat(C) + "px", e.config.legend.markers.customHTML && (Array.isArray(e.config.legend.markers.customHTML) ? e.config.legend.markers.customHTML[l] && (f.innerHTML = e.config.legend.markers.customHTML[l]()) : f.innerHTML = e.config.legend.markers.customHTML()), $d4be73e5731103af$var$m.setAttrs(f, {
                        rel: l + 1,
                        "data:collapsed": d || g
                    }), (d || g) && f.classList.add("apexcharts-inactive-legend");
                    var P = document.createElement("div"), I = document.createElement("span");
                    I.classList.add("apexcharts-legend-text"), I.innerHTML = Array.isArray(c) ? c.join(" ") : c;
                    var T = e.config.legend.labels.useSeriesColors ? e.globals.colors[l] : Array.isArray(e.config.legend.labels.colors) ? null === (h = e.config.legend.labels.colors) || void 0 === h ? void 0 : h[l] : e.config.legend.labels.colors;
                    T || (T = e.config.chart.foreColor), I.style.color = T, I.style.fontSize = parseFloat(e.config.legend.fontSize) + "px", I.style.fontWeight = e.config.legend.fontWeight, I.style.fontFamily = i || e.config.chart.fontFamily, $d4be73e5731103af$var$m.setAttrs(I, {
                        rel: l + 1,
                        i: l,
                        "data:default-text": encodeURIComponent(c),
                        "data:collapsed": d || g
                    }), P.appendChild(f), P.appendChild(I);
                    var M = new $d4be73e5731103af$var$y(this.ctx);
                    if (!e.config.legend.showForZeroSeries) 0 === M.getSeriesTotalByIndex(l) && M.seriesHaveSameValues(l) && !M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && P.classList.add("apexcharts-hidden-zero-series");
                    e.config.legend.showForNullSeries || M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && P.classList.add("apexcharts-hidden-null-series"), e.globals.dom.elLegendWrap.appendChild(P), e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)), e.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + e.config.legend.position), P.classList.add("apexcharts-legend-series"), P.style.margin = "".concat(e.config.legend.itemMargin.vertical, "px ").concat(e.config.legend.itemMargin.horizontal, "px"), e.globals.dom.elLegendWrap.style.width = e.config.legend.width ? e.config.legend.width + "px" : "", e.globals.dom.elLegendWrap.style.height = e.config.legend.height ? e.config.legend.height + "px" : "", $d4be73e5731103af$var$m.setAttrs(P, {
                        rel: l + 1,
                        seriesName: $d4be73e5731103af$var$x.escapeString(a[l]),
                        "data:collapsed": d || g
                    }), (d || g) && P.classList.add("apexcharts-inactive-legend"), e.config.legend.onItemClick.toggleDataSeries || P.classList.add("apexcharts-no-click");
                }
                e.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), e.config.legend.onItemHover.highlightDataSeries && 0 === e.config.legend.customLegendItems.length && (e.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), e.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0));
            }
        },
        {
            key: "setLegendWrapXY",
            value: function(t, e) {
                var i = this.w, a = i.globals.dom.elLegendWrap, s = a.getBoundingClientRect(), r = 0, o = 0;
                if ("bottom" === i.config.legend.position) o += i.globals.svgHeight - s.height / 2;
                else if ("top" === i.config.legend.position) {
                    var n = new $d4be73e5731103af$var$ot(this.ctx), l = n.dimHelpers.getTitleSubtitleCoords("title").height, h = n.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                    o = o + (l > 0 ? l - 10 : 0) + (h > 0 ? h - 10 : 0);
                }
                a.style.position = "absolute", r = r + t + i.config.legend.offsetX, o = o + e + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = o + "px", "bottom" === i.config.legend.position ? (a.style.top = "auto", a.style.bottom = 5 - i.config.legend.offsetY + "px") : "right" === i.config.legend.position && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px");
                [
                    "width",
                    "height"
                ].forEach(function(t) {
                    a.style[t] && (a.style[t] = parseInt(i.config.legend[t], 10) + "px");
                });
            }
        },
        {
            key: "legendAlignHorizontal",
            value: function() {
                var t = this.w;
                t.globals.dom.elLegendWrap.style.right = 0;
                var e = this.legendHelpers.getLegendBBox(), i = new $d4be73e5731103af$var$ot(this.ctx), a = i.dimHelpers.getTitleSubtitleCoords("title"), s = i.dimHelpers.getTitleSubtitleCoords("subtitle"), r = 0;
                "bottom" === t.config.legend.position ? r = -e.clwh / 1.8 : "top" === t.config.legend.position && (r = a.height + s.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, r);
            }
        },
        {
            key: "legendAlignVertical",
            value: function() {
                var t = this.w, e = this.legendHelpers.getLegendBBox(), i = 0;
                "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20);
            }
        },
        {
            key: "onLegendHovered",
            value: function(t) {
                var e = this.w, i = t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                    if (i) {
                        var a = parseInt(t.target.getAttribute("rel"), 10) - 1;
                        this.ctx.events.fireEvent("legendHover", [
                            this.ctx,
                            a,
                            this.w
                        ]), new $d4be73e5731103af$var$N(this.ctx).highlightRangeInSeries(t, t.target);
                    }
                } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new $d4be73e5731103af$var$N(this.ctx).toggleSeriesOnHover(t, t.target);
            }
        },
        {
            key: "onLegendClick",
            value: function(t) {
                var e = this.w;
                if (!e.config.legend.customLegendItems.length && (t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker"))) {
                    var i = parseInt(t.target.getAttribute("rel"), 10) - 1, a = "true" === t.target.getAttribute("data:collapsed"), s = this.w.config.chart.events.legendClick;
                    "function" == typeof s && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                        this.ctx,
                        i,
                        this.w
                    ]);
                    var r = this.w.config.legend.markers.onClick;
                    "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                        this.ctx,
                        i,
                        this.w
                    ])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$ht = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = i.globals.minX, this.maxX = i.globals.maxX;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "createToolbar",
            value: function() {
                var t = this, e = this.w, i = function() {
                    return document.createElement("div");
                }, a = i();
                if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = e.config.chart.toolbar.offsetY + "px", a.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                var r = [], o = function(i, a, s) {
                    var o = i.toLowerCase();
                    t.t[o] && e.config.chart.zoom.enabled && r.push({
                        el: a,
                        icon: "string" == typeof t.t[o] ? t.t[o] : s,
                        title: t.localeValues[i],
                        class: "apexcharts-".concat(o, "-icon")
                    });
                };
                o("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), o("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                var n = function(i) {
                    t.t[i] && e.config.chart[i].enabled && r.push({
                        el: "zoom" === i ? t.elZoom : t.elSelection,
                        icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                        title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                    });
                };
                n("zoom"), n("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                    el: this.elPan,
                    icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                    title: this.localeValues.pan,
                    class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                }), o("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                    el: this.elMenuIcon,
                    icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                    title: this.localeValues.menu,
                    class: "apexcharts-menu-icon"
                });
                for(var l = 0; l < this.elCustomIcons.length; l++)r.push({
                    el: this.elCustomIcons[l],
                    icon: this.t.customIcons[l].icon,
                    title: this.t.customIcons[l].title,
                    index: this.t.customIcons[l].index,
                    class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[l].class
                });
                r.forEach(function(t, e) {
                    t.index && $d4be73e5731103af$var$x.moveIndexInArray(r, e, t.index);
                });
                for(var h = 0; h < r.length; h++)$d4be73e5731103af$var$m.setAttrs(r[h].el, {
                    class: r[h].class,
                    title: r[h].title
                }), r[h].el.innerHTML = r[h].icon, a.appendChild(r[h].el);
                this._createHamburgerMenu(a), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
            }
        },
        {
            key: "_createHamburgerMenu",
            value: function(t) {
                this.elMenuItems = [], t.appendChild(this.elMenu), $d4be73e5731103af$var$m.setAttrs(this.elMenu, {
                    class: "apexcharts-menu"
                });
                var e = [
                    {
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    },
                    {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    },
                    {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }
                ];
                this.w.globals.allSeriesHasEqualX || e.splice(2, 1);
                for(var i = 0; i < e.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, $d4be73e5731103af$var$m.setAttrs(this.elMenuItems[i], {
                    class: "apexcharts-menu-item ".concat(e[i].name),
                    title: e[i].title
                }), this.elMenu.appendChild(this.elMenuItems[i]);
            }
        },
        {
            key: "addToolbarEventListeners",
            value: function() {
                var t = this;
                this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(e) {
                    e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"));
                });
                for(var e = 0; e < this.t.customIcons.length; e++)this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w));
            }
        },
        {
            key: "toggleZoomSelection",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(e) {
                    e.ctx.toolbar.toggleOtherControls();
                    var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom, a = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                    e.w.globals[a] = !e.w.globals[a], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "getToolbarIconsReference",
            value: function() {
                var t = this.w;
                this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
            }
        },
        {
            key: "enableZoomPanFromToolbar",
            value: function(t) {
                this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                var e = "pan" === t ? this.elPan : this.elZoom, i = "pan" === t ? this.elZoom : this.elPan;
                e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
            }
        },
        {
            key: "togglePanning",
            value: function() {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "toggleOtherControls",
            value: function() {
                var t = this, e = this.w;
                e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                    this.elPan,
                    this.elSelection,
                    this.elZoom
                ].forEach(function(e) {
                    e && e.classList.remove(t.selectedClass);
                });
            }
        },
        {
            key: "handleZoomIn",
            value: function() {
                var t = this.w;
                t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                var e = (this.minX + this.maxX) / 2, i = (this.minX + e) / 2, a = (this.maxX + e) / 2, s = this._getNewMinXMaxX(i, a);
                t.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
            }
        },
        {
            key: "handleZoomOut",
            value: function() {
                var t = this.w;
                if (t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                    var e = (this.minX + this.maxX) / 2, i = this.minX - (e - this.minX), a = this.maxX - (e - this.maxX), s = this._getNewMinXMaxX(i, a);
                    t.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            }
        },
        {
            key: "_getNewMinXMaxX",
            value: function(t, e) {
                var i = this.w.config.xaxis.convertedCatToNumeric;
                return {
                    minX: i ? Math.floor(t) : t,
                    maxX: i ? Math.floor(e) : e
                };
            }
        },
        {
            key: "zoomUpdateOptions",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== t || void 0 !== e) {
                    if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                        var a = {
                            min: t,
                            max: e
                        }, s = this.getBeforeZoomRange(a);
                        s && (a = s.xaxis);
                        var r = {
                            xaxis: a
                        }, o = $d4be73e5731103af$var$x.clone(i.globals.initialConfig.yaxis);
                        if (i.config.chart.zoom.autoScaleYaxis) o = new $d4be73e5731103af$var$_(this.ctx).autoScaleY(this.ctx, o, {
                            xaxis: a
                        });
                        i.config.chart.group || (r.yaxis = o), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, o);
                    }
                } else this.handleZoomReset();
            }
        },
        {
            key: "zoomCallback",
            value: function(t, e) {
                "function" == typeof this.ev.zoomed && this.ev.zoomed(this.ctx, {
                    xaxis: t,
                    yaxis: e
                });
            }
        },
        {
            key: "getBeforeZoomRange",
            value: function(t, e) {
                var i = null;
                return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                    xaxis: t,
                    yaxis: e
                })), i;
            }
        },
        {
            key: "toggleMenu",
            value: function() {
                var t = this;
                window.setTimeout(function() {
                    t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open");
                }, 0);
            }
        },
        {
            key: "handleDownload",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$G(this.ctx);
                switch(t){
                    case "svg":
                        i.exportToSVG(this.ctx);
                        break;
                    case "png":
                        i.exportToPng(this.ctx);
                        break;
                    case "csv":
                        i.exportToCSV({
                            series: e.config.series,
                            columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                        });
                }
            }
        },
        {
            key: "handleZoomReset",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    var e = t.w;
                    if (e.globals.lastXAxis.min = void 0, e.globals.lastXAxis.max = void 0, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                        var i = e.config.chart.events.beforeResetZoom(t, e);
                        i && t.updateHelpers.revertDefaultAxisMinMax(i);
                    }
                    "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                        min: e.config.xaxis.min,
                        max: e.config.xaxis.max
                    }), e.globals.zoomed = !1;
                    var a = t.ctx.series.emptyCollapsedSeries($d4be73e5731103af$var$x.clone(e.globals.initialSeries));
                    t.updateHelpers._updateSeries(a, e.config.chart.animations.dynamicAnimation.enabled);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$ct = function(t) {
    $d4be73e5731103af$var$n(i, $d4be73e5731103af$var$ht);
    var e = $d4be73e5731103af$var$d(i);
    function i(t) {
        var s;
        return $d4be73e5731103af$var$a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.dragged = !1, s.graphics = new $d4be73e5731103af$var$m(s.ctx), s.eventList = [
            "mousedown",
            "mouseleave",
            "mousemove",
            "touchstart",
            "touchmove",
            "mouseup",
            "touchend"
        ], s.clientX = 0, s.clientY = 0, s.startX = 0, s.endX = 0, s.dragX = 0, s.startY = 0, s.endY = 0, s.dragY = 0, s.moveDirection = "none", s;
    }
    return $d4be73e5731103af$var$r(i, [
        {
            key: "init",
            value: function(t) {
                var e = this, i = t.xyRatios, a = this.w, s = this;
                this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.elGraphical.add(this.zoomRect), a.globals.dom.elGraphical.add(this.selectionRect), "x" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    minY: 0,
                    maxX: a.globals.gridWidth,
                    maxY: a.globals.gridHeight
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : "y" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    maxX: a.globals.gridWidth
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(t) {
                    e.hoverArea.addEventListener(t, s.svgMouseEvents.bind(s, i), {
                        capture: !1,
                        passive: !0
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
            }
        },
        {
            key: "svgMouseEvents",
            value: function(t, e) {
                var i = this.w, a = this, s = this.ctx.toolbar, r = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, o = i.config.chart.toolbar.autoSelected;
                if (e.shiftKey ? (this.shiftWasPressed = !0, s.enableZoomPanFromToolbar("pan" === o ? "zoom" : "pan")) : this.shiftWasPressed && (s.enableZoomPanFromToolbar(o), this.shiftWasPressed = !1), e.target) {
                    var n, l = e.target.classList;
                    if (e.target.parentNode && null !== e.target.parentNode && (n = e.target.parentNode.classList), !(l.contains("apexcharts-selection-rect") || l.contains("apexcharts-legend-marker") || l.contains("apexcharts-legend-text") || n && n.contains("apexcharts-toolbar"))) {
                        if (a.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, a.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which) {
                            var h = a.gridRect.getBoundingClientRect();
                            a.startX = a.clientX - h.left, a.startY = a.clientY - h.top, a.dragged = !1, a.w.globals.mousedown = !0;
                        }
                        if (("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (a.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, a.w.globals.mousedown && a.panDragging({
                            context: a,
                            zoomtype: r,
                            xyRatios: t
                        })) : (a.w.globals.mousedown && i.globals.zoomEnabled || a.w.globals.mousedown && i.globals.selectionEnabled) && (a.selection = a.selectionDrawing({
                            context: a,
                            zoomtype: r
                        }))), "mouseup" === e.type || "touchend" === e.type || "mouseleave" === e.type) {
                            var c = a.gridRect.getBoundingClientRect();
                            a.w.globals.mousedown && (a.endX = a.clientX - c.left, a.endY = a.clientY - c.top, a.dragX = Math.abs(a.endX - a.startX), a.dragY = Math.abs(a.endY - a.startY), (i.globals.zoomEnabled || i.globals.selectionEnabled) && a.selectionDrawn({
                                context: a,
                                zoomtype: r
                            }), i.globals.panEnabled && i.config.xaxis.convertedCatToNumeric && a.delayedPanScrolled()), i.globals.zoomEnabled && a.hideSelectionRect(this.selectionRect), a.dragged = !1, a.w.globals.mousedown = !1;
                        }
                        this.makeSelectionRectDraggable();
                    }
                }
            }
        },
        {
            key: "makeSelectionRectDraggable",
            value: function() {
                var t = this.w;
                if (this.selectionRect) {
                    var e = this.selectionRect.node.getBoundingClientRect();
                    e.width > 0 && e.height > 0 && this.slDraggableRect.selectize({
                        points: "l, r",
                        pointSize: 8,
                        pointType: "rect"
                    }).resize({
                        constraint: {
                            minX: 0,
                            minY: 0,
                            maxX: t.globals.gridWidth,
                            maxY: t.globals.gridHeight
                        }
                    }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                }
            }
        },
        {
            key: "preselectedSelection",
            value: function() {
                var t = this.w, e = this.xyRatios;
                if (!t.globals.zoomEnabled) {
                    if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect(t.globals.selection);
                    else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio, a = {
                            x: i,
                            y: 0,
                            width: t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i,
                            height: t.globals.gridHeight,
                            translateX: 0,
                            translateY: 0,
                            selectionEnabled: !0
                        };
                        this.drawSelectionRect(a), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        });
                    }
                }
            }
        },
        {
            key: "drawSelectionRect",
            value: function(t) {
                var e = t.x, i = t.y, a = t.width, s = t.height, r = t.translateX, o = void 0 === r ? 0 : r, n = t.translateY, l = void 0 === n ? 0 : n, h = this.w, c = this.zoomRect, d = this.selectionRect;
                if (this.dragged || null !== h.globals.selection) {
                    var g = {
                        transform: "translate(" + o + ", " + l + ")"
                    };
                    h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), c.attr({
                        x: e,
                        y: i,
                        width: a,
                        height: s,
                        fill: h.config.chart.zoom.zoomedArea.fill.color,
                        "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity,
                        stroke: h.config.chart.zoom.zoomedArea.stroke.color,
                        "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width,
                        "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity
                    }), $d4be73e5731103af$var$m.setAttrs(c.node, g)), h.globals.selectionEnabled && (d.attr({
                        x: e,
                        y: i,
                        width: a > 0 ? a : 0,
                        height: s > 0 ? s : 0,
                        fill: h.config.chart.selection.fill.color,
                        "fill-opacity": h.config.chart.selection.fill.opacity,
                        stroke: h.config.chart.selection.stroke.color,
                        "stroke-width": h.config.chart.selection.stroke.width,
                        "stroke-dasharray": h.config.chart.selection.stroke.dashArray,
                        "stroke-opacity": h.config.chart.selection.stroke.opacity
                    }), $d4be73e5731103af$var$m.setAttrs(d.node, g));
                }
            }
        },
        {
            key: "hideSelectionRect",
            value: function(t) {
                t && t.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        },
        {
            key: "selectionDrawing",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.gridRect.getBoundingClientRect(), o = s.startX - 1, n = s.startY, l = !1, h = !1, c = s.clientX - r.left - o, d = s.clientY - r.top - n, g = {};
                return Math.abs(c + o) > a.globals.gridWidth ? c = a.globals.gridWidth - o : s.clientX - r.left < 0 && (c = o), o > s.clientX - r.left && (l = !0, c = Math.abs(c)), n > s.clientY - r.top && (h = !0, d = Math.abs(d)), g = "x" === i ? {
                    x: l ? o - c : o,
                    y: 0,
                    width: c,
                    height: a.globals.gridHeight
                } : "y" === i ? {
                    x: 0,
                    y: h ? n - d : n,
                    width: a.globals.gridWidth,
                    height: d
                } : {
                    x: l ? o - c : o,
                    y: h ? n - d : n,
                    width: c,
                    height: d
                }, s.drawSelectionRect(g), s.selectionDragging("resizing"), g;
            }
        },
        {
            key: "selectionDragging",
            value: function(t, e) {
                var i = this, a = this.w, s = this.xyRatios, r = this.selectionRect, o = 0;
                "resizing" === t && (o = 30);
                var n = function(t) {
                    return parseFloat(r.node.getAttribute(t));
                }, l = {
                    x: n("x"),
                    y: n("y"),
                    width: n("width"),
                    height: n("height")
                };
                a.globals.selection = l, "function" == typeof a.config.chart.events.selection && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                    var t = i.gridRect.getBoundingClientRect(), e = r.node.getBoundingClientRect(), o = {
                        xaxis: {
                            min: a.globals.xAxisScale.niceMin + (e.left - t.left) * s.xRatio,
                            max: a.globals.xAxisScale.niceMin + (e.right - t.left) * s.xRatio
                        },
                        yaxis: {
                            min: a.globals.yAxisScale[0].niceMin + (t.bottom - e.bottom) * s.yRatio[0],
                            max: a.globals.yAxisScale[0].niceMax - (e.top - t.top) * s.yRatio[0]
                        }
                    };
                    a.config.chart.events.selection(i.ctx, o), a.config.chart.brush.enabled && void 0 !== a.config.chart.events.brushScrolled && a.config.chart.events.brushScrolled(i.ctx, o);
                }, o));
            }
        },
        {
            key: "selectionDrawn",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.xyRatios, o = this.ctx.toolbar;
                if (s.startX > s.endX) {
                    var n = s.startX;
                    s.startX = s.endX, s.endX = n;
                }
                if (s.startY > s.endY) {
                    var l = s.startY;
                    s.startY = s.endY, s.endY = l;
                }
                var h = void 0, c = void 0;
                a.globals.isRangeBar ? (h = a.globals.yAxisScale[0].niceMin + s.startX * r.invertedYRatio, c = a.globals.yAxisScale[0].niceMin + s.endX * r.invertedYRatio) : (h = a.globals.xAxisScale.niceMin + s.startX * r.xRatio, c = a.globals.xAxisScale.niceMin + s.endX * r.xRatio);
                var d = [], g = [];
                if (a.config.yaxis.forEach(function(t, e) {
                    d.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.startY), g.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.endY);
                }), s.dragged && (s.dragX > 10 || s.dragY > 10) && h !== c) {
                    if (a.globals.zoomEnabled) {
                        var u = $d4be73e5731103af$var$x.clone(a.globals.initialConfig.yaxis), p = $d4be73e5731103af$var$x.clone(a.globals.initialConfig.xaxis);
                        if (a.globals.zoomed = !0, a.config.xaxis.convertedCatToNumeric && (h = Math.floor(h), c = Math.floor(c), h < 1 && (h = 1, c = a.globals.dataPoints), c - h < 2 && (c = h + 1)), "xy" !== i && "x" !== i || (p = {
                            min: h,
                            max: c
                        }), "xy" !== i && "y" !== i || u.forEach(function(t, e) {
                            u[e].min = g[e], u[e].max = d[e];
                        }), a.config.chart.zoom.autoScaleYaxis) {
                            var f = new $d4be73e5731103af$var$_(s.ctx);
                            u = f.autoScaleY(s.ctx, u, {
                                xaxis: p
                            });
                        }
                        if (o) {
                            var b = o.getBeforeZoomRange(p, u);
                            b && (p = b.xaxis ? b.xaxis : p, u = b.yaxis ? b.yaxis : u);
                        }
                        var v = {
                            xaxis: p
                        };
                        a.config.chart.group || (v.yaxis = u), s.ctx.updateHelpers._updateOptions(v, !1, s.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof a.config.chart.events.zoomed && o.zoomCallback(p, u);
                    } else if (a.globals.selectionEnabled) {
                        var m, y = null;
                        m = {
                            min: h,
                            max: c
                        }, "xy" !== i && "y" !== i || (y = $d4be73e5731103af$var$x.clone(a.config.yaxis)).forEach(function(t, e) {
                            y[e].min = g[e], y[e].max = d[e];
                        }), a.globals.selection = s.selection, "function" == typeof a.config.chart.events.selection && a.config.chart.events.selection(s.ctx, {
                            xaxis: m,
                            yaxis: y
                        });
                    }
                }
            }
        },
        {
            key: "panDragging",
            value: function(t) {
                var e = t.context, i = this.w, a = e;
                if (void 0 !== i.globals.lastClientPosition.x) {
                    var s = i.globals.lastClientPosition.x - a.clientX, r = i.globals.lastClientPosition.y - a.clientY;
                    Math.abs(s) > Math.abs(r) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(r) && s < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(s) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(s) && r < 0 && (this.moveDirection = "down");
                }
                i.globals.lastClientPosition = {
                    x: a.clientX,
                    y: a.clientY
                };
                var o = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, n = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                i.config.xaxis.convertedCatToNumeric || a.panScrolled(o, n);
            }
        },
        {
            key: "delayedPanScrolled",
            value: function() {
                var t = this.w, e = t.globals.minX, i = t.globals.maxX, a = (t.globals.maxX - t.globals.minX) / 2;
                "left" === this.moveDirection ? (e = t.globals.minX + a, i = t.globals.maxX + a) : "right" === this.moveDirection && (e = t.globals.minX - a, i = t.globals.maxX - a), e = Math.floor(e), i = Math.floor(i), this.updateScrolledChart({
                    xaxis: {
                        min: e,
                        max: i
                    }
                }, e, i);
            }
        },
        {
            key: "panScrolled",
            value: function(t, e) {
                var i = this.w, a = this.xyRatios, s = $d4be73e5731103af$var$x.clone(i.globals.initialConfig.yaxis), r = a.xRatio, o = i.globals.minX, n = i.globals.maxX;
                i.globals.isRangeBar && (r = a.invertedYRatio, o = i.globals.minY, n = i.globals.maxY), "left" === this.moveDirection ? (t = o + i.globals.gridWidth / 15 * r, e = n + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = o - i.globals.gridWidth / 15 * r, e = n - i.globals.gridWidth / 15 * r), i.globals.isRangeBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = o, e = n);
                var l = {
                    min: t,
                    max: e
                };
                i.config.chart.zoom.autoScaleYaxis && (s = new $d4be73e5731103af$var$_(this.ctx).autoScaleY(this.ctx, s, {
                    xaxis: l
                }));
                var h = {
                    xaxis: {
                        min: t,
                        max: e
                    }
                };
                i.config.chart.group || (h.yaxis = s), this.updateScrolledChart(h, t, e);
            }
        },
        {
            key: "updateScrolledChart",
            value: function(t, e, i) {
                var a = this.w;
                this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof a.config.chart.events.scrolled && a.config.chart.events.scrolled(this.ctx, {
                    xaxis: {
                        min: e,
                        max: i
                    }
                });
            }
        }
    ]), i;
}(), $d4be73e5731103af$var$dt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getNearestValues",
            value: function(t) {
                var e = t.hoverArea, i = t.elGrid, a = t.clientX, s = t.clientY, r = this.w, o = i.getBoundingClientRect(), n = o.width, l = o.height, h = n / (r.globals.dataPoints - 1), c = l / r.globals.dataPoints, d = this.hasBars();
                !r.globals.comboCharts && !d || r.config.xaxis.convertedCatToNumeric || (h = n / r.globals.dataPoints);
                var g = a - o.left - r.globals.barPadForNumericAxis, u = s - o.top;
                g < 0 || u < 0 || g > n || u > l ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                var p = Math.round(g / h), f = Math.floor(u / c);
                d && !r.config.xaxis.convertedCatToNumeric && (p = Math.ceil(g / h), p -= 1);
                var b = null, v = null, m = [], y = [];
                if (r.globals.seriesXvalues.forEach(function(t) {
                    m.push([
                        t[0] + 1e-6
                    ].concat(t));
                }), r.globals.seriesYvalues.forEach(function(t) {
                    y.push([
                        t[0] + 1e-6
                    ].concat(t));
                }), m = m.map(function(t) {
                    return t.filter(function(t) {
                        return $d4be73e5731103af$var$x.isNumber(t);
                    });
                }), y = y.map(function(t) {
                    return t.filter(function(t) {
                        return $d4be73e5731103af$var$x.isNumber(t);
                    });
                }), r.globals.isXNumeric) {
                    var w = this.ttCtx.getElGrid().getBoundingClientRect(), k = g * (w.width / n), A = u * (w.height / l);
                    b = (v = this.closestInMultiArray(k, A, m, y)).index, p = v.j, null !== b && (m = r.globals.seriesXvalues[b], p = (v = this.closestInArray(k, m)).index);
                }
                return r.globals.capturedSeriesIndex = null === b ? -1 : b, (!p || p < 1) && (p = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = f : r.globals.capturedDataPointIndex = p, {
                    capturedSeries: b,
                    j: r.globals.isBarHorizontal ? f : p,
                    hoverX: g,
                    hoverY: u
                };
            }
        },
        {
            key: "closestInMultiArray",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = null, n = -1;
                s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : o = 0;
                var l = i[r][0], h = Math.abs(t - l);
                if (i.forEach(function(e) {
                    e.forEach(function(e, i) {
                        var a = Math.abs(t - e);
                        a < h && (h = a, n = i);
                    });
                }), -1 !== n) {
                    var c = a[r][n], d = Math.abs(e - c);
                    o = r, a.forEach(function(t, i) {
                        var a = Math.abs(e - t[n]);
                        a < d && (d = a, o = i);
                    });
                }
                return {
                    index: o,
                    j: n
                };
            }
        },
        {
            key: "getFirstActiveXArray",
            value: function(t) {
                for(var e = this.w, i = 0, a = t.map(function(t, e) {
                    return t.length > 0 ? e : -1;
                }), s = 0; s < a.length; s++)if (-1 !== a[s] && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) {
                    i = a[s];
                    break;
                }
                return i;
            }
        },
        {
            key: "closestInArray",
            value: function(t, e) {
                for(var i = e[0], a = null, s = Math.abs(t - i), r = 0; r < e.length; r++){
                    var o = Math.abs(t - e[r]);
                    o < s && (s = o, a = r);
                }
                return {
                    index: a
                };
            }
        },
        {
            key: "isXoverlap",
            value: function(t) {
                var e = [], i = this.w.globals.seriesX.filter(function(t) {
                    return void 0 !== t[0];
                });
                if (i.length > 0) for(var a = 0; a < i.length - 1; a++)void 0 !== i[a][t] && void 0 !== i[a + 1][t] && i[a][t] !== i[a + 1][t] && e.push("unEqual");
                return 0 === e.length;
            }
        },
        {
            key: "isInitialSeriesSameLen",
            value: function() {
                for(var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)if (e[i].data.length !== e[i + 1].data.length) {
                    t = !1;
                    break;
                }
                return t;
            }
        },
        {
            key: "getBarsHeight",
            value: function(t) {
                return $d4be73e5731103af$var$u(t).reduce(function(t, e) {
                    return t + e.getBBox().height;
                }, 0);
            }
        },
        {
            key: "getElMarkers",
            value: function(t) {
                return "number" == typeof t ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
            }
        },
        {
            key: "getAllMarkers",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                (t = $d4be73e5731103af$var$u(t)).sort(function(t, e) {
                    var i = Number(t.getAttribute("data:realIndex")), a = Number(e.getAttribute("data:realIndex"));
                    return a < i ? 1 : a > i ? -1 : 0;
                });
                var e = [];
                return t.forEach(function(t) {
                    e.push(t.querySelector(".apexcharts-marker"));
                }), e;
            }
        },
        {
            key: "hasMarkers",
            value: function(t) {
                return this.getElMarkers(t).length > 0;
            }
        },
        {
            key: "getElBars",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
            }
        },
        {
            key: "hasBars",
            value: function() {
                return this.getElBars().length > 0;
            }
        },
        {
            key: "getHoverMarkerSize",
            value: function(t) {
                var e = this.w, i = e.config.markers.hover.size;
                return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i;
            }
        },
        {
            key: "toggleAllTooltipSeriesGroups",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)"enable" === t ? (a[s].classList.add("apexcharts-active"), a[s].style.display = e.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$gt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new $d4be73e5731103af$var$dt(e);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawSeriesTexts",
            value: function(t) {
                var e = t.shared, i = void 0 === e || e, a = t.ttItems, s = t.i, r = void 0 === s ? 0 : s, o = t.j, n = void 0 === o ? null : o, l = t.y1, h = t.y2, c = t.e, d = this.w;
                void 0 !== d.config.tooltip.custom ? this.handleCustomTooltip({
                    i: r,
                    j: n,
                    y1: l,
                    y2: h,
                    w: d
                }) : this.toggleActiveInactiveSeries(i);
                var g = this.getValuesToPrint({
                    i: r,
                    j: n
                });
                this.printLabels({
                    i: r,
                    j: n,
                    values: g,
                    ttItems: a,
                    shared: i,
                    e: c
                });
                var u = this.ttCtx.getElTooltip();
                this.ttCtx.tooltipRect.ttWidth = u.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = u.getBoundingClientRect().height;
            }
        },
        {
            key: "printLabels",
            value: function(t) {
                var i, a = this, s = t.i, r = t.j, o = t.values, n = t.ttItems, l = t.shared, h = t.e, c = this.w, d = [], g = function(t) {
                    return c.globals.seriesGoals[t] && c.globals.seriesGoals[t][r] && Array.isArray(c.globals.seriesGoals[t][r]);
                }, u = o.xVal, p = o.zVal, f = o.xAxisTTVal, x = "", b = c.globals.colors[s];
                null !== r && c.config.plotOptions.bar.distributed && (b = c.globals.colors[r]);
                for(var v = function(t, o) {
                    var v = a.getFormatters(s);
                    x = a.getSeriesName({
                        fn: v.yLbTitleFormatter,
                        index: s,
                        seriesIndex: s,
                        j: r
                    }), "treemap" === c.config.chart.type && (x = v.yLbTitleFormatter(String(c.config.series[s].data[r].x), {
                        series: c.globals.series,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: c
                    }));
                    var m = c.config.tooltip.inverseOrder ? o : t;
                    if (c.globals.axisCharts) {
                        var y = function(t) {
                            var e, i, a, s;
                            return c.globals.isRangeData ? v.yLbFormatter(null === (e = c.globals.seriesRangeStart) || void 0 === e || null === (i = e[t]) || void 0 === i ? void 0 : i[r], {
                                series: c.globals.seriesRangeStart,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            }) + " - " + v.yLbFormatter(null === (a = c.globals.seriesRangeEnd) || void 0 === a || null === (s = a[t]) || void 0 === s ? void 0 : s[r], {
                                series: c.globals.seriesRangeEnd,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            }) : v.yLbFormatter(c.globals.series[t][r], {
                                series: c.globals.series,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            });
                        };
                        if (l) v = a.getFormatters(m), x = a.getSeriesName({
                            fn: v.yLbTitleFormatter,
                            index: m,
                            seriesIndex: s,
                            j: r
                        }), b = c.globals.colors[m], i = y(m), g(m) && (d = c.globals.seriesGoals[m][r].map(function(t) {
                            return {
                                attrs: t,
                                val: v.yLbFormatter(t.value, {
                                    seriesIndex: m,
                                    dataPointIndex: r,
                                    w: c
                                })
                            };
                        }));
                        else {
                            var w, k = null == h || null === (w = h.target) || void 0 === w ? void 0 : w.getAttribute("fill");
                            k && (b = -1 !== k.indexOf("url") ? document.querySelector(k.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke") : k), i = y(s), g(s) && Array.isArray(c.globals.seriesGoals[s][r]) && (d = c.globals.seriesGoals[s][r].map(function(t) {
                                return {
                                    attrs: t,
                                    val: v.yLbFormatter(t.value, {
                                        seriesIndex: s,
                                        dataPointIndex: r,
                                        w: c
                                    })
                                };
                            }));
                        }
                    }
                    null === r && (i = v.yLbFormatter(c.globals.series[s], $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, c), {}, {
                        seriesIndex: s,
                        dataPointIndex: s
                    }))), a.DOMHandling({
                        i: s,
                        t: m,
                        j: r,
                        ttItems: n,
                        values: {
                            val: i,
                            goalVals: d,
                            xVal: u,
                            xAxisTTVal: f,
                            zVal: p
                        },
                        seriesName: x,
                        shared: l,
                        pColor: b
                    });
                }, m = 0, y = c.globals.series.length - 1; m < c.globals.series.length; m++, y--)v(m, y);
            }
        },
        {
            key: "getFormatters",
            value: function(t) {
                var e, i = this.w, a = i.globals.yLabelFormatters[t];
                return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (a = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof a && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(t) {
                    return t;
                }), "function" != typeof e && (e = function(t) {
                    return t;
                }), {
                    yLbFormatter: a,
                    yLbTitleFormatter: e
                };
            }
        },
        {
            key: "getSeriesName",
            value: function(t) {
                var e = t.fn, i = t.index, a = t.seriesIndex, s = t.j, r = this.w;
                return e(String(r.globals.seriesNames[i]), {
                    series: r.globals.series,
                    seriesIndex: a,
                    dataPointIndex: s,
                    w: r
                });
            }
        },
        {
            key: "DOMHandling",
            value: function(t) {
                t.i;
                var e = t.t, i = t.j, a = t.ttItems, s = t.values, r = t.seriesName, o = t.shared, n = t.pColor, l = this.w, h = this.ttCtx, c = s.val, d = s.goalVals, g = s.xVal, u = s.xAxisTTVal, p = s.zVal, f = null;
                f = a[e].children, l.config.tooltip.fillSeriesColor && (a[e].style.backgroundColor = n, f[0].style.display = "none"), h.showTooltipTitle && (null === h.tooltipTitle && (h.tooltipTitle = l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), h.tooltipTitle.innerHTML = g), h.isXAxisTooltipEnabled && (h.xaxisTooltipText.innerHTML = "" !== u ? u : g);
                var x = a[e].querySelector(".apexcharts-tooltip-text-y-label");
                x && (x.innerHTML = r || "");
                var b = a[e].querySelector(".apexcharts-tooltip-text-y-value");
                b && (b.innerHTML = void 0 !== c ? c : ""), f[0] && f[0].classList.contains("apexcharts-tooltip-marker") && (l.config.tooltip.marker.fillColors && Array.isArray(l.config.tooltip.marker.fillColors) && (n = l.config.tooltip.marker.fillColors[e]), f[0].style.backgroundColor = n), l.config.tooltip.marker.show || (f[0].style.display = "none");
                var v = a[e].querySelector(".apexcharts-tooltip-text-goals-label"), m = a[e].querySelector(".apexcharts-tooltip-text-goals-value");
                if (d.length && l.globals.seriesGoals[e]) {
                    var y = function() {
                        var t = "<div >", e = "<div>";
                        d.forEach(function(i, a) {
                            t += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name, "</div>"), e += "<div>".concat(i.val, "</div>");
                        }), v.innerHTML = t + "</div>", m.innerHTML = e + "</div>";
                    };
                    o ? l.globals.seriesGoals[e][i] && Array.isArray(l.globals.seriesGoals[e][i]) ? y() : (v.innerHTML = "", m.innerHTML = "") : y();
                } else v.innerHTML = "", m.innerHTML = "";
                null !== p && (a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = l.config.tooltip.z.title, a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== p ? p : "");
                o && f[0] && (null == c || l.globals.ancillaryCollapsedSeriesIndices.indexOf(e) > -1 || l.globals.collapsedSeriesIndices.indexOf(e) > -1 ? f[0].parentNode.style.display = "none" : f[0].parentNode.style.display = l.config.tooltip.items.display);
            }
        },
        {
            key: "toggleActiveInactiveSeries",
            value: function(t) {
                var e = this.w;
                if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                else {
                    this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                    var i = e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                    i && (i.classList.add("apexcharts-active"), i.style.display = e.config.tooltip.items.display);
                }
            }
        },
        {
            key: "getValuesToPrint",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", o = "", n = null, l = null, h = {
                    series: a.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }, c = a.globals.ttZFormatter;
                null === i ? l = a.globals.series[e] : a.globals.isXNumeric && "treemap" !== a.config.chart.type ? (r = s[e][i], 0 === s[e].length && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = void 0 !== a.globals.labels[i] ? a.globals.labels[i] : "";
                var d = r;
                a.globals.isXNumeric && "datetime" === a.config.xaxis.type ? r = new $d4be73e5731103af$var$T(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, d, d, {
                    i: void 0,
                    dateFormatter: new $d4be73e5731103af$var$I(this.ctx).formatDate,
                    w: this.w
                }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](d, h) : a.globals.xLabelFormatter(d, h);
                return void 0 !== a.config.tooltip.x.formatter && (r = a.globals.ttKeyFormatter(d, h)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[e].length > 0 && (n = c(a.globals.seriesZ[e][i], a)), o = "function" == typeof a.config.xaxis.tooltip.formatter ? a.globals.xaxisTooltipFormatter(d, h) : r, {
                    val: Array.isArray(l) ? l.join(" ") : l,
                    xVal: Array.isArray(r) ? r.join(" ") : r,
                    xAxisTTVal: Array.isArray(o) ? o.join(" ") : o,
                    zVal: n
                };
            }
        },
        {
            key: "handleCustomTooltip",
            value: function(t) {
                var e = t.i, i = t.j, a = t.y1, s = t.y2, r = t.w, o = this.ttCtx.getElTooltip(), n = r.config.tooltip.custom;
                Array.isArray(n) && n[e] && (n = n[e]), o.innerHTML = n({
                    ctx: this.ctx,
                    series: r.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    y1: a,
                    y2: s,
                    w: r
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$ut = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "moveXCrosshairs",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = t - i.xcrosshairsWidth / 2, o = a.globals.labels.slice().length;
                if (null !== e && (r = a.globals.gridWidth / o * e), null === s || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                    var n = r;
                    "tickWidth" !== a.config.xaxis.crosshairs.width && "barWidth" !== a.config.xaxis.crosshairs.width || (n = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(n);
                }
            }
        },
        {
            key: "moveYCrosshairs",
            value: function(t) {
                var e = this.ttCtx;
                null !== e.ycrosshairs && $d4be73e5731103af$var$m.setAttrs(e.ycrosshairs, {
                    y1: t,
                    y2: t
                }), null !== e.ycrosshairsHidden && $d4be73e5731103af$var$m.setAttrs(e.ycrosshairsHidden, {
                    y1: t,
                    y2: t
                });
            }
        },
        {
            key: "moveXAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                if (null !== i.xaxisTooltip && 0 !== i.xcrosshairsWidth) {
                    i.xaxisTooltip.classList.add("apexcharts-active");
                    var a = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                    if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) {
                        t += e.globals.translateX;
                        var s;
                        s = new $d4be73e5731103af$var$m(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = a + "px";
                    }
                }
            }
        },
        {
            key: "moveYAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = e.globals.translateY + a, r = i.yaxisTTEls[t].getBoundingClientRect().height, o = e.globals.translateYAxisX[t] - 2;
                e.config.yaxis[t].opposite && (o -= 26), s -= r / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = s + "px", i.yaxisTTEls[t].style.left = o + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active");
            }
        },
        {
            key: "moveTooltip",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), o = s.tooltipRect, n = null !== i ? parseFloat(i) : 1, l = parseFloat(t) + n + 5, h = parseFloat(e) + n / 2;
                if (l > a.globals.gridWidth / 2 && (l = l - o.ttWidth - n - 10), l > a.globals.gridWidth - o.ttWidth - 10 && (l = a.globals.gridWidth - o.ttWidth), l < -20 && (l = -20), a.config.tooltip.followCursor) {
                    var c = s.getElGrid().getBoundingClientRect();
                    (l = s.e.clientX - c.left) > a.globals.gridWidth / 2 && (l -= s.tooltipRect.ttWidth), (h = s.e.clientY + a.globals.translateY - c.top) > a.globals.gridHeight / 2 && (h -= s.tooltipRect.ttHeight);
                } else a.globals.isBarHorizontal || o.ttHeight / 2 + h > a.globals.gridHeight && (h = a.globals.gridHeight - o.ttHeight + a.globals.translateY);
                isNaN(l) || (l += a.globals.translateX, r.style.left = l + "px", r.style.top = h + "px");
            }
        },
        {
            key: "moveMarkers",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx;
                if (i.globals.markers.size[t] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === e && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(e, s[r]));
                else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t);
            }
        },
        {
            key: "moveDynamicPointOnHover",
            value: function(t, e) {
                var i, a, s = this.w, r = this.ttCtx, o = s.globals.pointsArray, n = r.tooltipUtil.getHoverMarkerSize(e), l = s.config.series[e].type;
                if (!l || "column" !== l && "candlestick" !== l && "boxPlot" !== l) {
                    i = o[e][t][0], a = o[e][t][1] ? o[e][t][1] : 0;
                    var h = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers circle"));
                    h && a < s.globals.gridHeight && a > 0 && (h.setAttribute("r", n), h.setAttribute("cx", i), h.setAttribute("cy", a)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, a, n);
                }
            }
        },
        {
            key: "moveDynamicPointsOnHover",
            value: function(t) {
                var e, i = this.ttCtx, a = i.w, s = 0, r = 0, o = a.globals.pointsArray;
                e = new $d4be73e5731103af$var$N(this.ctx).getActiveConfigSeriesIndex("asc", [
                    "line",
                    "area",
                    "scatter",
                    "bubble"
                ]);
                var n = i.tooltipUtil.getHoverMarkerSize(e);
                o[e] && (s = o[e][t][0], r = o[e][t][1]);
                var l = i.tooltipUtil.getAllMarkers();
                if (null !== l) for(var h = 0; h < a.globals.series.length; h++){
                    var c = o[h];
                    if (a.globals.comboCharts && void 0 === c && l.splice(h, 0, null), c && c.length) {
                        var d = o[h][t][1], g = void 0;
                        if (l[h].setAttribute("cx", s), "rangeArea" === a.config.chart.type && !a.globals.comboCharts) {
                            var u = t + a.globals.series[h].length;
                            g = o[h][u][1], d -= Math.abs(d - g) / 2;
                        }
                        null !== d && !isNaN(d) && d < a.globals.gridHeight + n && d + n > 0 ? (l[h] && l[h].setAttribute("r", n), l[h] && l[h].setAttribute("cy", d)) : l[h] && l[h].setAttribute("r", 0);
                    }
                }
                this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, n);
            }
        },
        {
            key: "moveStickyTooltipOverBars",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length, r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                i.globals.isBarHorizontal && (r = new $d4be73e5731103af$var$N(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                var o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "']"));
                o || "number" != typeof e || (o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "']")));
                var n = o ? parseFloat(o.getAttribute("cx")) : 0, l = o ? parseFloat(o.getAttribute("cy")) : 0, h = o ? parseFloat(o.getAttribute("barWidth")) : 0, c = a.getElGrid().getBoundingClientRect(), d = o && (o.classList.contains("apexcharts-candlestick-area") || o.classList.contains("apexcharts-boxPlot-area"));
                i.globals.isXNumeric ? (o && !d && (n -= s % 2 != 0 ? h / 2 : 0), o && d && i.globals.comboCharts && (n -= h / 2)) : i.globals.isBarHorizontal || (n = a.xAxisTicksPositions[t - 1] + a.dataPointsDividedWidth / 2, isNaN(n) && (n = a.xAxisTicksPositions[t] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? l -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? l = a.e.clientY - c.top - a.tooltipRect.ttHeight / 2 : l + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (l = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(n), a.fixedTooltip || this.moveTooltip(n, l || i.globals.gridHeight);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$pt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new $d4be73e5731103af$var$ut(e);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawDynamicPoints",
            value: function() {
                var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx), i = new $d4be73e5731103af$var$H(this.ctx), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                a = $d4be73e5731103af$var$u(a), t.config.chart.stacked && a.sort(function(t, e) {
                    return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"));
                });
                for(var s = 0; s < a.length; s++){
                    var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                    if (null !== r) {
                        var o = void 0, n = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                        "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (n += " no-pointer-events");
                        var l = i.getMarkerConfig({
                            cssClass: n,
                            seriesIndex: Number(r.getAttribute("data:realIndex"))
                        });
                        (o = e.drawMarker(0, 0, l)).node.setAttribute("default-marker-size", 0);
                        var h = document.createElementNS(t.globals.SVGNS, "g");
                        h.classList.add("apexcharts-series-markers"), h.appendChild(o.node), r.appendChild(h);
                    }
                }
            }
        },
        {
            key: "enlargeCurrentPoint",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w;
                "bubble" !== s.config.chart.type && this.newPointSize(t, e);
                var r = e.getAttribute("cx"), o = e.getAttribute("cy");
                if (null !== i && null !== a && (r = i, o = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                    if ("radar" === s.config.chart.type) {
                        var n = this.ttCtx.getElGrid().getBoundingClientRect();
                        r = this.ttCtx.e.clientX - n.left;
                    }
                    this.tooltipPosition.moveTooltip(r, o, s.config.markers.hover.size);
                }
            }
        },
        {
            key: "enlargePoints",
            value: function(t) {
                for(var e = this.w, i = this, a = this.ttCtx, s = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), o = e.config.markers.hover.size, n = 0; n < r.length; n++){
                    var l = r[n].getAttribute("rel"), h = r[n].getAttribute("index");
                    if (void 0 === o && (o = e.globals.markers.size[h] + e.config.markers.hover.sizeOffset), s === parseInt(l, 10)) {
                        i.newPointSize(s, r[n]);
                        var c = r[n].getAttribute("cx"), d = r[n].getAttribute("cy");
                        i.tooltipPosition.moveXCrosshairs(c), a.fixedTooltip || i.tooltipPosition.moveTooltip(c, d, o);
                    } else i.oldPointSize(r[n]);
                }
            }
        },
        {
            key: "newPointSize",
            value: function(t, e) {
                var i = this.w, a = i.config.markers.hover.size, s = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                if ("0" !== s.getAttribute("default-marker-size")) {
                    var r = parseInt(s.getAttribute("index"), 10);
                    void 0 === a && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0), s.setAttribute("r", a);
                }
            }
        },
        {
            key: "oldPointSize",
            value: function(t) {
                var e = parseFloat(t.getAttribute("default-marker-size"));
                t.setAttribute("r", e);
            }
        },
        {
            key: "resetPointsSize",
            value: function() {
                for(var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++){
                    var i = parseFloat(t[e].getAttribute("default-marker-size"));
                    $d4be73e5731103af$var$x.isNumber(i) && i >= 0 ? t[e].setAttribute("r", i) : t[e].setAttribute("r", 0);
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$ft = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w;
        var i = this.w;
        this.ttCtx = e, this.isVerticalGroupedRangeBar = !i.globals.isBarHorizontal && "rangeBar" === i.config.chart.type && i.config.plotOptions.bar.rangeBarGroupRows;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getAttr",
            value: function(t, e) {
                return parseFloat(t.target.getAttribute(e));
            }
        },
        {
            key: "handleHeatTreeTooltip",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.x, s = t.y, r = t.type, o = this.ttCtx, n = this.w;
                if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                    var l = this.getAttr(e, "i"), h = this.getAttr(e, "j"), c = this.getAttr(e, "cx"), d = this.getAttr(e, "cy"), g = this.getAttr(e, "width"), u = this.getAttr(e, "height");
                    if (o.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: l,
                        j: h,
                        shared: !1,
                        e: e
                    }), n.globals.capturedSeriesIndex = l, n.globals.capturedDataPointIndex = h, a = c + o.tooltipRect.ttWidth / 2 + g, s = d + o.tooltipRect.ttHeight / 2 - u / 2, o.tooltipPosition.moveXCrosshairs(c + g / 2), a > n.globals.gridWidth / 2 && (a = c - o.tooltipRect.ttWidth / 2 + g), o.w.config.tooltip.followCursor) {
                        var p = n.globals.dom.elWrap.getBoundingClientRect();
                        a = n.globals.clientX - p.left - (a > n.globals.gridWidth / 2 ? o.tooltipRect.ttWidth : 0), s = n.globals.clientY - p.top - (s > n.globals.gridHeight / 2 ? o.tooltipRect.ttHeight : 0);
                    }
                }
                return {
                    x: a,
                    y: s
                };
            }
        },
        {
            key: "handleMarkerTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = t.x, o = t.y, n = this.w, l = this.ttCtx;
                if (a.target.classList.contains("apexcharts-marker")) {
                    var h = parseInt(s.paths.getAttribute("cx"), 10), c = parseInt(s.paths.getAttribute("cy"), 10), d = parseFloat(s.paths.getAttribute("val"));
                    if (i = parseInt(s.paths.getAttribute("rel"), 10), e = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, l.intersect) {
                        var g = $d4be73e5731103af$var$x.findAncestor(s.paths, "apexcharts-series");
                        g && (e = parseInt(g.getAttribute("data:realIndex"), 10));
                    }
                    if (l.tooltipLabels.drawSeriesTexts({
                        ttItems: s.ttItems,
                        i: e,
                        j: i,
                        shared: !l.showOnIntersect && n.config.tooltip.shared,
                        e: a
                    }), "mouseup" === a.type && l.markerClick(a, e, i), n.globals.capturedSeriesIndex = e, n.globals.capturedDataPointIndex = i, r = h, o = c + n.globals.translateY - 1.4 * l.tooltipRect.ttHeight, l.w.config.tooltip.followCursor) {
                        var u = l.getElGrid().getBoundingClientRect();
                        o = l.e.clientY + n.globals.translateY - u.top;
                    }
                    d < 0 && (o = c), l.marker.enlargeCurrentPoint(i, s.paths, r, o);
                }
                return {
                    x: r,
                    y: o
                };
            }
        },
        {
            key: "handleBarTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = this.ttCtx, n = o.getElTooltip(), l = 0, h = 0, c = 0, d = this.getBarTooltipXY({
                    e: a,
                    opt: s
                });
                e = d.i;
                var g = d.barHeight, u = d.j;
                r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = u, r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (h = d.x, c = d.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, l = h) : r.globals.comboCharts || r.config.tooltip.shared || (l /= 2), isNaN(c) && (c = r.globals.svgHeight - o.tooltipRect.ttHeight);
                var p = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), f = r.globals.isMultipleYAxis ? r.config.yaxis[p] && r.config.yaxis[p].reversed : r.config.yaxis[0].reversed;
                if (h + o.tooltipRect.ttWidth > r.globals.gridWidth && !f ? h -= o.tooltipRect.ttWidth : h < 0 && (h = 0), o.w.config.tooltip.followCursor) {
                    var x = o.getElGrid().getBoundingClientRect();
                    c = o.e.clientY - x.top;
                }
                null === o.tooltip && (o.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? o.tooltipPosition.moveXCrosshairs(l + i / 2) : o.tooltipPosition.moveXCrosshairs(l)), !o.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && o.tooltipUtil.hasBars()) && (f && (h -= o.tooltipRect.ttWidth) < 0 && (h = 0), !f || r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || (c = c + g - 2 * (r.globals.series[e][u] < 0 ? g : 0)), c = c + r.globals.translateY - o.tooltipRect.ttHeight / 2, n.style.left = h + r.globals.translateX + "px", n.style.top = c + "px");
            }
        },
        {
            key: "getBarTooltipXY",
            value: function(t) {
                var e = this, i = t.e, a = t.opt, s = this.w, r = null, o = this.ttCtx, n = 0, l = 0, h = 0, c = 0, d = 0, g = i.target.classList;
                if (g.contains("apexcharts-bar-area") || g.contains("apexcharts-candlestick-area") || g.contains("apexcharts-boxPlot-area") || g.contains("apexcharts-rangebar-area")) {
                    var u = i.target, p = u.getBoundingClientRect(), f = a.elGrid.getBoundingClientRect(), x = p.height;
                    d = p.height;
                    var b = p.width, v = parseInt(u.getAttribute("cx"), 10), m = parseInt(u.getAttribute("cy"), 10);
                    c = parseFloat(u.getAttribute("barWidth"));
                    var y = "touchmove" === i.type ? i.touches[0].clientX : i.clientX;
                    r = parseInt(u.getAttribute("j"), 10), n = parseInt(u.parentNode.getAttribute("rel"), 10) - 1;
                    var w = u.getAttribute("data-range-y1"), k = u.getAttribute("data-range-y2");
                    s.globals.comboCharts && (n = parseInt(u.parentNode.getAttribute("data:realIndex"), 10));
                    var A = function(t) {
                        return s.globals.isXNumeric ? v - b / 2 : e.isVerticalGroupedRangeBar ? v + b / 2 : v - o.dataPointsDividedWidth + b / 2;
                    }, S = function() {
                        return m - o.dataPointsDividedHeight + x / 2 - o.tooltipRect.ttHeight / 2;
                    };
                    o.tooltipLabels.drawSeriesTexts({
                        ttItems: a.ttItems,
                        i: n,
                        j: r,
                        y1: w ? parseInt(w, 10) : null,
                        y2: k ? parseInt(k, 10) : null,
                        shared: !o.showOnIntersect && s.config.tooltip.shared,
                        e: i
                    }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (l = y - f.left + 15, h = S()) : (l = A(), h = i.clientY - f.top - o.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((l = v) < o.xyRatios.baseLineInvertedY && (l = v - o.tooltipRect.ttWidth), h = S()) : (l = A(), h = m);
                }
                return {
                    x: l,
                    y: h,
                    barHeight: d,
                    barWidth: c,
                    i: n,
                    j: r
                };
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$xt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.ttCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawXaxisTooltip",
            value: function() {
                var t = this.w, e = this.ttCtx, i = "bottom" === t.config.xaxis.position;
                e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = t.globals.dom.elWrap;
                e.isXAxisTooltipEnabled && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + t.config.tooltip.theme), s.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText));
            }
        },
        {
            key: "drawYaxisTooltip",
            value: function() {
                for(var t = this.w, e = this.ttCtx, i = function(i) {
                    var a = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                    e.yaxisOffX = a ? t.globals.gridWidth + 1 : 1;
                    var s = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, a ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                    t.globals.yAxisSameScaleIndices.map(function(e, a) {
                        e.map(function(e, a) {
                            a === i && (s += t.config.yaxis[a].show ? " " : " apexcharts-yaxistooltip-hidden");
                        });
                    });
                    var r = t.globals.dom.elWrap;
                    null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", s + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]));
                }, a = 0; a < t.config.yaxis.length; a++)i(a);
            }
        },
        {
            key: "setXCrosshairWidth",
            value: function() {
                var t = this.w, e = this.ttCtx, i = e.getElXCrosshairs();
                if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                    var a = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== a && "barWidth" === t.config.xaxis.crosshairs.width) {
                        var s = parseFloat(a.getAttribute("barWidth"));
                        e.xcrosshairsWidth = s;
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var r = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / r;
                    }
                } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                    var o = t.globals.labels.length;
                    e.xcrosshairsWidth = t.globals.gridWidth / o;
                } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                    var n = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== n) {
                        var l = parseFloat(n.getAttribute("barWidth"));
                        e.xcrosshairsWidth = l;
                    } else e.xcrosshairsWidth = 1;
                }
                t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth);
            }
        },
        {
            key: "handleYCrosshair",
            value: function() {
                var t = this.w, e = this.ttCtx;
                e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
            }
        },
        {
            key: "drawYaxisTooltipText",
            value: function(t, e, i) {
                var a = this.ttCtx, s = this.w, r = s.globals.yLabelFormatters[t];
                if (a.yaxisTooltips[t]) {
                    var o = a.getElGrid().getBoundingClientRect(), n = (e - o.top) * i.yRatio[t], l = s.globals.maxYArr[t] - s.globals.minYArr[t], h = s.globals.minYArr[t] + (l - n);
                    a.tooltipPosition.moveYCrosshairs(e - o.top), a.yaxisTooltipText[t].innerHTML = r(h), a.tooltipPosition.moveYAxisTooltip(t);
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$bt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.tConfig = i.config.tooltip, this.tooltipUtil = new $d4be73e5731103af$var$dt(this), this.tooltipLabels = new $d4be73e5731103af$var$gt(this), this.tooltipPosition = new $d4be73e5731103af$var$ut(this), this.marker = new $d4be73e5731103af$var$pt(this), this.intersect = new $d4be73e5731103af$var$ft(this), this.axesTooltip = new $d4be73e5731103af$var$xt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !i.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "getElTooltip",
            value: function(t) {
                return t || (t = this), t.w.globals.dom.baseEl ? t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
            }
        },
        {
            key: "getElXCrosshairs",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
            }
        },
        {
            key: "getElGrid",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
            }
        },
        {
            key: "drawTooltip",
            value: function(t) {
                var e = this.w;
                this.xyRatios = t, this.isXAxisTooltipEnabled = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map(function(t, i) {
                    return !!(t.show && t.tooltip.enabled && e.globals.axisCharts);
                }), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                var i = document.createElement("div");
                if (i.classList.add("apexcharts-tooltip"), e.config.tooltip.cssClass && i.classList.add(e.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                    this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                    var a = new $d4be73e5731103af$var$V(this.ctx);
                    this.xAxisTicksPositions = a.getXAxisTicksPositions();
                }
                if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                    this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                    var s = e.globals.series.length;
                    (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                }
            }
        },
        {
            key: "createTTElements",
            value: function(t) {
                for(var e = this, i = this.w, a = [], s = this.getElTooltip(), r = function(r) {
                    var o = document.createElement("div");
                    o.classList.add("apexcharts-tooltip-series-group"), o.style.order = i.config.tooltip.inverseOrder ? t - r : r + 1, e.tConfig.shared && e.tConfig.enabledOnSeries && Array.isArray(e.tConfig.enabledOnSeries) && e.tConfig.enabledOnSeries.indexOf(r) < 0 && o.classList.add("apexcharts-tooltip-series-group-hidden");
                    var n = document.createElement("span");
                    n.classList.add("apexcharts-tooltip-marker"), n.style.backgroundColor = i.globals.colors[r], o.appendChild(n);
                    var l = document.createElement("div");
                    l.classList.add("apexcharts-tooltip-text"), l.style.fontFamily = e.tConfig.style.fontFamily || i.config.chart.fontFamily, l.style.fontSize = e.tConfig.style.fontSize, [
                        "y",
                        "goals",
                        "z"
                    ].forEach(function(t) {
                        var e = document.createElement("div");
                        e.classList.add("apexcharts-tooltip-".concat(t, "-group"));
                        var i = document.createElement("span");
                        i.classList.add("apexcharts-tooltip-text-".concat(t, "-label")), e.appendChild(i);
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-text-".concat(t, "-value")), e.appendChild(a), l.appendChild(e);
                    }), o.appendChild(l), s.appendChild(o), a.push(o);
                }, o = 0; o < t; o++)r(o);
                return a;
            }
        },
        {
            key: "addSVGEvents",
            value: function() {
                var t = this.w, e = t.config.chart.type, i = this.getElTooltip(), a = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e), s = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e, r = t.globals.dom.Paper.node, o = this.getElGrid();
                o && (this.seriesBound = o.getBoundingClientRect());
                var n, l = [], h = [], c = {
                    hoverArea: r,
                    elGrid: o,
                    tooltipEl: i,
                    tooltipY: l,
                    tooltipX: h,
                    ttItems: this.ttItems
                };
                if (t.globals.axisCharts && (s ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), n && n.length)) for(var d = 0; d < n.length; d++)l.push(n[d].getAttribute("cy")), h.push(n[d].getAttribute("cx"));
                if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                    r
                ], c);
                else if (a && !t.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(c);
                else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                    var g = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    this.addPathsEventListeners(g, c);
                }
                if (this.showOnIntersect) {
                    var u = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                    u.length > 0 && this.addPathsEventListeners(u, c), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(c);
                }
            }
        },
        {
            key: "drawFixedTooltipRect",
            value: function() {
                var t = this.w, e = this.getElTooltip(), i = e.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, o = this.tConfig.fixed.offsetY, n = this.tConfig.fixed.position.toLowerCase();
                return n.indexOf("right") > -1 && (r = r + t.globals.svgWidth - a + 10), n.indexOf("bottom") > -1 && (o = o + t.globals.svgHeight - s - 10), e.style.left = r + "px", e.style.top = o + "px", {
                    x: r,
                    y: o,
                    ttWidth: a,
                    ttHeight: s
                };
            }
        },
        {
            key: "addDatapointEventsListeners",
            value: function(t) {
                var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                this.addPathsEventListeners(e, t);
            }
        },
        {
            key: "addPathsEventListeners",
            value: function(t, e) {
                for(var i = this, a = function(a) {
                    var s = {
                        paths: t[a],
                        tooltipEl: e.tooltipEl,
                        tooltipY: e.tooltipY,
                        tooltipX: e.tooltipX,
                        elGrid: e.elGrid,
                        hoverArea: e.hoverArea,
                        ttItems: e.ttItems
                    };
                    [
                        "mousemove",
                        "mouseup",
                        "touchmove",
                        "mouseout",
                        "touchend"
                    ].map(function(e) {
                        return t[a].addEventListener(e, i.onSeriesHover.bind(i, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }, s = 0; s < t.length; s++)a(s);
            }
        },
        {
            key: "onSeriesHover",
            value: function(t, e) {
                var i = this, a = Date.now() - this.lastHoverTime;
                a >= 100 ? this.seriesHover(t, e) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                    i.seriesHover(t, e);
                }, 100 - a));
            }
        },
        {
            key: "seriesHover",
            value: function(t, e) {
                var i = this;
                this.lastHoverTime = Date.now();
                var a = [], s = this.w;
                s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || 0 === s.globals.dataPoints) || (a.length ? a.forEach(function(a) {
                    var s = i.getElTooltip(a), r = {
                        paths: t.paths,
                        tooltipEl: s,
                        tooltipY: t.tooltipY,
                        tooltipX: t.tooltipX,
                        elGrid: t.elGrid,
                        hoverArea: t.hoverArea,
                        ttItems: a.w.globals.tooltip.ttItems
                    };
                    a.w.globals.minX === i.w.globals.minX && a.w.globals.maxX === i.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({
                        chartCtx: a,
                        ttCtx: a.w.globals.tooltip,
                        opt: r,
                        e: e
                    });
                }) : this.seriesHoverByContext({
                    chartCtx: this.ctx,
                    ttCtx: this.w.globals.tooltip,
                    opt: t,
                    e: e
                }));
            }
        },
        {
            key: "seriesHoverByContext",
            value: function(t) {
                var e = t.chartCtx, i = t.ttCtx, a = t.opt, s = t.e, r = e.w, o = this.getElTooltip();
                if (o) {
                    if (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: o.getBoundingClientRect().width,
                        ttHeight: o.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared) {
                        if (this.tConfig.onDatasetHover.highlightDataSeries) new $d4be73e5731103af$var$N(e).toggleSeriesOnHover(s, s.target.parentNode);
                    }
                    i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    });
                }
            }
        },
        {
            key: "axisChartsTooltips",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = s.elGrid.getBoundingClientRect(), n = "touchmove" === a.type ? a.touches[0].clientX : a.clientX, l = "touchmove" === a.type ? a.touches[0].clientY : a.clientY;
                if (this.clientY = l, this.clientX = n, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, l < o.top || l > o.top + o.height) this.handleMouseOut(s);
                else {
                    if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                        var h = parseInt(s.paths.getAttribute("index"), 10);
                        if (this.tConfig.enabledOnSeries.indexOf(h) < 0) return void this.handleMouseOut(s);
                    }
                    var c = this.getElTooltip(), d = this.getElXCrosshairs(), g = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                    if ("mousemove" === a.type || "touchmove" === a.type || "mouseup" === a.type) {
                        if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                        null !== d && d.classList.add("apexcharts-active");
                        var u = this.yaxisTooltips.filter(function(t) {
                            return !0 === t;
                        });
                        if (null !== this.ycrosshairs && u.length && this.ycrosshairs.classList.add("apexcharts-active"), g && !this.showOnIntersect) this.handleStickyTooltip(a, n, l, s);
                        else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                            var p = this.intersect.handleHeatTreeTooltip({
                                e: a,
                                opt: s,
                                x: e,
                                y: i,
                                type: r.config.chart.type
                            });
                            e = p.x, i = p.y, c.style.left = e + "px", c.style.top = i + "px";
                        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                            e: a,
                            opt: s
                        }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                            e: a,
                            opt: s,
                            x: e,
                            y: i
                        });
                        if (this.yaxisTooltips.length) for(var f = 0; f < r.config.yaxis.length; f++)this.axesTooltip.drawYaxisTooltipText(f, l, this.xyRatios);
                        s.tooltipEl.classList.add("apexcharts-active");
                    } else "mouseout" !== a.type && "touchend" !== a.type || this.handleMouseOut(s);
                }
            }
        },
        {
            key: "nonAxisChartsTooltips",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), o = this.getElTooltip(), n = s.globals.dom.elWrap.getBoundingClientRect();
                if ("mousemove" === e.type || "touchmove" === e.type) {
                    o.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: parseInt(r, 10) - 1,
                        shared: !1
                    });
                    var l = s.globals.clientX - n.left - a.ttWidth / 2, h = s.globals.clientY - n.top - a.ttHeight - 10;
                    if (o.style.left = l + "px", o.style.top = h + "px", s.config.legend.tooltipHoverFormatter) {
                        var c = r - 1, d = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"), {
                            seriesIndex: c,
                            dataPointIndex: c,
                            w: s
                        });
                        this.legendLabels[c].innerHTML = d;
                    }
                } else "mouseout" !== e.type && "touchend" !== e.type || (o.classList.remove("apexcharts-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                }));
            }
        },
        {
            key: "handleStickyTooltip",
            value: function(t, e, i, a) {
                var s = this.w, r = this.tooltipUtil.getNearestValues({
                    context: this,
                    hoverArea: a.hoverArea,
                    elGrid: a.elGrid,
                    clientX: e,
                    clientY: i
                }), o = r.j, n = r.capturedSeries;
                s.globals.collapsedSeriesIndices.includes(n) && (n = null);
                var l = a.elGrid.getBoundingClientRect();
                if (r.hoverX < 0 || r.hoverX > l.width) this.handleMouseOut(a);
                else if (null !== n) this.handleStickyCapturedSeries(t, n, a, o);
                else if (this.tooltipUtil.isXoverlap(o) || s.globals.isBarHorizontal) {
                    var h = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, h, o, a.ttItems);
                }
            }
        },
        {
            key: "handleStickyCapturedSeries",
            value: function(t, e, i, a) {
                var s = this.w;
                if (!this.tConfig.shared && null === s.globals.series[e][a]) return void this.handleMouseOut(i);
                if (void 0 !== s.globals.series[e][a]) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, a, i.ttItems) : this.create(t, this, e, a, i.ttItems, !1);
                else if (this.tooltipUtil.isXoverlap(a)) {
                    var r = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, r, a, i.ttItems);
                }
            }
        },
        {
            key: "deactivateHoverFilter",
            value: function() {
                for(var t = this.w, e = new $d4be73e5731103af$var$m(this.ctx), i = t.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)e.pathMouseLeave(i[a]);
            }
        },
        {
            key: "handleMouseOut",
            value: function(t) {
                var e = this.w, i = this.getElXCrosshairs();
                if (t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                    null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                }
                e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                });
            }
        },
        {
            key: "markerClick",
            value: function(t, e, i) {
                var a = this.w;
                "function" == typeof a.config.chart.events.markerClick && a.config.chart.events.markerClick(t, this.ctx, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }), this.ctx.events.fireEvent("markerClick", [
                    t,
                    this.ctx,
                    {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: a
                    }
                ]);
            }
        },
        {
            key: "create",
            value: function(t, i, a, s, r) {
                var o, n, l, h, c, d, g, u, p, f, x, b, v, y, w, k, A = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, S = this.w, C = i;
                "mouseup" === t.type && this.markerClick(t, a, s), null === A && (A = this.tConfig.shared);
                var L = this.tooltipUtil.hasMarkers(a), P = this.tooltipUtil.getElBars();
                if (S.config.legend.tooltipHoverFormatter) {
                    var I = S.config.legend.tooltipHoverFormatter, T = Array.from(this.legendLabels);
                    T.forEach(function(t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e);
                    });
                    for(var M = 0; M < T.length; M++){
                        var X = T[M], z = parseInt(X.getAttribute("i"), 10), E = decodeURIComponent(X.getAttribute("data:default-text")), Y = I(E, {
                            seriesIndex: A ? z : a,
                            dataPointIndex: s,
                            w: S
                        });
                        if (A) X.innerHTML = S.globals.collapsedSeriesIndices.indexOf(z) < 0 ? Y : E;
                        else if (X.innerHTML = z === a ? Y : E, a === z) break;
                    }
                }
                var F = $d4be73e5731103af$var$e($d4be73e5731103af$var$e({
                    ttItems: r,
                    i: a,
                    j: s
                }, void 0 !== (null === (o = S.globals.seriesRange) || void 0 === o || null === (n = o[a]) || void 0 === n || null === (l = n[s]) || void 0 === l || null === (h = l.y[0]) || void 0 === h ? void 0 : h.y1) && {
                    y1: null === (c = S.globals.seriesRange) || void 0 === c || null === (d = c[a]) || void 0 === d || null === (g = d[s]) || void 0 === g || null === (u = g.y[0]) || void 0 === u ? void 0 : u.y1
                }), void 0 !== (null === (p = S.globals.seriesRange) || void 0 === p || null === (f = p[a]) || void 0 === f || null === (x = f[s]) || void 0 === x || null === (b = x.y[0]) || void 0 === b ? void 0 : b.y2) && {
                    y2: null === (v = S.globals.seriesRange) || void 0 === v || null === (y = v[a]) || void 0 === y || null === (w = y[s]) || void 0 === w || null === (k = w.y[0]) || void 0 === k ? void 0 : k.y2
                });
                if (A) {
                    if (C.tooltipLabels.drawSeriesTexts($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, F), {}, {
                        shared: !this.showOnIntersect && this.tConfig.shared
                    })), L) S.globals.markers.largestSize > 0 ? C.marker.enlargePoints(s) : C.tooltipPosition.moveDynamicPointsOnHover(s);
                    else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(P), this.barSeriesHeight > 0)) {
                        var R = new $d4be73e5731103af$var$m(this.ctx), H = S.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(s, "']"));
                        this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(s, a);
                        for(var D = 0; D < H.length; D++)R.pathMouseEnter(H[D]);
                    }
                } else C.tooltipLabels.drawSeriesTexts($d4be73e5731103af$var$e({
                    shared: !1
                }, F)), this.tooltipUtil.hasBars() && C.tooltipPosition.moveStickyTooltipOverBars(s, a), L && C.tooltipPosition.moveMarkers(a, s);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$vt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "handleBarDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.y1, s = t.y2, r = t.i, o = t.j, n = t.realIndex, l = t.groupIndex, h = t.series, c = t.barHeight, d = t.barWidth, g = t.barXPosition, u = t.barYPosition, p = t.visibleSeries, f = t.renderedPath, x = this.w, b = new $d4be73e5731103af$var$m(this.barCtx.ctx), v = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[n] : this.barCtx.strokeWidth, y = e + parseFloat(d * p), w = i + parseFloat(c * p);
                x.globals.isXNumeric && !x.globals.isBarHorizontal && (y = e + parseFloat(d * (p + 1)), w = i + parseFloat(c * (p + 1)) - v);
                var k, A = null, S = e, C = i, L = {}, P = x.config.dataLabels, I = this.barCtx.barOptions.dataLabels, T = this.barCtx.barOptions.dataLabels.total;
                void 0 !== u && this.barCtx.isRangeBar && (w = u, C = u), void 0 !== g && this.barCtx.isVerticalGroupedRangeBar && (y = g, S = g);
                var M = P.offsetX, X = P.offsetY, z = {
                    width: 0,
                    height: 0
                };
                if (x.config.dataLabels.enabled) {
                    var E = this.barCtx.series[r][o];
                    z = b.getTextRects(x.globals.yLabelFormatters[0](E), parseFloat(P.style.fontSize));
                }
                var Y = {
                    x: e,
                    y: i,
                    i: r,
                    j: o,
                    realIndex: n,
                    groupIndex: l || -1,
                    renderedPath: f,
                    bcx: y,
                    bcy: w,
                    barHeight: c,
                    barWidth: d,
                    textRects: z,
                    strokeWidth: v,
                    dataLabelsX: S,
                    dataLabelsY: C,
                    dataLabelsConfig: P,
                    barDataLabelsConfig: I,
                    barTotalDataLabelsConfig: T,
                    offX: M,
                    offY: X
                };
                return L = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(Y) : this.calculateColumnsDataLabelsPosition(Y), f.attr({
                    cy: L.bcy,
                    cx: L.bcx,
                    j: o,
                    val: h[r][o],
                    barHeight: c,
                    barWidth: d
                }), k = this.drawCalculatedDataLabels({
                    x: L.dataLabelsX,
                    y: L.dataLabelsY,
                    val: this.barCtx.isRangeBar ? [
                        a,
                        s
                    ] : h[r][o],
                    i: n,
                    j: o,
                    barWidth: d,
                    barHeight: c,
                    textRects: z,
                    dataLabelsConfig: P
                }), x.config.chart.stacked && T.enabled && (A = this.drawTotalDataLabels({
                    x: L.totalDataLabelsX,
                    y: L.totalDataLabelsY,
                    realIndex: n,
                    textAnchor: L.totalDataLabelsAnchor,
                    val: this.getStackedTotalDataLabel({
                        realIndex: n,
                        j: o
                    }),
                    dataLabelsConfig: P,
                    barTotalDataLabelsConfig: T
                })), {
                    dataLabels: k,
                    totalDataLabels: A
                };
            }
        },
        {
            key: "getStackedTotalDataLabel",
            value: function(t) {
                var i = t.realIndex, a = t.j, s = this.w, r = this.barCtx.stackedSeriesTotals[a];
                return this.totalFormatter && (r = this.totalFormatter(r, $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, s), {}, {
                    seriesIndex: i,
                    dataPointIndex: a,
                    w: s
                }))), r;
            }
        },
        {
            key: "calculateColumnsDataLabelsPosition",
            value: function(t) {
                var e, i, a = this.w, s = t.i, r = t.j, o = t.realIndex, n = t.groupIndex, l = t.y, h = t.bcx, c = t.barWidth, d = t.barHeight, g = t.textRects, u = t.dataLabelsX, p = t.dataLabelsY, f = t.dataLabelsConfig, x = t.barDataLabelsConfig, b = t.barTotalDataLabelsConfig, v = t.strokeWidth, y = t.offX, w = t.offY;
                d = Math.abs(d);
                var k = "vertical" === a.config.plotOptions.bar.dataLabels.orientation;
                h = h - v / 2 + (-1 !== n ? n * c : 0);
                var A = a.globals.gridWidth / a.globals.dataPoints;
                if (this.barCtx.isVerticalGroupedRangeBar ? u += c / 2 : u = a.globals.isXNumeric ? h - c / 2 + y : h - A + c / 2 + y, k) u = u + g.height / 2 - v / 2 - 2;
                var S = this.barCtx.series[s][r] < 0, C = l;
                switch(this.barCtx.isReversed && (C = l - d + (S ? 2 * d : 0), l -= d), x.position){
                    case "center":
                        p = k ? S ? C + d / 2 + w : C + d / 2 - w : S ? C - d / 2 + g.height / 2 + w : C + d / 2 + g.height / 2 - w;
                        break;
                    case "bottom":
                        p = k ? S ? C + d + w : C + d - w : S ? C - d + g.height + v + w : C + d - g.height / 2 + v - w;
                        break;
                    case "top":
                        p = k ? S ? C + w : C - w : S ? C - g.height / 2 - w : C + g.height + w;
                }
                if (this.barCtx.lastActiveBarSerieIndex === o && b.enabled) {
                    var L = new $d4be73e5731103af$var$m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: o,
                        j: r
                    }), f.fontSize);
                    e = S ? C - L.height / 2 - w - b.offsetY + 18 : C + L.height + w + b.offsetY - 18, i = u + b.offsetX;
                }
                return a.config.chart.stacked || (p < 0 ? p = 0 + v : p + g.height / 3 > a.globals.gridHeight && (p = a.globals.gridHeight - v)), {
                    bcx: h,
                    bcy: l,
                    dataLabelsX: u,
                    dataLabelsY: p,
                    totalDataLabelsX: i,
                    totalDataLabelsY: e,
                    totalDataLabelsAnchor: "middle"
                };
            }
        },
        {
            key: "calculateBarsDataLabelsPosition",
            value: function(t) {
                var e = this.w, i = t.x, a = t.i, s = t.j, r = t.realIndex, o = t.groupIndex, n = t.bcy, l = t.barHeight, h = t.barWidth, c = t.textRects, d = t.dataLabelsX, g = t.strokeWidth, u = t.dataLabelsConfig, p = t.barDataLabelsConfig, f = t.barTotalDataLabelsConfig, x = t.offX, b = t.offY, v = e.globals.gridHeight / e.globals.dataPoints;
                h = Math.abs(h);
                var y, w, k = (n += -1 !== o ? o * l : 0) - (this.barCtx.isRangeBar ? 0 : v) + l / 2 + c.height / 2 + b - 3, A = "start", S = this.barCtx.series[a][s] < 0, C = i;
                switch(this.barCtx.isReversed && (C = i + h - (S ? 2 * h : 0), i = e.globals.gridWidth - h), p.position){
                    case "center":
                        d = S ? C + h / 2 - x : Math.max(c.width / 2, C - h / 2) + x;
                        break;
                    case "bottom":
                        d = S ? C + h - g - Math.round(c.width / 2) - x : C - h + g + Math.round(c.width / 2) + x;
                        break;
                    case "top":
                        d = S ? C - g + Math.round(c.width / 2) - x : C - g - Math.round(c.width / 2) + x;
                }
                if (this.barCtx.lastActiveBarSerieIndex === r && f.enabled) {
                    var L = new $d4be73e5731103af$var$m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: r,
                        j: s
                    }), u.fontSize);
                    S ? (y = C - g + Math.round(L.width / 2) - x - f.offsetX - 15, A = "end") : y = C - g - Math.round(L.width / 2) + x + f.offsetX + 15, w = k + f.offsetY;
                }
                return e.config.chart.stacked || (d < 0 ? d = d + c.width + g : d + c.width / 2 > e.globals.gridWidth && (d = e.globals.gridWidth - c.width - g)), {
                    bcx: i,
                    bcy: n,
                    dataLabelsX: d,
                    dataLabelsY: k,
                    totalDataLabelsX: y,
                    totalDataLabelsY: w,
                    totalDataLabelsAnchor: A
                };
            }
        },
        {
            key: "drawCalculatedDataLabels",
            value: function(t) {
                var i = t.x, a = t.y, s = t.val, r = t.i, o = t.j, n = t.textRects, l = t.barHeight, h = t.barWidth, c = t.dataLabelsConfig, d = this.w, g = "rotate(0)";
                "vertical" === d.config.plotOptions.bar.dataLabels.orientation && (g = "rotate(-90, ".concat(i, ", ").concat(a, ")"));
                var u = new $d4be73e5731103af$var$O(this.barCtx.ctx), p = new $d4be73e5731103af$var$m(this.barCtx.ctx), f = c.formatter, x = null, b = d.globals.collapsedSeriesIndices.indexOf(r) > -1;
                if (c.enabled && !b) {
                    x = p.group({
                        class: "apexcharts-data-labels",
                        transform: g
                    });
                    var v = "";
                    void 0 !== s && (v = f(s, $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, d), {}, {
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: d
                    }))), !s && d.config.plotOptions.bar.hideZeroBarsWhenGrouped && (v = "");
                    var y = d.globals.series[r][o] < 0, w = d.config.plotOptions.bar.dataLabels.position;
                    if ("vertical" === d.config.plotOptions.bar.dataLabels.orientation && ("top" === w && (c.textAnchor = y ? "end" : "start"), "center" === w && (c.textAnchor = "middle"), "bottom" === w && (c.textAnchor = y ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels) h < p.getTextRects(v, parseFloat(c.style.fontSize)).width && (v = "");
                    d.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(h) && (v = "") : n.height / 1.6 > Math.abs(l) && (v = ""));
                    var k = $d4be73e5731103af$var$e({}, c);
                    this.barCtx.isHorizontal && s < 0 && ("start" === c.textAnchor ? k.textAnchor = "end" : "end" === c.textAnchor && (k.textAnchor = "start")), u.plotDataLabelsText({
                        x: i,
                        y: a,
                        text: v,
                        i: r,
                        j: o,
                        parent: x,
                        dataLabelsConfig: k,
                        alwaysDrawDataLabel: !0,
                        offsetCorrection: !0
                    });
                }
                return x;
            }
        },
        {
            key: "drawTotalDataLabels",
            value: function(t) {
                var e, i = t.x, a = t.y, s = t.val, r = t.realIndex, o = t.textAnchor, n = t.barTotalDataLabelsConfig, l = new $d4be73e5731103af$var$m(this.barCtx.ctx);
                return n.enabled && void 0 !== i && void 0 !== a && this.barCtx.lastActiveBarSerieIndex === r && (e = l.drawText({
                    x: i,
                    y: a,
                    foreColor: n.style.color,
                    text: s,
                    textAnchor: o,
                    fontFamily: n.style.fontFamily,
                    fontSize: n.style.fontSize,
                    fontWeight: n.style.fontWeight
                })), e;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$mt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.barCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "initVariables",
            value: function(t) {
                var e = this.w;
                this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                for(var i = 0; i < t.length; i++)if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric) for(var a = 0; a < t[i].length; a++)e.globals.seriesX[i][a] > e.globals.minX && e.globals.seriesX[i][a] < e.globals.maxX && this.barCtx.visibleItems++;
                else this.barCtx.visibleItems = e.globals.dataPoints;
                0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], e.globals.comboCharts || this.checkZeroSeries({
                    series: t
                });
            }
        },
        {
            key: "initialPositions",
            value: function() {
                var t, e, i, a, s, r, o, n, l = this.w, h = l.globals.dataPoints;
                this.barCtx.isRangeBar && (h = l.globals.labels.length);
                var c = this.barCtx.seriesLen;
                if (l.config.plotOptions.bar.rangeBarGroupRows && (c = 1), this.barCtx.isHorizontal) s = (i = l.globals.gridHeight / h) / c, l.globals.isXNumeric && (s = (i = l.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, -1 === String(this.barCtx.barOptions.barHeight).indexOf("%") && (s = parseInt(this.barCtx.barOptions.barHeight, 10)), n = this.barCtx.baseLineInvertedY + l.globals.padHorizontal + (this.barCtx.isReversed ? l.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (n = l.globals.gridWidth / 2), e = (i - s * this.barCtx.seriesLen) / 2;
                else {
                    if (a = l.globals.gridWidth / this.barCtx.visibleItems, l.config.xaxis.convertedCatToNumeric && (a = l.globals.gridWidth / l.globals.dataPoints), r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, l.globals.isXNumeric) {
                        var d = this.barCtx.xRatio;
                        l.config.xaxis.convertedCatToNumeric && (d = this.barCtx.initialXRatio), l.globals.minXDiff && .5 !== l.globals.minXDiff && l.globals.minXDiff / d > 0 && (a = l.globals.minXDiff / d), (r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                    }
                    -1 === String(this.barCtx.barOptions.columnWidth).indexOf("%") && (r = parseInt(this.barCtx.barOptions.columnWidth, 10)), o = l.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? l.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), t = l.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                }
                return {
                    x: t,
                    y: e,
                    yDivision: i,
                    xDivision: a,
                    barHeight: s,
                    barWidth: r,
                    zeroH: o,
                    zeroW: n
                };
            }
        },
        {
            key: "initializeStackedPrevVars",
            value: function(t) {
                var e = t.w;
                e.globals.hasSeriesGroups ? e.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].prevY = [], t[e].prevX = [], t[e].prevYF = [], t[e].prevXF = [], t[e].prevYVal = [], t[e].prevXVal = [];
                }) : (t.prevY = [], t.prevX = [], t.prevYF = [], t.prevXF = [], t.prevYVal = [], t.prevXVal = []);
            }
        },
        {
            key: "initializeStackedXYVars",
            value: function(t) {
                var e = t.w;
                e.globals.hasSeriesGroups ? e.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].xArrj = [], t[e].xArrjF = [], t[e].xArrjVal = [], t[e].yArrj = [], t[e].yArrjF = [], t[e].yArrjVal = [];
                }) : (t.xArrj = [], t.xArrjF = [], t.xArrjVal = [], t.yArrj = [], t.yArrjF = [], t.yArrjVal = []);
            }
        },
        {
            key: "getPathFillColor",
            value: function(t, e, i, a) {
                var s, r, o, n, l = this.w, h = new $d4be73e5731103af$var$R(this.barCtx.ctx), c = null, d = this.barCtx.barOptions.distributed ? i : e;
                this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(a) {
                    t[e][i] >= a.from && t[e][i] <= a.to && (c = a.color);
                });
                return l.config.series[e].data[i] && l.config.series[e].data[i].fillColor && (c = l.config.series[e].data[i].fillColor), h.fillPath({
                    seriesNumber: this.barCtx.barOptions.distributed ? d : a,
                    dataPointIndex: i,
                    color: c,
                    value: t[e][i],
                    fillConfig: null === (s = l.config.series[e].data[i]) || void 0 === s ? void 0 : s.fill,
                    fillType: null !== (r = l.config.series[e].data[i]) && void 0 !== r && null !== (o = r.fill) && void 0 !== o && o.type ? null === (n = l.config.series[e].data[i]) || void 0 === n ? void 0 : n.fill.type : l.config.fill.type
                });
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t, e, i) {
                var a = 0, s = this.w;
                return this.barCtx.series[t][e] ? this.barCtx.isNullValue = !1 : this.barCtx.isNullValue = !0, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
            }
        },
        {
            key: "shouldApplyRadius",
            value: function(t) {
                var e = this.w, i = !1;
                return e.config.plotOptions.bar.borderRadius > 0 && (e.config.chart.stacked && "last" === e.config.plotOptions.bar.borderRadiusWhenStacked ? this.barCtx.lastActiveBarSerieIndex === t && (i = !0) : i = !0), i;
            }
        },
        {
            key: "barBackground",
            value: function(t) {
                var e = t.j, i = t.i, a = t.x1, s = t.x2, r = t.y1, o = t.y2, n = t.elSeries, l = this.w, h = new $d4be73e5731103af$var$m(this.barCtx.ctx), c = new $d4be73e5731103af$var$N(this.barCtx.ctx).getActiveConfigSeriesIndex();
                if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && c === i) {
                    e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                    var d = this.barCtx.barOptions.colors.backgroundBarColors[e], g = h.drawRect(void 0 !== a ? a : 0, void 0 !== r ? r : 0, void 0 !== s ? s : l.globals.gridWidth, void 0 !== o ? o : l.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, d, this.barCtx.barOptions.colors.backgroundBarOpacity);
                    n.add(g), g.node.classList.add("apexcharts-backgroundBar");
                }
            }
        },
        {
            key: "getColumnPaths",
            value: function(t) {
                var e, i = t.barWidth, a = t.barXPosition, s = t.y1, r = t.y2, o = t.strokeWidth, n = t.seriesGroup, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new $d4be73e5731103af$var$m(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = i, p = a;
                null !== (e = d.config.series[l].data[c]) && void 0 !== e && e.columnWidthOffset && (p = a - d.config.series[l].data[c].columnWidthOffset / 2, u = i + d.config.series[l].data[c].columnWidthOffset);
                var f = p, x = p + u;
                s += .001, r += .001;
                var b = g.move(f, s), v = g.move(f, s), y = g.line(x - o, s);
                if (d.globals.previousPaths.length > 0 && (v = this.barCtx.getPreviousPath(l, c, !1)), b = b + g.line(f, r) + g.line(x - o, r) + g.line(x - o, s) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), v = v + g.line(f, s) + y + y + y + y + y + g.line(f, s) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), this.shouldApplyRadius(l) && (b = g.roundPathCorners(b, d.config.plotOptions.bar.borderRadius)), d.config.chart.stacked) {
                    var w = this.barCtx;
                    d.globals.hasSeriesGroups && n && (w = this.barCtx[n]), w.yArrj.push(r), w.yArrjF.push(Math.abs(s - r)), w.yArrjVal.push(this.barCtx.series[h][c]);
                }
                return {
                    pathTo: b,
                    pathFrom: v
                };
            }
        },
        {
            key: "getBarpaths",
            value: function(t) {
                var e, i = t.barYPosition, a = t.barHeight, s = t.x1, r = t.x2, o = t.strokeWidth, n = t.seriesGroup, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new $d4be73e5731103af$var$m(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = i, p = a;
                null !== (e = d.config.series[l].data[c]) && void 0 !== e && e.barHeightOffset && (u = i - d.config.series[l].data[c].barHeightOffset / 2, p = a + d.config.series[l].data[c].barHeightOffset);
                var f = u, x = u + p;
                s += .001, r += .001;
                var b = g.move(s, f), v = g.move(s, f);
                d.globals.previousPaths.length > 0 && (v = this.barCtx.getPreviousPath(l, c, !1));
                var y = g.line(s, x - o);
                if (b = b + g.line(r, f) + g.line(r, x - o) + y + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), v = v + g.line(s, f) + y + y + y + y + y + g.line(s, f) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), this.shouldApplyRadius(l) && (b = g.roundPathCorners(b, d.config.plotOptions.bar.borderRadius)), d.config.chart.stacked) {
                    var w = this.barCtx;
                    d.globals.hasSeriesGroups && n && (w = this.barCtx[n]), w.xArrj.push(r), w.xArrjF.push(Math.abs(s - r)), w.xArrjVal.push(this.barCtx.series[h][c]);
                }
                return {
                    pathTo: b,
                    pathFrom: v
                };
            }
        },
        {
            key: "checkZeroSeries",
            value: function(t) {
                for(var e = t.series, i = this.w, a = 0; a < e.length; a++){
                    for(var s = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++)s += e[a][r];
                    0 === s && this.barCtx.zeroSerieses.push(a);
                }
            }
        },
        {
            key: "getXForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e + t / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? t / this.barCtx.invertedYRatio : 0)), i;
            }
        },
        {
            key: "getYForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e - t / this.barCtx.yRatio[this.barCtx.yaxisIndex] + 2 * (this.barCtx.isReversed ? t / this.barCtx.yRatio[this.barCtx.yaxisIndex] : 0)), i;
            }
        },
        {
            key: "getGoalValues",
            value: function(t, i, a, s, r) {
                var n = this, l = this.w, h = [], c = function(e, s) {
                    var r;
                    h.push(($d4be73e5731103af$var$o(r = {}, t, "x" === t ? n.getXForValue(e, i, !1) : n.getYForValue(e, a, !1)), $d4be73e5731103af$var$o(r, "attrs", s), r));
                };
                if (l.globals.seriesGoals[s] && l.globals.seriesGoals[s][r] && Array.isArray(l.globals.seriesGoals[s][r]) && l.globals.seriesGoals[s][r].forEach(function(t) {
                    c(t.value, t);
                }), this.barCtx.barOptions.isDumbbell && l.globals.seriesRange.length) {
                    var d = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : l.globals.colors, g = {
                        strokeHeight: "x" === t ? 0 : l.globals.markers.size[s],
                        strokeWidth: "x" === t ? l.globals.markers.size[s] : 0,
                        strokeDashArray: 0,
                        strokeLineCap: "round",
                        strokeColor: Array.isArray(d[s]) ? d[s][0] : d[s]
                    };
                    c(l.globals.seriesRangeStart[s][r], g), c(l.globals.seriesRangeEnd[s][r], $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, g), {}, {
                        strokeColor: Array.isArray(d[s]) ? d[s][1] : d[s]
                    }));
                }
                return h;
            }
        },
        {
            key: "drawGoalLine",
            value: function(t) {
                var e = t.barXPosition, i = t.barYPosition, a = t.goalX, s = t.goalY, r = t.barWidth, o = t.barHeight, n = new $d4be73e5731103af$var$m(this.barCtx.ctx), l = n.group({
                    className: "apexcharts-bar-goals-groups"
                });
                l.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                    el: l.node
                }), l.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                var h = null;
                return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(t) {
                    var e = void 0 !== t.attrs.strokeHeight ? t.attrs.strokeHeight : o / 2, a = i + e + o / 2;
                    h = n.drawLine(t.x, a - 2 * e, t.x, a, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeWidth ? t.attrs.strokeWidth : 2, t.attrs.strokeLineCap), l.add(h);
                }) : Array.isArray(s) && s.forEach(function(t) {
                    var i = void 0 !== t.attrs.strokeWidth ? t.attrs.strokeWidth : r / 2, a = e + i + r / 2;
                    h = n.drawLine(a - 2 * i, t.y, a, t.y, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeHeight ? t.attrs.strokeHeight : 2, t.attrs.strokeLineCap), l.add(h);
                }), l;
            }
        },
        {
            key: "drawBarShadow",
            value: function(t) {
                var e = t.prevPaths, i = t.currPaths, a = t.color, s = this.w, r = e.x, o = e.x1, n = e.barYPosition, l = i.x, h = i.x1, c = i.barYPosition, d = n + i.barHeight, g = new $d4be73e5731103af$var$m(this.barCtx.ctx), u = new $d4be73e5731103af$var$x, p = g.move(o, d) + g.line(r, d) + g.line(l, c) + g.line(h, c) + g.line(o, d) + ("around" === s.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z");
                return g.drawPath({
                    d: p,
                    fill: u.shadeColor(.5, $d4be73e5731103af$var$x.rgb2hex(a)),
                    stroke: "none",
                    strokeWidth: 0,
                    fillOpacity: 1,
                    classes: "apexcharts-bar-shadows"
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$yt = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
        var s = this.w;
        this.barOptions = s.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = s.config.stroke.width, this.isNullValue = !1, this.isRangeBar = s.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !s.globals.isBarHorizontal && s.globals.seriesRange.length && s.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = i, null !== this.xyRatios && (this.xRatio = i.xRatio, this.initialXRatio = i.initialXRatio, this.yRatio = i.yRatio, this.invertedXRatio = i.invertedXRatio, this.invertedYRatio = i.invertedYRatio, this.baseLineY = i.baseLineY, this.baseLineInvertedY = i.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.pathArr = [];
        var r = new $d4be73e5731103af$var$N(this.ctx);
        this.lastActiveBarSerieIndex = r.getActiveConfigSeriesIndex("desc", [
            "bar",
            "column"
        ]);
        var o = r.getBarSeriesIndices(), n = new $d4be73e5731103af$var$y(this.ctx);
        this.stackedSeriesTotals = n.getStackedSeriesTotals(this.w.config.series.map(function(t, e) {
            return -1 === o.indexOf(e) ? e : -1;
        }).filter(function(t) {
            return -1 !== t;
        })), this.barHelpers = new $d4be73e5731103af$var$mt(this);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new $d4be73e5731103af$var$m(this.ctx), r = new $d4be73e5731103af$var$y(this.ctx, a);
                t = r.getLogSeries(t), this.series = t, this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                var o = s.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                });
                a.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering.");
                for(var n = 0, l = 0; n < t.length; n++, l++){
                    var h, c, d, g, u = void 0, p = void 0, f = [], b = [], v = a.globals.comboCharts ? i[n] : n, w = s.group({
                        class: "apexcharts-series",
                        rel: n + 1,
                        seriesName: $d4be73e5731103af$var$x.escapeString(a.globals.seriesNames[v]),
                        "data:realIndex": v
                    });
                    this.ctx.series.addCollapsedClassToSeries(w, v), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var k = 0, A = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = v), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed;
                    var S = this.barHelpers.initialPositions();
                    p = S.y, k = S.barHeight, c = S.yDivision, g = S.zeroW, u = S.x, A = S.barWidth, h = S.xDivision, d = S.zeroH, this.horizontal || b.push(u + A / 2);
                    var C = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    });
                    a.globals.delayedElements.push({
                        el: C.node
                    }), C.node.classList.add("apexcharts-element-hidden");
                    var L = s.group({
                        class: "apexcharts-bar-goals-markers"
                    }), P = s.group({
                        class: "apexcharts-bar-shadows"
                    });
                    a.globals.delayedElements.push({
                        el: P.node
                    }), P.node.classList.add("apexcharts-element-hidden");
                    for(var I = 0; I < a.globals.dataPoints; I++){
                        var T = this.barHelpers.getStrokeWidth(n, I, v), M = null, X = {
                            indexes: {
                                i: n,
                                j: I,
                                realIndex: v,
                                bc: l
                            },
                            x: u,
                            y: p,
                            strokeWidth: T,
                            elSeries: w
                        };
                        this.isHorizontal ? (M = this.drawBarPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, X), {}, {
                            barHeight: k,
                            zeroW: g,
                            yDivision: c
                        })), A = this.series[n][I] / this.invertedYRatio) : (M = this.drawColumnPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, X), {}, {
                            xDivision: h,
                            barWidth: A,
                            zeroH: d
                        })), k = this.series[n][I] / this.yRatio[this.yaxisIndex]);
                        var z = this.barHelpers.getPathFillColor(t, n, I, v);
                        if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && I > 0) {
                            var E = this.barHelpers.drawBarShadow({
                                color: "string" == typeof z && -1 === (null == z ? void 0 : z.indexOf("url")) ? z : $d4be73e5731103af$var$x.hexToRgba(a.globals.colors[n]),
                                prevPaths: this.pathArr[this.pathArr.length - 1],
                                currPaths: M
                            });
                            E && P.add(E);
                        }
                        this.pathArr.push(M);
                        var Y = this.barHelpers.drawGoalLine({
                            barXPosition: M.barXPosition,
                            barYPosition: M.barYPosition,
                            goalX: M.goalX,
                            goalY: M.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        Y && L.add(Y), p = M.y, u = M.x, I > 0 && b.push(u + A / 2), f.push(p), this.renderSeries({
                            realIndex: v,
                            pathFill: z,
                            j: I,
                            i: n,
                            pathFrom: M.pathFrom,
                            pathTo: M.pathTo,
                            strokeWidth: T,
                            elSeries: w,
                            x: u,
                            y: p,
                            series: t,
                            barHeight: M.barHeight ? M.barHeight : k,
                            barWidth: M.barWidth ? M.barWidth : A,
                            elDataLabelsWrap: C,
                            elGoalsMarkers: L,
                            elBarShadows: P,
                            visibleSeries: this.visibleI,
                            type: "bar"
                        });
                    }
                    a.globals.seriesXvalues[v] = b, a.globals.seriesYvalues[v] = f, o.add(w);
                }
                return o;
            }
        },
        {
            key: "renderSeries",
            value: function(t) {
                var e = t.realIndex, i = t.pathFill, a = t.lineFill, s = t.j, r = t.i, o = t.groupIndex, n = t.pathFrom, l = t.pathTo, h = t.strokeWidth, c = t.elSeries, d = t.x, g = t.y, u = t.y1, p = t.y2, f = t.series, x = t.barHeight, b = t.barWidth, y = t.barXPosition, w = t.barYPosition, k = t.elDataLabelsWrap, A = t.elGoalsMarkers, S = t.elBarShadows, C = t.visibleSeries, L = t.type, P = this.w, I = new $d4be73e5731103af$var$m(this.ctx);
                a || (a = this.barOptions.distributed ? P.globals.stroke.colors[s] : P.globals.stroke.colors[e]), P.config.series[r].data[s] && P.config.series[r].data[s].strokeColor && (a = P.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                var T = s / P.config.chart.animations.animateGradually.delay * (P.config.chart.animations.speed / P.globals.dataPoints) / 2.4, M = I.renderPaths({
                    i: r,
                    j: s,
                    realIndex: e,
                    pathFrom: n,
                    pathTo: l,
                    stroke: a,
                    strokeWidth: h,
                    strokeLineCap: P.config.stroke.lineCap,
                    fill: i,
                    animationDelay: T,
                    initialSpeed: P.config.chart.animations.speed,
                    dataChangeSpeed: P.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(L, "-area")
                });
                M.attr("clip-path", "url(#gridRectMask".concat(P.globals.cuid, ")"));
                var X = P.config.forecastDataPoints;
                X.count > 0 && s >= P.globals.dataPoints - X.count && (M.node.setAttribute("stroke-dasharray", X.dashArray), M.node.setAttribute("stroke-width", X.strokeWidth), M.node.setAttribute("fill-opacity", X.fillOpacity)), void 0 !== u && void 0 !== p && (M.attr("data-range-y1", u), M.attr("data-range-y2", p)), new $d4be73e5731103af$var$v(this.ctx).setSelectionFilter(M, e, s), c.add(M);
                var z = new $d4be73e5731103af$var$vt(this).handleBarDataLabels({
                    x: d,
                    y: g,
                    y1: u,
                    y2: p,
                    i: r,
                    j: s,
                    series: f,
                    realIndex: e,
                    groupIndex: o,
                    barHeight: x,
                    barWidth: b,
                    barXPosition: y,
                    barYPosition: w,
                    renderedPath: M,
                    visibleSeries: C
                });
                return null !== z.dataLabels && k.add(z.dataLabels), z.totalDataLabels && k.add(z.totalDataLabels), c.add(k), A && c.add(A), S && c.add(S), c;
            }
        },
        {
            key: "drawBarPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.yDivision, h = t.elSeries, c = this.w, d = i.i, g = i.j;
                if (c.globals.isXNumeric) e = (n = (c.globals.seriesX[d][g] - c.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var u = 0, p = 0;
                    c.globals.seriesPercent.forEach(function(t, e) {
                        t[g] && u++, e < d && 0 === t[g] && p++;
                    }), u > 0 && (a = this.seriesLen * a / u), e = n + a * this.visibleI, e -= a * p;
                } else e = n + a * this.visibleI;
                this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[d][g], r) - r) / 2), o = this.barHelpers.getXForValue(this.series[d][g], r);
                var f = this.barHelpers.getBarpaths({
                    barYPosition: e,
                    barHeight: a,
                    x1: r,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return c.globals.isXNumeric || (n += l), this.barHelpers.barBackground({
                    j: g,
                    i: d,
                    y1: e - a * this.visibleI,
                    y2: a * this.seriesLen,
                    elSeries: h
                }), {
                    pathTo: f.pathTo,
                    pathFrom: f.pathFrom,
                    x1: r,
                    x: o,
                    y: n,
                    goalX: this.barHelpers.getGoalValues("x", r, null, d, g),
                    barYPosition: e,
                    barHeight: a
                };
            }
        },
        {
            key: "drawColumnPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.x, s = t.y, r = t.xDivision, o = t.barWidth, n = t.zeroH, l = t.strokeWidth, h = t.elSeries, c = this.w, d = i.realIndex, g = i.i, u = i.j, p = i.bc;
                if (c.globals.isXNumeric) {
                    var f = d;
                    c.globals.seriesX[d].length || (f = c.globals.maxValsInArrayIndex), c.globals.seriesX[f][u] && (a = (c.globals.seriesX[f][u] - c.globals.minX) / this.xRatio - o * this.seriesLen / 2), e = a + o * this.visibleI;
                } else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var x = 0, b = 0;
                    c.globals.seriesPercent.forEach(function(t, e) {
                        t[u] && x++, e < g && 0 === t[u] && b++;
                    }), x > 0 && (o = this.seriesLen * o / x), e = a + o * this.visibleI, e -= o * b;
                } else e = a + o * this.visibleI;
                s = this.barHelpers.getYForValue(this.series[g][u], n);
                var v = this.barHelpers.getColumnPaths({
                    barXPosition: e,
                    barWidth: o,
                    y1: n,
                    y2: s,
                    strokeWidth: l,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: g,
                    j: u,
                    w: c
                });
                return c.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                    bc: p,
                    j: u,
                    i: g,
                    x1: e - l / 2 - o * this.visibleI,
                    x2: o * this.seriesLen + l / 2,
                    elSeries: h
                }), {
                    pathTo: v.pathTo,
                    pathFrom: v.pathFrom,
                    x: a,
                    y: s,
                    goalY: this.barHelpers.getGoalValues("y", null, n, g, u),
                    barXPosition: e,
                    barWidth: o
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t, e) {
                for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                    var r = a.globals.previousPaths[s];
                    r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== a.globals.previousPaths[s].paths[e] && (i = a.globals.previousPaths[s].paths[e].d);
                }
                return i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$wt = function(t) {
    $d4be73e5731103af$var$n(s, $d4be73e5731103af$var$yt);
    var i = $d4be73e5731103af$var$d(s);
    function s() {
        return $d4be73e5731103af$var$a(this, s), i.apply(this, arguments);
    }
    return $d4be73e5731103af$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this, s = this.w;
                this.graphics = new $d4be73e5731103af$var$m(this.ctx), this.bar = new $d4be73e5731103af$var$yt(this.ctx, this.xyRatios);
                var r = new $d4be73e5731103af$var$y(this.ctx, s);
                t = r.getLogSeries(t), this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === s.config.chart.stackType && (t = s.globals.seriesPercent.slice()), this.series = t, this.barHelpers.initializeStackedPrevVars(this);
                for(var o = this.graphics.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                }), n = 0, l = 0, h = function(r, h) {
                    var c = void 0, d = void 0, g = void 0, u = void 0, p = -1;
                    a.groupCtx = a, s.globals.seriesGroups.forEach(function(t, e) {
                        t.indexOf(s.config.series[r].name) > -1 && (p = e);
                    }), -1 !== p && (a.groupCtx = a[s.globals.seriesGroups[p]]);
                    var f = [], b = [], v = s.globals.comboCharts ? i[r] : r;
                    a.yRatio.length > 1 && (a.yaxisIndex = v), a.isReversed = s.config.yaxis[a.yaxisIndex] && s.config.yaxis[a.yaxisIndex].reversed;
                    var m = a.graphics.group({
                        class: "apexcharts-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(s.globals.seriesNames[v]),
                        rel: r + 1,
                        "data:realIndex": v
                    });
                    a.ctx.series.addCollapsedClassToSeries(m, v);
                    var y = a.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), w = a.graphics.group({
                        class: "apexcharts-bar-goals-markers"
                    }), k = 0, A = 0, S = a.initialPositions(n, l, c, d, g, u);
                    l = S.y, k = S.barHeight, d = S.yDivision, u = S.zeroW, n = S.x, A = S.barWidth, c = S.xDivision, g = S.zeroH, a.barHelpers.initializeStackedXYVars(a), 1 === a.groupCtx.prevY.length && a.groupCtx.prevY[0].every(function(t) {
                        return isNaN(t);
                    }) && (a.groupCtx.prevY[0] = a.groupCtx.prevY[0].map(function(t) {
                        return g;
                    }), a.groupCtx.prevYF[0] = a.groupCtx.prevYF[0].map(function(t) {
                        return 0;
                    }));
                    for(var C = 0; C < s.globals.dataPoints; C++){
                        var L = a.barHelpers.getStrokeWidth(r, C, v), P = {
                            indexes: {
                                i: r,
                                j: C,
                                realIndex: v,
                                bc: h
                            },
                            strokeWidth: L,
                            x: n,
                            y: l,
                            elSeries: m,
                            groupIndex: p,
                            seriesGroup: s.globals.seriesGroups[p]
                        }, I = null;
                        a.isHorizontal ? (I = a.drawStackedBarPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, P), {}, {
                            zeroW: u,
                            barHeight: k,
                            yDivision: d
                        })), A = a.series[r][C] / a.invertedYRatio) : (I = a.drawStackedColumnPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, P), {}, {
                            xDivision: c,
                            barWidth: A,
                            zeroH: g
                        })), k = a.series[r][C] / a.yRatio[a.yaxisIndex]);
                        var T = a.barHelpers.drawGoalLine({
                            barXPosition: I.barXPosition,
                            barYPosition: I.barYPosition,
                            goalX: I.goalX,
                            goalY: I.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        T && w.add(T), l = I.y, n = I.x, f.push(n), b.push(l);
                        var M = a.barHelpers.getPathFillColor(t, r, C, v);
                        m = a.renderSeries({
                            realIndex: v,
                            pathFill: M,
                            j: C,
                            i: r,
                            groupIndex: p,
                            pathFrom: I.pathFrom,
                            pathTo: I.pathTo,
                            strokeWidth: L,
                            elSeries: m,
                            x: n,
                            y: l,
                            series: t,
                            barHeight: k,
                            barWidth: A,
                            elDataLabelsWrap: y,
                            elGoalsMarkers: w,
                            type: "bar",
                            visibleSeries: 0
                        });
                    }
                    s.globals.seriesXvalues[v] = f, s.globals.seriesYvalues[v] = b, a.groupCtx.prevY.push(a.groupCtx.yArrj), a.groupCtx.prevYF.push(a.groupCtx.yArrjF), a.groupCtx.prevYVal.push(a.groupCtx.yArrjVal), a.groupCtx.prevX.push(a.groupCtx.xArrj), a.groupCtx.prevXF.push(a.groupCtx.xArrjF), a.groupCtx.prevXVal.push(a.groupCtx.xArrjVal), o.add(m);
                }, c = 0, d = 0; c < t.length; c++, d++)h(c, d);
                return o;
            }
        },
        {
            key: "initialPositions",
            value: function(t, e, i, a, s, r) {
                var o, n, l, h, c = this.w;
                return this.isHorizontal ? (l = (l = a = c.globals.gridHeight / c.globals.dataPoints) * parseInt(c.config.plotOptions.bar.barHeight, 10) / 100, -1 === String(c.config.plotOptions.bar.barHeight).indexOf("%") && (l = parseInt(c.config.plotOptions.bar.barHeight, 10)), r = this.baseLineInvertedY + c.globals.padHorizontal + (this.isReversed ? c.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), e = (a - l) / 2) : (h = i = c.globals.gridWidth / c.globals.dataPoints, h = c.globals.isXNumeric && c.globals.dataPoints > 1 ? (i = c.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : h * parseInt(c.config.plotOptions.bar.columnWidth, 10) / 100, -1 === String(c.config.plotOptions.bar.columnWidth).indexOf("%") && (h = parseInt(c.config.plotOptions.bar.columnWidth, 10)), s = c.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? c.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), t = c.globals.padHorizontal + (i - h) / 2), {
                    x: t,
                    y: e,
                    yDivision: a,
                    xDivision: i,
                    barHeight: null !== (o = c.globals.seriesGroups) && void 0 !== o && o.length ? l / c.globals.seriesGroups.length : l,
                    barWidth: null !== (n = c.globals.seriesGroups) && void 0 !== n && n.length ? h / c.globals.seriesGroups.length : h,
                    zeroH: s,
                    zeroW: r
                };
            }
        },
        {
            key: "drawStackedBarPaths",
            value: function(t) {
                for(var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.groupIndex, h = t.seriesGroup, c = t.yDivision, d = t.elSeries, g = this.w, u = n + (-1 !== l ? l * a : 0), p = i.i, f = i.j, x = 0, b = 0; b < this.groupCtx.prevXF.length; b++)x += this.groupCtx.prevXF[b][f];
                var v = p;
                if (h && (v = h.indexOf(g.config.series[p].name)), v > 0) {
                    var m = r;
                    this.groupCtx.prevXVal[v - 1][f] < 0 ? m = this.series[p][f] >= 0 ? this.groupCtx.prevX[v - 1][f] + x - 2 * (this.isReversed ? x : 0) : this.groupCtx.prevX[v - 1][f] : this.groupCtx.prevXVal[v - 1][f] >= 0 && (m = this.series[p][f] >= 0 ? this.groupCtx.prevX[v - 1][f] : this.groupCtx.prevX[v - 1][f] - x + 2 * (this.isReversed ? x : 0)), e = m;
                } else e = r;
                o = null === this.series[p][f] ? e : e + this.series[p][f] / this.invertedYRatio - 2 * (this.isReversed ? this.series[p][f] / this.invertedYRatio : 0);
                var y = this.barHelpers.getBarpaths({
                    barYPosition: u,
                    barHeight: a,
                    x1: e,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    seriesGroup: h,
                    i: p,
                    j: f,
                    w: g
                });
                return this.barHelpers.barBackground({
                    j: f,
                    i: p,
                    y1: u,
                    y2: a,
                    elSeries: d
                }), n += c, {
                    pathTo: y.pathTo,
                    pathFrom: y.pathFrom,
                    goalX: this.barHelpers.getGoalValues("x", r, null, p, f),
                    barYPosition: u,
                    x: o,
                    y: n
                };
            }
        },
        {
            key: "drawStackedColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, o = t.zeroH, n = t.groupIndex, l = t.seriesGroup, h = t.elSeries, c = this.w, d = e.i, g = e.j, u = e.bc;
                if (c.globals.isXNumeric) {
                    var p = c.globals.seriesX[d][g];
                    p || (p = 0), i = (p - c.globals.minX) / this.xRatio - r / 2, c.globals.seriesGroups.length && (i = (p - c.globals.minX) / this.xRatio - r / 2 * c.globals.seriesGroups.length);
                }
                for(var f, x = i + (-1 !== n ? n * r : 0), b = 0, v = 0; v < this.groupCtx.prevYF.length; v++)b += isNaN(this.groupCtx.prevYF[v][g]) ? 0 : this.groupCtx.prevYF[v][g];
                var m = d;
                if (l && (m = l.indexOf(c.config.series[d].name)), m > 0 && !c.globals.isXNumeric || m > 0 && c.globals.isXNumeric && c.globals.seriesX[d - 1][g] === c.globals.seriesX[d][g]) {
                    var y, w, k, A = Math.min(this.yRatio.length + 1, d + 1);
                    if (void 0 !== this.groupCtx.prevY[m - 1] && this.groupCtx.prevY[m - 1].length) for(var S = 1; S < A; S++){
                        var C;
                        if (!isNaN(null === (C = this.groupCtx.prevY[m - S]) || void 0 === C ? void 0 : C[g])) {
                            k = this.groupCtx.prevY[m - S][g];
                            break;
                        }
                    }
                    for(var L = 1; L < A; L++){
                        var P, I;
                        if ((null === (P = this.groupCtx.prevYVal[m - L]) || void 0 === P ? void 0 : P[g]) < 0) {
                            w = this.series[d][g] >= 0 ? k - b + 2 * (this.isReversed ? b : 0) : k;
                            break;
                        }
                        if ((null === (I = this.groupCtx.prevYVal[m - L]) || void 0 === I ? void 0 : I[g]) >= 0) {
                            w = this.series[d][g] >= 0 ? k : k + b - 2 * (this.isReversed ? b : 0);
                            break;
                        }
                    }
                    void 0 === w && (w = c.globals.gridHeight), f = null !== (y = this.groupCtx.prevYF[0]) && void 0 !== y && y.every(function(t) {
                        return 0 === t;
                    }) && this.groupCtx.prevYF.slice(1, m).every(function(t) {
                        return t.every(function(t) {
                            return isNaN(t);
                        });
                    }) ? o : w;
                } else f = o;
                a = this.series[d][g] ? f - this.series[d][g] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[d][g] / this.yRatio[this.yaxisIndex] : 0) : f;
                var T = this.barHelpers.getColumnPaths({
                    barXPosition: x,
                    barWidth: r,
                    y1: f,
                    y2: a,
                    yRatio: this.yRatio[this.yaxisIndex],
                    strokeWidth: this.strokeWidth,
                    series: this.series,
                    seriesGroup: l,
                    realIndex: e.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return this.barHelpers.barBackground({
                    bc: u,
                    j: g,
                    i: d,
                    x1: x,
                    x2: r,
                    elSeries: h
                }), i += s, {
                    pathTo: T.pathTo,
                    pathFrom: T.pathFrom,
                    goalY: this.barHelpers.getGoalValues("y", null, o, d, g),
                    barXPosition: x,
                    x: c.globals.isXNumeric ? i - s : i,
                    y: a
                };
            }
        }
    ]), s;
}(), $d4be73e5731103af$var$kt = function(t) {
    $d4be73e5731103af$var$n(s, $d4be73e5731103af$var$yt);
    var i = $d4be73e5731103af$var$d(s);
    function s() {
        return $d4be73e5731103af$var$a(this, s), i.apply(this, arguments);
    }
    return $d4be73e5731103af$var$r(s, [
        {
            key: "draw",
            value: function(t, i, a) {
                var s = this, r = this.w, o = new $d4be73e5731103af$var$m(this.ctx), n = r.globals.comboCharts ? i : r.config.chart.type, l = new $d4be73e5731103af$var$R(this.ctx);
                this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = r.config.plotOptions.bar.horizontal;
                var h = new $d4be73e5731103af$var$y(this.ctx, r);
                t = h.getLogSeries(t), this.series = t, this.yRatio = h.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                for(var c = o.group({
                    class: "apexcharts-".concat(n, "-series apexcharts-plot-series")
                }), d = function(i) {
                    s.isBoxPlot = "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[i].type;
                    var n, h, d, g, u = void 0, p = void 0, f = [], b = [], v = r.globals.comboCharts ? a[i] : i, m = o.group({
                        class: "apexcharts-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(r.globals.seriesNames[v]),
                        rel: i + 1,
                        "data:realIndex": v
                    });
                    s.ctx.series.addCollapsedClassToSeries(m, v), t[i].length > 0 && (s.visibleI = s.visibleI + 1);
                    var y, w;
                    s.yRatio.length > 1 && (s.yaxisIndex = v);
                    var k = s.barHelpers.initialPositions();
                    p = k.y, y = k.barHeight, h = k.yDivision, g = k.zeroW, u = k.x, w = k.barWidth, n = k.xDivision, d = k.zeroH, b.push(u + w / 2);
                    for(var A = o.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), S = function(a) {
                        var o = s.barHelpers.getStrokeWidth(i, a, v), c = null, x = {
                            indexes: {
                                i: i,
                                j: a,
                                realIndex: v
                            },
                            x: u,
                            y: p,
                            strokeWidth: o,
                            elSeries: m
                        };
                        c = s.isHorizontal ? s.drawHorizontalBoxPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, x), {}, {
                            yDivision: h,
                            barHeight: y,
                            zeroW: g
                        })) : s.drawVerticalBoxPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, x), {}, {
                            xDivision: n,
                            barWidth: w,
                            zeroH: d
                        })), p = c.y, u = c.x, a > 0 && b.push(u + w / 2), f.push(p), c.pathTo.forEach(function(e, n) {
                            var h = !s.isBoxPlot && s.candlestickOptions.wick.useFillColor ? c.color[n] : r.globals.stroke.colors[i], d = l.fillPath({
                                seriesNumber: v,
                                dataPointIndex: a,
                                color: c.color[n],
                                value: t[i][a]
                            });
                            s.renderSeries({
                                realIndex: v,
                                pathFill: d,
                                lineFill: h,
                                j: a,
                                i: i,
                                pathFrom: c.pathFrom,
                                pathTo: e,
                                strokeWidth: o,
                                elSeries: m,
                                x: u,
                                y: p,
                                series: t,
                                barHeight: y,
                                barWidth: w,
                                elDataLabelsWrap: A,
                                visibleSeries: s.visibleI,
                                type: r.config.chart.type
                            });
                        });
                    }, C = 0; C < r.globals.dataPoints; C++)S(C);
                    r.globals.seriesXvalues[v] = b, r.globals.seriesYvalues[v] = f, c.add(m);
                }, g = 0; g < t.length; g++)d(g);
                return c;
            }
        },
        {
            key: "drawVerticalBoxPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.y;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, o = t.strokeWidth, n = this.w, l = new $d4be73e5731103af$var$m(this.ctx), h = e.i, c = e.j, d = !0, g = n.config.plotOptions.candlestick.colors.upward, u = n.config.plotOptions.candlestick.colors.downward, p = "";
                this.isBoxPlot && (p = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var f = this.yRatio[this.yaxisIndex], x = e.realIndex, b = this.getOHLCValue(x, c), v = r, y = r;
                b.o > b.c && (d = !1);
                var w = Math.min(b.o, b.c), k = Math.max(b.o, b.c), A = b.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[x][c] - n.globals.minX) / this.xRatio - s / 2);
                var S = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (w = r, k = r) : (w = r - w / f, k = r - k / f, v = r - b.h / f, y = r - b.l / f, A = r - b.m / f);
                var C = l.move(S, r), L = l.move(S + s / 2, w);
                return n.globals.previousPaths.length > 0 && (L = this.getPreviousPath(x, c, !0)), C = this.isBoxPlot ? [
                    l.move(S, w) + l.line(S + s / 2, w) + l.line(S + s / 2, v) + l.line(S + s / 4, v) + l.line(S + s - s / 4, v) + l.line(S + s / 2, v) + l.line(S + s / 2, w) + l.line(S + s, w) + l.line(S + s, A) + l.line(S, A) + l.line(S, w + o / 2),
                    l.move(S, A) + l.line(S + s, A) + l.line(S + s, k) + l.line(S + s / 2, k) + l.line(S + s / 2, y) + l.line(S + s - s / 4, y) + l.line(S + s / 4, y) + l.line(S + s / 2, y) + l.line(S + s / 2, k) + l.line(S, k) + l.line(S, A) + "z"
                ] : [
                    l.move(S, k) + l.line(S + s / 2, k) + l.line(S + s / 2, v) + l.line(S + s / 2, k) + l.line(S + s, k) + l.line(S + s, w) + l.line(S + s / 2, w) + l.line(S + s / 2, y) + l.line(S + s / 2, w) + l.line(S, w) + l.line(S, k - o / 2)
                ], L += l.move(S, w), n.globals.isXNumeric || (i += a), {
                    pathTo: C,
                    pathFrom: L,
                    x: i,
                    y: k,
                    barXPosition: S,
                    color: this.isBoxPlot ? p : d ? [
                        g
                    ] : [
                        u
                    ]
                };
            }
        },
        {
            key: "drawHorizontalBoxPaths",
            value: function(t) {
                var e = t.indexes;
                t.x;
                var i = t.y, a = t.yDivision, s = t.barHeight, r = t.zeroW, o = t.strokeWidth, n = this.w, l = new $d4be73e5731103af$var$m(this.ctx), h = e.i, c = e.j, d = this.boxOptions.colors.lower;
                this.isBoxPlot && (d = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var g = this.invertedYRatio, u = e.realIndex, p = this.getOHLCValue(u, c), f = r, x = r, b = Math.min(p.o, p.c), v = Math.max(p.o, p.c), y = p.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[u][c] - n.globals.minX) / this.invertedXRatio - s / 2);
                var w = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (b = r, v = r) : (b = r + b / g, v = r + v / g, f = r + p.h / g, x = r + p.l / g, y = r + p.m / g);
                var k = l.move(r, w), A = l.move(b, w + s / 2);
                return n.globals.previousPaths.length > 0 && (A = this.getPreviousPath(u, c, !0)), k = [
                    l.move(b, w) + l.line(b, w + s / 2) + l.line(f, w + s / 2) + l.line(f, w + s / 2 - s / 4) + l.line(f, w + s / 2 + s / 4) + l.line(f, w + s / 2) + l.line(b, w + s / 2) + l.line(b, w + s) + l.line(y, w + s) + l.line(y, w) + l.line(b + o / 2, w),
                    l.move(y, w) + l.line(y, w + s) + l.line(v, w + s) + l.line(v, w + s / 2) + l.line(x, w + s / 2) + l.line(x, w + s - s / 4) + l.line(x, w + s / 4) + l.line(x, w + s / 2) + l.line(v, w + s / 2) + l.line(v, w) + l.line(y, w) + "z"
                ], A += l.move(b, w), n.globals.isXNumeric || (i += a), {
                    pathTo: k,
                    pathFrom: A,
                    x: v,
                    y: i,
                    barYPosition: w,
                    color: d
                };
            }
        },
        {
            key: "getOHLCValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    o: this.isBoxPlot ? i.globals.seriesCandleH[t][e] : i.globals.seriesCandleO[t][e],
                    h: this.isBoxPlot ? i.globals.seriesCandleO[t][e] : i.globals.seriesCandleH[t][e],
                    m: i.globals.seriesCandleM[t][e],
                    l: this.isBoxPlot ? i.globals.seriesCandleC[t][e] : i.globals.seriesCandleL[t][e],
                    c: this.isBoxPlot ? i.globals.seriesCandleL[t][e] : i.globals.seriesCandleC[t][e]
                };
            }
        }
    ]), s;
}(), $d4be73e5731103af$var$At = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "checkColorRange",
            value: function() {
                var t = this.w, e = !1, i = t.config.plotOptions[t.config.chart.type];
                return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(t, i) {
                    t.from <= 0 && (e = !0);
                }), e;
            }
        },
        {
            key: "getShadeColor",
            value: function(t, e, i, a) {
                var s = this.w, r = 1, o = s.config.plotOptions[t].shadeIntensity, n = this.determineColor(t, e, i);
                s.globals.hasNegs || a ? r = s.config.plotOptions[t].reverseNegativeShade ? n.percent < 0 ? n.percent / 100 * (1.25 * o) : (1 - n.percent / 100) * (1.25 * o) : n.percent <= 0 ? 1 - (1 + n.percent / 100) * o : (1 - n.percent / 100) * o : (r = 1 - n.percent / 100, "treemap" === t && (r = (1 - n.percent / 100) * (1.25 * o)));
                var l = n.color, h = new $d4be73e5731103af$var$x;
                return s.config.plotOptions[t].enableShades && (l = "dark" === this.w.config.theme.mode ? $d4be73e5731103af$var$x.hexToRgba(h.shadeColor(-1 * r, n.color), s.config.fill.opacity) : $d4be73e5731103af$var$x.hexToRgba(h.shadeColor(r, n.color), s.config.fill.opacity)), {
                    color: l,
                    colorProps: n
                };
            }
        },
        {
            key: "determineColor",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.series[e][i], r = a.config.plotOptions[t], o = r.colorScale.inverse ? i : e;
                r.distributed && "treemap" === a.config.chart.type && (o = i);
                var n = a.globals.colors[o], l = null, h = Math.min.apply(Math, $d4be73e5731103af$var$u(a.globals.series[e])), c = Math.max.apply(Math, $d4be73e5731103af$var$u(a.globals.series[e]));
                r.distributed || "heatmap" !== t || (h = a.globals.minY, c = a.globals.maxY), void 0 !== r.colorScale.min && (h = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, c = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                var d = Math.abs(c) + Math.abs(h), g = 100 * s / (0 === d ? d - 1e-6 : d);
                r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(t, e) {
                    if (s >= t.from && s <= t.to) {
                        n = t.color, l = t.foreColor ? t.foreColor : null, h = t.from, c = t.to;
                        var i = Math.abs(c) + Math.abs(h);
                        g = 100 * s / (0 === i ? i - 1e-6 : i);
                    }
                });
                return {
                    color: n,
                    foreColor: l,
                    percent: g
                };
            }
        },
        {
            key: "calculateDataLabels",
            value: function(t) {
                var e = t.text, i = t.x, a = t.y, s = t.i, r = t.j, o = t.colorProps, n = t.fontSize, l = this.w.config.dataLabels, h = new $d4be73e5731103af$var$m(this.ctx), c = new $d4be73e5731103af$var$O(this.ctx), d = null;
                if (l.enabled) {
                    d = h.group({
                        class: "apexcharts-data-labels"
                    });
                    var g = l.offsetX, u = l.offsetY, p = i + g, f = a + parseFloat(l.style.fontSize) / 3 + u;
                    c.plotDataLabelsText({
                        x: p,
                        y: f,
                        text: e,
                        i: s,
                        j: r,
                        color: o.foreColor,
                        parent: d,
                        fontSize: n,
                        dataLabelsConfig: l
                    });
                }
                return d;
            }
        },
        {
            key: "addListeners",
            value: function(t) {
                var e = new $d4be73e5731103af$var$m(this.ctx);
                t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t));
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$St = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.xRatio = i.xRatio, this.yRatio = i.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new $d4be73e5731103af$var$At(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = i.group({
                    class: "apexcharts-heatmap"
                });
                a.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                var s = e.globals.gridWidth / e.globals.dataPoints, r = e.globals.gridHeight / e.globals.series.length, o = 0, n = !1;
                this.negRange = this.helpers.checkColorRange();
                var l = t.slice();
                e.config.yaxis[0].reversed && (n = !0, l.reverse());
                for(var h = n ? 0 : l.length - 1; n ? h < l.length : h >= 0; n ? h++ : h--){
                    var c = i.group({
                        class: "apexcharts-series apexcharts-heatmap-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(e.globals.seriesNames[h]),
                        rel: h + 1,
                        "data:realIndex": h
                    });
                    if (this.ctx.series.addCollapsedClassToSeries(c, h), e.config.chart.dropShadow.enabled) {
                        var d = e.config.chart.dropShadow;
                        new $d4be73e5731103af$var$v(this.ctx).dropShadow(c, d, h);
                    }
                    for(var g = 0, u = e.config.plotOptions.heatmap.shadeIntensity, p = 0; p < l[h].length; p++){
                        var f = this.helpers.getShadeColor(e.config.chart.type, h, p, this.negRange), b = f.color, y = f.colorProps;
                        if ("image" === e.config.fill.type) b = new $d4be73e5731103af$var$R(this.ctx).fillPath({
                            seriesNumber: h,
                            dataPointIndex: p,
                            opacity: e.globals.hasNegs ? y.percent < 0 ? 1 - (1 + y.percent / 100) : u + y.percent / 100 : y.percent / 100,
                            patternID: $d4be73e5731103af$var$x.randomId(),
                            width: e.config.fill.image.width ? e.config.fill.image.width : s,
                            height: e.config.fill.image.height ? e.config.fill.image.height : r
                        });
                        var w = this.rectRadius, k = i.drawRect(g, o, s, r, w);
                        if (k.attr({
                            cx: g,
                            cy: o
                        }), k.node.classList.add("apexcharts-heatmap-rect"), c.add(k), k.attr({
                            fill: b,
                            i: h,
                            index: h,
                            j: p,
                            val: l[h][p],
                            "stroke-width": this.strokeWidth,
                            stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? b : e.globals.stroke.colors[0],
                            color: b
                        }), this.helpers.addListeners(k), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                            var A = 1;
                            e.globals.resized || (A = e.config.chart.animations.speed), this.animateHeatMap(k, g, o, s, r, A);
                        }
                        if (e.globals.dataChanged) {
                            var S = 1;
                            if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                S = this.dynamicAnim.speed;
                                var C = e.globals.previousPaths[h] && e.globals.previousPaths[h][p] && e.globals.previousPaths[h][p].color;
                                C || (C = "rgba(255, 255, 255, 0)"), this.animateHeatColor(k, $d4be73e5731103af$var$x.isColorHex(C) ? C : $d4be73e5731103af$var$x.rgb2hex(C), $d4be73e5731103af$var$x.isColorHex(b) ? b : $d4be73e5731103af$var$x.rgb2hex(b), S);
                            }
                        }
                        var L = (0, e.config.dataLabels.formatter)(e.globals.series[h][p], {
                            value: e.globals.series[h][p],
                            seriesIndex: h,
                            dataPointIndex: p,
                            w: e
                        }), P = this.helpers.calculateDataLabels({
                            text: L,
                            x: g + s / 2,
                            y: o + r / 2,
                            i: h,
                            j: p,
                            colorProps: y,
                            series: l
                        });
                        null !== P && c.add(P), g += s;
                    }
                    o += r, a.add(c);
                }
                var I = e.globals.yAxisScale[0].result.slice();
                e.config.yaxis[0].reversed ? I.unshift("") : I.push(""), e.globals.yAxisScale[0].result = I;
                var T = e.globals.gridHeight / e.globals.series.length;
                return e.config.yaxis[0].labels.offsetY = -T / 2, a;
            }
        },
        {
            key: "animateHeatMap",
            value: function(t, e, i, a, s, r) {
                var o = new $d4be73e5731103af$var$b(this.ctx);
                o.animateRect(t, {
                    x: e + a / 2,
                    y: i + s / 2,
                    width: 0,
                    height: 0
                }, {
                    x: e,
                    y: i,
                    width: a,
                    height: s
                }, r, function() {
                    o.animationCompleted(t);
                });
            }
        },
        {
            key: "animateHeatColor",
            value: function(t, e, i, a) {
                t.attr({
                    fill: e
                }).animate(a).attr({
                    fill: i
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Ct = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "drawYAxisTexts",
            value: function(t, e, i, a) {
                var s = this.w, r = s.config.yaxis[0], o = s.globals.yLabelFormatters[0];
                return new $d4be73e5731103af$var$m(this.ctx).drawText({
                    x: t + r.labels.offsetX,
                    y: e + r.labels.offsetY,
                    text: o(a, i),
                    textAnchor: "middle",
                    fontSize: r.labels.style.fontSize,
                    fontFamily: r.labels.style.fontFamily,
                    foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Lt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
            0
        ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = Math.min(i.globals.gridWidth, i.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = i.globals.gridWidth / 2, "radialBar" === i.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(i.config.plotOptions.pie.endAngle - i.config.plotOptions.pie.startAngle), this.initialAngle = i.config.plotOptions.pie.startAngle % this.fullAngle, i.globals.radialSize = this.defaultSize / 2.05 - i.config.stroke.width - (i.config.chart.sparkline.enabled ? 0 : i.config.chart.dropShadow.blur), this.donutSize = i.globals.radialSize * parseInt(i.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $d4be73e5731103af$var$m(this.ctx);
                if (this.ret = a.group({
                    class: "apexcharts-pie"
                }), i.globals.noData) return this.ret;
                for(var s = 0, r = 0; r < t.length; r++)s += $d4be73e5731103af$var$x.negToZero(t[r]);
                var o = [], n = a.group();
                0 === s && (s = 1e-5), t.forEach(function(t) {
                    e.maxY = Math.max(e.maxY, t);
                }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret);
                for(var l = 0; l < t.length; l++){
                    var h = this.fullAngle * $d4be73e5731103af$var$x.negToZero(t[l]) / s;
                    o.push(h), "polarArea" === this.chartType ? (o[l] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[l] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                }
                if (i.globals.dataChanged) {
                    for(var c, d = 0, g = 0; g < i.globals.previousPaths.length; g++)d += $d4be73e5731103af$var$x.negToZero(i.globals.previousPaths[g]);
                    for(var u = 0; u < i.globals.previousPaths.length; u++)c = this.fullAngle * $d4be73e5731103af$var$x.negToZero(i.globals.previousPaths[u]) / d, this.prevSectorAngleArr.push(c);
                }
                this.donutSize < 0 && (this.donutSize = 0);
                var p = i.config.plotOptions.pie.customScale, f = i.globals.gridWidth / 2, b = i.globals.gridHeight / 2, v = f - i.globals.gridWidth / 2 * p, y = b - i.globals.gridHeight / 2 * p;
                if ("donut" === this.chartType) {
                    var w = a.drawCircle(this.donutSize);
                    w.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                    }), n.add(w);
                }
                var k = this.drawArcs(o, t);
                if (this.sliceLabels.forEach(function(t) {
                    k.add(t);
                }), n.attr({
                    transform: "translate(".concat(v, ", ").concat(y, ") scale(").concat(p, ")")
                }), n.add(k), this.ret.add(n), this.donutDataLabels.show) {
                    var A = this.renderInnerDataLabels(this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show,
                        translateX: v,
                        translateY: y
                    });
                    this.ret.add(A);
                }
                return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret), this.ret;
            }
        },
        {
            key: "drawArcs",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$v(this.ctx), s = new $d4be73e5731103af$var$m(this.ctx), r = new $d4be73e5731103af$var$R(this.ctx), o = s.group({
                    class: "apexcharts-slices"
                }), n = this.initialAngle, l = this.initialAngle, h = this.initialAngle, c = this.initialAngle;
                this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                for(var d = 0; d < t.length; d++){
                    var g = s.group({
                        class: "apexcharts-series apexcharts-pie-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(i.globals.seriesNames[d]),
                        rel: d + 1,
                        "data:realIndex": d
                    });
                    o.add(g), l = c, h = (n = h) + t[d], c = l + this.prevSectorAngleArr[d];
                    var u = h < n ? this.fullAngle + h - n : h - n, p = r.fillPath({
                        seriesNumber: d,
                        size: this.sliceSizes[d],
                        value: e[d]
                    }), f = this.getChangedPath(l, c), b = s.drawPath({
                        d: f,
                        stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[d] : this.lineColorArr,
                        strokeWidth: 0,
                        fill: p,
                        fillOpacity: i.config.fill.opacity,
                        classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(d)
                    });
                    if (b.attr({
                        index: 0,
                        j: d
                    }), a.setSelectionFilter(b, 0, d), i.config.chart.dropShadow.enabled) {
                        var y = i.config.chart.dropShadow;
                        a.dropShadow(b, y, d);
                    }
                    this.addListeners(b, this.donutDataLabels), $d4be73e5731103af$var$m.setAttrs(b.node, {
                        "data:angle": u,
                        "data:startAngle": n,
                        "data:strokeWidth": this.strokeWidth,
                        "data:value": e[d]
                    });
                    var w = {
                        x: 0,
                        y: 0
                    };
                    "pie" === this.chartType || "polarArea" === this.chartType ? w = $d4be73e5731103af$var$x.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle) : "donut" === this.chartType && (w = $d4be73e5731103af$var$x.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle)), g.add(b);
                    var k = 0;
                    if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 === (k = u / this.fullAngle * i.config.chart.animations.speed) && (k = 1), this.animDur = k + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(b, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        prevStartAngle: l,
                        prevEndAngle: c,
                        animateStartingPos: !0,
                        i: d,
                        animBeginArr: this.animBeginArr,
                        shouldSetPrevPaths: !0,
                        dur: i.config.chart.animations.dynamicAnimation.speed
                    }) : this.animatePaths(b, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        i: d,
                        totalItems: t.length - 1,
                        animBeginArr: this.animBeginArr,
                        dur: k
                    }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && b.click(this.pieClicked.bind(this, d)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(d) > -1 && this.pieClicked(d), i.config.dataLabels.enabled) {
                        var A = w.x, S = w.y, C = 100 * u / this.fullAngle + "%";
                        if (0 !== u && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[d]) {
                            var L = i.config.dataLabels.formatter;
                            void 0 !== L && (C = L(i.globals.seriesPercent[d][0], {
                                seriesIndex: d,
                                w: i
                            }));
                            var P = i.globals.dataLabels.style.colors[d], I = s.group({
                                class: "apexcharts-datalabels"
                            }), T = s.drawText({
                                x: A,
                                y: S,
                                text: C,
                                textAnchor: "middle",
                                fontSize: i.config.dataLabels.style.fontSize,
                                fontFamily: i.config.dataLabels.style.fontFamily,
                                fontWeight: i.config.dataLabels.style.fontWeight,
                                foreColor: P
                            });
                            if (I.add(T), i.config.dataLabels.dropShadow.enabled) {
                                var M = i.config.dataLabels.dropShadow;
                                a.dropShadow(T, M);
                            }
                            T.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (T.node.classList.add("apexcharts-pie-label-delay"), T.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(I);
                        }
                    }
                }
                return o;
            }
        },
        {
            key: "addListeners",
            value: function(t, e) {
                var i = new $d4be73e5731103af$var$m(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)));
            }
        },
        {
            key: "animatePaths",
            value: function(t, e) {
                var i = this.w, a = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle, s = a, r = e.startAngle, o = e.startAngle;
                void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, s = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (a + o > this.fullAngle ? e.endAngle = e.endAngle - (a + o) : a + o < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (a + o)))), a === this.fullAngle && (a = this.fullAngle - .01), this.animateArc(t, r, o, a, s, e);
            }
        },
        {
            key: "animateArc",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = this.w, h = new $d4be73e5731103af$var$b(this.ctx), c = r.size;
                (isNaN(e) || isNaN(s)) && (e = i, s = a, r.dur = 0);
                var d = a, g = i, u = e < i ? this.fullAngle + e - i : e - i;
                l.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (o = n.getPiePath({
                    me: n,
                    startAngle: r.prevStartAngle,
                    angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                    size: c
                }), t.attr({
                    d: o
                })), 0 !== r.dur ? t.animate(r.dur, l.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                    "pie" !== n.chartType && "donut" !== n.chartType && "polarArea" !== n.chartType || this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({
                        "stroke-width": n.strokeWidth
                    }), r.i === l.config.series.length - 1 && h.animationCompleted(t);
                }).during(function(l) {
                    d = u + (a - u) * l, r.animateStartingPos && (d = s + (a - s) * l, g = e - s + (i - (e - s)) * l), o = n.getPiePath({
                        me: n,
                        startAngle: g,
                        angle: d,
                        size: c
                    }), t.node.setAttribute("data:pathOrig", o), t.attr({
                        d: o
                    });
                }) : (o = n.getPiePath({
                    me: n,
                    startAngle: g,
                    angle: a,
                    size: c
                }), r.isTrack || (l.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", o), t.attr({
                    d: o,
                    "stroke-width": n.strokeWidth
                }));
            }
        },
        {
            key: "pieClicked",
            value: function(t) {
                var e, i = this.w, a = this, s = a.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(t)).members[0];
                if ("true" !== r.attr("data:pieClicked")) {
                    var o = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                    Array.prototype.forEach.call(o, function(t) {
                        t.setAttribute("data:pieClicked", "false");
                        var e = t.getAttribute("data:pathOrig");
                        e && t.setAttribute("d", e);
                    }), r.attr("data:pieClicked", "true");
                    var n = parseInt(r.attr("data:startAngle"), 10), l = parseInt(r.attr("data:angle"), 10);
                    e = a.getPiePath({
                        me: a,
                        startAngle: n,
                        angle: l,
                        size: s
                    }), 360 !== l && r.plot(e);
                } else {
                    r.attr({
                        "data:pieClicked": "false"
                    }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                    var h = r.attr("data:pathOrig");
                    r.attr({
                        d: h
                    });
                }
            }
        },
        {
            key: "getChangedPath",
            value: function(t, e) {
                var i = "";
                return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                    me: this,
                    startAngle: t,
                    angle: e - t,
                    size: this.size
                })), i;
            }
        },
        {
            key: "getPiePath",
            value: function(t) {
                var e = t.me, i = t.startAngle, a = t.angle, s = t.size, r = i, o = Math.PI * (r - 90) / 180, n = a + i;
                Math.ceil(n) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (n = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(n) > this.fullAngle && (n -= this.fullAngle);
                var l = Math.PI * (n - 90) / 180, h = e.centerX + s * Math.cos(o), c = e.centerY + s * Math.sin(o), d = e.centerX + s * Math.cos(l), g = e.centerY + s * Math.sin(l), u = $d4be73e5731103af$var$x.polarToCartesian(e.centerX, e.centerY, e.donutSize, n), p = $d4be73e5731103af$var$x.polarToCartesian(e.centerX, e.centerY, e.donutSize, r), f = a > 180 ? 1 : 0, b = [
                    "M",
                    h,
                    c,
                    "A",
                    s,
                    s,
                    0,
                    f,
                    1,
                    d,
                    g
                ];
                return "donut" === e.chartType ? [].concat(b, [
                    "L",
                    u.x,
                    u.y,
                    "A",
                    e.donutSize,
                    e.donutSize,
                    0,
                    f,
                    0,
                    p.x,
                    p.y,
                    "L",
                    h,
                    c,
                    "z"
                ]).join(" ") : "pie" === e.chartType || "polarArea" === e.chartType ? [].concat(b, [
                    "L",
                    e.centerX,
                    e.centerY,
                    "L",
                    h,
                    c
                ]).join(" ") : [].concat(b).join(" ");
            }
        },
        {
            key: "drawPolarElements",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$_(this.ctx), a = new $d4be73e5731103af$var$m(this.ctx), s = new $d4be73e5731103af$var$Ct(this.ctx), r = a.group(), o = a.group(), n = i.niceScale(0, Math.ceil(this.maxY), e.config.yaxis[0].tickAmount, 0, !0), l = n.result.reverse(), h = n.result.length;
                this.maxY = n.niceMax;
                for(var c = e.globals.radialSize, d = c / (h - 1), g = 0; g < h - 1; g++){
                    var u = a.drawCircle(c);
                    if (u.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: "none",
                        "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                        stroke: e.config.plotOptions.polarArea.rings.strokeColor
                    }), e.config.yaxis[0].show) {
                        var p = s.drawYAxisTexts(this.centerX, this.centerY - c + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, g, l[g]);
                        o.add(p);
                    }
                    r.add(u), c -= d;
                }
                this.drawSpokes(t), t.add(r), t.add(o);
            }
        },
        {
            key: "renderInnerDataLabels",
            value: function(t, e) {
                var i = this.w, a = new $d4be73e5731103af$var$m(this.ctx), s = a.group({
                    class: "apexcharts-datalabels-group",
                    transform: "translate(".concat(e.translateX ? e.translateX : 0, ", ").concat(e.translateY ? e.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                }), r = t.total.show;
                s.node.style.opacity = e.opacity;
                var o, n, l = e.centerX, h = e.centerY;
                o = void 0 === t.name.color ? i.globals.colors[0] : t.name.color;
                var c = t.name.fontSize, d = t.name.fontFamily, g = t.name.fontWeight;
                n = void 0 === t.value.color ? i.config.chart.foreColor : t.value.color;
                var u = t.value.formatter, p = "", f = "";
                if (r ? (o = t.total.color, c = t.total.fontSize, d = t.total.fontFamily, g = t.total.fontWeight, f = t.total.label, p = t.total.formatter(i)) : 1 === i.globals.series.length && (p = u(i.globals.series[0], i), f = i.globals.seriesNames[0]), f && (f = t.name.formatter(f, t.total.show, i)), t.name.show) {
                    var x = a.drawText({
                        x: l,
                        y: h + parseFloat(t.name.offsetY),
                        text: f,
                        textAnchor: "middle",
                        foreColor: o,
                        fontSize: c,
                        fontWeight: g,
                        fontFamily: d
                    });
                    x.node.classList.add("apexcharts-datalabel-label"), s.add(x);
                }
                if (t.value.show) {
                    var b = t.name.show ? parseFloat(t.value.offsetY) + 16 : t.value.offsetY, v = a.drawText({
                        x: l,
                        y: h + b,
                        text: p,
                        textAnchor: "middle",
                        foreColor: n,
                        fontWeight: t.value.fontWeight,
                        fontSize: t.value.fontSize,
                        fontFamily: t.value.fontFamily
                    });
                    v.node.classList.add("apexcharts-datalabel-value"), s.add(v);
                }
                return s;
            }
        },
        {
            key: "printInnerLabels",
            value: function(t, e, i, a) {
                var s, r = this.w;
                a ? s = void 0 === t.name.color ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (s = t.total.color);
                var o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                i = (0, t.value.formatter)(i, r), a || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                var l = e === t.total.label;
                e = t.name.formatter(e, l, r), null !== o && (o.textContent = e), null !== n && (n.textContent = i), null !== o && (o.style.fill = s);
            }
        },
        {
            key: "printDataLabelsInner",
            value: function(t, e) {
                var i = this.w, a = t.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                i.globals.series.length > 1 && this.printInnerLabels(e, s, a, t);
                var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                null !== r && (r.style.opacity = 1);
            }
        },
        {
            key: "drawSpokes",
            value: function(t) {
                var e = this, i = this.w, a = new $d4be73e5731103af$var$m(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                if (0 !== s.strokeWidth) {
                    for(var r = [], o = 360 / i.globals.series.length, n = 0; n < i.globals.series.length; n++)r.push($d4be73e5731103af$var$x.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + o * n));
                    r.forEach(function(i, r) {
                        var o = a.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[r] : s.connectorColors);
                        t.add(o);
                    });
                }
            }
        },
        {
            key: "revertDataLabelsInner",
            value: function(t, e, i) {
                var a = this, s = this.w, r = s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"), o = !1, n = s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"), l = function(t) {
                    var i = t.makeSliceOut, s = t.printLabel;
                    Array.prototype.forEach.call(n, function(t) {
                        "true" === t.getAttribute("data:pieClicked") && (i && (o = !0), s && a.printDataLabelsInner(t, e));
                    });
                };
                if (l({
                    makeSliceOut: !0,
                    printLabel: !1
                }), e.total.show && s.globals.series.length > 1) o && !e.total.showAlways ? l({
                    makeSliceOut: !1,
                    printLabel: !0
                }) : this.printInnerLabels(e, e.total.label, e.total.formatter(s));
                else if (l({
                    makeSliceOut: !1,
                    printLabel: !0
                }), !o) {
                    if (s.globals.selectedDataPoints.length && s.globals.series.length > 1) {
                        if (s.globals.selectedDataPoints[0].length > 0) {
                            var h = s.globals.selectedDataPoints[0], c = s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(h));
                            this.printDataLabelsInner(c, e);
                        } else r && s.globals.selectedDataPoints.length && 0 === s.globals.selectedDataPoints[0].length && (r.style.opacity = 0);
                    } else r && s.globals.series.length > 1 && (r.style.opacity = 0);
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Pt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
        var i = this.w;
        this.graphics = new $d4be73e5731103af$var$m(this.ctx), this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = i.globals.svgHeight < i.globals.svgWidth ? i.globals.gridHeight + 1.5 * i.globals.goldenPadding : i.globals.gridWidth, this.isLog = i.config.yaxis[0].logarithmic, this.coreUtils = new $d4be73e5731103af$var$y(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(i.globals.maxY, 0) : i.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : i.globals.minY, this.polygons = i.config.plotOptions.radar.polygons, this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - i.config.chart.dropShadow.blur, i.config.xaxis.labels.show && (this.size = this.size - i.globals.xAxisLabelsWidth / 1.75), void 0 !== i.config.plotOptions.radar.size && (this.size = i.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var i = this, a = this.w, s = new $d4be73e5731103af$var$R(this.ctx), r = [], o = new $d4be73e5731103af$var$O(this.ctx);
                t.length && (this.dataPointsLen = t[a.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                var n = a.globals.gridWidth / 2, l = a.globals.gridHeight / 2, h = n + a.config.plotOptions.radar.offsetX, c = l + a.config.plotOptions.radar.offsetY, d = this.graphics.group({
                    class: "apexcharts-radar-series apexcharts-plot-series",
                    transform: "translate(".concat(h || 0, ", ").concat(c || 0, ")")
                }), g = [], u = null, p = null;
                if (this.yaxisLabels = this.graphics.group({
                    class: "apexcharts-yaxis"
                }), t.forEach(function(t, n) {
                    var l = t.length === a.globals.dataPoints, h = i.graphics.group().attr({
                        class: "apexcharts-series",
                        "data:longestSeries": l,
                        seriesName: $d4be73e5731103af$var$x.escapeString(a.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    i.dataRadiusOfPercent[n] = [], i.dataRadius[n] = [], i.angleArr[n] = [], t.forEach(function(t, e) {
                        var a = Math.abs(i.maxValue - i.minValue);
                        t += Math.abs(i.minValue), i.isLog && (t = i.coreUtils.getLogVal(t, 0)), i.dataRadiusOfPercent[n][e] = t / a, i.dataRadius[n][e] = i.dataRadiusOfPercent[n][e] * i.size, i.angleArr[n][e] = e * i.disAngle;
                    }), g = i.getDataPointsPos(i.dataRadius[n], i.angleArr[n]);
                    var c = i.createPaths(g, {
                        x: 0,
                        y: 0
                    });
                    u = i.graphics.group({
                        class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                    }), p = i.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": n
                    }), a.globals.delayedElements.push({
                        el: u.node,
                        index: n
                    });
                    var d = {
                        i: n,
                        realIndex: n,
                        animationDelay: n,
                        initialSpeed: a.config.chart.animations.speed,
                        dataChangeSpeed: a.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-radar",
                        shouldClipToGrid: !1,
                        bindEventsOnPaths: !1,
                        stroke: a.globals.stroke.colors[n],
                        strokeLineCap: a.config.stroke.lineCap
                    }, f = null;
                    a.globals.previousPaths.length > 0 && (f = i.getPreviousPath(n));
                    for(var b = 0; b < c.linePathsTo.length; b++){
                        var m = i.graphics.renderPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, d), {}, {
                            pathFrom: null === f ? c.linePathsFrom[b] : f,
                            pathTo: c.linePathsTo[b],
                            strokeWidth: Array.isArray(i.strokeWidth) ? i.strokeWidth[n] : i.strokeWidth,
                            fill: "none",
                            drawShadow: !1
                        }));
                        h.add(m);
                        var y = s.fillPath({
                            seriesNumber: n
                        }), w = i.graphics.renderPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, d), {}, {
                            pathFrom: null === f ? c.areaPathsFrom[b] : f,
                            pathTo: c.areaPathsTo[b],
                            strokeWidth: 0,
                            fill: y,
                            drawShadow: !1
                        }));
                        if (a.config.chart.dropShadow.enabled) {
                            var k = new $d4be73e5731103af$var$v(i.ctx), A = a.config.chart.dropShadow;
                            k.dropShadow(w, Object.assign({}, A, {
                                noUserSpaceOnUse: !0
                            }), n);
                        }
                        h.add(w);
                    }
                    t.forEach(function(t, s) {
                        var r = new $d4be73e5731103af$var$H(i.ctx).getMarkerConfig({
                            cssClass: "apexcharts-marker",
                            seriesIndex: n,
                            dataPointIndex: s
                        }), l = i.graphics.drawMarker(g[s].x, g[s].y, r);
                        l.attr("rel", s), l.attr("j", s), l.attr("index", n), l.node.setAttribute("default-marker-size", r.pSize);
                        var c = i.graphics.group({
                            class: "apexcharts-series-markers"
                        });
                        c && c.add(l), u.add(c), h.add(u);
                        var d = a.config.dataLabels;
                        if (d.enabled) {
                            var f = d.formatter(a.globals.series[n][s], {
                                seriesIndex: n,
                                dataPointIndex: s,
                                w: a
                            });
                            o.plotDataLabelsText({
                                x: g[s].x,
                                y: g[s].y,
                                text: f,
                                textAnchor: "middle",
                                i: n,
                                j: n,
                                parent: p,
                                offsetCorrection: !1,
                                dataLabelsConfig: $d4be73e5731103af$var$e({}, d)
                            });
                        }
                        h.add(p);
                    }), r.push(h);
                }), this.drawPolygons({
                    parent: d
                }), a.config.xaxis.labels.show) {
                    var f = this.drawXAxisTexts();
                    d.add(f);
                }
                return r.forEach(function(t) {
                    d.add(t);
                }), d.add(this.yaxisLabels), d;
            }
        },
        {
            key: "drawPolygons",
            value: function(t) {
                for(var e = this, i = this.w, a = t.parent, s = new $d4be73e5731103af$var$Ct(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), o = r.length, n = [], l = this.size / (o - 1), h = 0; h < o; h++)n[h] = l * h;
                n.reverse();
                var c = [], d = [];
                n.forEach(function(t, i) {
                    var a = $d4be73e5731103af$var$x.getPolygonPos(t, e.dataPointsLen), s = "";
                    a.forEach(function(t, a) {
                        if (0 === i) {
                            var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[a] : e.polygons.connectorColors);
                            d.push(r);
                        }
                        0 === a && e.yaxisLabelsTextsPos.push({
                            x: t.x,
                            y: t.y
                        }), s += t.x + "," + t.y + " ";
                    }), c.push(s);
                }), c.forEach(function(t, s) {
                    var r = e.polygons.strokeColors, o = e.polygons.strokeWidth, n = e.graphics.drawPolygon(t, Array.isArray(r) ? r[s] : r, Array.isArray(o) ? o[s] : o, i.globals.radarPolygons.fill.colors[s]);
                    a.add(n);
                }), d.forEach(function(t) {
                    a.add(t);
                }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(t, i) {
                    var a = s.drawYAxisTexts(t.x, t.y, i, r[i]);
                    e.yaxisLabels.add(a);
                });
            }
        },
        {
            key: "drawXAxisTexts",
            value: function() {
                var t = this, i = this.w, a = i.config.xaxis.labels, s = this.graphics.group({
                    class: "apexcharts-xaxis"
                }), r = $d4be73e5731103af$var$x.getPolygonPos(this.size, this.dataPointsLen);
                return i.globals.labels.forEach(function(o, n) {
                    var l = i.config.xaxis.labels.formatter, h = new $d4be73e5731103af$var$O(t.ctx);
                    if (r[n]) {
                        var c = t.getTextPos(r[n], t.size), d = l(o, {
                            seriesIndex: -1,
                            dataPointIndex: n,
                            w: i
                        });
                        h.plotDataLabelsText({
                            x: c.newX,
                            y: c.newY,
                            text: d,
                            textAnchor: c.textAnchor,
                            i: n,
                            j: n,
                            parent: s,
                            color: Array.isArray(a.style.colors) && a.style.colors[n] ? a.style.colors[n] : "#a8a8a8",
                            dataLabelsConfig: $d4be73e5731103af$var$e({
                                textAnchor: c.textAnchor,
                                dropShadow: {
                                    enabled: !1
                                }
                            }, a),
                            offsetCorrection: !1
                        });
                    }
                }), s;
            }
        },
        {
            key: "createPaths",
            value: function(t, e) {
                var i = this, a = [], s = [], r = [], o = [];
                if (t.length) {
                    s = [
                        this.graphics.move(e.x, e.y)
                    ], o = [
                        this.graphics.move(e.x, e.y)
                    ];
                    var n = this.graphics.move(t[0].x, t[0].y), l = this.graphics.move(t[0].x, t[0].y);
                    t.forEach(function(e, a) {
                        n += i.graphics.line(e.x, e.y), l += i.graphics.line(e.x, e.y), a === t.length - 1 && (n += "Z", l += "Z");
                    }), a.push(n), r.push(l);
                }
                return {
                    linePathsFrom: s,
                    linePathsTo: a,
                    areaPathsFrom: o,
                    areaPathsTo: r
                };
            }
        },
        {
            key: "getTextPos",
            value: function(t, e) {
                var i = "middle", a = t.x, s = t.y;
                return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", a += 10) : t.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? s -= 10 : t.y > 0 && (s += 10)), {
                    textAnchor: i,
                    newX: a,
                    newY: s
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t) {
                for(var e = this.w, i = null, a = 0; a < e.globals.previousPaths.length; a++){
                    var s = e.globals.previousPaths[a];
                    s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[a].paths[0] && (i = e.globals.previousPaths[a].paths[0].d);
                }
                return i;
            }
        },
        {
            key: "getDataPointsPos",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                t = t || [], e = e || [];
                for(var a = [], s = 0; s < i; s++){
                    var r = {};
                    r.x = t[s] * Math.sin(e[s]), r.y = -t[s] * Math.cos(e[s]), a.push(r);
                }
                return a;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$It = function(t) {
    $d4be73e5731103af$var$n(i, $d4be73e5731103af$var$Lt);
    var e = $d4be73e5731103af$var$d(i);
    function i(t) {
        var s;
        $d4be73e5731103af$var$a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.animBeginArr = [
            0
        ], s.animDur = 0;
        var r = s.w;
        return s.startAngle = r.config.plotOptions.radialBar.startAngle, s.endAngle = r.config.plotOptions.radialBar.endAngle, s.totalAngle = Math.abs(r.config.plotOptions.radialBar.endAngle - r.config.plotOptions.radialBar.startAngle), s.trackStartAngle = r.config.plotOptions.radialBar.track.startAngle, s.trackEndAngle = r.config.plotOptions.radialBar.track.endAngle, s.donutDataLabels = s.w.config.plotOptions.radialBar.dataLabels, s.radialDataLabels = s.donutDataLabels, s.trackStartAngle || (s.trackStartAngle = s.startAngle), s.trackEndAngle || (s.trackEndAngle = s.endAngle), 360 === s.endAngle && (s.endAngle = 359.99), s.margin = parseInt(r.config.plotOptions.radialBar.track.margin, 10), s;
    }
    return $d4be73e5731103af$var$r(i, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = i.group({
                    class: "apexcharts-radialbar"
                });
                if (e.globals.noData) return a;
                var s = i.group(), r = this.defaultSize / 2, o = e.globals.gridWidth / 2, n = this.defaultSize / 2.05;
                e.config.chart.sparkline.enabled || (n = n - e.config.stroke.width - e.config.chart.dropShadow.blur);
                var l = e.globals.fill.colors;
                if (e.config.plotOptions.radialBar.track.show) {
                    var h = this.drawTracks({
                        size: n,
                        centerX: o,
                        centerY: r,
                        colorArr: l,
                        series: t
                    });
                    s.add(h);
                }
                var c = this.drawArcs({
                    size: n,
                    centerX: o,
                    centerY: r,
                    colorArr: l,
                    series: t
                }), d = 360;
                e.config.plotOptions.radialBar.startAngle < 0 && (d = this.totalAngle);
                var g = (360 - d) / 360;
                if (e.globals.radialSize = n - n * g, this.radialDataLabels.value.show) {
                    var u = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                    e.globals.radialSize += u * g;
                }
                return s.add(c.g), "front" === e.config.plotOptions.radialBar.hollow.position && (c.g.add(c.elHollow), c.dataLabels && c.g.add(c.dataLabels)), a.add(s), a;
            }
        },
        {
            key: "drawTracks",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = i.group({
                    class: "apexcharts-tracks"
                }), s = new $d4be73e5731103af$var$v(this.ctx), r = new $d4be73e5731103af$var$R(this.ctx), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                for(var n = 0; n < t.series.length; n++){
                    var l = i.group({
                        class: "apexcharts-radialbar-track apexcharts-track"
                    });
                    a.add(l), l.attr({
                        rel: n + 1
                    }), t.size = t.size - o - this.margin;
                    var h = e.config.plotOptions.radialBar.track, c = r.fillPath({
                        seriesNumber: 0,
                        size: t.size,
                        fillColors: Array.isArray(h.background) ? h.background[n] : h.background,
                        solid: !0
                    }), d = this.trackStartAngle, g = this.trackEndAngle;
                    Math.abs(g) + Math.abs(d) >= 360 && (g = 360 - Math.abs(this.startAngle) - .1);
                    var u = i.drawPath({
                        d: "",
                        stroke: c,
                        strokeWidth: o * parseInt(h.strokeWidth, 10) / 100,
                        fill: "none",
                        strokeOpacity: h.opacity,
                        classes: "apexcharts-radialbar-area"
                    });
                    if (h.dropShadow.enabled) {
                        var p = h.dropShadow;
                        s.dropShadow(u, p);
                    }
                    l.add(u), u.attr("id", "apexcharts-radialbarTrack-" + n), this.animatePaths(u, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: g,
                        startAngle: d,
                        size: t.size,
                        i: n,
                        totalItems: 2,
                        animBeginArr: 0,
                        dur: 0,
                        isTrack: !0,
                        easing: e.globals.easing
                    });
                }
                return a;
            }
        },
        {
            key: "drawArcs",
            value: function(t) {
                var e = this.w, i = new $d4be73e5731103af$var$m(this.ctx), a = new $d4be73e5731103af$var$R(this.ctx), s = new $d4be73e5731103af$var$v(this.ctx), r = i.group(), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                var n = e.config.plotOptions.radialBar.hollow.background, l = t.size - o * t.series.length - this.margin * t.series.length - o * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = l - e.config.plotOptions.radialBar.hollow.margin;
                void 0 !== e.config.plotOptions.radialBar.hollow.image && (n = this.drawHollowImage(t, r, l, n));
                var c = this.drawHollow({
                    size: h,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    fill: n || "transparent"
                });
                if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                    var d = e.config.plotOptions.radialBar.hollow.dropShadow;
                    s.dropShadow(c, d);
                }
                var g = 1;
                !this.radialDataLabels.total.show && e.globals.series.length > 1 && (g = 0);
                var u = null;
                this.radialDataLabels.show && (u = this.renderInnerDataLabels(this.radialDataLabels, {
                    hollowSize: l,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    opacity: g
                })), "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(c), u && r.add(u));
                var p = !1;
                e.config.plotOptions.radialBar.inverseOrder && (p = !0);
                for(var f = p ? t.series.length - 1 : 0; p ? f >= 0 : f < t.series.length; p ? f-- : f++){
                    var b = i.group({
                        class: "apexcharts-series apexcharts-radial-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(e.globals.seriesNames[f])
                    });
                    r.add(b), b.attr({
                        rel: f + 1,
                        "data:realIndex": f
                    }), this.ctx.series.addCollapsedClassToSeries(b, f), t.size = t.size - o - this.margin;
                    var y = a.fillPath({
                        seriesNumber: f,
                        size: t.size,
                        value: t.series[f]
                    }), w = this.startAngle, k = void 0, A = $d4be73e5731103af$var$x.negToZero(t.series[f] > 100 ? 100 : t.series[f]) / 100, S = Math.round(this.totalAngle * A) + this.startAngle, C = void 0;
                    e.globals.dataChanged && (k = this.startAngle, C = Math.round(this.totalAngle * $d4be73e5731103af$var$x.negToZero(e.globals.previousPaths[f]) / 100) + k), Math.abs(S) + Math.abs(w) >= 360 && (S -= .01), Math.abs(C) + Math.abs(k) >= 360 && (C -= .01);
                    var L = S - w, P = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[f] : e.config.stroke.dashArray, I = i.drawPath({
                        d: "",
                        stroke: y,
                        strokeWidth: o,
                        fill: "none",
                        fillOpacity: e.config.fill.opacity,
                        classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + f,
                        strokeDashArray: P
                    });
                    if ($d4be73e5731103af$var$m.setAttrs(I.node, {
                        "data:angle": L,
                        "data:value": t.series[f]
                    }), e.config.chart.dropShadow.enabled) {
                        var T = e.config.chart.dropShadow;
                        s.dropShadow(I, T, f);
                    }
                    s.setSelectionFilter(I, 0, f), this.addListeners(I, this.radialDataLabels), b.add(I), I.attr({
                        index: 0,
                        j: f
                    });
                    var M = 0;
                    !this.initialAnim || e.globals.resized || e.globals.dataChanged || (M = e.config.chart.animations.speed), e.globals.dataChanged && (M = e.config.chart.animations.dynamicAnimation.speed), this.animDur = M / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(I, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: S,
                        startAngle: w,
                        prevEndAngle: C,
                        prevStartAngle: k,
                        size: t.size,
                        i: f,
                        totalItems: 2,
                        animBeginArr: this.animBeginArr,
                        dur: M,
                        shouldSetPrevPaths: !0,
                        easing: e.globals.easing
                    });
                }
                return {
                    g: r,
                    elHollow: c,
                    dataLabels: u
                };
            }
        },
        {
            key: "drawHollow",
            value: function(t) {
                var e = new $d4be73e5731103af$var$m(this.ctx).drawCircle(2 * t.size);
                return e.attr({
                    class: "apexcharts-radialbar-hollow",
                    cx: t.centerX,
                    cy: t.centerY,
                    r: t.size,
                    fill: t.fill
                }), e;
            }
        },
        {
            key: "drawHollowImage",
            value: function(t, e, i, a) {
                var s = this.w, r = new $d4be73e5731103af$var$R(this.ctx), o = $d4be73e5731103af$var$x.randomId(), n = s.config.plotOptions.radialBar.hollow.image;
                if (s.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                    width: i,
                    height: i,
                    image: n,
                    patternID: "pattern".concat(s.globals.cuid).concat(o)
                }), a = "url(#pattern".concat(s.globals.cuid).concat(o, ")");
                else {
                    var l = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
                    if (void 0 === l && void 0 === h) {
                        var c = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - e.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
                        });
                        e.add(c);
                    } else {
                        var d = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - l / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(l, h);
                        });
                        e.add(d);
                    }
                }
                return a;
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t) {
                var e = this.w;
                return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin;
            }
        }
    ]), i;
}(), $d4be73e5731103af$var$Tt = function(t) {
    $d4be73e5731103af$var$n(s, $d4be73e5731103af$var$yt);
    var i = $d4be73e5731103af$var$d(s);
    function s() {
        return $d4be73e5731103af$var$a(this, s), i.apply(this, arguments);
    }
    return $d4be73e5731103af$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new $d4be73e5731103af$var$m(this.ctx);
                this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = a.globals.seriesRangeStart, this.seriesRangeEnd = a.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                for(var r = s.group({
                    class: "apexcharts-rangebar-series apexcharts-plot-series"
                }), n = 0; n < t.length; n++){
                    var l, h, c, d, g = void 0, u = void 0, p = a.globals.comboCharts ? i[n] : n, f = s.group({
                        class: "apexcharts-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(a.globals.seriesNames[p]),
                        rel: n + 1,
                        "data:realIndex": p
                    });
                    this.ctx.series.addCollapsedClassToSeries(f, p), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var b = 0, v = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = p);
                    var y = this.barHelpers.initialPositions();
                    u = y.y, d = y.zeroW, g = y.x, v = y.barWidth, b = y.barHeight, l = y.xDivision, h = y.yDivision, c = y.zeroH;
                    for(var w = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": p
                    }), k = s.group({
                        class: "apexcharts-rangebar-goals-markers"
                    }), A = 0; A < a.globals.dataPoints; A++){
                        var S, C = this.barHelpers.getStrokeWidth(n, A, p), L = this.seriesRangeStart[n][A], P = this.seriesRangeEnd[n][A], I = null, T = null, M = null, X = {
                            x: g,
                            y: u,
                            strokeWidth: C,
                            elSeries: f
                        }, z = this.seriesLen;
                        if (a.config.plotOptions.bar.rangeBarGroupRows && (z = 1), void 0 === a.config.series[n].data[A]) break;
                        if (this.isHorizontal) {
                            M = u + b * this.visibleI;
                            var E = (h - b * z) / 2;
                            if (a.config.series[n].data[A].x) {
                                var Y = this.detectOverlappingBars({
                                    i: n,
                                    j: A,
                                    barYPosition: M,
                                    srty: E,
                                    barHeight: b,
                                    yDivision: h,
                                    initPositions: y
                                });
                                b = Y.barHeight, M = Y.barYPosition;
                            }
                            v = (I = this.drawRangeBarPaths($d4be73e5731103af$var$e({
                                indexes: {
                                    i: n,
                                    j: A,
                                    realIndex: p
                                },
                                barHeight: b,
                                barYPosition: M,
                                zeroW: d,
                                yDivision: h,
                                y1: L,
                                y2: P
                            }, X))).barWidth;
                        } else {
                            a.globals.isXNumeric && (g = (a.globals.seriesX[n][A] - a.globals.minX) / this.xRatio - v / 2), T = g + v * this.visibleI;
                            var F = (l - v * z) / 2;
                            if (a.config.series[n].data[A].x) {
                                var R = this.detectOverlappingBars({
                                    i: n,
                                    j: A,
                                    barXPosition: T,
                                    srtx: F,
                                    barWidth: v,
                                    xDivision: l,
                                    initPositions: y
                                });
                                v = R.barWidth, T = R.barXPosition;
                            }
                            b = (I = this.drawRangeColumnPaths($d4be73e5731103af$var$e({
                                indexes: {
                                    i: n,
                                    j: A,
                                    realIndex: p
                                },
                                barWidth: v,
                                barXPosition: T,
                                zeroH: c,
                                xDivision: l
                            }, X))).barHeight;
                        }
                        var H = this.barHelpers.drawGoalLine({
                            barXPosition: I.barXPosition,
                            barYPosition: M,
                            goalX: I.goalX,
                            goalY: I.goalY,
                            barHeight: b,
                            barWidth: v
                        });
                        H && k.add(H), u = I.y, g = I.x;
                        var D = this.barHelpers.getPathFillColor(t, n, A, p), O = a.globals.stroke.colors[p];
                        this.renderSeries(($d4be73e5731103af$var$o(S = {
                            realIndex: p,
                            pathFill: D,
                            lineFill: O,
                            j: A,
                            i: n,
                            x: g,
                            y: u,
                            y1: L,
                            y2: P,
                            pathFrom: I.pathFrom,
                            pathTo: I.pathTo,
                            strokeWidth: C,
                            elSeries: f,
                            series: t,
                            barHeight: b,
                            barWidth: v,
                            barXPosition: T,
                            barYPosition: M
                        }, "barWidth", v), $d4be73e5731103af$var$o(S, "elDataLabelsWrap", w), $d4be73e5731103af$var$o(S, "elGoalsMarkers", k), $d4be73e5731103af$var$o(S, "visibleSeries", this.visibleI), $d4be73e5731103af$var$o(S, "type", "rangebar"), S));
                    }
                    r.add(f);
                }
                return r;
            }
        },
        {
            key: "detectOverlappingBars",
            value: function(t) {
                var e = t.i, i = t.j, a = t.barYPosition, s = t.barXPosition, r = t.srty, o = t.srtx, n = t.barHeight, l = t.barWidth, h = t.yDivision, c = t.xDivision, d = t.initPositions, g = this.w, u = [], p = g.config.series[e].data[i].rangeName, f = g.config.series[e].data[i].x, x = Array.isArray(f) ? f.join(" ") : f, b = g.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(x), v = g.globals.seriesRange[e].findIndex(function(t) {
                    return t.x === x && t.overlaps.length > 0;
                });
                return this.isHorizontal ? (a = g.config.plotOptions.bar.rangeBarGroupRows ? r + h * b : r + n * this.visibleI + h * b, v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(p) > -1 && (a = (n = d.barHeight / u.length) * this.visibleI + h * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + n * (this.visibleI + u.indexOf(p)) + h * b)) : (b > -1 && (s = g.config.plotOptions.bar.rangeBarGroupRows ? o + c * b : o + l * this.visibleI + c * b), v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(p) > -1 && (s = (l = d.barWidth / u.length) * this.visibleI + c * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + l * (this.visibleI + u.indexOf(p)) + c * b)), {
                    barYPosition: a,
                    barXPosition: s,
                    barHeight: n,
                    barWidth: l
                };
            }
        },
        {
            key: "drawRangeColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.xDivision, s = t.barWidth, r = t.barXPosition, o = t.zeroH, n = this.w, l = e.i, h = e.j, c = this.yRatio[this.yaxisIndex], d = e.realIndex, g = this.getRangeValue(d, h), u = Math.min(g.start, g.end), p = Math.max(g.start, g.end);
                void 0 === this.series[l][h] || null === this.series[l][h] ? u = o : (u = o - u / c, p = o - p / c);
                var f = Math.abs(p - u), x = this.barHelpers.getColumnPaths({
                    barXPosition: r,
                    barWidth: s,
                    y1: u,
                    y2: p,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    realIndex: e.realIndex,
                    i: d,
                    j: h,
                    w: n
                });
                return n.globals.isXNumeric || (i += a), {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    barHeight: f,
                    x: i,
                    y: p,
                    goalY: this.barHelpers.getGoalValues("y", null, o, l, h),
                    barXPosition: r
                };
            }
        },
        {
            key: "drawRangeBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.y, a = t.y1, s = t.y2, r = t.yDivision, o = t.barHeight, n = t.barYPosition, l = t.zeroW, h = this.w, c = l + a / this.invertedYRatio, d = l + s / this.invertedYRatio, g = Math.abs(d - c), u = this.barHelpers.getBarpaths({
                    barYPosition: n,
                    barHeight: o,
                    x1: c,
                    x2: d,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    i: e.realIndex,
                    realIndex: e.realIndex,
                    j: e.j,
                    w: h
                });
                return h.globals.isXNumeric || (i += r), {
                    pathTo: u.pathTo,
                    pathFrom: u.pathFrom,
                    barWidth: g,
                    x: d,
                    goalX: this.barHelpers.getGoalValues("x", l, null, e.realIndex, e.j),
                    y: i
                };
            }
        },
        {
            key: "getRangeValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    start: i.globals.seriesRangeStart[t][e],
                    end: i.globals.seriesRangeEnd[t][e]
                };
            }
        }
    ]), s;
}(), $d4be73e5731103af$var$Mt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.w = e.w, this.lineCtx = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "sameValueSeriesFix",
            value: function(t, e) {
                var i = this.w;
                if (("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new $d4be73e5731103af$var$y(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                    var a = e[t].slice();
                    a[a.length - 1] = a[a.length - 1] + 1e-6, e[t] = a;
                }
                return e;
            }
        },
        {
            key: "calculatePoints",
            value: function(t) {
                var e = t.series, i = t.realIndex, a = t.x, s = t.y, r = t.i, o = t.j, n = t.prevY, l = this.w, h = [], c = [];
                if (0 === o) {
                    var d = this.lineCtx.categoryAxisCorrection + l.config.markers.offsetX;
                    l.globals.isXNumeric && (d = (l.globals.seriesX[i][0] - l.globals.minX) / this.lineCtx.xRatio + l.config.markers.offsetX), h.push(d), c.push($d4be73e5731103af$var$x.isNumber(e[r][0]) ? n + l.config.markers.offsetY : null), h.push(a + l.config.markers.offsetX), c.push($d4be73e5731103af$var$x.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                } else h.push(a + l.config.markers.offsetX), c.push($d4be73e5731103af$var$x.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                return {
                    x: h,
                    y: c
                };
            }
        },
        {
            key: "checkPreviousPaths",
            value: function(t) {
                for(var e = t.pathFromLine, i = t.pathFromArea, a = t.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                    var o = s.globals.previousPaths[r];
                    ("line" === o.type || "area" === o.type) && o.paths.length > 0 && parseInt(o.realIndex, 10) === parseInt(a, 10) && ("line" === o.type ? (this.lineCtx.appendPathFrom = !1, e = s.globals.previousPaths[r].paths[0].d) : "area" === o.type && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (e = s.globals.previousPaths[r].paths[1].d)));
                }
                return {
                    pathFromLine: e,
                    pathFromArea: i
                };
            }
        },
        {
            key: "determineFirstPrevY",
            value: function(t) {
                var e, i = t.i, a = t.series, s = t.prevY, r = t.lineYPosition, o = this.w;
                if (void 0 !== (null === (e = a[i]) || void 0 === e ? void 0 : e[0])) s = (r = o.config.chart.stacked && i > 0 ? this.lineCtx.prevSeriesY[i - 1][0] : this.lineCtx.zeroY) - a[i][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? a[i][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                else if (o.config.chart.stacked && i > 0 && void 0 === a[i][0]) {
                    for(var n = i - 1; n >= 0; n--)if (null !== a[n][0] && void 0 !== a[n][0]) {
                        s = r = this.lineCtx.prevSeriesY[n][0];
                        break;
                    }
                }
                return {
                    prevY: s,
                    lineYPosition: r
                };
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Xt = function(t) {
    for(var e, i, a, s, r = function(t) {
        for(var e = [], i = t[0], a = t[1], s = e[0] = $d4be73e5731103af$var$Yt(i, a), r = 1, o = t.length - 1; r < o; r++)i = a, a = t[r + 1], e[r] = .5 * (s + (s = $d4be73e5731103af$var$Yt(i, a)));
        return e[r] = s, e;
    }(t), o = t.length - 1, n = [], l = 0; l < o; l++)a = $d4be73e5731103af$var$Yt(t[l], t[l + 1]), Math.abs(a) < 1e-6 ? r[l] = r[l + 1] = 0 : (s = (e = r[l] / a) * e + (i = r[l + 1] / a) * i) > 9 && (s = 3 * a / Math.sqrt(s), r[l] = s * e, r[l + 1] = s * i);
    for(var h = 0; h <= o; h++)s = (t[Math.min(o, h + 1)][0] - t[Math.max(0, h - 1)][0]) / (6 * (1 + r[h] * r[h])), n.push([
        s || 0,
        r[h] * s || 0
    ]);
    return n;
}, $d4be73e5731103af$var$zt = function(t) {
    for(var e = "", i = 0; i < t.length; i++){
        var a = t[i], s = a.length;
        s > 4 ? (e += "C".concat(a[0], ", ").concat(a[1]), e += ", ".concat(a[2], ", ").concat(a[3]), e += ", ".concat(a[4], ", ").concat(a[5])) : s > 2 && (e += "S".concat(a[0], ", ").concat(a[1]), e += ", ".concat(a[2], ", ").concat(a[3]));
    }
    return e;
}, $d4be73e5731103af$var$Et = function(t) {
    var e = $d4be73e5731103af$var$Xt(t), i = t[1], a = t[0], s = [], r = e[1], o = e[0];
    s.push(a, [
        a[0] + o[0],
        a[1] + o[1],
        i[0] - r[0],
        i[1] - r[1],
        i[0],
        i[1]
    ]);
    for(var n = 2, l = e.length; n < l; n++){
        var h = t[n], c = e[n];
        s.push([
            h[0] - c[0],
            h[1] - c[1],
            h[0],
            h[1]
        ]);
    }
    return s;
};
function $d4be73e5731103af$var$Yt(t, e) {
    return (e[1] - t[1]) / (e[0] - t[0]);
}
var $d4be73e5731103af$var$Ft = function() {
    function t(e, i, s) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.xyRatios = i, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || s, this.scatter = new $d4be73e5731103af$var$D(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new $d4be73e5731103af$var$Mt(this), this.markers = new $d4be73e5731103af$var$H(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t, i, a, s) {
                var r = this.w, o = new $d4be73e5731103af$var$m(this.ctx), n = r.globals.comboCharts ? i : r.config.chart.type, l = o.group({
                    class: "apexcharts-".concat(n, "-series apexcharts-plot-series")
                }), h = new $d4be73e5731103af$var$y(this.ctx, r);
                this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = h.getLogSeries(t), this.yRatio = h.getLogYRatios(this.yRatio);
                for(var c = [], d = 0; d < t.length; d++){
                    t = this.lineHelpers.sameValueSeriesFix(d, t);
                    var g = r.globals.comboCharts ? a[d] : d;
                    this._initSerieVariables(t, d, g);
                    var u = [], p = [], f = [], x = r.globals.padHorizontal + this.categoryAxisCorrection;
                    this.ctx.series.addCollapsedClassToSeries(this.elSeries, g), r.globals.isXNumeric && r.globals.seriesX.length > 0 && (x = (r.globals.seriesX[g][0] - r.globals.minX) / this.xRatio), f.push(x);
                    var b, v = x, w = void 0, k = v, A = this.zeroY, S = this.zeroY;
                    A = this.lineHelpers.determineFirstPrevY({
                        i: d,
                        series: t,
                        prevY: A,
                        lineYPosition: 0
                    }).prevY, u.push(A), b = A;
                    "rangeArea" === n && (w = S = this.lineHelpers.determineFirstPrevY({
                        i: d,
                        series: s,
                        prevY: S,
                        lineYPosition: 0
                    }).prevY, p.push(S));
                    var C = {
                        type: n,
                        series: t,
                        realIndex: g,
                        i: d,
                        x: x,
                        y: 1,
                        pX: v,
                        pY: b,
                        pathsFrom: this._calculatePathsFrom({
                            type: n,
                            series: t,
                            i: d,
                            realIndex: g,
                            prevX: k,
                            prevY: A,
                            prevY2: S
                        }),
                        linePaths: [],
                        areaPaths: [],
                        seriesIndex: a,
                        lineYPosition: 0,
                        xArrj: f,
                        yArrj: u,
                        y2Arrj: p,
                        seriesRangeEnd: s
                    }, L = this._iterateOverDataPoints($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, C), {}, {
                        iterations: "rangeArea" === n ? t[d].length - 1 : void 0,
                        isRangeStart: !0
                    }));
                    if ("rangeArea" === n) {
                        var P = this._calculatePathsFrom({
                            series: s,
                            i: d,
                            realIndex: g,
                            prevX: k,
                            prevY: S
                        }), I = this._iterateOverDataPoints($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, C), {}, {
                            series: s,
                            pY: w,
                            pathsFrom: P,
                            iterations: s[d].length - 1,
                            isRangeStart: !1
                        }));
                        L.linePaths[0] = I.linePath + L.linePath, L.pathFromLine = I.pathFromLine + L.pathFromLine;
                    }
                    this._handlePaths({
                        type: n,
                        realIndex: g,
                        i: d,
                        paths: L
                    }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), c.push(this.elSeries);
                }
                if (r.config.chart.stacked) for(var T = c.length; T > 0; T--)l.add(c[T - 1]);
                else for(var M = 0; M < c.length; M++)l.add(c[M]);
                return l;
            }
        },
        {
            key: "_initSerieVariables",
            value: function(t, e, i) {
                var a = this.w, s = new $d4be73e5731103af$var$m(this.ctx);
                this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - ("on" === a.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || "end" === a.config.plotOptions.area.fillTo) && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                    class: "apexcharts-series",
                    seriesName: $d4be73e5731103af$var$x.escapeString(a.globals.seriesNames[i])
                }), this.elPointsMain = s.group({
                    class: "apexcharts-series-markers-wrap",
                    "data:realIndex": i
                }), this.elDataLabelsWrap = s.group({
                    class: "apexcharts-datalabels",
                    "data:realIndex": i
                });
                var r = t[e].length === a.globals.dataPoints;
                this.elSeries.attr({
                    "data:longestSeries": r,
                    rel: e + 1,
                    "data:realIndex": i
                }), this.appendPathFrom = !0;
            }
        },
        {
            key: "_calculatePathsFrom",
            value: function(t) {
                var e, i, a, s, r = t.type, o = t.series, n = t.i, l = t.realIndex, h = t.prevX, c = t.prevY, d = t.prevY2, g = this.w, u = new $d4be73e5731103af$var$m(this.ctx);
                if (null === o[n][0]) {
                    for(var p = 0; p < o[n].length; p++)if (null !== o[n][p]) {
                        h = this.xDivision * p, c = this.zeroY - o[n][p] / this.yRatio[this.yaxisIndex], e = u.move(h, c), i = u.move(h, this.areaBottomY);
                        break;
                    }
                } else e = u.move(h, c), "rangeArea" === r && (e = u.move(h, d) + u.line(h, c)), i = u.move(h, this.areaBottomY) + u.line(h, c);
                if (a = u.move(-1, this.zeroY) + u.line(-1, this.zeroY), s = u.move(-1, this.zeroY) + u.line(-1, this.zeroY), g.globals.previousPaths.length > 0) {
                    var f = this.lineHelpers.checkPreviousPaths({
                        pathFromLine: a,
                        pathFromArea: s,
                        realIndex: l
                    });
                    a = f.pathFromLine, s = f.pathFromArea;
                }
                return {
                    prevX: h,
                    prevY: c,
                    linePath: e,
                    areaPath: i,
                    pathFromLine: a,
                    pathFromArea: s
                };
            }
        },
        {
            key: "_handlePaths",
            value: function(t) {
                var i = t.type, a = t.realIndex, s = t.i, r = t.paths, o = this.w, n = new $d4be73e5731103af$var$m(this.ctx), l = new $d4be73e5731103af$var$R(this.ctx);
                this.prevSeriesY.push(r.yArrj), o.globals.seriesXvalues[a] = r.xArrj, o.globals.seriesYvalues[a] = r.yArrj;
                var h = o.config.forecastDataPoints;
                if (h.count > 0 && "rangeArea" !== i) {
                    var c = o.globals.seriesXvalues[a][o.globals.seriesXvalues[a].length - h.count - 1], d = n.drawRect(c, 0, o.globals.gridWidth, o.globals.gridHeight, 0);
                    o.globals.dom.elForecastMask.appendChild(d.node);
                    var g = n.drawRect(0, 0, c, o.globals.gridHeight, 0);
                    o.globals.dom.elNonForecastMask.appendChild(g.node);
                }
                this.pointsChart || o.globals.delayedElements.push({
                    el: this.elPointsMain.node,
                    index: a
                });
                var u = {
                    i: s,
                    realIndex: a,
                    animationDelay: s,
                    initialSpeed: o.config.chart.animations.speed,
                    dataChangeSpeed: o.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(i)
                };
                if ("area" === i) for(var p = l.fillPath({
                    seriesNumber: a
                }), f = 0; f < r.areaPaths.length; f++){
                    var x = n.renderPaths($d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, u), {}, {
                        pathFrom: r.pathFromArea,
                        pathTo: r.areaPaths[f],
                        stroke: "none",
                        strokeWidth: 0,
                        strokeLineCap: null,
                        fill: p
                    }));
                    this.elSeries.add(x);
                }
                if (o.config.stroke.show && !this.pointsChart) {
                    var b = null;
                    if ("line" === i) b = l.fillPath({
                        seriesNumber: a,
                        i: s
                    });
                    else if ("solid" === o.config.stroke.fill.type) b = o.globals.stroke.colors[a];
                    else {
                        var v = o.config.fill;
                        o.config.fill = o.config.stroke.fill, b = l.fillPath({
                            seriesNumber: a,
                            i: s
                        }), o.config.fill = v;
                    }
                    for(var y = 0; y < r.linePaths.length; y++){
                        var w = b;
                        "rangeArea" === i && (w = l.fillPath({
                            seriesNumber: a
                        }));
                        var k = $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, u), {}, {
                            pathFrom: r.pathFromLine,
                            pathTo: r.linePaths[y],
                            stroke: b,
                            strokeWidth: this.strokeWidth,
                            strokeLineCap: o.config.stroke.lineCap,
                            fill: "rangeArea" === i ? w : "none"
                        }), A = n.renderPaths(k);
                        if (this.elSeries.add(A), A.attr("fill-rule", "evenodd"), h.count > 0 && "rangeArea" !== i) {
                            var S = n.renderPaths(k);
                            S.node.setAttribute("stroke-dasharray", h.dashArray), h.strokeWidth && S.node.setAttribute("stroke-width", h.strokeWidth), this.elSeries.add(S), S.attr("clip-path", "url(#forecastMask".concat(o.globals.cuid, ")")), A.attr("clip-path", "url(#nonForecastMask".concat(o.globals.cuid, ")"));
                        }
                    }
                }
            }
        },
        {
            key: "_iterateOverDataPoints",
            value: function(t) {
                var e = t.type, i = t.series, a = t.iterations, s = t.realIndex, r = t.i, o = t.x, n = t.y, l = t.pX, h = t.pY, c = t.pathsFrom, d = t.linePaths, g = t.areaPaths, u = t.seriesIndex, p = t.lineYPosition, f = t.xArrj, b = t.yArrj, v = t.y2Arrj, y = t.isRangeStart, w = t.seriesRangeEnd, k = this.w, A = new $d4be73e5731103af$var$m(this.ctx), S = this.yRatio, C = c.prevY, L = c.linePath, P = c.areaPath, I = c.pathFromLine, T = c.pathFromArea, M = $d4be73e5731103af$var$x.isNumber(k.globals.minYArr[s]) ? k.globals.minYArr[s] : k.globals.minY;
                a || (a = k.globals.dataPoints > 1 ? k.globals.dataPoints - 1 : k.globals.dataPoints);
                for(var X = n, z = 0; z < a; z++){
                    var E = void 0 === i[r][z + 1] || null === i[r][z + 1];
                    if (k.globals.isXNumeric) {
                        var Y = k.globals.seriesX[s][z + 1];
                        void 0 === k.globals.seriesX[s][z + 1] && (Y = k.globals.seriesX[s][a - 1]), o = (Y - k.globals.minX) / this.xRatio;
                    } else o += this.xDivision;
                    if (k.config.chart.stacked) {
                        if (r > 0 && k.globals.collapsedSeries.length < k.config.series.length - 1) p = this.prevSeriesY[function(t) {
                            for(var e = t, i = 0; i < k.globals.series.length; i++)if (k.globals.collapsedSeriesIndices.indexOf(t) > -1) {
                                e--;
                                break;
                            }
                            return e >= 0 ? e : 0;
                        }(r - 1)][z + 1];
                        else p = this.zeroY;
                    } else p = this.zeroY;
                    E ? n = p - M / S[this.yaxisIndex] + 2 * (this.isReversed ? M / S[this.yaxisIndex] : 0) : (n = p - i[r][z + 1] / S[this.yaxisIndex] + 2 * (this.isReversed ? i[r][z + 1] / S[this.yaxisIndex] : 0), "rangeArea" === e && (X = p - w[r][z + 1] / S[this.yaxisIndex] + 2 * (this.isReversed ? w[r][z + 1] / S[this.yaxisIndex] : 0))), f.push(o), b.push(n), v.push(X);
                    var F = this.lineHelpers.calculatePoints({
                        series: i,
                        x: o,
                        y: n,
                        realIndex: s,
                        i: r,
                        j: z,
                        prevY: C
                    }), R = this._createPaths({
                        type: e,
                        series: i,
                        i: r,
                        realIndex: s,
                        j: z,
                        x: o,
                        y: n,
                        y2: X,
                        xArrj: f,
                        yArrj: b,
                        y2Arrj: v,
                        pX: l,
                        pY: h,
                        linePath: L,
                        areaPath: P,
                        linePaths: d,
                        areaPaths: g,
                        seriesIndex: u,
                        isRangeStart: y
                    });
                    g = R.areaPaths, d = R.linePaths, l = R.pX, h = R.pY, P = R.areaPath, L = R.linePath, !this.appendPathFrom || "monotoneCubic" === k.config.stroke.curve && "rangeArea" === e || (I += A.line(o, this.zeroY), T += A.line(o, this.zeroY)), this.handleNullDataPoints(i, F, r, z, s), this._handleMarkersAndLabels({
                        type: e,
                        pointsPos: F,
                        i: r,
                        j: z,
                        realIndex: s,
                        isRangeStart: y
                    });
                }
                return {
                    yArrj: b,
                    xArrj: f,
                    pathFromArea: T,
                    areaPaths: g,
                    pathFromLine: I,
                    linePaths: d,
                    linePath: L,
                    areaPath: P
                };
            }
        },
        {
            key: "_handleMarkersAndLabels",
            value: function(t) {
                var e = t.type, i = t.pointsPos, a = t.isRangeStart, s = t.i, r = t.j, o = t.realIndex, n = this.w, l = new $d4be73e5731103af$var$O(this.ctx);
                if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                    realIndex: o,
                    pointsPos: i,
                    zRatio: this.zRatio,
                    elParent: this.elPointsMain
                });
                else {
                    n.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                    var h = this.markers.plotChartMarkers(i, o, r + 1);
                    null !== h && this.elPointsMain.add(h);
                }
                var c = l.drawDataLabel({
                    type: e,
                    isRangeStart: a,
                    pos: i,
                    i: o,
                    j: r + 1
                });
                null !== c && this.elDataLabelsWrap.add(c);
            }
        },
        {
            key: "_createPaths",
            value: function(t) {
                var e = t.type, i = t.series, a = t.i, s = t.realIndex, r = t.j, o = t.x, n = t.y, l = t.xArrj, h = t.yArrj, c = t.y2, d = t.y2Arrj, g = t.pX, u = t.pY, p = t.linePath, f = t.areaPath, x = t.linePaths, b = t.areaPaths, v = t.seriesIndex, y = t.isRangeStart, w = this.w, k = new $d4be73e5731103af$var$m(this.ctx), A = w.config.stroke.curve, S = this.areaBottomY;
                if (Array.isArray(w.config.stroke.curve) && (A = Array.isArray(v) ? w.config.stroke.curve[v[a]] : w.config.stroke.curve[a]), ("rangeArea" === e && (w.globals.hasNullValues || w.config.forecastDataPoints.count > 0) || w.globals.hasNullValues) && "monotoneCubic" === A && (A = "straight"), "smooth" === A) {
                    var C = .35 * (o - g);
                    w.globals.hasNullValues ? (null !== i[a][r] && (null !== i[a][r + 1] ? (p = k.move(g, u) + k.curve(g + C, u, o - C, n, o + 1, n), f = k.move(g + 1, u) + k.curve(g + C, u, o - C, n, o + 1, n) + k.line(o, S) + k.line(g, S) + "z") : (p = k.move(g, u), f = k.move(g, u) + "z")), x.push(p), b.push(f)) : (p += k.curve(g + C, u, o - C, n, o, n), f += k.curve(g + C, u, o - C, n, o, n)), g = o, u = n, r === i[a].length - 2 && (f += k.curve(g, u, o, n, o, S) + k.move(o, n) + "z", "rangeArea" === e && y ? p += k.curve(g, u, o, n, o, c) + k.move(o, c) + "z" : w.globals.hasNullValues || (x.push(p), b.push(f)));
                } else if ("monotoneCubic" === A) {
                    if ("rangeArea" === e ? l.length === w.globals.dataPoints : r === i[a].length - 2) {
                        var L = l.map(function(t, e) {
                            return [
                                l[e],
                                h[e]
                            ];
                        }), P = $d4be73e5731103af$var$Et(L);
                        if (p += $d4be73e5731103af$var$zt(P), f += $d4be73e5731103af$var$zt(P), g = o, u = n, "rangeArea" === e && y) {
                            p += k.line(l[l.length - 1], d[d.length - 1]);
                            var I = l.slice().reverse(), T = d.slice().reverse(), M = I.map(function(t, e) {
                                return [
                                    I[e],
                                    T[e]
                                ];
                            }), X = $d4be73e5731103af$var$Et(M);
                            f = p += $d4be73e5731103af$var$zt(X);
                        } else f += k.curve(g, u, o, n, o, S) + k.move(o, n) + "z";
                        x.push(p), b.push(f);
                    }
                } else {
                    if (null === i[a][r + 1]) {
                        p += k.move(o, n);
                        var z = w.globals.isXNumeric ? (w.globals.seriesX[s][r] - w.globals.minX) / this.xRatio : o - this.xDivision;
                        f = f + k.line(z, S) + k.move(o, n) + "z";
                    }
                    null === i[a][r] && (p += k.move(o, n), f += k.move(o, S)), "stepline" === A ? (p = p + k.line(o, null, "H") + k.line(null, n, "V"), f = f + k.line(o, null, "H") + k.line(null, n, "V")) : "straight" === A && (p += k.line(o, n), f += k.line(o, n)), r === i[a].length - 2 && (f = f + k.line(o, S) + k.move(o, n) + "z", "rangeArea" === e && y ? p = p + k.line(o, c) + k.move(o, c) + "z" : (x.push(p), b.push(f)));
                }
                return {
                    linePaths: x,
                    areaPaths: b,
                    pX: g,
                    pY: u,
                    linePath: p,
                    areaPath: f
                };
            }
        },
        {
            key: "handleNullDataPoints",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (null === t[i][a] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                    var o = this.markers.plotChartMarkers(e, s, a + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                    null !== o && this.elPointsMain.add(o);
                }
            }
        }
    ]), t;
}();
window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
    function t(e, i, a, s) {
        this.xoffset = e, this.yoffset = i, this.height = s, this.width = a, this.shortestEdge = function() {
            return Math.min(this.height, this.width);
        }, this.getCoordinates = function(t) {
            var e, i = [], a = this.xoffset, s = this.yoffset, o = r(t) / this.height, n = r(t) / this.width;
            if (this.width >= this.height) for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + o,
                s + t[e] / o
            ]), s += t[e] / o;
            else for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + t[e] / n,
                s + n
            ]), a += t[e] / n;
            return i;
        }, this.cutArea = function(e) {
            var i;
            if (this.width >= this.height) {
                var a = e / this.height, s = this.width - a;
                i = new t(this.xoffset + a, this.yoffset, s, this.height);
            } else {
                var r = e / this.width, o = this.height - r;
                i = new t(this.xoffset, this.yoffset + r, this.width, o);
            }
            return i;
        };
    }
    function e(e, a, s, o, n) {
        o = void 0 === o ? 0 : o, n = void 0 === n ? 0 : n;
        var l = i(function(t, e) {
            var i, a = [], s = e / r(t);
            for(i = 0; i < t.length; i++)a[i] = t[i] * s;
            return a;
        }(e, a * s), [], new t(o, n, a, s), []);
        return function(t) {
            var e, i, a = [];
            for(e = 0; e < t.length; e++)for(i = 0; i < t[e].length; i++)a.push(t[e][i]);
            return a;
        }(l);
    }
    function i(t, e, s, o) {
        var n, l, h;
        if (0 !== t.length) return n = s.shortestEdge(), function(t, e, i) {
            var s;
            if (0 === t.length) return !0;
            (s = t.slice()).push(e);
            var r = a(t, i), o = a(s, i);
            return r >= o;
        }(e, l = t[0], n) ? (e.push(l), i(t.slice(1), e, s, o)) : (h = s.cutArea(r(e), o), o.push(s.getCoordinates(e)), i(t, [], h, o)), o;
        o.push(s.getCoordinates(e));
    }
    function a(t, e) {
        var i = Math.min.apply(Math, t), a = Math.max.apply(Math, t), s = r(t);
        return Math.max(Math.pow(e, 2) * a / Math.pow(s, 2), Math.pow(s, 2) / (Math.pow(e, 2) * i));
    }
    function s(t) {
        return t && t.constructor === Array;
    }
    function r(t) {
        var e, i = 0;
        for(e = 0; e < t.length; e++)i += t[e];
        return i;
    }
    function o(t) {
        var e, i = 0;
        if (s(t[0])) for(e = 0; e < t.length; e++)i += o(t[e]);
        else i = r(t);
        return i;
    }
    return function t(i, a, r, n, l) {
        n = void 0 === n ? 0 : n, l = void 0 === l ? 0 : l;
        var h, c, d = [], g = [];
        if (s(i[0])) {
            for(c = 0; c < i.length; c++)d[c] = o(i[c]);
            for(h = e(d, a, r, n, l), c = 0; c < i.length; c++)g.push(t(i[c], h[c][2] - h[c][0], h[c][3] - h[c][1], h[c][0], h[c][1]));
        } else g = e(i, a, r, n, l);
        return g;
    };
}();
var $d4be73e5731103af$var$Rt, $d4be73e5731103af$var$Ht, $d4be73e5731103af$var$Dt = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new $d4be73e5731103af$var$At(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $d4be73e5731103af$var$m(this.ctx), s = new $d4be73e5731103af$var$R(this.ctx), r = a.group({
                    class: "apexcharts-treemap"
                });
                if (i.globals.noData) return r;
                var o = [];
                return t.forEach(function(t) {
                    var e = t.map(function(t) {
                        return Math.abs(t);
                    });
                    o.push(e);
                }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(t, i) {
                    t.data.forEach(function(t) {
                        Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x);
                    });
                }), window.TreemapSquared.generate(o, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, n) {
                    var l = a.group({
                        class: "apexcharts-series apexcharts-treemap-series",
                        seriesName: $d4be73e5731103af$var$x.escapeString(i.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    if (i.config.chart.dropShadow.enabled) {
                        var h = i.config.chart.dropShadow;
                        new $d4be73e5731103af$var$v(e.ctx).dropShadow(r, h, n);
                    }
                    var c = a.group({
                        class: "apexcharts-data-labels"
                    });
                    o.forEach(function(r, o) {
                        var h = r[0], c = r[1], d = r[2], g = r[3], u = a.drawRect(h, c, d - h, g - c, 0, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? f : i.globals.stroke.colors[n]);
                        u.attr({
                            cx: h,
                            cy: c,
                            index: n,
                            i: n,
                            j: o,
                            width: d - h,
                            height: g - c
                        });
                        var p = e.helpers.getShadeColor(i.config.chart.type, n, o, e.negRange), f = p.color;
                        void 0 !== i.config.series[n].data[o] && i.config.series[n].data[o].fillColor && (f = i.config.series[n].data[o].fillColor);
                        var x = s.fillPath({
                            color: f,
                            seriesNumber: n,
                            dataPointIndex: o
                        });
                        u.node.classList.add("apexcharts-treemap-rect"), u.attr({
                            fill: x
                        }), e.helpers.addListeners(u);
                        var b = {
                            x: h + (d - h) / 2,
                            y: c + (g - c) / 2,
                            width: 0,
                            height: 0
                        }, v = {
                            x: h,
                            y: c,
                            width: d - h,
                            height: g - c
                        };
                        if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                            var m = 1;
                            i.globals.resized || (m = i.config.chart.animations.speed), e.animateTreemap(u, b, v, m);
                        }
                        if (i.globals.dataChanged) {
                            var y = 1;
                            e.dynamicAnim.enabled && i.globals.shouldAnimate && (y = e.dynamicAnim.speed, i.globals.previousPaths[n] && i.globals.previousPaths[n][o] && i.globals.previousPaths[n][o].rect && (b = i.globals.previousPaths[n][o].rect), e.animateTreemap(u, b, v, y));
                        }
                        var w = e.getFontSize(r), k = i.config.dataLabels.formatter(e.labels[n][o], {
                            value: i.globals.series[n][o],
                            seriesIndex: n,
                            dataPointIndex: o,
                            w: i
                        });
                        "truncate" === i.config.plotOptions.treemap.dataLabels.format && (w = parseInt(i.config.dataLabels.style.fontSize, 10), k = e.truncateLabels(k, w, h, c, d, g));
                        var A = e.helpers.calculateDataLabels({
                            text: k,
                            x: (h + d) / 2,
                            y: (c + g) / 2 + e.strokeWidth / 2 + w / 3,
                            i: n,
                            j: o,
                            colorProps: p,
                            fontSize: w,
                            series: t
                        });
                        i.config.dataLabels.enabled && A && e.rotateToFitLabel(A, w, k, h, c, d, g), l.add(u), null !== A && l.add(A);
                    }), l.add(c), r.add(l);
                }), r;
            }
        },
        {
            key: "getFontSize",
            value: function(t) {
                var e = this.w;
                var i, a, s, r, o = function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += e[i].length;
                    return a;
                }(this.labels) / function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += 1;
                    return a;
                }(this.labels);
                return i = t[2] - t[0], a = t[3] - t[1], s = i * a, r = Math.pow(s, .5), Math.min(r / o, parseInt(e.config.dataLabels.style.fontSize, 10));
            }
        },
        {
            key: "rotateToFitLabel",
            value: function(t, e, i, a, s, r, o) {
                var n = new $d4be73e5731103af$var$m(this.ctx), l = n.getTextRects(i, e);
                if (l.width + this.w.config.stroke.width + 5 > r - a && l.width <= o - s) {
                    var h = n.rotateAroundCenter(t.node);
                    t.node.setAttribute("transform", "rotate(-90 ".concat(h.x, " ").concat(h.y, ") translate(").concat(l.height / 3, ")"));
                }
            }
        },
        {
            key: "truncateLabels",
            value: function(t, e, i, a, s, r) {
                var o = new $d4be73e5731103af$var$m(this.ctx), n = o.getTextRects(t, e).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, l = o.getTextBasedOnMaxWidth({
                    text: t,
                    maxWidth: n,
                    fontSize: e
                });
                return t.length !== l.length && n / e < 5 ? "" : l;
            }
        },
        {
            key: "animateTreemap",
            value: function(t, e, i, a) {
                var s = new $d4be73e5731103af$var$b(this.ctx);
                s.animateRect(t, {
                    x: e.x,
                    y: e.y,
                    width: e.width,
                    height: e.height
                }, {
                    x: i.x,
                    y: i.y,
                    width: i.width,
                    height: i.height
                }, a, function() {
                    s.animationCompleted(t);
                });
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Ot = 86400, $d4be73e5731103af$var$Nt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "calculateTimeScaleTicks",
            value: function(t, i) {
                var a = this, s = this.w;
                if (s.globals.allSeriesCollapsed) return s.globals.labels = [], s.globals.timescaleLabels = [], [];
                var r = new $d4be73e5731103af$var$I(this.ctx), o = (i - t) / 864e5;
                this.determineInterval(o), s.globals.disableZoomIn = !1, s.globals.disableZoomOut = !1, o < .00011574074074074075 ? s.globals.disableZoomIn = !0 : o > 5e4 && (s.globals.disableZoomOut = !0);
                var n = r.getTimeUnitsfromTimestamp(t, i, this.utc), l = s.globals.gridWidth / o, h = l / 24, c = h / 60, d = c / 60, g = Math.floor(24 * o), u = Math.floor(1440 * o), p = Math.floor(o * $d4be73e5731103af$var$Ot), f = Math.floor(o), x = Math.floor(o / 30), b = Math.floor(o / 365), v = {
                    minMillisecond: n.minMillisecond,
                    minSecond: n.minSecond,
                    minMinute: n.minMinute,
                    minHour: n.minHour,
                    minDate: n.minDate,
                    minMonth: n.minMonth,
                    minYear: n.minYear
                }, m = {
                    firstVal: v,
                    currentMillisecond: v.minMillisecond,
                    currentSecond: v.minSecond,
                    currentMinute: v.minMinute,
                    currentHour: v.minHour,
                    currentMonthDate: v.minDate,
                    currentDate: v.minDate,
                    currentMonth: v.minMonth,
                    currentYear: v.minYear,
                    daysWidthOnXAxis: l,
                    hoursWidthOnXAxis: h,
                    minutesWidthOnXAxis: c,
                    secondsWidthOnXAxis: d,
                    numberOfSeconds: p,
                    numberOfMinutes: u,
                    numberOfHours: g,
                    numberOfDays: f,
                    numberOfMonths: x,
                    numberOfYears: b
                };
                switch(this.tickInterval){
                    case "years":
                        this.generateYearScale(m);
                        break;
                    case "months":
                    case "half_year":
                        this.generateMonthScale(m);
                        break;
                    case "months_days":
                    case "months_fortnight":
                    case "days":
                    case "week_days":
                        this.generateDayScale(m);
                        break;
                    case "hours":
                        this.generateHourScale(m);
                        break;
                    case "minutes_fives":
                    case "minutes":
                        this.generateMinuteScale(m);
                        break;
                    case "seconds_tens":
                    case "seconds_fives":
                    case "seconds":
                        this.generateSecondScale(m);
                }
                var y = this.timeScaleArray.map(function(t) {
                    var i = {
                        position: t.position,
                        unit: t.unit,
                        year: t.year,
                        day: t.day ? t.day : 1,
                        hour: t.hour ? t.hour : 0,
                        month: t.month + 1
                    };
                    return "month" === t.unit ? $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, i), {}, {
                        day: 1,
                        value: t.value + 1
                    }) : "day" === t.unit || "hour" === t.unit ? $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, i), {}, {
                        value: t.value
                    }) : "minute" === t.unit ? $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, i), {}, {
                        value: t.value,
                        minute: t.value
                    }) : "second" === t.unit ? $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, i), {}, {
                        value: t.value,
                        minute: t.minute,
                        second: t.second
                    }) : t;
                });
                return y.filter(function(t) {
                    var e = 1, i = Math.ceil(s.globals.gridWidth / 120), r = t.value;
                    void 0 !== s.config.xaxis.tickAmount && (i = s.config.xaxis.tickAmount), y.length > i && (e = Math.floor(y.length / i));
                    var o = !1, n = !1;
                    switch(a.tickInterval){
                        case "years":
                            "year" === t.unit && (o = !0);
                            break;
                        case "half_year":
                            e = 7, "year" === t.unit && (o = !0);
                            break;
                        case "months":
                            e = 1, "year" === t.unit && (o = !0);
                            break;
                        case "months_fortnight":
                            e = 15, "year" !== t.unit && "month" !== t.unit || (o = !0), 30 === r && (n = !0);
                            break;
                        case "months_days":
                            e = 10, "month" === t.unit && (o = !0), 30 === r && (n = !0);
                            break;
                        case "week_days":
                            e = 8, "month" === t.unit && (o = !0);
                            break;
                        case "days":
                            e = 1, "month" === t.unit && (o = !0);
                            break;
                        case "hours":
                            "day" === t.unit && (o = !0);
                            break;
                        case "minutes_fives":
                        case "seconds_fives":
                            r % 5 != 0 && (n = !0);
                            break;
                        case "seconds_tens":
                            r % 10 != 0 && (n = !0);
                    }
                    if ("hours" === a.tickInterval || "minutes_fives" === a.tickInterval || "seconds_tens" === a.tickInterval || "seconds_fives" === a.tickInterval) {
                        if (!n) return !0;
                    } else if ((r % e == 0 || o) && !n) return !0;
                });
            }
        },
        {
            key: "recalcDimensionsBasedOnFormat",
            value: function(t, e) {
                var i = this.w, a = this.formatDates(t), s = this.removeOverlappingTS(a);
                i.globals.timescaleLabels = s.slice(), new $d4be73e5731103af$var$ot(this.ctx).plotCoords();
            }
        },
        {
            key: "determineInterval",
            value: function(t) {
                var e = 24 * t, i = 60 * e;
                switch(!0){
                    case t / 365 > 5:
                        this.tickInterval = "years";
                        break;
                    case t > 800:
                        this.tickInterval = "half_year";
                        break;
                    case t > 180:
                        this.tickInterval = "months";
                        break;
                    case t > 90:
                        this.tickInterval = "months_fortnight";
                        break;
                    case t > 60:
                        this.tickInterval = "months_days";
                        break;
                    case t > 30:
                        this.tickInterval = "week_days";
                        break;
                    case t > 2:
                        this.tickInterval = "days";
                        break;
                    case e > 2.4:
                        this.tickInterval = "hours";
                        break;
                    case i > 15:
                        this.tickInterval = "minutes_fives";
                        break;
                    case i > 5:
                        this.tickInterval = "minutes";
                        break;
                    case i > 1:
                        this.tickInterval = "seconds_tens";
                        break;
                    case 60 * i > 20:
                        this.tickInterval = "seconds_fives";
                        break;
                    default:
                        this.tickInterval = "seconds";
                }
            }
        },
        {
            key: "generateYearScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.daysWidthOnXAxis, r = t.numberOfYears, o = e.minYear, n = 0, l = new $d4be73e5731103af$var$I(this.ctx), h = "year";
                if (e.minDate > 1 || e.minMonth > 0) {
                    var c = l.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                    n = (l.determineDaysOfYear(e.minYear) - c + 1) * s, o = e.minYear + 1, this.timeScaleArray.push({
                        position: n,
                        value: o,
                        unit: h,
                        year: o,
                        month: $d4be73e5731103af$var$x.monthMod(i + 1)
                    });
                } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                    position: n,
                    value: o,
                    unit: h,
                    year: a,
                    month: $d4be73e5731103af$var$x.monthMod(i + 1)
                });
                for(var d = o, g = n, u = 0; u < r; u++)d++, g = l.determineDaysOfYear(d - 1) * s + g, this.timeScaleArray.push({
                    position: g,
                    value: d,
                    unit: h,
                    year: d,
                    month: 1
                });
            }
        },
        {
            key: "generateMonthScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonthDate, a = t.currentMonth, s = t.currentYear, r = t.daysWidthOnXAxis, o = t.numberOfMonths, n = a, l = 0, h = new $d4be73e5731103af$var$I(this.ctx), c = "month", d = 0;
                if (e.minDate > 1) {
                    l = (h.determineDaysOfMonths(a + 1, e.minYear) - i + 1) * r, n = $d4be73e5731103af$var$x.monthMod(a + 1);
                    var g = s + d, u = $d4be73e5731103af$var$x.monthMod(n), p = n;
                    0 === n && (c = "year", p = g, u = 1, g += d += 1), this.timeScaleArray.push({
                        position: l,
                        value: p,
                        unit: c,
                        year: g,
                        month: u
                    });
                } else this.timeScaleArray.push({
                    position: l,
                    value: n,
                    unit: c,
                    year: s,
                    month: $d4be73e5731103af$var$x.monthMod(a)
                });
                for(var f = n + 1, b = l, v = 0, m = 1; v < o; v++, m++){
                    0 === (f = $d4be73e5731103af$var$x.monthMod(f)) ? (c = "year", d += 1) : c = "month";
                    var y = this._getYear(s, f, d);
                    b = h.determineDaysOfMonths(f, y) * r + b;
                    var w = 0 === f ? y : f;
                    this.timeScaleArray.push({
                        position: b,
                        value: w,
                        unit: c,
                        year: y,
                        month: 0 === f ? 1 : f
                    }), f++;
                }
            }
        },
        {
            key: "generateDayScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.hoursWidthOnXAxis, r = t.numberOfDays, o = new $d4be73e5731103af$var$I(this.ctx), n = "day", l = e.minDate + 1, h = l, c = function(t, e, i) {
                    return t > o.determineDaysOfMonths(e + 1, i) ? (h = 1, n = "month", g = e += 1, e) : e;
                }, d = (24 - e.minHour) * s, g = l, u = c(h, i, a);
                0 === e.minHour && 1 === e.minDate ? (d = 0, g = $d4be73e5731103af$var$x.monthMod(e.minMonth), n = "month", h = e.minDate, r++) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (d = 0, l = e.minDate, g = l, u = c(h = l, i, a)), this.timeScaleArray.push({
                    position: d,
                    value: g,
                    unit: n,
                    year: this._getYear(a, u, 0),
                    month: $d4be73e5731103af$var$x.monthMod(u),
                    day: h
                });
                for(var p = d, f = 0; f < r; f++){
                    n = "day", u = c(h += 1, u, this._getYear(a, u, 0));
                    var b = this._getYear(a, u, 0);
                    p = 24 * s + p;
                    var v = 1 === h ? $d4be73e5731103af$var$x.monthMod(u) : h;
                    this.timeScaleArray.push({
                        position: p,
                        value: v,
                        unit: n,
                        year: b,
                        month: $d4be73e5731103af$var$x.monthMod(u),
                        day: v
                    });
                }
            }
        },
        {
            key: "generateHourScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentDate, a = t.currentMonth, s = t.currentYear, r = t.minutesWidthOnXAxis, o = t.numberOfHours, n = new $d4be73e5731103af$var$I(this.ctx), l = "hour", h = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) && (f = 1, e += 1), {
                        month: e,
                        date: f
                    };
                }, c = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) ? e += 1 : e;
                }, d = 60 - (e.minMinute + e.minSecond / 60), g = d * r, u = e.minHour + 1, p = u + 1;
                60 === d && (g = 0, p = (u = e.minHour) + 1);
                var f = i, b = c(f, a);
                this.timeScaleArray.push({
                    position: g,
                    value: u,
                    unit: l,
                    day: f,
                    hour: p,
                    year: s,
                    month: $d4be73e5731103af$var$x.monthMod(b)
                });
                for(var v = g, m = 0; m < o; m++){
                    if (l = "hour", p >= 24) p = 0, l = "day", b = h(f += 1, b).month, b = c(f, b);
                    var y = this._getYear(s, b, 0);
                    v = 60 * r + v;
                    var w = 0 === p ? f : p;
                    this.timeScaleArray.push({
                        position: v,
                        value: w,
                        unit: l,
                        hour: p,
                        day: f,
                        year: y,
                        month: $d4be73e5731103af$var$x.monthMod(b)
                    }), p++;
                }
            }
        },
        {
            key: "generateMinuteScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.minutesWidthOnXAxis, h = t.secondsWidthOnXAxis, c = t.numberOfMinutes, d = a + 1, g = r, u = o, p = n, f = s, b = (60 - i - e / 1e3) * h, v = 0; v < c; v++)d >= 60 && (d = 0, 24 === (f += 1) && (f = 0)), this.timeScaleArray.push({
                    position: b,
                    value: d,
                    unit: "minute",
                    hour: f,
                    minute: d,
                    day: g,
                    year: this._getYear(p, u, 0),
                    month: $d4be73e5731103af$var$x.monthMod(u)
                }), b += l, d++;
            }
        },
        {
            key: "generateSecondScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.secondsWidthOnXAxis, h = t.numberOfSeconds, c = i + 1, d = a, g = r, u = o, p = n, f = s, b = (1e3 - e) / 1e3 * l, v = 0; v < h; v++)c >= 60 && (c = 0, ++d >= 60 && (d = 0, 24 === ++f && (f = 0))), this.timeScaleArray.push({
                    position: b,
                    value: c,
                    unit: "second",
                    hour: f,
                    minute: d,
                    second: c,
                    day: g,
                    year: this._getYear(p, u, 0),
                    month: $d4be73e5731103af$var$x.monthMod(u)
                }), b += l, c++;
            }
        },
        {
            key: "createRawDateString",
            value: function(t, e) {
                var i = t.year;
                return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
            }
        },
        {
            key: "formatDates",
            value: function(t) {
                var e = this, i = this.w;
                return t.map(function(t) {
                    var a = t.value.toString(), s = new $d4be73e5731103af$var$I(e.ctx), r = e.createRawDateString(t, a), o = s.getDate(s.parseDate(r));
                    if (e.utc || (o = s.getDate(s.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                        var n = "dd MMM", l = i.config.xaxis.labels.datetimeFormatter;
                        "year" === t.unit && (n = l.year), "month" === t.unit && (n = l.month), "day" === t.unit && (n = l.day), "hour" === t.unit && (n = l.hour), "minute" === t.unit && (n = l.minute), "second" === t.unit && (n = l.second), a = s.formatDate(o, n);
                    } else a = s.formatDate(o, i.config.xaxis.labels.format);
                    return {
                        dateString: r,
                        position: t.position,
                        value: a,
                        unit: t.unit,
                        year: t.year,
                        month: t.month
                    };
                });
            }
        },
        {
            key: "removeOverlappingTS",
            value: function(t) {
                var e, i = this, a = new $d4be73e5731103af$var$m(this.ctx), s = !1;
                t.length > 0 && t[0].value && t.every(function(e) {
                    return e.value.length === t[0].value.length;
                }) && (s = !0, e = a.getTextRects(t[0].value).width);
                var r = 0, o = t.map(function(o, n) {
                    if (n > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                        var l = s ? e : a.getTextRects(t[r].value).width, h = t[r].position;
                        return o.position > h + l + 10 ? (r = n, o) : null;
                    }
                    return o;
                });
                return o = o.filter(function(t) {
                    return null !== t;
                });
            }
        },
        {
            key: "_getYear",
            value: function(t, e, i) {
                return t + Math.floor(e / 12) + i;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Wt = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.ctx = i, this.w = i.w, this.el = e;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "setupElements",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = e.chart.type;
                t.axisCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble",
                    "radar",
                    "heatmap",
                    "treemap"
                ].indexOf(i) > -1, t.xyCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble"
                ].indexOf(i) > -1, t.isBarHorizontal = ("bar" === e.chart.type || "rangeBar" === e.chart.type || "boxPlot" === e.chart.type) && e.plotOptions.bar.horizontal, t.chartClass = ".apexcharts" + t.chartID, t.dom.baseEl = this.el, t.dom.elWrap = document.createElement("div"), $d4be73e5731103af$var$m.setAttrs(t.dom.elWrap, {
                    id: t.chartClass.substring(1),
                    class: "apexcharts-canvas " + t.chartClass.substring(1)
                }), this.el.appendChild(t.dom.elWrap), t.dom.Paper = new window.SVG.Doc(t.dom.elWrap), t.dom.Paper.attr({
                    class: "apexcharts-svg",
                    "xmlns:data": "ApexChartsNS",
                    transform: "translate(".concat(e.chart.offsetX, ", ").concat(e.chart.offsetY, ")")
                }), t.dom.Paper.node.style.background = e.chart.background, this.setSVGDimensions(), t.dom.elLegendForeign = document.createElementNS(t.SVGNS, "foreignObject"), $d4be73e5731103af$var$m.setAttrs(t.dom.elLegendForeign, {
                    x: 0,
                    y: 0,
                    width: t.svgWidth,
                    height: t.svgHeight
                }), t.dom.elLegendWrap = document.createElement("div"), t.dom.elLegendWrap.classList.add("apexcharts-legend"), t.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), t.dom.elLegendForeign.appendChild(t.dom.elLegendWrap), t.dom.Paper.node.appendChild(t.dom.elLegendForeign), t.dom.elGraphical = t.dom.Paper.group().attr({
                    class: "apexcharts-inner apexcharts-graphical"
                }), t.dom.elDefs = t.dom.Paper.defs(), t.dom.Paper.add(t.dom.elGraphical), t.dom.elGraphical.add(t.dom.elDefs);
            }
        },
        {
            key: "plotChartType",
            value: function(t, e) {
                var i = this.w, a = i.config, s = i.globals, r = {
                    series: [],
                    i: []
                }, o = {
                    series: [],
                    i: []
                }, n = {
                    series: [],
                    i: []
                }, l = {
                    series: [],
                    i: []
                }, h = {
                    series: [],
                    i: []
                }, c = {
                    series: [],
                    i: []
                }, d = {
                    series: [],
                    i: []
                }, g = {
                    series: [],
                    i: []
                }, u = {
                    series: [],
                    seriesRangeEnd: [],
                    i: []
                };
                s.series.map(function(e, p) {
                    var f = 0;
                    void 0 !== t[p].type ? ("column" === t[p].type || "bar" === t[p].type ? (s.series.length > 1 && a.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), h.series.push(e), h.i.push(p), f++, i.globals.columnSeries = h.series) : "area" === t[p].type ? (o.series.push(e), o.i.push(p), f++) : "line" === t[p].type ? (r.series.push(e), r.i.push(p), f++) : "scatter" === t[p].type ? (n.series.push(e), n.i.push(p)) : "bubble" === t[p].type ? (l.series.push(e), l.i.push(p), f++) : "candlestick" === t[p].type ? (c.series.push(e), c.i.push(p), f++) : "boxPlot" === t[p].type ? (d.series.push(e), d.i.push(p), f++) : "rangeBar" === t[p].type ? (g.series.push(e), g.i.push(p), f++) : "rangeArea" === t[p].type ? (u.series.push(s.seriesRangeStart[p]), u.seriesRangeEnd.push(s.seriesRangeEnd[p]), u.i.push(p), f++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble/candlestick/boxPlot/rangeBar/rangeArea"), f > 1 && (s.comboCharts = !0)) : (r.series.push(e), r.i.push(p));
                });
                var p = new $d4be73e5731103af$var$Ft(this.ctx, e), f = new $d4be73e5731103af$var$kt(this.ctx, e);
                this.ctx.pie = new $d4be73e5731103af$var$Lt(this.ctx);
                var x = new $d4be73e5731103af$var$It(this.ctx);
                this.ctx.rangeBar = new $d4be73e5731103af$var$Tt(this.ctx, e);
                var b = new $d4be73e5731103af$var$Pt(this.ctx), v = [];
                if (s.comboCharts) {
                    if (o.series.length > 0 && v.push(p.draw(o.series, "area", o.i)), h.series.length > 0) {
                        if (i.config.chart.stacked) {
                            var m = new $d4be73e5731103af$var$wt(this.ctx, e);
                            v.push(m.draw(h.series, h.i));
                        } else this.ctx.bar = new $d4be73e5731103af$var$yt(this.ctx, e), v.push(this.ctx.bar.draw(h.series, h.i));
                    }
                    if (u.series.length > 0 && v.push(p.draw(u.series, "rangeArea", u.i, u.seriesRangeEnd)), r.series.length > 0 && v.push(p.draw(r.series, "line", r.i)), c.series.length > 0 && v.push(f.draw(c.series, "candlestick", c.i)), d.series.length > 0 && v.push(f.draw(d.series, "boxPlot", d.i)), g.series.length > 0 && v.push(this.ctx.rangeBar.draw(g.series, g.i)), n.series.length > 0) {
                        var y = new $d4be73e5731103af$var$Ft(this.ctx, e, !0);
                        v.push(y.draw(n.series, "scatter", n.i));
                    }
                    if (l.series.length > 0) {
                        var w = new $d4be73e5731103af$var$Ft(this.ctx, e, !0);
                        v.push(w.draw(l.series, "bubble", l.i));
                    }
                } else switch(a.chart.type){
                    case "line":
                        v = p.draw(s.series, "line");
                        break;
                    case "area":
                        v = p.draw(s.series, "area");
                        break;
                    case "bar":
                        if (a.chart.stacked) v = new $d4be73e5731103af$var$wt(this.ctx, e).draw(s.series);
                        else this.ctx.bar = new $d4be73e5731103af$var$yt(this.ctx, e), v = this.ctx.bar.draw(s.series);
                        break;
                    case "candlestick":
                        v = new $d4be73e5731103af$var$kt(this.ctx, e).draw(s.series, "candlestick");
                        break;
                    case "boxPlot":
                        v = new $d4be73e5731103af$var$kt(this.ctx, e).draw(s.series, a.chart.type);
                        break;
                    case "rangeBar":
                        v = this.ctx.rangeBar.draw(s.series);
                        break;
                    case "rangeArea":
                        v = p.draw(s.seriesRangeStart, "rangeArea", void 0, s.seriesRangeEnd);
                        break;
                    case "heatmap":
                        v = new $d4be73e5731103af$var$St(this.ctx, e).draw(s.series);
                        break;
                    case "treemap":
                        v = new $d4be73e5731103af$var$Dt(this.ctx, e).draw(s.series);
                        break;
                    case "pie":
                    case "donut":
                    case "polarArea":
                        v = this.ctx.pie.draw(s.series);
                        break;
                    case "radialBar":
                        v = x.draw(s.series);
                        break;
                    case "radar":
                        v = b.draw(s.series);
                        break;
                    default:
                        v = p.draw(s.series);
                }
                return v;
            }
        },
        {
            key: "setSVGDimensions",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.svgWidth = e.chart.width, t.svgHeight = e.chart.height;
                var i = $d4be73e5731103af$var$x.getDimensions(this.el), a = e.chart.width.toString().split(/[0-9]+/g).pop();
                "%" === a ? $d4be73e5731103af$var$x.isNumber(i[0]) && (0 === i[0].width && (i = $d4be73e5731103af$var$x.getDimensions(this.el.parentNode)), t.svgWidth = i[0] * parseInt(e.chart.width, 10) / 100) : "px" !== a && "" !== a || (t.svgWidth = parseInt(e.chart.width, 10));
                var s = e.chart.height.toString().split(/[0-9]+/g).pop();
                if ("auto" !== t.svgHeight && "" !== t.svgHeight) {
                    if ("%" === s) {
                        var r = $d4be73e5731103af$var$x.getDimensions(this.el.parentNode);
                        t.svgHeight = r[1] * parseInt(e.chart.height, 10) / 100;
                    } else t.svgHeight = parseInt(e.chart.height, 10);
                } else t.axisCharts ? t.svgHeight = t.svgWidth / 1.61 : t.svgHeight = t.svgWidth / 1.2;
                if (t.svgWidth < 0 && (t.svgWidth = 0), t.svgHeight < 0 && (t.svgHeight = 0), $d4be73e5731103af$var$m.setAttrs(t.dom.Paper.node, {
                    width: t.svgWidth,
                    height: t.svgHeight
                }), "%" !== s) {
                    var o = e.chart.sparkline.enabled ? 0 : t.axisCharts ? e.chart.parentHeightOffset : 0;
                    t.dom.Paper.node.parentNode.parentNode.style.minHeight = t.svgHeight + o + "px";
                }
                t.dom.elWrap.style.width = t.svgWidth + "px", t.dom.elWrap.style.height = t.svgHeight + "px";
            }
        },
        {
            key: "shiftGraphPosition",
            value: function() {
                var t = this.w.globals, e = t.translateY, i = {
                    transform: "translate(" + t.translateX + ", " + e + ")"
                };
                $d4be73e5731103af$var$m.setAttrs(t.dom.elGraphical.node, i);
            }
        },
        {
            key: "resizeNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = 0, a = t.config.chart.sparkline.enabled ? 1 : 15;
                a += t.config.grid.padding.bottom, "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || !t.config.legend.show || t.config.legend.floating || (i = new $d4be73e5731103af$var$lt(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                var s = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * t.globals.radialSize;
                if (s && !t.config.chart.sparkline.enabled && 0 !== t.config.plotOptions.radialBar.startAngle) {
                    var o = $d4be73e5731103af$var$x.getBoundingClientRect(s);
                    r = o.bottom;
                    var n = o.bottom - o.top;
                    r = Math.max(2.05 * t.globals.radialSize, n);
                }
                var l = r + e.translateY + i + a;
                e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", l), t.config.chart.height && String(t.config.chart.height).indexOf("%") > 0 || (e.dom.elWrap.style.height = l + "px", $d4be73e5731103af$var$m.setAttrs(e.dom.Paper.node, {
                    height: l
                }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = l + "px");
            }
        },
        {
            key: "coreCalculations",
            value: function() {
                new $d4be73e5731103af$var$U(this.ctx).init();
            }
        },
        {
            key: "resetGlobals",
            value: function() {
                var t = this, e = function() {
                    return t.w.config.series.map(function(t) {
                        return [];
                    });
                }, i = new $d4be73e5731103af$var$Y, a = this.w.globals;
                i.initGlobalVars(a), a.seriesXvalues = e(), a.seriesYvalues = e();
            }
        },
        {
            key: "isMultipleY",
            value: function() {
                if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0;
            }
        },
        {
            key: "xySettings",
            value: function() {
                var t = null, e = this.w;
                if (e.globals.axisCharts) {
                    if ("back" === e.config.xaxis.crosshairs.position) new $d4be73e5731103af$var$Q(this.ctx).drawXCrosshairs();
                    if ("back" === e.config.yaxis[0].crosshairs.position) new $d4be73e5731103af$var$Q(this.ctx).drawYCrosshairs();
                    if ("datetime" === e.config.xaxis.type && void 0 === e.config.xaxis.labels.formatter) {
                        this.ctx.timeScale = new $d4be73e5731103af$var$Nt(this.ctx);
                        var i = [];
                        isFinite(e.globals.minX) && isFinite(e.globals.maxX) && !e.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX, e.globals.maxX) : e.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY, e.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                    }
                    t = new $d4be73e5731103af$var$y(this.ctx).getCalculatedRatios();
                }
                return t;
            }
        },
        {
            key: "updateSourceChart",
            value: function(t) {
                this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                    chart: {
                        selection: {
                            xaxis: {
                                min: t.w.globals.minX,
                                max: t.w.globals.maxX
                            }
                        }
                    }
                }, !1, !1);
            }
        },
        {
            key: "setupBrushHandler",
            value: function() {
                var t = this, i = this.w;
                if (i.config.chart.brush.enabled && "function" != typeof i.config.chart.events.selection) {
                    var a = Array.isArray(i.config.chart.brush.targets) || [
                        i.config.chart.brush.target
                    ];
                    a.forEach(function(e) {
                        var i = ApexCharts.getChartByID(e);
                        i.w.globals.brushSource = t.ctx, "function" != typeof i.w.config.chart.events.zoomed && (i.w.config.chart.events.zoomed = function() {
                            t.updateSourceChart(i);
                        }), "function" != typeof i.w.config.chart.events.scrolled && (i.w.config.chart.events.scrolled = function() {
                            t.updateSourceChart(i);
                        });
                    }), i.config.chart.events.selection = function(t, s) {
                        a.forEach(function(t) {
                            var a = ApexCharts.getChartByID(t), r = $d4be73e5731103af$var$x.clone(i.config.yaxis);
                            if (i.config.chart.brush.autoScaleYaxis && 1 === a.w.globals.series.length) {
                                var o = new $d4be73e5731103af$var$_(a);
                                r = o.autoScaleY(a, r, s);
                            }
                            var n = a.w.config.yaxis.reduce(function(t, i, s) {
                                return [].concat($d4be73e5731103af$var$u(t), [
                                    $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, a.w.config.yaxis[s]), {}, {
                                        min: r[0].min,
                                        max: r[0].max
                                    })
                                ]);
                            }, []);
                            a.ctx.updateHelpers._updateOptions({
                                xaxis: {
                                    min: s.xaxis.min,
                                    max: s.xaxis.max
                                },
                                yaxis: n
                            }, !1, !1, !1, !1);
                        });
                    };
                }
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Bt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "_updateOptions",
            value: function(t) {
                var e = this, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], s = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return new Promise(function(n) {
                    var l = [
                        e.ctx
                    ];
                    r && (l = e.ctx.getSyncedCharts()), e.ctx.w.globals.isExecCalled && (l = [
                        e.ctx
                    ], e.ctx.w.globals.isExecCalled = !1), l.forEach(function(r, h) {
                        var c = r.w;
                        if (c.globals.shouldAnimate = s, a || (c.globals.resized = !0, c.globals.dataChanged = !0, s && r.series.getPreviousPaths()), t && "object" === $d4be73e5731103af$var$i(t) && (r.config = new $d4be73e5731103af$var$E(t), t = $d4be73e5731103af$var$y.extendArrayProps(r.config, t, c), r.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, c.config = $d4be73e5731103af$var$x.extend(c.config, t), o && (c.globals.lastXAxis = t.xaxis ? $d4be73e5731103af$var$x.clone(t.xaxis) : [], c.globals.lastYAxis = t.yaxis ? $d4be73e5731103af$var$x.clone(t.yaxis) : [], c.globals.initialConfig = $d4be73e5731103af$var$x.extend({}, c.config), c.globals.initialSeries = $d4be73e5731103af$var$x.clone(c.config.series), t.series))) {
                            for(var d = 0; d < c.globals.collapsedSeriesIndices.length; d++){
                                var g = c.config.series[c.globals.collapsedSeriesIndices[d]];
                                c.globals.collapsedSeries[d].data = c.globals.axisCharts ? g.data.slice() : g;
                            }
                            for(var u = 0; u < c.globals.ancillaryCollapsedSeriesIndices.length; u++){
                                var p = c.config.series[c.globals.ancillaryCollapsedSeriesIndices[u]];
                                c.globals.ancillaryCollapsedSeries[u].data = c.globals.axisCharts ? p.data.slice() : p;
                            }
                            r.series.emptyCollapsedSeries(c.config.series);
                        }
                        return r.update(t).then(function() {
                            h === l.length - 1 && n(r);
                        });
                    });
                });
            }
        },
        {
            key: "_updateSeries",
            value: function(t, e) {
                var i = this, a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(function(s) {
                    var r, o = i.w;
                    return o.globals.shouldAnimate = e, o.globals.dataChanged = !0, e && i.ctx.series.getPreviousPaths(), o.globals.axisCharts ? (0 === (r = t.map(function(t, e) {
                        return i._extendSeries(t, e);
                    })).length && (r = [
                        {
                            data: []
                        }
                    ]), o.config.series = r) : o.config.series = t.slice(), a && (o.globals.initialConfig.series = $d4be73e5731103af$var$x.clone(o.config.series), o.globals.initialSeries = $d4be73e5731103af$var$x.clone(o.config.series)), i.ctx.update().then(function() {
                        s(i.ctx);
                    });
                });
            }
        },
        {
            key: "_extendSeries",
            value: function(t, i) {
                var a = this.w, s = a.config.series[i];
                return $d4be73e5731103af$var$e($d4be73e5731103af$var$e({}, a.config.series[i]), {}, {
                    name: t.name ? t.name : s && s.name,
                    color: t.color ? t.color : s && s.color,
                    type: t.type ? t.type : s && s.type,
                    group: t.group ? t.group : s && s.group,
                    data: t.data ? t.data : s && s.data
                });
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "'], ").concat(s, " circle[j='").concat(e, "'], ").concat(s, " rect[j='").concat(e, "']")).members[0] : void 0 === e && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "']")).members[0], "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), a ? (new $d4be73e5731103af$var$m(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
            }
        },
        {
            key: "forceXAxisUpdate",
            value: function(t) {
                var e = this.w;
                if ([
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i]);
                }), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                    var i = new $d4be73e5731103af$var$z(t);
                    t = i.convertCatToNumericXaxis(t, this.ctx);
                }
                return t;
            }
        },
        {
            key: "forceYAxisUpdate",
            value: function(t) {
                return t.chart && t.chart.stacked && "100%" === t.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }) : (t.yaxis.min = 0, t.yaxis.max = 100)), t;
            }
        },
        {
            key: "revertDefaultAxisMinMax",
            value: function(t) {
                var e = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                t && t.xaxis && (a = t.xaxis), t && t.yaxis && (s = t.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                var r = function(t) {
                    void 0 !== s[t] && (i.config.yaxis[t].min = s[t].min, i.config.yaxis[t].max = s[t].max);
                };
                i.config.yaxis.map(function(t, a) {
                    i.globals.zoomed || void 0 !== s[a] ? r(a) : void 0 !== e.ctx.opts.yaxis[a] && (t.min = e.ctx.opts.yaxis[a].min, t.max = e.ctx.opts.yaxis[a].max);
                });
            }
        }
    ]), t;
}();
$d4be73e5731103af$var$Rt = "undefined" != typeof window ? window : void 0, $d4be73e5731103af$var$Ht = function(t, e) {
    var a = (void 0 !== this ? this : t).SVG = function(t) {
        if (a.supported) return t = new a.Doc(t), a.parser.draw || a.prepare(), t;
    };
    if (a.ns = "http://www.w3.org/2000/svg", a.xmlns = "http://www.w3.org/2000/xmlns/", a.xlink = "http://www.w3.org/1999/xlink", a.svgjs = "http://svgjs.dev", a.supported = !0, !a.supported) return !1;
    a.did = 1e3, a.eid = function(t) {
        return "Svgjs" + d(t) + a.did++;
    }, a.create = function(t) {
        var i = e.createElementNS(this.ns, t);
        return i.setAttribute("id", this.eid(t)), i;
    }, a.extend = function() {
        var t, e;
        e = (t = [].slice.call(arguments)).pop();
        for(var i = t.length - 1; i >= 0; i--)if (t[i]) for(var s in e)t[i].prototype[s] = e[s];
        a.Set && a.Set.inherit && a.Set.inherit();
    }, a.invent = function(t) {
        var e = "function" == typeof t.create ? t.create : function() {
            this.constructor.call(this, a.create(t.create));
        };
        return t.inherit && (e.prototype = new t.inherit), t.extend && a.extend(e, t.extend), t.construct && a.extend(t.parent || a.Container, t.construct), e;
    }, a.adopt = function(e) {
        var i;
        return e ? e.instance ? e.instance : ((i = "svg" == e.nodeName ? e.parentNode instanceof t.SVGElement ? new a.Nested : new a.Doc : "linearGradient" == e.nodeName ? new a.Gradient("linear") : "radialGradient" == e.nodeName ? new a.Gradient("radial") : a[d(e.nodeName)] ? new a[d(e.nodeName)] : new a.Element(e)).type = e.nodeName, i.node = e, e.instance = i, i instanceof a.Doc && i.namespace().defs(), i.setData(JSON.parse(e.getAttribute("svgjs:data")) || {}), i) : null;
    }, a.prepare = function() {
        var t = e.getElementsByTagName("body")[0], i = (t ? new a.Doc(t) : a.adopt(e.documentElement).nested()).size(2, 0);
        a.parser = {
            body: t || e.documentElement,
            draw: i.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
            poly: i.polyline().node,
            path: i.path().node,
            native: a.create("svg")
        };
    }, a.parser = {
        native: a.create("svg")
    }, e.addEventListener("DOMContentLoaded", function() {
        a.parser.draw || a.prepare();
    }, !1), a.regex = {
        numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
        hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /rgb\((\d+),(\d+),(\d+)\)/,
        reference: /#([a-z0-9\-_]+)/i,
        transforms: /\)\s*,?\s*/,
        whitespace: /\s/g,
        isHex: /^#[a-f0-9]{3,6}$/i,
        isRgb: /^rgb\(/,
        isCss: /[^:]+:[^;]+;?/,
        isBlank: /^(\s+)?$/,
        isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        isPercent: /^-?[\d\.]+%$/,
        isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
        delimiter: /[\s,]+/,
        hyphen: /([^e])\-/gi,
        pathLetters: /[MLHVCSQTAZ]/gi,
        isPathLetter: /[MLHVCSQTAZ]/i,
        numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
        dots: /\./g
    }, a.utils = {
        map: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)a.push(e(t[s]));
            return a;
        },
        filter: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)e(t[s]) && a.push(t[s]);
            return a;
        },
        filterSVGElements: function(e) {
            return this.filter(e, function(e) {
                return e instanceof t.SVGElement;
            });
        }
    }, a.defaults = {
        attrs: {
            "fill-opacity": 1,
            "stroke-opacity": 1,
            "stroke-width": 0,
            "stroke-linejoin": "miter",
            "stroke-linecap": "butt",
            fill: "#000000",
            stroke: "#000000",
            opacity: 1,
            x: 0,
            y: 0,
            cx: 0,
            cy: 0,
            width: 0,
            height: 0,
            r: 0,
            rx: 0,
            ry: 0,
            offset: 0,
            "stop-opacity": 1,
            "stop-color": "#000000",
            "font-size": 16,
            "font-family": "Helvetica, Arial, sans-serif",
            "text-anchor": "start"
        }
    }, a.Color = function(t) {
        var e, s;
        this.r = 0, this.g = 0, this.b = 0, t && ("string" == typeof t ? a.regex.isRgb.test(t) ? (e = a.regex.rgb.exec(t.replace(a.regex.whitespace, "")), this.r = parseInt(e[1]), this.g = parseInt(e[2]), this.b = parseInt(e[3])) : a.regex.isHex.test(t) && (e = a.regex.hex.exec(4 == (s = t).length ? [
            "#",
            s.substring(1, 2),
            s.substring(1, 2),
            s.substring(2, 3),
            s.substring(2, 3),
            s.substring(3, 4),
            s.substring(3, 4)
        ].join("") : s), this.r = parseInt(e[1], 16), this.g = parseInt(e[2], 16), this.b = parseInt(e[3], 16)) : "object" === $d4be73e5731103af$var$i(t) && (this.r = t.r, this.g = t.g, this.b = t.b));
    }, a.extend(a.Color, {
        toString: function() {
            return this.toHex();
        },
        toHex: function() {
            return "#" + g(this.r) + g(this.g) + g(this.b);
        },
        toRgb: function() {
            return "rgb(" + [
                this.r,
                this.g,
                this.b
            ].join() + ")";
        },
        brightness: function() {
            return this.r / 255 * .3 + this.g / 255 * .59 + this.b / 255 * .11;
        },
        morph: function(t) {
            return this.destination = new a.Color(t), this;
        },
        at: function(t) {
            return this.destination ? (t = t < 0 ? 0 : t > 1 ? 1 : t, new a.Color({
                r: ~~(this.r + (this.destination.r - this.r) * t),
                g: ~~(this.g + (this.destination.g - this.g) * t),
                b: ~~(this.b + (this.destination.b - this.b) * t)
            })) : this;
        }
    }), a.Color.test = function(t) {
        return t += "", a.regex.isHex.test(t) || a.regex.isRgb.test(t);
    }, a.Color.isRgb = function(t) {
        return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b;
    }, a.Color.isColor = function(t) {
        return a.Color.isRgb(t) || a.Color.test(t);
    }, a.Array = function(t, e) {
        0 == (t = (t || []).valueOf()).length && e && (t = e.valueOf()), this.value = this.parse(t);
    }, a.extend(a.Array, {
        toString: function() {
            return this.value.join(" ");
        },
        valueOf: function() {
            return this.value;
        },
        parse: function(t) {
            return t = t.valueOf(), Array.isArray(t) ? t : this.split(t);
        }
    }), a.PointArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                0,
                0
            ]
        ]);
    }, a.PointArray.prototype = new a.Array, a.PointArray.prototype.constructor = a.PointArray;
    for(var s = {
        M: function(t, e, i) {
            return e.x = i.x = t[0], e.y = i.y = t[1], [
                "M",
                e.x,
                e.y
            ];
        },
        L: function(t, e) {
            return e.x = t[0], e.y = t[1], [
                "L",
                t[0],
                t[1]
            ];
        },
        H: function(t, e) {
            return e.x = t[0], [
                "H",
                t[0]
            ];
        },
        V: function(t, e) {
            return e.y = t[0], [
                "V",
                t[0]
            ];
        },
        C: function(t, e) {
            return e.x = t[4], e.y = t[5], [
                "C",
                t[0],
                t[1],
                t[2],
                t[3],
                t[4],
                t[5]
            ];
        },
        Q: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "Q",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        S: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "S",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        Z: function(t, e, i) {
            return e.x = i.x, e.y = i.y, [
                "Z"
            ];
        }
    }, r = "mlhvqtcsaz".split(""), o = 0, n = r.length; o < n; ++o)s[r[o]] = function(t) {
        return function(e, i, a) {
            if ("H" == t) e[0] = e[0] + i.x;
            else if ("V" == t) e[0] = e[0] + i.y;
            else if ("A" == t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
            else for(var r = 0, o = e.length; r < o; ++r)e[r] = e[r] + (r % 2 ? i.y : i.x);
            if (s && "function" == typeof s[t]) return s[t](e, i, a);
        };
    }(r[o].toUpperCase());
    a.PathArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                "M",
                0,
                0
            ]
        ]);
    }, a.PathArray.prototype = new a.Array, a.PathArray.prototype.constructor = a.PathArray, a.extend(a.PathArray, {
        toString: function() {
            return function(t) {
                for(var e = 0, i = t.length, a = ""; e < i; e++)a += t[e][0], null != t[e][1] && (a += t[e][1], null != t[e][2] && (a += " ", a += t[e][2], null != t[e][3] && (a += " ", a += t[e][3], a += " ", a += t[e][4], null != t[e][5] && (a += " ", a += t[e][5], a += " ", a += t[e][6], null != t[e][7] && (a += " ", a += t[e][7])))));
                return a + " ";
            }(this.value);
        },
        move: function(t, e) {
            var i = this.bbox();
            return i.x, i.y, this;
        },
        at: function(t) {
            if (!this.destination) return this;
            for(var e = this.value, i = this.destination.value, s = [], r = new a.PathArray, o = 0, n = e.length; o < n; o++){
                s[o] = [
                    e[o][0]
                ];
                for(var l = 1, h = e[o].length; l < h; l++)s[o][l] = e[o][l] + (i[o][l] - e[o][l]) * t;
                "A" === s[o][0] && (s[o][4] = +(0 != s[o][4]), s[o][5] = +(0 != s[o][5]));
            }
            return r.value = s, r;
        },
        parse: function(t) {
            if (t instanceof a.PathArray) return t.valueOf();
            var e, i = {
                M: 2,
                L: 2,
                H: 1,
                V: 1,
                C: 6,
                S: 4,
                Q: 4,
                T: 2,
                A: 7,
                Z: 0
            };
            t = "string" == typeof t ? t.replace(a.regex.numbersWithDots, h).replace(a.regex.pathLetters, " $& ").replace(a.regex.hyphen, "$1 -").trim().split(a.regex.delimiter) : t.reduce(function(t, e) {
                return [].concat.call(t, e);
            }, []);
            var r = [], o = new a.Point, n = new a.Point, l = 0, c = t.length;
            do a.regex.isPathLetter.test(t[l]) ? (e = t[l], ++l) : "M" == e ? e = "L" : "m" == e && (e = "l"), r.push(s[e].call(null, t.slice(l, l += i[e.toUpperCase()]).map(parseFloat), o, n));
            while (c > l);
            return r;
        },
        bbox: function() {
            return a.parser.draw || a.prepare(), a.parser.path.setAttribute("d", this.toString()), a.parser.path.getBBox();
        }
    }), a.Number = a.invent({
        create: function(t, e) {
            this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -340000000000000000000000000000000000000 : 34e37 : "string" == typeof t ? (e = t.match(a.regex.numberAndUnit)) && (this.value = parseFloat(e[1]), "%" == e[5] ? this.value /= 100 : "s" == e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof a.Number && (this.value = t.valueOf(), this.unit = t.unit);
        },
        extend: {
            toString: function() {
                return ("%" == this.unit ? ~~(1e8 * this.value) / 1e6 : "s" == this.unit ? this.value / 1e3 : this.value) + this.unit;
            },
            toJSON: function() {
                return this.toString();
            },
            valueOf: function() {
                return this.value;
            },
            plus: function(t) {
                return t = new a.Number(t), new a.Number(this + t, this.unit || t.unit);
            },
            minus: function(t) {
                return t = new a.Number(t), new a.Number(this - t, this.unit || t.unit);
            },
            times: function(t) {
                return t = new a.Number(t), new a.Number(this * t, this.unit || t.unit);
            },
            divide: function(t) {
                return t = new a.Number(t), new a.Number(this / t, this.unit || t.unit);
            },
            to: function(t) {
                var e = new a.Number(this);
                return "string" == typeof t && (e.unit = t), e;
            },
            morph: function(t) {
                return this.destination = new a.Number(t), t.relative && (this.destination.value += this.value), this;
            },
            at: function(t) {
                return this.destination ? new a.Number(this.destination).minus(this).times(t).plus(this) : this;
            }
        }
    }), a.Element = a.invent({
        create: function(t) {
            this._stroke = a.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = t) && (this.type = t.nodeName, this.node.instance = this, this._stroke = t.getAttribute("stroke") || this._stroke);
        },
        extend: {
            x: function(t) {
                return this.attr("x", t);
            },
            y: function(t) {
                return this.attr("y", t);
            },
            cx: function(t) {
                return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2);
            },
            cy: function(t) {
                return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2);
            },
            move: function(t, e) {
                return this.x(t).y(e);
            },
            center: function(t, e) {
                return this.cx(t).cy(e);
            },
            width: function(t) {
                return this.attr("width", t);
            },
            height: function(t) {
                return this.attr("height", t);
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.width(new a.Number(i.width)).height(new a.Number(i.height));
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = x(this.node.cloneNode(!0));
                return t ? t.add(e) : this.after(e), e;
            },
            remove: function() {
                return this.parent() && this.parent().removeElement(this), this;
            },
            replace: function(t) {
                return this.after(t).remove(), t;
            },
            addTo: function(t) {
                return t.put(this);
            },
            putIn: function(t) {
                return t.add(this);
            },
            id: function(t) {
                return this.attr("id", t);
            },
            show: function() {
                return this.style("display", "");
            },
            hide: function() {
                return this.style("display", "none");
            },
            visible: function() {
                return "none" != this.style("display");
            },
            toString: function() {
                return this.attr("id");
            },
            classes: function() {
                var t = this.attr("class");
                return null == t ? [] : t.trim().split(a.regex.delimiter);
            },
            hasClass: function(t) {
                return -1 != this.classes().indexOf(t);
            },
            addClass: function(t) {
                if (!this.hasClass(t)) {
                    var e = this.classes();
                    e.push(t), this.attr("class", e.join(" "));
                }
                return this;
            },
            removeClass: function(t) {
                return this.hasClass(t) && this.attr("class", this.classes().filter(function(e) {
                    return e != t;
                }).join(" ")), this;
            },
            toggleClass: function(t) {
                return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
            },
            reference: function(t) {
                return a.get(this.attr(t));
            },
            parent: function(e) {
                var i = this;
                if (!i.node.parentNode) return null;
                if (i = a.adopt(i.node.parentNode), !e) return i;
                for(; i && i.node instanceof t.SVGElement;){
                    if ("string" == typeof e ? i.matches(e) : i instanceof e) return i;
                    if (!i.node.parentNode || "#document" == i.node.parentNode.nodeName) return null;
                    i = a.adopt(i.node.parentNode);
                }
            },
            doc: function() {
                return this instanceof a.Doc ? this : this.parent(a.Doc);
            },
            parents: function(t) {
                var e = [], i = this;
                do {
                    if (!(i = i.parent(t)) || !i.node) break;
                    e.push(i);
                }while (i.parent);
                return e;
            },
            matches: function(t) {
                return function(t, e) {
                    return (t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector).call(t, e);
                }(this.node, t);
            },
            native: function() {
                return this.node;
            },
            svg: function(t) {
                var i = e.createElement("svg");
                if (!(t && this instanceof a.Parent)) return i.appendChild(t = e.createElement("svg")), this.writeDataToDom(), t.appendChild(this.node.cloneNode(!0)), i.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                i.innerHTML = "<svg>" + t.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                for(var s = 0, r = i.firstChild.childNodes.length; s < r; s++)this.node.appendChild(i.firstChild.firstChild);
                return this;
            },
            writeDataToDom: function() {
                return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                    this.writeDataToDom();
                }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
            },
            setData: function(t) {
                return this.dom = t, this;
            },
            is: function(t) {
                return function(t, e) {
                    return t instanceof e;
                }(this, t);
            }
        }
    }), a.easing = {
        "-": function(t) {
            return t;
        },
        "<>": function(t) {
            return -Math.cos(t * Math.PI) / 2 + .5;
        },
        ">": function(t) {
            return Math.sin(t * Math.PI / 2);
        },
        "<": function(t) {
            return 1 - Math.cos(t * Math.PI / 2);
        }
    }, a.morph = function(t) {
        return function(e, i) {
            return new a.MorphObj(e, i).at(t);
        };
    }, a.Situation = a.invent({
        create: function(t) {
            this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new a.Number(t.duration).valueOf(), this.delay = new a.Number(t.delay).valueOf(), this.start = +new Date + this.delay, this.finish = this.start + this.duration, this.ease = t.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
        }
    }), a.FX = a.invent({
        create: function(t) {
            this._target = t, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
        },
        extend: {
            animate: function(t, e, s) {
                "object" === $d4be73e5731103af$var$i(t) && (e = t.ease, s = t.delay, t = t.duration);
                var r = new a.Situation({
                    duration: t || 1e3,
                    delay: s || 0,
                    ease: a.easing[e || "-"] || e
                });
                return this.queue(r), this;
            },
            target: function(t) {
                return t && t instanceof a.Element ? (this._target = t, this) : this._target;
            },
            timeToAbsPos: function(t) {
                return (t - this.situation.start) / (this.situation.duration / this._speed);
            },
            absPosToTime: function(t) {
                return this.situation.duration / this._speed * t + this.situation.start;
            },
            startAnimFrame: function() {
                this.stopAnimFrame(), this.animationFrame = t.requestAnimationFrame((function() {
                    this.step();
                }).bind(this));
            },
            stopAnimFrame: function() {
                t.cancelAnimationFrame(this.animationFrame);
            },
            start: function() {
                return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
            },
            startCurrent: function() {
                return this.situation.start = +new Date + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
            },
            queue: function(t) {
                return ("function" == typeof t || t instanceof a.Situation) && this.situations.push(t), this.situation || (this.situation = this.situations.shift()), this;
            },
            dequeue: function() {
                return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof a.Situation ? this.start() : this.situation.call(this)), this;
            },
            initAnimations: function() {
                var t, e = this.situation;
                if (e.init) return this;
                for(var i in e.animations){
                    t = this.target()[i](), Array.isArray(t) || (t = [
                        t
                    ]), Array.isArray(e.animations[i]) || (e.animations[i] = [
                        e.animations[i]
                    ]);
                    for(var s = t.length; s--;)e.animations[i][s] instanceof a.Number && (t[s] = new a.Number(t[s])), e.animations[i][s] = t[s].morph(e.animations[i][s]);
                }
                for(var i in e.attrs)e.attrs[i] = new a.MorphObj(this.target().attr(i), e.attrs[i]);
                for(var i in e.styles)e.styles[i] = new a.MorphObj(this.target().style(i), e.styles[i]);
                return e.initialTransformation = this.target().matrixify(), e.init = !0, this;
            },
            clearQueue: function() {
                return this.situations = [], this;
            },
            clearCurrent: function() {
                return this.situation = null, this;
            },
            stop: function(t, e) {
                var i = this.active;
                return this.active = !1, e && this.clearQueue(), t && this.situation && (!i && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
            },
            after: function(t) {
                var e = this.last();
                return this.target().on("finished.fx", function i(a) {
                    a.detail.situation == e && (t.call(this, e), this.off("finished.fx", i));
                }), this._callStart();
            },
            during: function(t) {
                var e = this.last(), i = function(i) {
                    i.detail.situation == e && t.call(this, i.detail.pos, a.morph(i.detail.pos), i.detail.eased, e);
                };
                return this.target().off("during.fx", i).on("during.fx", i), this.after(function() {
                    this.off("during.fx", i);
                }), this._callStart();
            },
            afterAll: function(t) {
                var e = function e(i) {
                    t.call(this), this.off("allfinished.fx", e);
                };
                return this.target().off("allfinished.fx", e).on("allfinished.fx", e), this._callStart();
            },
            last: function() {
                return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
            },
            add: function(t, e, i) {
                return this.last()[i || "animations"][t] = e, this._callStart();
            },
            step: function(t) {
                var e, i, a;
                t || (this.absPos = this.timeToAbsPos(+new Date)), !1 !== this.situation.loops ? (e = Math.max(this.absPos, 0), i = Math.floor(e), !0 === this.situation.loops || i < this.situation.loops ? (this.pos = e - i, a = this.situation.loop, this.situation.loop = i) : (this.absPos = this.situation.loops, this.pos = 1, a = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - a) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                var s = this.situation.ease(this.pos);
                for(var r in this.situation.once)r > this.lastPos && r <= s && (this.situation.once[r].call(this.target(), this.pos, s), delete this.situation.once[r]);
                return this.active && this.target().fire("during", {
                    pos: this.pos,
                    eased: s,
                    fx: this,
                    situation: this.situation
                }), this.situation ? (this.eachAt(), 1 == this.pos && !this.situation.reversed || this.situation.reversed && 0 == this.pos ? (this.stopAnimFrame(), this.target().fire("finished", {
                    fx: this,
                    situation: this.situation
                }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = s, this) : this;
            },
            eachAt: function() {
                var t, e = this, i = this.target(), s = this.situation;
                for(var r in s.animations)t = [].concat(s.animations[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i[r].apply(i, t);
                for(var r in s.attrs)t = [
                    r
                ].concat(s.attrs[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.attr.apply(i, t);
                for(var r in s.styles)t = [
                    r
                ].concat(s.styles[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.style.apply(i, t);
                if (s.transforms.length) {
                    t = s.initialTransformation, r = 0;
                    for(var o = s.transforms.length; r < o; r++){
                        var n = s.transforms[r];
                        n instanceof a.Matrix ? t = n.relative ? t.multiply((new a.Matrix).morph(n).at(s.ease(this.pos))) : t.morph(n).at(s.ease(this.pos)) : (n.relative || n.undo(t.extract()), t = t.multiply(n.at(s.ease(this.pos))));
                    }
                    i.matrix(t);
                }
                return this;
            },
            once: function(t, e, i) {
                var a = this.last();
                return i || (t = a.ease(t)), a.once[t] = e, this;
            },
            _callStart: function() {
                return setTimeout((function() {
                    this.start();
                }).bind(this), 0), this;
            }
        },
        parent: a.Element,
        construct: {
            animate: function(t, e, i) {
                return (this.fx || (this.fx = new a.FX(this))).animate(t, e, i);
            },
            delay: function(t) {
                return (this.fx || (this.fx = new a.FX(this))).delay(t);
            },
            stop: function(t, e) {
                return this.fx && this.fx.stop(t, e), this;
            },
            finish: function() {
                return this.fx && this.fx.finish(), this;
            }
        }
    }), a.MorphObj = a.invent({
        create: function(t, e) {
            return a.Color.isColor(e) ? new a.Color(t).morph(e) : a.regex.delimiter.test(t) ? a.regex.pathLetters.test(t) ? new a.PathArray(t).morph(e) : new a.Array(t).morph(e) : a.regex.numberAndUnit.test(e) ? new a.Number(t).morph(e) : (this.value = t, void (this.destination = e));
        },
        extend: {
            at: function(t, e) {
                return e < 1 ? this.value : this.destination;
            },
            valueOf: function() {
                return this.value;
            }
        }
    }), a.extend(a.FX, {
        attr: function(t, e, a) {
            if ("object" === $d4be73e5731103af$var$i(t)) for(var s in t)this.attr(s, t[s]);
            else this.add(t, e, "attrs");
            return this;
        },
        plot: function(t, e, i, a) {
            return 4 == arguments.length ? this.plot([
                t,
                e,
                i,
                a
            ]) : this.add("plot", new (this.target()).morphArray(t));
        }
    }), a.Box = a.invent({
        create: function(t, e, s, r) {
            if (!("object" !== $d4be73e5731103af$var$i(t) || t instanceof a.Element)) return a.Box.call(this, null != t.left ? t.left : t.x, null != t.top ? t.top : t.y, t.width, t.height);
            var o;
            4 == arguments.length && (this.x = t, this.y = e, this.width = s, this.height = r), null == (o = this).x && (o.x = 0, o.y = 0, o.width = 0, o.height = 0), o.w = o.width, o.h = o.height, o.x2 = o.x + o.width, o.y2 = o.y + o.height, o.cx = o.x + o.width / 2, o.cy = o.y + o.height / 2;
        }
    }), a.BBox = a.invent({
        create: function(t) {
            if (a.Box.apply(this, [].slice.call(arguments)), t instanceof a.Element) {
                var i;
                try {
                    if (!e.documentElement.contains) {
                        for(var s = t.node; s.parentNode;)s = s.parentNode;
                        if (s != e) throw new Error("Element not in the dom");
                    }
                    i = t.node.getBBox();
                } catch (e) {
                    if (t instanceof a.Shape) {
                        a.parser.draw || a.prepare();
                        var r = t.clone(a.parser.draw.instance).show();
                        r && r.node && "function" == typeof r.node.getBBox && (i = r.node.getBBox()), r && "function" == typeof r.remove && r.remove();
                    } else i = {
                        x: t.node.clientLeft,
                        y: t.node.clientTop,
                        width: t.node.clientWidth,
                        height: t.node.clientHeight
                    };
                }
                a.Box.call(this, i);
            }
        },
        inherit: a.Box,
        parent: a.Element,
        construct: {
            bbox: function() {
                return new a.BBox(this);
            }
        }
    }), a.BBox.prototype.constructor = a.BBox, a.Matrix = a.invent({
        create: function(t) {
            var e = f([
                1,
                0,
                0,
                1,
                0,
                0
            ]);
            t = null === t ? e : t instanceof a.Element ? t.matrixify() : "string" == typeof t ? f(t.split(a.regex.delimiter).map(parseFloat)) : 6 == arguments.length ? f([].slice.call(arguments)) : Array.isArray(t) ? f(t) : t && "object" === $d4be73e5731103af$var$i(t) ? t : e;
            for(var s = v.length - 1; s >= 0; --s)this[v[s]] = null != t[v[s]] ? t[v[s]] : e[v[s]];
        },
        extend: {
            extract: function() {
                var t = p(this, 0, 1);
                p(this, 1, 0);
                var e = 180 / Math.PI * Math.atan2(t.y, t.x) - 90;
                return {
                    x: this.e,
                    y: this.f,
                    transformedX: (this.e * Math.cos(e * Math.PI / 180) + this.f * Math.sin(e * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                    transformedY: (this.f * Math.cos(e * Math.PI / 180) + this.e * Math.sin(-e * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                    rotation: e,
                    a: this.a,
                    b: this.b,
                    c: this.c,
                    d: this.d,
                    e: this.e,
                    f: this.f,
                    matrix: new a.Matrix(this)
                };
            },
            clone: function() {
                return new a.Matrix(this);
            },
            morph: function(t) {
                return this.destination = new a.Matrix(t), this;
            },
            multiply: function(t) {
                return new a.Matrix(this.native().multiply((function(t) {
                    return t instanceof a.Matrix || (t = new a.Matrix(t)), t;
                })(t).native()));
            },
            inverse: function() {
                return new a.Matrix(this.native().inverse());
            },
            translate: function(t, e) {
                return new a.Matrix(this.native().translate(t || 0, e || 0));
            },
            native: function() {
                for(var t = a.parser.native.createSVGMatrix(), e = v.length - 1; e >= 0; e--)t[v[e]] = this[v[e]];
                return t;
            },
            toString: function() {
                return "matrix(" + b(this.a) + "," + b(this.b) + "," + b(this.c) + "," + b(this.d) + "," + b(this.e) + "," + b(this.f) + ")";
            }
        },
        parent: a.Element,
        construct: {
            ctm: function() {
                return new a.Matrix(this.node.getCTM());
            },
            screenCTM: function() {
                if (this instanceof a.Nested) {
                    var t = this.rect(1, 1), e = t.node.getScreenCTM();
                    return t.remove(), new a.Matrix(e);
                }
                return new a.Matrix(this.node.getScreenCTM());
            }
        }
    }), a.Point = a.invent({
        create: function(t, e) {
            var a;
            a = Array.isArray(t) ? {
                x: t[0],
                y: t[1]
            } : "object" === $d4be73e5731103af$var$i(t) ? {
                x: t.x,
                y: t.y
            } : null != t ? {
                x: t,
                y: null != e ? e : t
            } : {
                x: 0,
                y: 0
            }, this.x = a.x, this.y = a.y;
        },
        extend: {
            clone: function() {
                return new a.Point(this);
            },
            morph: function(t, e) {
                return this.destination = new a.Point(t, e), this;
            }
        }
    }), a.extend(a.Element, {
        point: function(t, e) {
            return new a.Point(t, e).transform(this.screenCTM().inverse());
        }
    }), a.extend(a.Element, {
        attr: function(t, e, s) {
            if (null == t) {
                for(t = {}, s = (e = this.node.attributes).length - 1; s >= 0; s--)t[e[s].nodeName] = a.regex.isNumber.test(e[s].nodeValue) ? parseFloat(e[s].nodeValue) : e[s].nodeValue;
                return t;
            }
            if ("object" === $d4be73e5731103af$var$i(t)) for(var r in t)this.attr(r, t[r]);
            else if (null === e) this.node.removeAttribute(t);
            else {
                if (null == e) return null == (e = this.node.getAttribute(t)) ? a.defaults.attrs[t] : a.regex.isNumber.test(e) ? parseFloat(e) : e;
                "stroke-width" == t ? this.attr("stroke", parseFloat(e) > 0 ? this._stroke : null) : "stroke" == t && (this._stroke = e), "fill" != t && "stroke" != t || (a.regex.isImage.test(e) && (e = this.doc().defs().image(e, 0, 0)), e instanceof a.Image && (e = this.doc().defs().pattern(0, 0, function() {
                    this.add(e);
                }))), "number" == typeof e ? e = new a.Number(e) : a.Color.isColor(e) ? e = new a.Color(e) : Array.isArray(e) && (e = new a.Array(e)), "leading" == t ? this.leading && this.leading(e) : "string" == typeof s ? this.node.setAttributeNS(s, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" != t && "x" != t || this.rebuild(t, e);
            }
            return this;
        }
    }), a.extend(a.Element, {
        transform: function(t, e) {
            var s;
            return "object" !== $d4be73e5731103af$var$i(t) ? (s = new a.Matrix(this).extract(), "string" == typeof t ? s[t] : s) : (s = new a.Matrix(this), e = !!e || !!t.relative, null != t.a && (s = e ? s.multiply(new a.Matrix(t)) : new a.Matrix(t)), this.attr("transform", s));
        }
    }), a.extend(a.Element, {
        untransform: function() {
            return this.attr("transform", null);
        },
        matrixify: function() {
            return (this.attr("transform") || "").split(a.regex.transforms).slice(0, -1).map(function(t) {
                var e = t.trim().split("(");
                return [
                    e[0],
                    e[1].split(a.regex.delimiter).map(function(t) {
                        return parseFloat(t);
                    })
                ];
            }).reduce(function(t, e) {
                return "matrix" == e[0] ? t.multiply(f(e[1])) : t[e[0]].apply(t, e[1]);
            }, new a.Matrix);
        },
        toParent: function(t) {
            if (this == t) return this;
            var e = this.screenCTM(), i = t.screenCTM().inverse();
            return this.addTo(t).untransform().transform(i.multiply(e)), this;
        },
        toDoc: function() {
            return this.toParent(this.doc());
        }
    }), a.Transformation = a.invent({
        create: function(t, e) {
            if (arguments.length > 1 && "boolean" != typeof e) return this.constructor.call(this, [].slice.call(arguments));
            if (Array.isArray(t)) for(var a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[a];
            else if (t && "object" === $d4be73e5731103af$var$i(t)) for(a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[this.arguments[a]];
            this.inversed = !1, !0 === e && (this.inversed = !0);
        }
    }), a.Translate = a.invent({
        parent: a.Matrix,
        inherit: a.Transformation,
        create: function(t, e) {
            this.constructor.apply(this, [].slice.call(arguments));
        },
        extend: {
            arguments: [
                "transformedX",
                "transformedY"
            ],
            method: "translate"
        }
    }), a.extend(a.Element, {
        style: function(t, e) {
            if (0 == arguments.length) return this.node.style.cssText || "";
            if (arguments.length < 2) {
                if ("object" === $d4be73e5731103af$var$i(t)) for(var s in t)this.style(s, t[s]);
                else {
                    if (!a.regex.isCss.test(t)) return this.node.style[c(t)];
                    for(t = t.split(/\s*;\s*/).filter(function(t) {
                        return !!t;
                    }).map(function(t) {
                        return t.split(/\s*:\s*/);
                    }); e = t.pop();)this.style(e[0], e[1]);
                }
            } else this.node.style[c(t)] = null === e || a.regex.isBlank.test(e) ? "" : e;
            return this;
        }
    }), a.Parent = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element,
        extend: {
            children: function() {
                return a.utils.map(a.utils.filterSVGElements(this.node.childNodes), function(t) {
                    return a.adopt(t);
                });
            },
            add: function(t, e) {
                return null == e ? this.node.appendChild(t.node) : t.node != this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this;
            },
            put: function(t, e) {
                return this.add(t, e), t;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return [].slice.call(this.node.childNodes).indexOf(t.node);
            },
            get: function(t) {
                return a.adopt(this.node.childNodes[t]);
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.node.childNodes.length - 1);
            },
            each: function(t, e) {
                for(var i = this.children(), s = 0, r = i.length; s < r; s++)i[s] instanceof a.Element && t.apply(i[s], [
                    s,
                    i
                ]), e && i[s] instanceof a.Container && i[s].each(t, e);
                return this;
            },
            removeElement: function(t) {
                return this.node.removeChild(t.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, this;
            },
            defs: function() {
                return this.doc().defs();
            }
        }
    }), a.extend(a.Parent, {
        ungroup: function(t, e) {
            return 0 === e || this instanceof a.Defs || this.node == a.parser.draw || (t = t || (this instanceof a.Doc ? this : this.parent(a.Parent)), e = e || 1 / 0, this.each(function() {
                return this instanceof a.Defs ? this : this instanceof a.Parent ? this.ungroup(t, e - 1) : this.toParent(t);
            }), this.node.firstChild || this.remove()), this;
        },
        flatten: function(t, e) {
            return this.ungroup(t, e);
        }
    }), a.Container = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Parent
    }), a.ViewBox = a.invent({
        parent: a.Container,
        construct: {}
    }), [
        "click",
        "dblclick",
        "mousedown",
        "mouseup",
        "mouseover",
        "mouseout",
        "mousemove",
        "touchstart",
        "touchmove",
        "touchleave",
        "touchend",
        "touchcancel"
    ].forEach(function(t) {
        a.Element.prototype[t] = function(e) {
            return a.on(this.node, t, e), this;
        };
    }), a.listeners = [], a.handlerMap = [], a.listenerId = 0, a.on = function(t, e, i, s, r) {
        var o = i.bind(s || t.instance || t), n = (a.handlerMap.indexOf(t) + 1 || a.handlerMap.push(t)) - 1, l = e.split(".")[0], h = e.split(".")[1] || "*";
        a.listeners[n] = a.listeners[n] || {}, a.listeners[n][l] = a.listeners[n][l] || {}, a.listeners[n][l][h] = a.listeners[n][l][h] || {}, i._svgjsListenerId || (i._svgjsListenerId = ++a.listenerId), a.listeners[n][l][h][i._svgjsListenerId] = o, t.addEventListener(l, o, r || {
            passive: !0
        });
    }, a.off = function(t, e, i) {
        var s = a.handlerMap.indexOf(t), r = e && e.split(".")[0], o = e && e.split(".")[1], n = "";
        if (-1 != s) {
            if (i) {
                if ("function" == typeof i && (i = i._svgjsListenerId), !i) return;
                a.listeners[s][r] && a.listeners[s][r][o || "*"] && (t.removeEventListener(r, a.listeners[s][r][o || "*"][i], !1), delete a.listeners[s][r][o || "*"][i]);
            } else if (o && r) {
                if (a.listeners[s][r] && a.listeners[s][r][o]) {
                    for(var l in a.listeners[s][r][o])a.off(t, [
                        r,
                        o
                    ].join("."), l);
                    delete a.listeners[s][r][o];
                }
            } else if (o) for(var h in a.listeners[s])for(var n in a.listeners[s][h])o === n && a.off(t, [
                h,
                o
            ].join("."));
            else if (r) {
                if (a.listeners[s][r]) {
                    for(var n in a.listeners[s][r])a.off(t, [
                        r,
                        n
                    ].join("."));
                    delete a.listeners[s][r];
                }
            } else {
                for(var h in a.listeners[s])a.off(t, h);
                delete a.listeners[s], delete a.handlerMap[s];
            }
        }
    }, a.extend(a.Element, {
        on: function(t, e, i, s) {
            return a.on(this.node, t, e, i, s), this;
        },
        off: function(t, e) {
            return a.off(this.node, t, e), this;
        },
        fire: function(e, i) {
            return e instanceof t.Event ? this.node.dispatchEvent(e) : this.node.dispatchEvent(e = new a.CustomEvent(e, {
                detail: i,
                cancelable: !0
            })), this._event = e, this;
        },
        event: function() {
            return this._event;
        }
    }), a.Defs = a.invent({
        create: "defs",
        inherit: a.Container
    }), a.G = a.invent({
        create: "g",
        inherit: a.Container,
        extend: {
            x: function(t) {
                return null == t ? this.transform("x") : this.transform({
                    x: t - this.x()
                }, !0);
            }
        },
        construct: {
            group: function() {
                return this.put(new a.G);
            }
        }
    }), a.Doc = a.invent({
        create: function(t) {
            t && ("svg" == (t = "string" == typeof t ? e.getElementById(t) : t).nodeName ? this.constructor.call(this, t) : (this.constructor.call(this, a.create("svg")), t.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
        },
        inherit: a.Container,
        extend: {
            namespace: function() {
                return this.attr({
                    xmlns: a.ns,
                    version: "1.1"
                }).attr("xmlns:xlink", a.xlink, a.xmlns).attr("xmlns:svgjs", a.svgjs, a.xmlns);
            },
            defs: function() {
                var t;
                return this._defs || ((t = this.node.getElementsByTagName("defs")[0]) ? this._defs = a.adopt(t) : this._defs = new a.Defs, this.node.appendChild(this._defs.node)), this._defs;
            },
            parent: function() {
                return this.node.parentNode && "#document" != this.node.parentNode.nodeName ? this.node.parentNode : null;
            },
            remove: function() {
                return this.parent() && this.parent().removeChild(this.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, a.parser.draw && !a.parser.draw.parentNode && this.node.appendChild(a.parser.draw), this;
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = this.node, i = x(e.cloneNode(!0));
                return t ? (t.node || t).appendChild(i.node) : e.parentNode.insertBefore(i.node, e.nextSibling), i;
            }
        }
    }), a.extend(a.Element, {}), a.Gradient = a.invent({
        create: function(t) {
            this.constructor.call(this, a.create(t + "Gradient")), this.type = t;
        },
        inherit: a.Container,
        extend: {
            at: function(t, e, i) {
                return this.put(new a.Stop).update(t, e, i);
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "gradientTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            gradient: function(t, e) {
                return this.defs().gradient(t, e);
            }
        }
    }), a.extend(a.Gradient, a.FX, {
        from: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                fx: new a.Number(t),
                fy: new a.Number(e)
            }) : this.attr({
                x1: new a.Number(t),
                y1: new a.Number(e)
            });
        },
        to: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                cx: new a.Number(t),
                cy: new a.Number(e)
            }) : this.attr({
                x2: new a.Number(t),
                y2: new a.Number(e)
            });
        }
    }), a.extend(a.Defs, {
        gradient: function(t, e) {
            return this.put(new a.Gradient(t)).update(e);
        }
    }), a.Stop = a.invent({
        create: "stop",
        inherit: a.Element,
        extend: {
            update: function(t) {
                return ("number" == typeof t || t instanceof a.Number) && (t = {
                    offset: arguments[0],
                    color: arguments[1],
                    opacity: arguments[2]
                }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new a.Number(t.offset)), this;
            }
        }
    }), a.Pattern = a.invent({
        create: "pattern",
        inherit: a.Container,
        extend: {
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "patternTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            pattern: function(t, e, i) {
                return this.defs().pattern(t, e, i);
            }
        }
    }), a.extend(a.Defs, {
        pattern: function(t, e, i) {
            return this.put(new a.Pattern).update(i).attr({
                x: 0,
                y: 0,
                width: t,
                height: e,
                patternUnits: "userSpaceOnUse"
            });
        }
    }), a.Shape = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element
    }), a.Symbol = a.invent({
        create: "symbol",
        inherit: a.Container,
        construct: {
            symbol: function() {
                return this.put(new a.Symbol);
            }
        }
    }), a.Use = a.invent({
        create: "use",
        inherit: a.Shape,
        extend: {
            element: function(t, e) {
                return this.attr("href", (e || "") + "#" + t, a.xlink);
            }
        },
        construct: {
            use: function(t, e) {
                return this.put(new a.Use).element(t, e);
            }
        }
    }), a.Rect = a.invent({
        create: "rect",
        inherit: a.Shape,
        construct: {
            rect: function(t, e) {
                return this.put(new a.Rect).size(t, e);
            }
        }
    }), a.Circle = a.invent({
        create: "circle",
        inherit: a.Shape,
        construct: {
            circle: function(t) {
                return this.put(new a.Circle).rx(new a.Number(t).divide(2)).move(0, 0);
            }
        }
    }), a.extend(a.Circle, a.FX, {
        rx: function(t) {
            return this.attr("r", t);
        },
        ry: function(t) {
            return this.rx(t);
        }
    }), a.Ellipse = a.invent({
        create: "ellipse",
        inherit: a.Shape,
        construct: {
            ellipse: function(t, e) {
                return this.put(new a.Ellipse).size(t, e).move(0, 0);
            }
        }
    }), a.extend(a.Ellipse, a.Rect, a.FX, {
        rx: function(t) {
            return this.attr("rx", t);
        },
        ry: function(t) {
            return this.attr("ry", t);
        }
    }), a.extend(a.Circle, a.Ellipse, {
        x: function(t) {
            return null == t ? this.cx() - this.rx() : this.cx(t + this.rx());
        },
        y: function(t) {
            return null == t ? this.cy() - this.ry() : this.cy(t + this.ry());
        },
        cx: function(t) {
            return null == t ? this.attr("cx") : this.attr("cx", t);
        },
        cy: function(t) {
            return null == t ? this.attr("cy") : this.attr("cy", t);
        },
        width: function(t) {
            return null == t ? 2 * this.rx() : this.rx(new a.Number(t).divide(2));
        },
        height: function(t) {
            return null == t ? 2 * this.ry() : this.ry(new a.Number(t).divide(2));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.rx(new a.Number(i.width).divide(2)).ry(new a.Number(i.height).divide(2));
        }
    }), a.Line = a.invent({
        create: "line",
        inherit: a.Shape,
        extend: {
            array: function() {
                return new a.PointArray([
                    [
                        this.attr("x1"),
                        this.attr("y1")
                    ],
                    [
                        this.attr("x2"),
                        this.attr("y2")
                    ]
                ]);
            },
            plot: function(t, e, i, s) {
                return null == t ? this.array() : (t = void 0 !== e ? {
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: s
                } : new a.PointArray(t).toLine(), this.attr(t));
            },
            move: function(t, e) {
                return this.attr(this.array().move(t, e).toLine());
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.attr(this.array().size(i.width, i.height).toLine());
            }
        },
        construct: {
            line: function(t, e, i, s) {
                return a.Line.prototype.plot.apply(this.put(new a.Line), null != t ? [
                    t,
                    e,
                    i,
                    s
                ] : [
                    0,
                    0,
                    0,
                    0
                ]);
            }
        }
    }), a.Polyline = a.invent({
        create: "polyline",
        inherit: a.Shape,
        construct: {
            polyline: function(t) {
                return this.put(new a.Polyline).plot(t || new a.PointArray);
            }
        }
    }), a.Polygon = a.invent({
        create: "polygon",
        inherit: a.Shape,
        construct: {
            polygon: function(t) {
                return this.put(new a.Polygon).plot(t || new a.PointArray);
            }
        }
    }), a.extend(a.Polyline, a.Polygon, {
        array: function() {
            return this._array || (this._array = new a.PointArray(this.attr("points")));
        },
        plot: function(t) {
            return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new a.PointArray(t));
        },
        clear: function() {
            return delete this._array, this;
        },
        move: function(t, e) {
            return this.attr("points", this.array().move(t, e));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.attr("points", this.array().size(i.width, i.height));
        }
    }), a.extend(a.Line, a.Polyline, a.Polygon, {
        morphArray: a.PointArray,
        x: function(t) {
            return null == t ? this.bbox().x : this.move(t, this.bbox().y);
        },
        y: function(t) {
            return null == t ? this.bbox().y : this.move(this.bbox().x, t);
        },
        width: function(t) {
            var e = this.bbox();
            return null == t ? e.width : this.size(t, e.height);
        },
        height: function(t) {
            var e = this.bbox();
            return null == t ? e.height : this.size(e.width, t);
        }
    }), a.Path = a.invent({
        create: "path",
        inherit: a.Shape,
        extend: {
            morphArray: a.PathArray,
            array: function() {
                return this._array || (this._array = new a.PathArray(this.attr("d")));
            },
            plot: function(t) {
                return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new a.PathArray(t));
            },
            clear: function() {
                return delete this._array, this;
            }
        },
        construct: {
            path: function(t) {
                return this.put(new a.Path).plot(t || new a.PathArray);
            }
        }
    }), a.Image = a.invent({
        create: "image",
        inherit: a.Shape,
        extend: {
            load: function(e) {
                if (!e) return this;
                var i = this, s = new t.Image;
                return a.on(s, "load", function() {
                    a.off(s);
                    var t = i.parent(a.Pattern);
                    null !== t && (0 == i.width() && 0 == i.height() && i.size(s.width, s.height), t && 0 == t.width() && 0 == t.height() && t.size(i.width(), i.height()), "function" == typeof i._loaded && i._loaded.call(i, {
                        width: s.width,
                        height: s.height,
                        ratio: s.width / s.height,
                        url: e
                    }));
                }), a.on(s, "error", function(t) {
                    a.off(s), "function" == typeof i._error && i._error.call(i, t);
                }), this.attr("href", s.src = this.src = e, a.xlink);
            },
            loaded: function(t) {
                return this._loaded = t, this;
            },
            error: function(t) {
                return this._error = t, this;
            }
        },
        construct: {
            image: function(t, e, i) {
                return this.put(new a.Image).load(t).size(e || 0, i || e || 0);
            }
        }
    }), a.Text = a.invent({
        create: function() {
            this.constructor.call(this, a.create("text")), this.dom.leading = new a.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", a.defaults.attrs["font-family"]);
        },
        inherit: a.Shape,
        extend: {
            x: function(t) {
                return null == t ? this.attr("x") : this.attr("x", t);
            },
            text: function(t) {
                if (void 0 === t) {
                    t = "";
                    for(var e = this.node.childNodes, i = 0, s = e.length; i < s; ++i)0 != i && 3 != e[i].nodeType && 1 == a.adopt(e[i]).dom.newLined && (t += "\n"), t += e[i].textContent;
                    return t;
                }
                if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
                else {
                    i = 0;
                    for(var r = (t = t.split("\n")).length; i < r; i++)this.tspan(t[i]).newLine();
                }
                return this.build(!1).rebuild();
            },
            size: function(t) {
                return this.attr("font-size", t).rebuild();
            },
            leading: function(t) {
                return null == t ? this.dom.leading : (this.dom.leading = new a.Number(t), this.rebuild());
            },
            lines: function() {
                var t = (this.textPath && this.textPath() || this).node, e = a.utils.map(a.utils.filterSVGElements(t.childNodes), function(t) {
                    return a.adopt(t);
                });
                return new a.Set(e);
            },
            rebuild: function(t) {
                if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
                    var e = this, i = 0, s = this.dom.leading * new a.Number(this.attr("font-size"));
                    this.lines().each(function() {
                        this.dom.newLined && (e.textPath() || this.attr("x", e.attr("x")), "\n" == this.text() ? i += s : (this.attr("dy", s + i), i = 0));
                    }), this.fire("rebuild");
                }
                return this;
            },
            build: function(t) {
                return this._build = !!t, this;
            },
            setData: function(t) {
                return this.dom = t, this.dom.leading = new a.Number(t.leading || 1.3), this;
            }
        },
        construct: {
            text: function(t) {
                return this.put(new a.Text).text(t);
            },
            plain: function(t) {
                return this.put(new a.Text).plain(t);
            }
        }
    }), a.Tspan = a.invent({
        create: "tspan",
        inherit: a.Shape,
        extend: {
            text: function(t) {
                return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? t.call(this, this) : this.plain(t), this);
            },
            dx: function(t) {
                return this.attr("dx", t);
            },
            dy: function(t) {
                return this.attr("dy", t);
            },
            newLine: function() {
                var t = this.parent(a.Text);
                return this.dom.newLined = !0, this.dy(t.dom.leading * t.attr("font-size")).attr("x", t.x());
            }
        }
    }), a.extend(a.Text, a.Tspan, {
        plain: function(t) {
            return !1 === this._build && this.clear(), this.node.appendChild(e.createTextNode(t)), this;
        },
        tspan: function(t) {
            var e = (this.textPath && this.textPath() || this).node, i = new a.Tspan;
            return !1 === this._build && this.clear(), e.appendChild(i.node), i.text(t);
        },
        clear: function() {
            for(var t = (this.textPath && this.textPath() || this).node; t.hasChildNodes();)t.removeChild(t.lastChild);
            return this;
        },
        length: function() {
            return this.node.getComputedTextLength();
        }
    }), a.TextPath = a.invent({
        create: "textPath",
        inherit: a.Parent,
        parent: a.Text,
        construct: {
            morphArray: a.PathArray,
            array: function() {
                var t = this.track();
                return t ? t.array() : null;
            },
            plot: function(t) {
                var e = this.track(), i = null;
                return e && (i = e.plot(t)), null == t ? i : this;
            },
            track: function() {
                var t = this.textPath();
                if (t) return t.reference("href");
            },
            textPath: function() {
                if (this.node.firstChild && "textPath" == this.node.firstChild.nodeName) return a.adopt(this.node.firstChild);
            }
        }
    }), a.Nested = a.invent({
        create: function() {
            this.constructor.call(this, a.create("svg")), this.style("overflow", "visible");
        },
        inherit: a.Container,
        construct: {
            nested: function() {
                return this.put(new a.Nested);
            }
        }
    });
    var l = {
        stroke: [
            "color",
            "width",
            "opacity",
            "linecap",
            "linejoin",
            "miterlimit",
            "dasharray",
            "dashoffset"
        ],
        fill: [
            "color",
            "opacity",
            "rule"
        ],
        prefix: function(t, e) {
            return "color" == e ? t : t + "-" + e;
        }
    };
    function h(t, e, i, s) {
        return i + s.replace(a.regex.dots, " .");
    }
    function c(t) {
        return t.toLowerCase().replace(/-(.)/g, function(t, e) {
            return e.toUpperCase();
        });
    }
    function d(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function g(t) {
        var e = t.toString(16);
        return 1 == e.length ? "0" + e : e;
    }
    function u(t, e, i) {
        if (null == e || null == i) {
            var a = t.bbox();
            null == e ? e = a.width / a.height * i : null == i && (i = a.height / a.width * e);
        }
        return {
            width: e,
            height: i
        };
    }
    function p(t, e, i) {
        return {
            x: e * t.a + i * t.c + 0,
            y: e * t.b + i * t.d + 0
        };
    }
    function f(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2],
            d: t[3],
            e: t[4],
            f: t[5]
        };
    }
    function x(e) {
        for(var i = e.childNodes.length - 1; i >= 0; i--)e.childNodes[i] instanceof t.SVGElement && x(e.childNodes[i]);
        return a.adopt(e).id(a.eid(e.nodeName));
    }
    function b(t) {
        return Math.abs(t) > 1e-37 ? t : 0;
    }
    [
        "fill",
        "stroke"
    ].forEach(function(t) {
        var e = {};
        e[t] = function(e) {
            if (void 0 === e) return this;
            if ("string" == typeof e || a.Color.isRgb(e) || e && "function" == typeof e.fill) this.attr(t, e);
            else for(var i = l[t].length - 1; i >= 0; i--)null != e[l[t][i]] && this.attr(l.prefix(t, l[t][i]), e[l[t][i]]);
            return this;
        }, a.extend(a.Element, a.FX, e);
    }), a.extend(a.Element, a.FX, {
        translate: function(t, e) {
            return this.transform({
                x: t,
                y: e
            });
        },
        matrix: function(t) {
            return this.attr("transform", new a.Matrix(6 == arguments.length ? [].slice.call(arguments) : t));
        },
        opacity: function(t) {
            return this.attr("opacity", t);
        },
        dx: function(t) {
            return this.x(new a.Number(t).plus(this instanceof a.FX ? 0 : this.x()), !0);
        },
        dy: function(t) {
            return this.y(new a.Number(t).plus(this instanceof a.FX ? 0 : this.y()), !0);
        }
    }), a.extend(a.Path, {
        length: function() {
            return this.node.getTotalLength();
        },
        pointAt: function(t) {
            return this.node.getPointAtLength(t);
        }
    }), a.Set = a.invent({
        create: function(t) {
            Array.isArray(t) ? this.members = t : this.clear();
        },
        extend: {
            add: function() {
                for(var t = [].slice.call(arguments), e = 0, i = t.length; e < i; e++)this.members.push(t[e]);
                return this;
            },
            remove: function(t) {
                var e = this.index(t);
                return e > -1 && this.members.splice(e, 1), this;
            },
            each: function(t) {
                for(var e = 0, i = this.members.length; e < i; e++)t.apply(this.members[e], [
                    e,
                    this.members
                ]);
                return this;
            },
            clear: function() {
                return this.members = [], this;
            },
            length: function() {
                return this.members.length;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return this.members.indexOf(t);
            },
            get: function(t) {
                return this.members[t];
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.members.length - 1);
            },
            valueOf: function() {
                return this.members;
            }
        },
        construct: {
            set: function(t) {
                return new a.Set(t);
            }
        }
    }), a.FX.Set = a.invent({
        create: function(t) {
            this.set = t;
        }
    }), a.Set.inherit = function() {
        var t = [];
        for(var e in a.Shape.prototype)"function" == typeof a.Shape.prototype[e] && "function" != typeof a.Set.prototype[e] && t.push(e);
        for(var e in t.forEach(function(t) {
            a.Set.prototype[t] = function() {
                for(var e = 0, i = this.members.length; e < i; e++)this.members[e] && "function" == typeof this.members[e][t] && this.members[e][t].apply(this.members[e], arguments);
                return "animate" == t ? this.fx || (this.fx = new a.FX.Set(this)) : this;
            };
        }), t = [], a.FX.prototype)"function" == typeof a.FX.prototype[e] && "function" != typeof a.FX.Set.prototype[e] && t.push(e);
        t.forEach(function(t) {
            a.FX.Set.prototype[t] = function() {
                for(var e = 0, i = this.set.members.length; e < i; e++)this.set.members[e].fx[t].apply(this.set.members[e].fx, arguments);
                return this;
            };
        });
    }, a.extend(a.Element, {}), a.extend(a.Element, {
        remember: function(t, e) {
            if ("object" === $d4be73e5731103af$var$i(arguments[0])) for(var a in t)this.remember(a, t[a]);
            else {
                if (1 == arguments.length) return this.memory()[t];
                this.memory()[t] = e;
            }
            return this;
        },
        forget: function() {
            if (0 == arguments.length) this._memory = {};
            else for(var t = arguments.length - 1; t >= 0; t--)delete this.memory()[arguments[t]];
            return this;
        },
        memory: function() {
            return this._memory || (this._memory = {});
        }
    }), a.get = function(t) {
        var i = e.getElementById(function(t) {
            var e = (t || "").toString().match(a.regex.reference);
            if (e) return e[1];
        }(t) || t);
        return a.adopt(i);
    }, a.select = function(t, i) {
        return new a.Set(a.utils.map((i || e).querySelectorAll(t), function(t) {
            return a.adopt(t);
        }));
    }, a.extend(a.Parent, {
        select: function(t) {
            return a.select(t, this.node);
        }
    });
    var v = "abcdef".split("");
    if ("function" != typeof t.CustomEvent) {
        var m = function(t, i) {
            i = i || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var a = e.createEvent("CustomEvent");
            return a.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), a;
        };
        m.prototype = t.Event.prototype, a.CustomEvent = m;
    } else a.CustomEvent = t.CustomEvent;
    return a;
}, "function" == typeof define && define.amd ? define(function() {
    return $d4be73e5731103af$var$Ht($d4be73e5731103af$var$Rt, $d4be73e5731103af$var$Rt.document);
}) : "object" === $d4be73e5731103af$var$i($d4be73e5731103af$exports) && true ? $d4be73e5731103af$exports = $d4be73e5731103af$var$Rt.document ? $d4be73e5731103af$var$Ht($d4be73e5731103af$var$Rt, $d4be73e5731103af$var$Rt.document) : function(t) {
    return $d4be73e5731103af$var$Ht(t, t.document);
} : $d4be73e5731103af$var$Rt.SVG = $d4be73e5731103af$var$Ht($d4be73e5731103af$var$Rt, $d4be73e5731103af$var$Rt.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
* https://github.com/wout/svg.filter.js
* Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
    SVG.Filter = SVG.invent({
        create: "filter",
        inherit: SVG.Parent,
        extend: {
            source: "SourceGraphic",
            sourceAlpha: "SourceAlpha",
            background: "BackgroundImage",
            backgroundAlpha: "BackgroundAlpha",
            fill: "FillPaint",
            stroke: "StrokePaint",
            autoSetIn: !0,
            put: function(t, e) {
                return this.add(t, e), !t.attr("in") && this.autoSetIn && t.attr("in", this.source), t.attr("result") || t.attr("result", t), t;
            },
            blend: function(t, e, i) {
                return this.put(new SVG.BlendEffect(t, e, i));
            },
            colorMatrix: function(t, e) {
                return this.put(new SVG.ColorMatrixEffect(t, e));
            },
            convolveMatrix: function(t) {
                return this.put(new SVG.ConvolveMatrixEffect(t));
            },
            componentTransfer: function(t) {
                return this.put(new SVG.ComponentTransferEffect(t));
            },
            composite: function(t, e, i) {
                return this.put(new SVG.CompositeEffect(t, e, i));
            },
            flood: function(t, e) {
                return this.put(new SVG.FloodEffect(t, e));
            },
            offset: function(t, e) {
                return this.put(new SVG.OffsetEffect(t, e));
            },
            image: function(t) {
                return this.put(new SVG.ImageEffect(t));
            },
            merge: function() {
                var t = [
                    void 0
                ];
                for(var e in arguments)t.push(arguments[e]);
                return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, t)));
            },
            gaussianBlur: function(t, e) {
                return this.put(new SVG.GaussianBlurEffect(t, e));
            },
            morphology: function(t, e) {
                return this.put(new SVG.MorphologyEffect(t, e));
            },
            diffuseLighting: function(t, e, i) {
                return this.put(new SVG.DiffuseLightingEffect(t, e, i));
            },
            displacementMap: function(t, e, i, a, s) {
                return this.put(new SVG.DisplacementMapEffect(t, e, i, a, s));
            },
            specularLighting: function(t, e, i, a) {
                return this.put(new SVG.SpecularLightingEffect(t, e, i, a));
            },
            tile: function() {
                return this.put(new SVG.TileEffect);
            },
            turbulence: function(t, e, i, a, s) {
                return this.put(new SVG.TurbulenceEffect(t, e, i, a, s));
            },
            toString: function() {
                return "url(#" + this.attr("id") + ")";
            }
        }
    }), SVG.extend(SVG.Defs, {
        filter: function(t) {
            var e = this.put(new SVG.Filter);
            return "function" == typeof t && t.call(e, e), e;
        }
    }), SVG.extend(SVG.Container, {
        filter: function(t) {
            return this.defs().filter(t);
        }
    }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
        filter: function(t) {
            return this.filterer = t instanceof SVG.Element ? t : this.doc().filter(t), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
        },
        unfilter: function(t) {
            return this.filterer && !0 === t && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
        }
    }), SVG.Effect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    }), SVG.ParentEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Parent,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    });
    var t = {
        blend: function(t, e) {
            return this.parent() && this.parent().blend(this, t, e);
        },
        colorMatrix: function(t, e) {
            return this.parent() && this.parent().colorMatrix(t, e).in(this);
        },
        convolveMatrix: function(t) {
            return this.parent() && this.parent().convolveMatrix(t).in(this);
        },
        componentTransfer: function(t) {
            return this.parent() && this.parent().componentTransfer(t).in(this);
        },
        composite: function(t, e) {
            return this.parent() && this.parent().composite(this, t, e);
        },
        flood: function(t, e) {
            return this.parent() && this.parent().flood(t, e);
        },
        offset: function(t, e) {
            return this.parent() && this.parent().offset(t, e).in(this);
        },
        image: function(t) {
            return this.parent() && this.parent().image(t);
        },
        merge: function() {
            return this.parent() && this.parent().merge.apply(this.parent(), [
                this
            ].concat(arguments));
        },
        gaussianBlur: function(t, e) {
            return this.parent() && this.parent().gaussianBlur(t, e).in(this);
        },
        morphology: function(t, e) {
            return this.parent() && this.parent().morphology(t, e).in(this);
        },
        diffuseLighting: function(t, e, i) {
            return this.parent() && this.parent().diffuseLighting(t, e, i).in(this);
        },
        displacementMap: function(t, e, i, a) {
            return this.parent() && this.parent().displacementMap(this, t, e, i, a);
        },
        specularLighting: function(t, e, i, a) {
            return this.parent() && this.parent().specularLighting(t, e, i, a).in(this);
        },
        tile: function() {
            return this.parent() && this.parent().tile().in(this);
        },
        turbulence: function(t, e, i, a, s) {
            return this.parent() && this.parent().turbulence(t, e, i, a, s).in(this);
        }
    };
    SVG.extend(SVG.Effect, t), SVG.extend(SVG.ParentEffect, t), SVG.ChildEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                this.attr("in", t);
            }
        }
    });
    var e = {
        blend: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                mode: i || "normal"
            });
        },
        colorMatrix: function(t, e) {
            "matrix" == t && (e = s(e)), this.attr({
                type: t,
                values: void 0 === e ? null : e
            });
        },
        convolveMatrix: function(t) {
            t = s(t), this.attr({
                order: Math.sqrt(t.split(" ").length),
                kernelMatrix: t
            });
        },
        composite: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                operator: i
            });
        },
        flood: function(t, e) {
            this.attr("flood-color", t), null != e && this.attr("flood-opacity", e);
        },
        offset: function(t, e) {
            this.attr({
                dx: t,
                dy: e
            });
        },
        image: function(t) {
            this.attr("href", t, SVG.xlink);
        },
        displacementMap: function(t, e, i, a, s) {
            this.attr({
                in: t,
                in2: e,
                scale: i,
                xChannelSelector: a,
                yChannelSelector: s
            });
        },
        gaussianBlur: function(t, e) {
            null != t || null != e ? this.attr("stdDeviation", function(t) {
                if (!Array.isArray(t)) return t;
                for(var e = 0, i = t.length, a = []; e < i; e++)a.push(t[e]);
                return a.join(" ");
            }(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
        },
        morphology: function(t, e) {
            this.attr({
                operator: t,
                radius: e
            });
        },
        tile: function() {},
        turbulence: function(t, e, i, a, s) {
            this.attr({
                numOctaves: e,
                seed: i,
                stitchTiles: a,
                baseFrequency: t,
                type: s
            });
        }
    }, i = {
        merge: function() {
            var t;
            if (arguments[0] instanceof SVG.Set) {
                var e = this;
                arguments[0].each(function(t) {
                    this instanceof SVG.MergeNode ? e.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && e.put(new SVG.MergeNode(this));
                });
            } else {
                t = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                for(var i = 0; i < t.length; i++)t[i] instanceof SVG.MergeNode ? this.put(t[i]) : this.put(new SVG.MergeNode(t[i]));
            }
        },
        componentTransfer: function(t) {
            if (this.rgb = new SVG.Set, [
                "r",
                "g",
                "b",
                "a"
            ].forEach((function(t) {
                this[t] = new SVG["Func" + t.toUpperCase()]("identity"), this.rgb.add(this[t]), this.node.appendChild(this[t].node);
            }).bind(this)), t) for(var e in t.rgb && ([
                "r",
                "g",
                "b"
            ].forEach((function(e) {
                this[e].attr(t.rgb);
            }).bind(this)), delete t.rgb), t)this[e].attr(t[e]);
        },
        diffuseLighting: function(t, e, i) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                kernelUnitLength: i
            });
        },
        specularLighting: function(t, e, i, a) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                specularExponent: i,
                kernelUnitLength: a
            });
        }
    }, a = {
        distantLight: function(t, e) {
            this.attr({
                azimuth: t,
                elevation: e
            });
        },
        pointLight: function(t, e, i) {
            this.attr({
                x: t,
                y: e,
                z: i
            });
        },
        spotLight: function(t, e, i, a, s, r) {
            this.attr({
                x: t,
                y: e,
                z: i,
                pointsAtX: a,
                pointsAtY: s,
                pointsAtZ: r
            });
        },
        mergeNode: function(t) {
            this.attr("in", t);
        }
    };
    function s(t) {
        return Array.isArray(t) && (t = new SVG.Array(t)), t.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
    }
    function r() {
        var t = function() {};
        for(var e in "function" == typeof arguments[arguments.length - 1] && (t = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var i in arguments[e])t(arguments[e][i], i, arguments[e]);
    }
    [
        "r",
        "g",
        "b",
        "a"
    ].forEach(function(t) {
        a["Func" + t.toUpperCase()] = function(t) {
            switch(this.attr("type", t), t){
                case "table":
                    this.attr("tableValues", arguments[1]);
                    break;
                case "linear":
                    this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                    break;
                case "gamma":
                    this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
            }
        };
    }), r(e, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.Effect,
            extend: {}
        });
    }), r(i, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.ParentEffect,
            extend: {}
        });
    }), r(a, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments);
            },
            inherit: SVG.ChildEffect,
            extend: {}
        });
    }), SVG.extend(SVG.MergeEffect, {
        in: function(t) {
            return t instanceof SVG.MergeNode ? this.add(t, 0) : this.add(new SVG.MergeNode(t), 0), this;
        }
    }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
        in2: function(t) {
            return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", t);
        }
    }), SVG.filter = {
        sepiatone: [
            .343,
            .669,
            .119,
            0,
            0,
            .249,
            .626,
            .13,
            0,
            0,
            .172,
            .334,
            .111,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ]
    };
}).call(void 0), function() {
    function t(t, s, r, o, n, l, h) {
        for(var c = t.slice(s, r || h), d = o.slice(n, l || h), g = 0, u = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        }, p = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        };;){
            if (c[g] = e.call(u, c[g]), d[g] = e.call(p, d[g]), c[g][0] != d[g][0] || "M" == c[g][0] || "A" == c[g][0] && (c[g][4] != d[g][4] || c[g][5] != d[g][5]) ? (Array.prototype.splice.apply(c, [
                g,
                1
            ].concat(a.call(u, c[g]))), Array.prototype.splice.apply(d, [
                g,
                1
            ].concat(a.call(p, d[g])))) : (c[g] = i.call(u, c[g]), d[g] = i.call(p, d[g])), ++g == c.length && g == d.length) break;
            g == c.length && c.push([
                "C",
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1]
            ]), g == d.length && d.push([
                "C",
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1]
            ]);
        }
        return {
            start: c,
            dest: d
        };
    }
    function e(t) {
        switch(t[0]){
            case "z":
            case "Z":
                t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                break;
            case "H":
                t[0] = "L", t[2] = this.pos[1];
                break;
            case "V":
                t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                break;
            case "T":
                t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                break;
            case "S":
                t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0];
        }
        return t;
    }
    function i(t) {
        var e = t.length;
        return this.pos = [
            t[e - 2],
            t[e - 1]
        ], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [
            2 * this.pos[0] - t[e - 4],
            2 * this.pos[1] - t[e - 3]
        ]), t;
    }
    function a(t) {
        var e = [
            t
        ];
        switch(t[0]){
            case "M":
                return this.pos = this.start = [
                    t[1],
                    t[2]
                ], e;
            case "L":
                t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                break;
            case "Q":
                t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                break;
            case "A":
                e = function(t, e) {
                    var i, a, s, r, o, n, l, h, c, d, g, u, p, f, x, b, v, m, y, w, k, A, S, C, L, P, I = Math.abs(e[1]), T = Math.abs(e[2]), M = e[3] % 360, X = e[4], z = e[5], E = e[6], Y = e[7], F = new SVG.Point(t), R = new SVG.Point(E, Y), H = [];
                    if (0 === I || 0 === T || F.x === R.x && F.y === R.y) return [
                        [
                            "C",
                            F.x,
                            F.y,
                            R.x,
                            R.y,
                            R.x,
                            R.y
                        ]
                    ];
                    i = new SVG.Point((F.x - R.x) / 2, (F.y - R.y) / 2).transform((new SVG.Matrix).rotate(M)), (a = i.x * i.x / (I * I) + i.y * i.y / (T * T)) > 1 && (I *= a = Math.sqrt(a), T *= a);
                    s = (new SVG.Matrix).rotate(M).scale(1 / I, 1 / T).rotate(-M), F = F.transform(s), R = R.transform(s), r = [
                        R.x - F.x,
                        R.y - F.y
                    ], n = r[0] * r[0] + r[1] * r[1], o = Math.sqrt(n), r[0] /= o, r[1] /= o, l = n < 4 ? Math.sqrt(1 - n / 4) : 0, X === z && (l *= -1);
                    h = new SVG.Point((R.x + F.x) / 2 + l * -r[1], (R.y + F.y) / 2 + l * r[0]), c = new SVG.Point(F.x - h.x, F.y - h.y), d = new SVG.Point(R.x - h.x, R.y - h.y), g = Math.acos(c.x / Math.sqrt(c.x * c.x + c.y * c.y)), c.y < 0 && (g *= -1);
                    u = Math.acos(d.x / Math.sqrt(d.x * d.x + d.y * d.y)), d.y < 0 && (u *= -1);
                    z && g > u && (u += 2 * Math.PI);
                    !z && g < u && (u -= 2 * Math.PI);
                    for(f = Math.ceil(2 * Math.abs(g - u) / Math.PI), b = [], v = g, p = (u - g) / f, x = 4 * Math.tan(p / 4) / 3, k = 0; k <= f; k++)y = Math.cos(v), m = Math.sin(v), w = new SVG.Point(h.x + y, h.y + m), b[k] = [
                        new SVG.Point(w.x + x * m, w.y - x * y),
                        w,
                        new SVG.Point(w.x - x * m, w.y + x * y)
                    ], v += p;
                    for(b[0][0] = b[0][1].clone(), b[b.length - 1][2] = b[b.length - 1][1].clone(), s = (new SVG.Matrix).rotate(M).scale(I, T).rotate(-M), k = 0, A = b.length; k < A; k++)b[k][0] = b[k][0].transform(s), b[k][1] = b[k][1].transform(s), b[k][2] = b[k][2].transform(s);
                    for(k = 1, A = b.length; k < A; k++)S = (w = b[k - 1][2]).x, C = w.y, L = (w = b[k][0]).x, P = w.y, E = (w = b[k][1]).x, Y = w.y, H.push([
                        "C",
                        S,
                        C,
                        L,
                        P,
                        E,
                        Y
                    ]);
                    return H;
                }(this.pos, t), t = e[0];
        }
        return t[0] = "C", this.pos = [
            t[5],
            t[6]
        ], this.reflection = [
            2 * t[5] - t[3],
            2 * t[6] - t[4]
        ], e;
    }
    function s(t, e) {
        if (!1 === e) return !1;
        for(var i = e, a = t.length; i < a; ++i)if ("M" == t[i][0]) return i;
        return !1;
    }
    SVG.extend(SVG.PathArray, {
        morph: function(e) {
            for(var i = this.value, a = this.parse(e), r = 0, o = 0, n = !1, l = !1; !1 !== r || !1 !== o;){
                var h;
                n = s(i, !1 !== r && r + 1), l = s(a, !1 !== o && o + 1), !1 === r && (r = 0 == (h = new SVG.PathArray(c.start).bbox()).height || 0 == h.width ? i.push(i[0]) - 1 : i.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1), !1 === o && (o = 0 == (h = new SVG.PathArray(c.dest).bbox()).height || 0 == h.width ? a.push(a[0]) - 1 : a.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1);
                var c = t(i, r, n, a, o, l);
                i = i.slice(0, r).concat(c.start, !1 === n ? [] : i.slice(n)), a = a.slice(0, o).concat(c.dest, !1 === l ? [] : a.slice(l)), r = !1 !== n && r + c.start.length, o = !1 !== l && o + c.dest.length;
            }
            return this.value = i, this.destination = new SVG.PathArray, this.destination.value = a, this;
        }
    });
}(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
* https://github.com/svgdotjs/svg.draggable.js
* Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
    function t(t) {
        t.remember("_draggable", this), this.el = t;
    }
    t.prototype.init = function(t, e) {
        var i = this;
        this.constraint = t, this.value = e, this.el.on("mousedown.drag", function(t) {
            i.start(t);
        }), this.el.on("touchstart.drag", function(t) {
            i.start(t);
        });
    }, t.prototype.transformPoint = function(t, e) {
        var i = (t = t || window.event).changedTouches && t.changedTouches[0] || t;
        return this.p.x = i.clientX - (e || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
    }, t.prototype.getBBox = function() {
        var t = this.el.bbox();
        return this.el instanceof SVG.Nested && (t = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (t.x = this.el.x(), t.y = this.el.y()), t;
    }, t.prototype.start = function(t) {
        if ("click" != t.type && "mousedown" != t.type && "mousemove" != t.type || 1 == (t.which || t.buttons)) {
            var e = this;
            if (this.el.fire("beforedrag", {
                event: t,
                handler: this
            }), !this.el.event().defaultPrevented) {
                t.preventDefault(), t.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                var i, a = this.getBBox();
                if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                    case "middle":
                        i /= 2;
                        break;
                    case "start":
                        i = 0;
                }
                this.startPoints = {
                    point: this.transformPoint(t, i),
                    box: a,
                    transform: this.el.transform()
                }, SVG.on(window, "mousemove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "touchmove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "mouseup.drag", function(t) {
                    e.end(t);
                }), SVG.on(window, "touchend.drag", function(t) {
                    e.end(t);
                }), this.el.fire("dragstart", {
                    event: t,
                    p: this.startPoints.point,
                    m: this.m,
                    handler: this
                });
            }
        }
    }, t.prototype.drag = function(t) {
        var e = this.getBBox(), i = this.transformPoint(t), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, o = i.x - this.startPoints.point.x, n = i.y - this.startPoints.point.y;
        if (this.el.fire("dragmove", {
            event: t,
            p: i,
            m: this.m,
            handler: this
        }), this.el.event().defaultPrevented) return i;
        if ("function" == typeof r) {
            var l = r.call(this.el, a, s, this.m);
            "boolean" == typeof l && (l = {
                x: l,
                y: l
            }), !0 === l.x ? this.el.x(a) : !1 !== l.x && this.el.x(l.x), !0 === l.y ? this.el.y(s) : !1 !== l.y && this.el.y(l.y);
        } else "object" == typeof r && (null != r.minX && a < r.minX ? o = (a = r.minX) - this.startPoints.box.x : null != r.maxX && a > r.maxX - e.width && (o = (a = r.maxX - e.width) - this.startPoints.box.x), null != r.minY && s < r.minY ? n = (s = r.minY) - this.startPoints.box.y : null != r.maxY && s > r.maxY - e.height && (n = (s = r.maxY - e.height) - this.startPoints.box.y), null != r.snapToGrid && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, o -= o % r.snapToGrid, n -= n % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
            x: o,
            y: n
        }, !0) : this.el.move(a, s));
        return i;
    }, t.prototype.end = function(t) {
        var e = this.drag(t);
        this.el.fire("dragend", {
            event: t,
            p: e,
            m: this.m,
            handler: this
        }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
    }, SVG.extend(SVG.Element, {
        draggable: function(e, i) {
            "function" != typeof e && "object" != typeof e || (i = e, e = !0);
            var a = this.remember("_draggable") || new t(this);
            return (e = void 0 === e || e) ? a.init(i || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
        }
    });
}).call(void 0), function() {
    function t(t) {
        this.el = t, t.remember("_selectHandler", this), this.pointSelection = {
            isSelected: !1
        }, this.rectSelection = {
            isSelected: !1
        }, this.pointsList = {
            lt: [
                0,
                0
            ],
            rt: [
                "width",
                0
            ],
            rb: [
                "width",
                "height"
            ],
            lb: [
                0,
                "height"
            ],
            t: [
                "width",
                0
            ],
            r: [
                "width",
                "height"
            ],
            b: [
                "width",
                "height"
            ],
            l: [
                0,
                "height"
            ]
        }, this.pointCoord = function(t, e, i) {
            var a = "string" != typeof t ? t : e[t];
            return i ? a / 2 : a;
        }, this.pointCoords = function(t, e) {
            var i = this.pointsList[t];
            return {
                x: this.pointCoord(i[0], e, "t" === t || "b" === t),
                y: this.pointCoord(i[1], e, "r" === t || "l" === t)
            };
        };
    }
    t.prototype.init = function(t, e) {
        var i = this.el.bbox();
        this.options = {};
        var a = this.el.selectize.defaults.points;
        for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], void 0 !== e[s] && (this.options[s] = e[s]);
        var r = [
            "points",
            "pointsExclude"
        ];
        for(var s in r){
            var o = this.options[r[s]];
            "string" == typeof o ? o = o.length > 0 ? o.split(/\s*,\s*/i) : [] : "boolean" == typeof o && "points" === r[s] && (o = o ? a : []), this.options[r[s]] = o;
        }
        this.options.points = [
            a,
            this.options.points
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) > -1;
            });
        }), this.options.points = [
            this.options.points,
            this.options.pointsExclude
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) < 0;
            });
        }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && -1 !== [
            "line",
            "polyline",
            "polygon"
        ].indexOf(this.el.type) ? this.selectPoints(t) : this.selectRect(t), this.observe(), this.cleanup();
    }, t.prototype.selectPoints = function(t) {
        return this.pointSelection.isSelected = t, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
    }, t.prototype.getPointArray = function() {
        var t = this.el.bbox();
        return this.el.array().valueOf().map(function(e) {
            return [
                e[0] - t.x,
                e[1] - t.y
            ];
        });
    }, t.prototype.drawPoints = function() {
        for(var t = this, e = this.getPointArray(), i = 0, a = e.length; i < a; ++i){
            var s = function(e) {
                return function(i) {
                    (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                    var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                    t.el.fire("point", {
                        x: a,
                        y: s,
                        i: e,
                        event: i
                    });
                };
            }(i), r = this.drawPoint(e[i][0], e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
            this.pointSelection.set.add(r);
        }
    }, t.prototype.drawPoint = function(t, e) {
        var i = this.options.pointType;
        switch(i){
            case "circle":
                return this.drawCircle(t, e);
            case "rect":
                return this.drawRect(t, e);
            default:
                if ("function" == typeof i) return i.call(this, t, e);
                throw new Error("Unknown " + i + " point type!");
        }
    }, t.prototype.drawCircle = function(t, e) {
        return this.nested.circle(this.options.pointSize).center(t, e);
    }, t.prototype.drawRect = function(t, e) {
        return this.nested.rect(this.options.pointSize, this.options.pointSize).center(t, e);
    }, t.prototype.updatePointSelection = function() {
        var t = this.getPointArray();
        this.pointSelection.set.each(function(e) {
            this.cx() === t[e][0] && this.cy() === t[e][1] || this.center(t[e][0], t[e][1]);
        });
    }, t.prototype.updateRectSelection = function() {
        var t = this, e = this.el.bbox();
        if (this.rectSelection.set.get(0).attr({
            width: e.width,
            height: e.height
        }), this.options.points.length && this.options.points.map(function(i, a) {
            var s = t.pointCoords(i, e);
            t.rectSelection.set.get(a + 1).center(s.x, s.y);
        }), this.options.rotationPoint) {
            var i = this.rectSelection.set.length();
            this.rectSelection.set.get(i - 1).center(e.width / 2, 20);
        }
    }, t.prototype.selectRect = function(t) {
        var e = this, i = this.el.bbox();
        function a(t) {
            return function(i) {
                (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                e.el.fire(t, {
                    x: a,
                    y: s,
                    event: i
                });
            };
        }
        if (this.rectSelection.isSelected = t, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2) this.options.points.map(function(t, s) {
            var r = e.pointCoords(t, i), o = e.drawPoint(r.x, r.y).attr("class", e.options.classPoints + "_" + t).on("mousedown", a(t)).on("touchstart", a(t));
            e.rectSelection.set.add(o);
        }), this.rectSelection.set.each(function() {
            this.addClass(e.options.classPoints);
        });
        if (this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
            var s = function(t) {
                (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation();
                var i = t.pageX || t.touches[0].pageX, a = t.pageY || t.touches[0].pageY;
                e.el.fire("rot", {
                    x: i,
                    y: a,
                    event: t
                });
            }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
            this.rectSelection.set.add(r);
        }
    }, t.prototype.handler = function() {
        var t = this.el.bbox();
        this.nested.matrix(new SVG.Matrix(this.el).translate(t.x, t.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
    }, t.prototype.observe = function() {
        var t = this;
        if (MutationObserver) {
            if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                t.handler();
            }), this.observerInst.observe(this.el.node, {
                attributes: !0
            });
            else try {
                this.observerInst.disconnect(), delete this.observerInst;
            } catch (t) {}
        } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
            t.handler();
        });
    }, t.prototype.cleanup = function() {
        !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
            this.remove();
        }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
            this.remove();
        }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
    }, SVG.extend(SVG.Element, {
        selectize: function(e, i) {
            return "object" == typeof e && (i = e, e = !0), (this.remember("_selectHandler") || new t(this)).init(void 0 === e || e, i || {}), this;
        }
    }), SVG.Element.prototype.selectize.defaults = {
        points: [
            "lt",
            "rt",
            "rb",
            "lb",
            "t",
            "r",
            "b",
            "l"
        ],
        pointsExclude: [],
        classRect: "svg_select_boundingRect",
        classPoints: "svg_select_points",
        pointSize: 7,
        rotationPoint: !0,
        deepSelect: !1,
        pointType: "circle"
    };
}(), function() {
    (function() {
        function t(t) {
            t.remember("_resizeHandler", this), this.el = t, this.parameters = {}, this.lastUpdateCall = null, this.p = t.doc().node.createSVGPoint();
        }
        t.prototype.transformPoint = function(t, e, i) {
            return this.p.x = t - (this.offset.x - window.pageXOffset), this.p.y = e - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
        }, t.prototype._extractPosition = function(t) {
            return {
                x: null != t.clientX ? t.clientX : t.touches[0].clientX,
                y: null != t.clientY ? t.clientY : t.touches[0].clientY
            };
        }, t.prototype.init = function(t) {
            var e = this;
            if (this.stop(), "stop" !== t) {
                for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], void 0 !== t[i] && (this.options[i] = t[i]);
                this.el.on("lt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("lb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("t.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("r.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("b.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("l.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rot.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("point.resize", function(t) {
                    e.resize(t || window.event);
                }), this.update();
            }
        }, t.prototype.stop = function() {
            return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
        }, t.prototype.resize = function(t) {
            var e = this;
            this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                x: window.pageXOffset,
                y: window.pageYOffset
            };
            var i = this._extractPosition(t.detail.event);
            if (this.parameters = {
                type: this.el.type,
                p: this.transformPoint(i.x, i.y),
                x: t.detail.x,
                y: t.detail.y,
                box: this.el.bbox(),
                rotation: this.el.transform().rotation
            }, "text" === this.el.type && (this.parameters.fontSize = this.el.attr()["font-size"]), void 0 !== t.detail.i) {
                var a = this.el.array().valueOf();
                this.parameters.i = t.detail.i, this.parameters.pointCoords = [
                    a[t.detail.i][0],
                    a[t.detail.i][1]
                ];
            }
            switch(t.type){
                case "lt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y + i[1]).size(this.parameters.box.width - i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).size(this.parameters.box.width + i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "lb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).size(this.parameters.box.width - i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "t":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).height(this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "r":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + i[0]);
                        }
                    };
                    break;
                case "b":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "l":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).width(this.parameters.box.width - i[0]);
                        }
                    };
                    break;
                case "rot":
                    this.calc = function(t, e) {
                        var i = t + this.parameters.p.x, a = e + this.parameters.p.y, s = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), r = Math.atan2(a - this.parameters.box.y - this.parameters.box.height / 2, i - this.parameters.box.x - this.parameters.box.width / 2), o = this.parameters.rotation + 180 * (r - s) / Math.PI + this.options.snapToAngle / 2;
                        this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(o - o % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                    };
                    break;
                case "point":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), a = this.el.array().valueOf();
                        a[this.parameters.i][0] = this.parameters.pointCoords[0] + i[0], a[this.parameters.i][1] = this.parameters.pointCoords[1] + i[1], this.el.plot(a);
                    };
            }
            this.el.fire("resizestart", {
                dx: this.parameters.x,
                dy: this.parameters.y,
                event: t
            }), SVG.on(window, "touchmove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "touchend.resize", function() {
                e.done();
            }), SVG.on(window, "mousemove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "mouseup.resize", function() {
                e.done();
            });
        }, t.prototype.update = function(t) {
            if (t) {
                var e = this._extractPosition(t), i = this.transformPoint(e.x, e.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                this.lastUpdateCall = [
                    a,
                    s
                ], this.calc(a, s), this.el.fire("resizing", {
                    dx: a,
                    dy: s,
                    event: t
                });
            } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
        }, t.prototype.done = function() {
            this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
        }, t.prototype.snapToGrid = function(t, e, i, a) {
            var s;
            return void 0 !== a ? s = [
                (i + t) % this.options.snapToGrid,
                (a + e) % this.options.snapToGrid
            ] : (i = null == i ? 3 : i, s = [
                (this.parameters.box.x + t + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                (this.parameters.box.y + e + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
            ]), t < 0 && (s[0] -= this.options.snapToGrid), e < 0 && (s[1] -= this.options.snapToGrid), t -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), e -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(t, e, i, a);
        }, t.prototype.constraintToBox = function(t, e, i, a) {
            var s, r, o = this.options.constraint || {};
            return void 0 !== a ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), void 0 !== o.minX && s + t < o.minX && (t = o.minX - s), void 0 !== o.maxX && s + t > o.maxX && (t = o.maxX - s), void 0 !== o.minY && r + e < o.minY && (e = o.minY - r), void 0 !== o.maxY && r + e > o.maxY && (e = o.maxY - r), [
                t,
                e
            ];
        }, t.prototype.checkAspectRatio = function(t, e) {
            if (!this.options.saveAspectRatio) return t;
            var i = t.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + t[0], r = this.parameters.box.height - t[1], o = s / r;
            return o < a ? (i[1] = s / a - this.parameters.box.height, e && (i[1] = -i[1])) : o > a && (i[0] = this.parameters.box.width - r * a, e && (i[0] = -i[0])), i;
        }, SVG.extend(SVG.Element, {
            resize: function(e) {
                return (this.remember("_resizeHandler") || new t(this)).init(e || {}), this;
            }
        }), SVG.Element.prototype.resize.defaults = {
            snapToAngle: .1,
            snapToGrid: 1,
            constraint: {},
            saveAspectRatio: !1
        };
    }).call(this);
}(), void 0 === window.Apex && (window.Apex = {});
var $d4be73e5731103af$var$Gt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "initModules",
            value: function() {
                this.ctx.publicMethods = [
                    "updateOptions",
                    "updateSeries",
                    "appendData",
                    "appendSeries",
                    "toggleSeries",
                    "showSeries",
                    "hideSeries",
                    "setLocale",
                    "resetSeries",
                    "zoomX",
                    "toggleDataPointSelection",
                    "dataURI",
                    "exportToCSV",
                    "addXaxisAnnotation",
                    "addYaxisAnnotation",
                    "addPointAnnotation",
                    "clearAnnotations",
                    "removeAnnotation",
                    "paper",
                    "destroy"
                ], this.ctx.eventList = [
                    "click",
                    "mousedown",
                    "mousemove",
                    "mouseleave",
                    "touchstart",
                    "touchmove",
                    "touchleave",
                    "mouseup",
                    "touchend"
                ], this.ctx.animations = new $d4be73e5731103af$var$b(this.ctx), this.ctx.axes = new $d4be73e5731103af$var$J(this.ctx), this.ctx.core = new $d4be73e5731103af$var$Wt(this.ctx.el, this.ctx), this.ctx.config = new $d4be73e5731103af$var$E({}), this.ctx.data = new $d4be73e5731103af$var$W(this.ctx), this.ctx.grid = new $d4be73e5731103af$var$j(this.ctx), this.ctx.graphics = new $d4be73e5731103af$var$m(this.ctx), this.ctx.coreUtils = new $d4be73e5731103af$var$y(this.ctx), this.ctx.crosshairs = new $d4be73e5731103af$var$Q(this.ctx), this.ctx.events = new $d4be73e5731103af$var$Z(this.ctx), this.ctx.exports = new $d4be73e5731103af$var$G(this.ctx), this.ctx.localization = new $d4be73e5731103af$var$$(this.ctx), this.ctx.options = new $d4be73e5731103af$var$L, this.ctx.responsive = new $d4be73e5731103af$var$K(this.ctx), this.ctx.series = new $d4be73e5731103af$var$N(this.ctx), this.ctx.theme = new $d4be73e5731103af$var$tt(this.ctx), this.ctx.formatters = new $d4be73e5731103af$var$T(this.ctx), this.ctx.titleSubtitle = new $d4be73e5731103af$var$et(this.ctx), this.ctx.legend = new $d4be73e5731103af$var$lt(this.ctx), this.ctx.toolbar = new $d4be73e5731103af$var$ht(this.ctx), this.ctx.tooltip = new $d4be73e5731103af$var$bt(this.ctx), this.ctx.dimensions = new $d4be73e5731103af$var$ot(this.ctx), this.ctx.updateHelpers = new $d4be73e5731103af$var$Bt(this.ctx), this.ctx.zoomPanSelection = new $d4be73e5731103af$var$ct(this.ctx), this.ctx.w.globals.tooltip = new $d4be73e5731103af$var$bt(this.ctx);
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$Vt = function() {
    function t(e) {
        $d4be73e5731103af$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "clear",
            value: function(t) {
                var e = t.isUpdating;
                this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                    isUpdating: e
                });
            }
        },
        {
            key: "killSVG",
            value: function(t) {
                t.each(function(t, e) {
                    this.removeClass("*"), this.off(), this.stop();
                }, !0), t.ungroup(), t.clear();
            }
        },
        {
            key: "clearDomElements",
            value: function(t) {
                var e = this, i = t.isUpdating, a = this.w.globals.dom.Paper.node;
                a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                var s = this.w.globals.dom.baseEl;
                s && this.ctx.eventList.forEach(function(t) {
                    s.removeEventListener(t, e.ctx.events.documentEvent);
                });
                var r = this.w.globals.dom;
                if (null !== this.ctx.el) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
            }
        }
    ]), t;
}(), $d4be73e5731103af$var$jt = new WeakMap;
var $d4be73e5731103af$var$_t = function() {
    function t(e, i) {
        $d4be73e5731103af$var$a(this, t), this.opts = i, this.ctx = this, this.w = new $d4be73e5731103af$var$F(i).init(), this.el = e, this.w.globals.cuid = $d4be73e5731103af$var$x.randomId(), this.w.globals.chartID = this.w.config.chart.id ? $d4be73e5731103af$var$x.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new $d4be73e5731103af$var$Gt(this).initModules(), this.create = $d4be73e5731103af$var$x.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
    }
    return $d4be73e5731103af$var$r(t, [
        {
            key: "render",
            value: function() {
                var t = this;
                return new Promise(function(e, i) {
                    if (null !== t.el) {
                        void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                            id: t.w.globals.chartID,
                            group: t.w.config.chart.group,
                            chart: t
                        }), t.setLocale(t.w.config.chart.defaultLocale);
                        var a = t.w.config.chart.events.beforeMount;
                        if ("function" == typeof a && a(t, t.w), t.events.fireEvent("beforeMount", [
                            t,
                            t.w
                        ]), window.addEventListener("resize", t.windowResizeHandler), function(t, e) {
                            var i = !1;
                            if (t.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                var a = t.getBoundingClientRect();
                                "none" !== t.style.display && 0 !== a.width || (i = !0);
                            }
                            var s = new ResizeObserver(function(a) {
                                i && e.call(t, a), i = !0;
                            });
                            t.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(t.children).forEach(function(t) {
                                return s.observe(t);
                            }) : s.observe(t), $d4be73e5731103af$var$jt.set(e, s);
                        }(t.el.parentNode, t.parentResizeHandler), !t.css) {
                            var s = t.el.getRootNode && t.el.getRootNode(), r = $d4be73e5731103af$var$x.is("ShadowRoot", s), o = t.el.ownerDocument, n = o.getElementById("apexcharts-css");
                            !r && n || (t.css = document.createElement("style"), t.css.id = "apexcharts-css", t.css.textContent = '@keyframes opaque {\n  0% {\n      opacity: 0\n  }\n\n  to {\n      opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n  0%,to {\n      opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0,0,0,.5);\n  box-shadow: 0 0 1px rgba(255,255,255,.5);\n  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\n.legend-mouseover-inactive {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255,255,255,.96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30,30,30,.8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0,0,0,.7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,.apexcharts-tooltip-text-y-value,.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,.apexcharts-tooltip-text-goals-value:empty,.apexcharts-tooltip-text-y-label:empty,.apexcharts-tooltip-text-y-value:empty,.apexcharts-tooltip-text-z-value:empty,.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  border-radius: 50%\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0!important\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_boundingRect,.svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_boundingRect,.apexcharts-selection-rect+g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_points_l,.apexcharts-selection-rect+g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,.apexcharts-pan-icon,.apexcharts-reset-icon,.apexcharts-selection-icon,.apexcharts-toolbar-custom-icon,.apexcharts-zoom-icon,.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,.apexcharts-reset-icon svg,.apexcharts-zoom-icon svg,.apexcharts-zoomin-icon svg,.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,.apexcharts-theme-dark .apexcharts-pan-icon svg,.apexcharts-theme-dark .apexcharts-reset-icon svg,.apexcharts-theme-dark .apexcharts-selection-icon svg,.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,.apexcharts-theme-dark .apexcharts-zoom-icon svg,.apexcharts-theme-dark .apexcharts-zoomin-icon svg,.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,.apexcharts-theme-light .apexcharts-reset-icon:hover svg,.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,.apexcharts-reset-icon,.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0,0,0,.7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n      opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,.apexcharts-datalabel.apexcharts-element-hidden,.apexcharts-hide .apexcharts-series-points {\n  opacity: 0\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n.apexcharts-datalabel,.apexcharts-datalabel-label,.apexcharts-datalabel-value,.apexcharts-datalabels,.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-annotation-rect,.apexcharts-area-series .apexcharts-area,.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-gridline,.apexcharts-line,.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-point-annotation-label,.apexcharts-radar-series path,.apexcharts-radar-series polygon,.apexcharts-toolbar svg,.apexcharts-tooltip .apexcharts-marker,.apexcharts-xaxis-annotation-label,.apexcharts-yaxis-annotation-label,.apexcharts-zoom-rect {\n  pointer-events: none\n}\n\n.apexcharts-marker {\n  transition: .15s ease all\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,.resize-triggers,.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers{\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows{\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers{\n  pointer-events: none\n}', r ? s.prepend(t.css) : o.head.appendChild(t.css));
                        }
                        var l = t.create(t.w.config.series, {});
                        if (!l) return e(t);
                        t.mount(l).then(function() {
                            "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [
                                t,
                                t.w
                            ]), e(l);
                        }).catch(function(t) {
                            i(t);
                        });
                    } else i(new Error("Element not found"));
                });
            }
        },
        {
            key: "create",
            value: function(t, e) {
                var i = this.w;
                new $d4be73e5731103af$var$Gt(this).initModules();
                var a = this.w.globals;
                (a.noData = !1, a.animationEnded = !1, this.responsive.checkResponsiveConfig(e), i.config.xaxis.convertedCatToNumeric) && new $d4be73e5731103af$var$z(i.config).convertCatToNumericXaxis(i.config, this.ctx);
                if (null === this.el) return a.animationEnded = !0, null;
                if (this.core.setupElements(), "treemap" === i.config.chart.type && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), 0 === a.svgWidth) return a.animationEnded = !0, null;
                var s = $d4be73e5731103af$var$y.checkComboSeries(t);
                a.comboCharts = s.comboCharts, a.comboBarCount = s.comboBarCount;
                var r = t.every(function(t) {
                    return t.data && 0 === t.data.length;
                });
                (0 === t.length || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(t), this.theme.init(), new $d4be73e5731103af$var$H(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), a.noData && a.collapsedSeries.length !== a.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), a.axisCharts && (this.core.coreCalculations(), "category" !== i.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), new $d4be73e5731103af$var$y(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                var o = this.core.xySettings();
                this.grid.createGridMask();
                var n = this.core.plotChartType(t, o), l = new $d4be73e5731103af$var$O(this);
                return l.bringForward(), i.config.dataLabels.background.enabled && l.dataLabelsBackground(), this.core.shiftGraphPosition(), {
                    elGraph: n,
                    xyRatios: o,
                    dimensions: {
                        plot: {
                            left: i.globals.translateX,
                            top: i.globals.translateY,
                            width: i.globals.gridWidth,
                            height: i.globals.gridHeight
                        }
                    }
                };
            }
        },
        {
            key: "mount",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = this, a = i.w;
                return new Promise(function(s, r) {
                    if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                    (null === e || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new $d4be73e5731103af$var$j(i);
                    var o, n, l = i.grid.drawGrid();
                    (i.annotations = new $d4be73e5731103af$var$P(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === a.config.grid.position) && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (o = l.elGridBorders) && void 0 !== o && o.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    if (Array.isArray(e.elGraph)) for(var h = 0; h < e.elGraph.length; h++)a.globals.dom.elGraphical.add(e.elGraph[h]);
                    else a.globals.dom.elGraphical.add(e.elGraph);
                    "front" === a.config.grid.position && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (n = l.elGridBorders) && void 0 !== n && n.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    "front" === a.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === a.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "treemap" !== a.config.chart.type && i.axes.drawAxis(a.config.chart.type, l);
                    var c = new $d4be73e5731103af$var$V(t.ctx, l), d = new $d4be73e5731103af$var$q(t.ctx, l);
                    if (null !== l && (c.xAxisLabelCorrections(l.xAxisTickWidth), d.setYAxisTextAlignments(), a.config.yaxis.map(function(t, e) {
                        -1 === a.globals.ignoreYAxisIndexes.indexOf(e) && d.yAxisTitleRotate(e, t.opposite);
                    })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                        if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                            xyRatios: e.xyRatios
                        });
                        else {
                            var g = a.config.chart.toolbar.tools;
                            [
                                "zoom",
                                "zoomin",
                                "zoomout",
                                "selection",
                                "pan",
                                "reset"
                            ].forEach(function(t) {
                                g[t] = !1;
                            });
                        }
                        a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                    }
                    a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(t) {
                        t.method(t.params, !1, t.context);
                    }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                var t, e;
                window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, t = this.parentResizeHandler, (e = $d4be73e5731103af$var$jt.get(t)) && (e.disconnect(), $d4be73e5731103af$var$jt.delete(t));
                var i = this.w.config.chart.id;
                i && Apex._chartInstances.forEach(function(t, e) {
                    t.id === $d4be73e5731103af$var$x.escapeString(i) && Apex._chartInstances.splice(e, 1);
                }), new $d4be73e5731103af$var$Vt(this.ctx).clear({
                    isUpdating: !1
                });
            }
        },
        {
            key: "updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], o = this.w;
                return o.globals.selection = void 0, t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map(function(t, i) {
                    return e.updateHelpers._extendSeries(t, i);
                })), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), o.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, a, s, r);
            }
        },
        {
            key: "updateSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i);
            }
        },
        {
            key: "appendSeries",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w.config.series.slice();
                return a.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, e, i);
            }
        },
        {
            key: "appendData",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this;
                i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (null !== t[s] && void 0 !== t[s]) for(var r = 0; r < t[s].data.length; r++)a[s].data.push(t[s].data[r]);
                return i.w.config.series = a, e && (i.w.globals.initialSeries = $d4be73e5731103af$var$x.clone(i.w.config.series)), this.update();
            }
        },
        {
            key: "update",
            value: function(t) {
                var e = this;
                return new Promise(function(i, a) {
                    new $d4be73e5731103af$var$Vt(e.ctx).clear({
                        isUpdating: !0
                    });
                    var s = e.create(e.w.config.series, t);
                    if (!s) return i(e);
                    e.mount(s).then(function() {
                        "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [
                            e,
                            e.w
                        ]), e.w.globals.isDirty = !0, i(e);
                    }).catch(function(t) {
                        a(t);
                    });
                });
            }
        },
        {
            key: "getSyncedCharts",
            value: function() {
                var t = this.getGroupedCharts(), e = [
                    this
                ];
                return t.length && (e = [], t.forEach(function(t) {
                    e.push(t);
                })), e;
            }
        },
        {
            key: "getGroupedCharts",
            value: function() {
                var t = this;
                return Apex._chartInstances.filter(function(t) {
                    if (t.group) return !0;
                }).map(function(e) {
                    return t.w.config.chart.group === e.group ? e.chart : t;
                });
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                return this.series.toggleSeries(t);
            }
        },
        {
            key: "highlightSeriesOnLegendHover",
            value: function(t, e) {
                return this.series.toggleSeriesOnHover(t, e);
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                this.series.showSeries(t);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                this.series.hideSeries(t);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.series.resetSeries(t, e);
            }
        },
        {
            key: "addEventListener",
            value: function(t, e) {
                this.events.addEventListener(t, e);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                this.events.removeEventListener(t, e);
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addXaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addYaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addPointAnnotationExternal(t, e, a);
            }
        },
        {
            key: "clearAnnotations",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, e = this;
                t && (e = t), e.annotations.clearAnnotations(e);
            }
        },
        {
            key: "removeAnnotation",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = this;
                e && (i = e), i.annotations.removeAnnotation(i, t);
            }
        },
        {
            key: "getChartArea",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
            }
        },
        {
            key: "getSeriesTotalXRange",
            value: function(t, e) {
                return this.coreUtils.getSeriesTotalsXRange(t, e);
            }
        },
        {
            key: "getHighestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new $d4be73e5731103af$var$U(this.ctx).getMinYMaxY(t).highestY;
            }
        },
        {
            key: "getLowestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new $d4be73e5731103af$var$U(this.ctx).getMinYMaxY(t).lowestY;
            }
        },
        {
            key: "getSeriesTotal",
            value: function() {
                return this.w.globals.seriesTotals;
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                return this.updateHelpers.toggleDataPointSelection(t, e);
            }
        },
        {
            key: "zoomX",
            value: function(t, e) {
                this.ctx.toolbar.zoomUpdateOptions(t, e);
            }
        },
        {
            key: "setLocale",
            value: function(t) {
                this.localization.setCurrentLocaleValues(t);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                return new $d4be73e5731103af$var$G(this.ctx).dataURI(t);
            }
        },
        {
            key: "exportToCSV",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new $d4be73e5731103af$var$G(this.ctx).exportToCSV(t);
            }
        },
        {
            key: "paper",
            value: function() {
                return this.w.globals.dom.Paper;
            }
        },
        {
            key: "_parentResizeCallback",
            value: function() {
                this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
            }
        },
        {
            key: "_windowResize",
            value: function() {
                var t = this;
                clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                    t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update();
                }, 150);
            }
        },
        {
            key: "_windowResizeHandler",
            value: function() {
                var t = this.w.config.chart.redrawOnWindowResize;
                "function" == typeof t && (t = t()), t && this._windowResize();
            }
        }
    ], [
        {
            key: "getChartByID",
            value: function(t) {
                var e = $d4be73e5731103af$var$x.escapeString(t), i = Apex._chartInstances.filter(function(t) {
                    return t.id === e;
                })[0];
                return i && i.chart;
            }
        },
        {
            key: "initOnLoad",
            value: function() {
                for(var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++)new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render();
            }
        },
        {
            key: "exec",
            value: function(t, e) {
                var i = this.getChartByID(t);
                if (i) {
                    i.w.globals.isExecCalled = !0;
                    var a = null;
                    if (-1 !== i.publicMethods.indexOf(e)) {
                        for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)r[o - 2] = arguments[o];
                        a = i[e].apply(i, r);
                    }
                    return a;
                }
            }
        },
        {
            key: "merge",
            value: function(t, e) {
                return $d4be73e5731103af$var$x.extend(t, e);
            }
        }
    ]), t;
}();
$d4be73e5731103af$exports = $d4be73e5731103af$var$_t;


var $22d66edd2850c5e1$exports = {};
//
// Get computed styles
//
"use strict";
function $22d66edd2850c5e1$var$Styles() {
    // API
    this.style = function(property) {
        var style = getComputedStyle(document.body);
        var propertyValye = style.getPropertyValue(property);
        if (propertyValye) return propertyValye.trim();
        else return "undefined";
    };
    this.colors = function() {
        var colors = {
            gray: {
                50: this.style("--x-gray-50"),
                100: this.style("--x-gray-100"),
                200: this.style("--x-gray-200"),
                300: this.style("--x-gray-300"),
                400: this.style("--x-gray-400"),
                500: this.style("--x-gray-500"),
                600: this.style("--x-gray-600"),
                700: this.style("--x-gray-700"),
                800: this.style("--x-gray-800"),
                900: this.style("--x-gray-900")
            },
            theme: {
                "primary": this.style("--x-primary"),
                "primarySubtle": this.style("--x-primary-subtle"),
                "secondary": this.style("--x-secondary"),
                "tertiary": this.style("--x-tertiary"),
                "info": this.style("--x-info"),
                "success": this.style("--x-success"),
                "danger": this.style("--x-danger"),
                "warning": this.style("--x-warning"),
                "light": this.style("--x-light"),
                "dark": this.style("--x-dark")
            },
            transparent: "transparent",
            "body": {
                "color": this.style("--x-body-color"),
                "fontSize": this.style("--x-body-font-size")
            },
            "border": {
                "width": this.style("--x-border-width"),
                "color": this.style("--x-border-color")
            }
        };
        return colors;
    };
    this.fonts = function() {
        var fonts = {
            base: this.style("--x-font-sans-serif"),
            code: this.style("--x-font-monospace"),
            serif: this.style("--x-font-serif")
        };
        return fonts;
    };
}
$22d66edd2850c5e1$exports = $22d66edd2850c5e1$var$Styles;


function $9782e7c5651bfc5f$var$apexLineChart() {
    this.init = function(chartEl) {
        var styles = new $22d66edd2850c5e1$exports();
        var colorPalette = [
            styles.colors().theme.primary,
            styles.colors().theme.success,
            styles.colors().theme.warning,
            styles.colors().theme.danger
        ];
        function init($this) {
            var options = {
                chart: {
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    shadow: {
                        enabled: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                colors: colorPalette,
                stroke: {
                    width: 4,
                    curve: "smooth"
                },
                series: [
                    {
                        name: "Ongoing",
                        type: "line",
                        data: [
                            30,
                            50,
                            70,
                            90,
                            80,
                            70,
                            90,
                            120,
                            100,
                            120,
                            140
                        ]
                    },
                    {
                        name: "Finished",
                        type: "line",
                        data: [
                            50,
                            70,
                            30,
                            20,
                            10,
                            10,
                            40,
                            100,
                            90,
                            100,
                            120
                        ]
                    }
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    labels: {
                        style: {
                            colors: "#999",
                            fontSize: "13px",
                            fontFamily: "#333",
                            cssClass: "apexcharts-xaxis-label"
                        }
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        style: {
                            colors: "#999",
                            fontSize: "13px",
                            fontFamily: "inherit",
                            cssClass: "apexcharts-xaxis-label"
                        }
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    borderColor: "#f3f3f3",
                    strokeDashArray: 3
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function(y) {
                            if (typeof y !== "undefined") return y.toFixed(0) + " orders";
                            return y;
                        }
                    }
                }
            };
            // Get data from data attributes
            var height = $this.dataset.height;
            // Inject dynamic properties
            options.colors = colorPalette;
            options.chart.height = height ? height : 350;
            // Create chart
            new $d4be73e5731103af$exports($this, options).render();
        }
        if (chartEl) init(chartEl);
    };
}
$9782e7c5651bfc5f$exports = $9782e7c5651bfc5f$var$apexLineChart;


var $8a75de220626f106$exports = {};
//
// Apex bar chart
//
"use strict";


function $8a75de220626f106$var$apexBarChart() {
    this.init = function(chartEl) {
        var styles = new $22d66edd2850c5e1$exports();
        var colorPalette = [
            styles.colors().theme.primary,
            styles.colors().theme.light,
            styles.colors().theme.dark
        ];
        function init($this) {
            var options = {
                chart: {
                    type: "line",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    shadow: {
                        enabled: false
                    },
                    offsetX: 0,
                    animations: {
                        enabled: false,
                        easing: "easeinout",
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    },
                    fontFamily: styles.fonts().base
                },
                colors: colorPalette,
                plotOptions: {
                    bar: {
                        columnWidth: "40%",
                        borderRadius: 3
                    }
                },
                stroke: {
                    colors: [
                        "transparent"
                    ],
                    width: 4,
                    curve: "smooth"
                },
                series: [
                    {
                        name: "Delivered",
                        type: "bar",
                        data: [
                            10,
                            17,
                            12,
                            8,
                            10,
                            10,
                            20
                        ]
                    }
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    categories: [
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat",
                        "Sun"
                    ],
                    labels: {
                        style: {
                            colors: "#999",
                            fontSize: "13px",
                            cssClass: "apexcharts-xaxis-label"
                        }
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        style: {
                            colors: [
                                "#999"
                            ],
                            fontSize: "13px",
                            cssClass: "apexcharts-xaxis-label"
                        }
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    borderColor: "#e3ebf6",
                    strokeDashArray: 3
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function(y) {
                            if (typeof y !== "undefined") return y.toFixed(0) + " orders";
                            return y;
                        }
                    }
                }
            };
            // Get data from data attributes
            var height = $this.dataset.height;
            // Inject dynamic properties
            options.colors = colorPalette;
            options.chart.height = height ? height : 350;
            // Create chart
            new $d4be73e5731103af$exports($this, options).render();
        }
        if (chartEl) init(chartEl);
    };
}
$8a75de220626f106$exports = $8a75de220626f106$var$apexBarChart;


var $32bc6d93a2e33f71$exports = {};
//
// Apex bar chart
//
"use strict";


function $32bc6d93a2e33f71$var$apexChartBarStacked() {
    this.init = function(chartEl) {
        var styles = new $22d66edd2850c5e1$exports();
        var colorPalette = [
            styles.colors().theme.primary
        ];
        function init($this) {
            var options = {
                chart: {
                    type: "bar",
                    stacked: true,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    shadow: {
                        enabled: false
                    },
                    offsetX: 0,
                    animations: {
                        enabled: false,
                        easing: "easeinout",
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    },
                    fontFamily: styles.fonts().base
                },
                colors: colorPalette,
                plotOptions: {
                    bar: {
                        columnWidth: "23px",
                        borderRadius: 2
                    }
                },
                stroke: {
                    colors: [
                        "transparent"
                    ],
                    width: 2,
                    curve: "smooth"
                },
                series: [
                    {
                        name: "Revenue",
                        type: "bar",
                        data: [
                            30,
                            10,
                            20,
                            10,
                            17,
                            12,
                            8,
                            20
                        ]
                    }
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    categories: [
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    labels: {
                        style: {
                            colors: styles.colors().body.color,
                            fontSize: "13px",
                            cssClass: "apexcharts-xaxis-label"
                        }
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        style: {
                            colors: [
                                styles.colors().body.color
                            ],
                            fontSize: "13px",
                            cssClass: "apexcharts-xaxis-label"
                        }
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    borderColor: styles.colors().border.color,
                    strokeDashArray: 3
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function(y) {
                            if (typeof y !== "undefined") return y.toFixed(0) + " orders";
                            return y;
                        }
                    }
                },
                responsive: [
                    {
                        breakpoint: 364,
                        options: {
                            plotOptions: {
                                bar: {
                                    columnWidth: "30px",
                                    borderRadius: 2
                                }
                            }
                        }
                    }
                ]
            };
            // Get data from data attributes
            var height = $this.dataset.height;
            // Inject dynamic properties
            options.colors = colorPalette;
            options.chart.height = height ? height : 350;
            // Create chart
            new $d4be73e5731103af$exports($this, options).render();
        }
        if (chartEl) init(chartEl);
    };
}
$32bc6d93a2e33f71$exports = $32bc6d93a2e33f71$var$apexChartBarStacked;


var $53deaa4ce77c32ef$exports = {};
//
// Crypto Price Chart
//
"use strict";


var $823d85de923e7e58$exports = {};
!function(t, e) {
    $823d85de923e7e58$exports = e();
}($823d85de923e7e58$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof b;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new b(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var b = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, f = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(f), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return O.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return O.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return O.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return O.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return O.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return O.s(e.$s, 2, "0");
                        case "SSS":
                            return O.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = O.p(d), m = w(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return O.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : O.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), _ = b.prototype;
    return w.prototype = _, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        _[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, b, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});



function $53deaa4ce77c32ef$var$apexCryptoPriceChart() {
    this.init = function(chartEl) {
        var styles = new $22d66edd2850c5e1$exports();
        var colorPalette = [
            styles.colors().theme.primary,
            styles.colors().theme.light,
            styles.colors().theme.dark
        ];
        function init($this) {
            const priceData = (parcelRequire("6rwMJ"));
            var options = {
                chart: {
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    shadow: {
                        enabled: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                colors: colorPalette,
                stroke: {
                    width: 3,
                    curve: "smooth",
                    lineCap: "butt",
                    dashArray: [
                        0,
                        3
                    ]
                },
                series: [
                    {
                        name: "Price",
                        data: priceData.map((d)=>{
                            return {
                                x: new Date(d.date),
                                y: [
                                    d.open,
                                    d.open,
                                    d.close,
                                    d.close
                                ]
                            };
                        })
                    }
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: "datetime",
                    tooltip: {
                        enabled: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: true
                    },
                    tooltip: {
                        enabled: true,
                        formatter: function(val) {
                            return $823d85de923e7e58$exports(val).format("MMM YYYY");
                        }
                    },
                    labels: {
                        show: true,
                        showDuplicates: false,
                        formatter: function(val) {
                            return $823d85de923e7e58$exports(val).format("MMM YYYY");
                        }
                    }
                },
                yaxis: [
                    {
                        seriesName: "Price",
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: true
                        },
                        labels: {
                            style: {
                                colors: styles.colors().body.color,
                                fontSize: "13px",
                                fontFamily: "inherit",
                                cssClass: "apexcharts-xaxis-label"
                            }
                        },
                        opposite: false
                    }
                ],
                legend: {
                    show: false
                },
                grid: {
                    borderColor: styles.colors().border.color,
                    strokeDashArray: 3
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    x: {
                        formatter: function(val) {
                            return $823d85de923e7e58$exports(val).format("MMM DD, YYYY");
                        }
                    }
                }
            };
            // Get data from data attributes
            var height = $this.dataset.height;
            // Inject dynamic properties
            options.colors = colorPalette;
            options.chart.height = height ? height : 350;
            // Create chart
            new $d4be73e5731103af$exports($this, options).render();
        }
        if (chartEl) init(chartEl);
    };
}
$53deaa4ce77c32ef$exports = $53deaa4ce77c32ef$var$apexCryptoPriceChart;


var $27965befda2b0938$exports = {};
//
// Apex spark chart
//
"use strict";


function $27965befda2b0938$var$apexSparkChart() {
    this.init = function(chartEl) {
        var styles = new $22d66edd2850c5e1$exports();
        function init(chartEl) {
            const options = {
                chart: {
                    width: "100%",
                    sparkline: {
                        enabled: true
                    },
                    animations: {
                        enabled: false
                    }
                },
                series: [],
                labels: [],
                plotOptions: {
                    bar: {
                        columnWidth: "40%",
                        endingShape: "rounded"
                    }
                },
                stroke: {
                    curve: "smooth"
                },
                markers: {
                    size: 0
                },
                colors: [],
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function(e) {
                                return "";
                            }
                        }
                    },
                    marker: {
                        show: !1
                    }
                }
            };
            // Get data from data attributes
            let dataset = chartEl.dataset.dataset, labels = chartEl.dataset.labels, color = chartEl.dataset.color, height = chartEl.dataset.height, type = chartEl.dataset.type, stroke = chartEl.dataset.stroke;
            // Inject synamic properties
            options.series = [
                {
                    data: dataset.split(",")
                }
            ];
            if (labels) options.labels = [
                labels
            ];
            options.colors = [
                styles.colors().theme[color]
            ];
            options.chart.height = height ? height : 35;
            options.chart.type = type ? type : "line";
            options.stroke.width = stroke ? stroke : 2;
            // Create chart
            setTimeout(function() {
                new $d4be73e5731103af$exports(chartEl, options).render();
            }, 300);
        }
        if (chartEl) init(chartEl);
    };
}
$27965befda2b0938$exports = $27965befda2b0938$var$apexSparkChart;


var $90a82cd45add0cec$exports = {};
//
// Datepicker
// using the Flatpickr plugin
//
var $5ea753774305934a$exports = {};

$parcel$export($5ea753774305934a$exports, "default", function () { return $5ea753774305934a$export$2e2bcd8739ae039; });
var $cf5b00b61f6e83f2$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $cf5b00b61f6e83f2$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $63e4d6df9da8dd0f$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $63e4d6df9da8dd0f$export$2e2bcd8739ae039 = $63e4d6df9da8dd0f$export$33e6c23ebe2ee669;


var $1f185ef3d3aa53eb$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $1f185ef3d3aa53eb$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $1f185ef3d3aa53eb$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $d5f58f93bb541547$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $d5f58f93bb541547$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $d5f58f93bb541547$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $d5f58f93bb541547$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $d5f58f93bb541547$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $d5f58f93bb541547$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $d5f58f93bb541547$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $d5f58f93bb541547$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $d5f58f93bb541547$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $d5f58f93bb541547$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $d5f58f93bb541547$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $2598bd8d85fe5b91$var$doNothing = function() {
    return undefined;
};
var $2598bd8d85fe5b91$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $2598bd8d85fe5b91$export$9490b78b888a863f = {
    D: $2598bd8d85fe5b91$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $2598bd8d85fe5b91$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $2598bd8d85fe5b91$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $2598bd8d85fe5b91$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $2598bd8d85fe5b91$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$2598bd8d85fe5b91$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $2598bd8d85fe5b91$export$27a2dd9af757e89c($2598bd8d85fe5b91$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)($2598bd8d85fe5b91$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $2598bd8d85fe5b91$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $a17ed51d0f8b1a59$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $cf5b00b61f6e83f2$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $63e4d6df9da8dd0f$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $2598bd8d85fe5b91$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $2598bd8d85fe5b91$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $a17ed51d0f8b1a59$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $cf5b00b61f6e83f2$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $63e4d6df9da8dd0f$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $cf5b00b61f6e83f2$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $2598bd8d85fe5b91$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $a17ed51d0f8b1a59$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $a17ed51d0f8b1a59$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $a17ed51d0f8b1a59$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $a17ed51d0f8b1a59$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $a17ed51d0f8b1a59$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $a17ed51d0f8b1a59$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $a17ed51d0f8b1a59$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $5ea753774305934a$var$__assign = undefined && undefined.__assign || function() {
    $5ea753774305934a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ea753774305934a$var$__assign.apply(this, arguments);
};
var $5ea753774305934a$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $5ea753774305934a$var$DEBOUNCED_CHANGE_MS = 300;
function $5ea753774305934a$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $5ea753774305934a$var$__assign($5ea753774305934a$var$__assign({}, (0, $cf5b00b61f6e83f2$export$ebe90cb607ad99e)), $5ea753774305934a$var$flatpickr.defaultConfig),
        l10n: (0, $63e4d6df9da8dd0f$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $a17ed51d0f8b1a59$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $a17ed51d0f8b1a59$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $a17ed51d0f8b1a59$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $a17ed51d0f8b1a59$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $a17ed51d0f8b1a59$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $a17ed51d0f8b1a59$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $1f185ef3d3aa53eb$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $1f185ef3d3aa53eb$export$61fc7d43ac8f84b0)(triggerChange, $5ea753774305934a$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $d5f58f93bb541547$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $d5f58f93bb541547$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $2598bd8d85fe5b91$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $d5f58f93bb541547$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $d5f58f93bb541547$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $a17ed51d0f8b1a59$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $d5f58f93bb541547$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $d5f58f93bb541547$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $d5f58f93bb541547$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $d5f58f93bb541547$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $5ea753774305934a$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $5ea753774305934a$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $a17ed51d0f8b1a59$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $a17ed51d0f8b1a59$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $a17ed51d0f8b1a59$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $5ea753774305934a$var$__assign($5ea753774305934a$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $5ea753774305934a$var$flatpickr.defaultConfig.dateFormat || (0, $cf5b00b61f6e83f2$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $5ea753774305934a$var$flatpickr.defaultConfig.altFormat || (0, $cf5b00b61f6e83f2$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $cf5b00b61f6e83f2$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $1f185ef3d3aa53eb$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $cf5b00b61f6e83f2$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $1f185ef3d3aa53eb$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $5ea753774305934a$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $5ea753774305934a$var$__assign($5ea753774305934a$var$__assign({}, $5ea753774305934a$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $5ea753774305934a$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $2598bd8d85fe5b91$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $5ea753774305934a$var$__assign($5ea753774305934a$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $5ea753774305934a$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $a17ed51d0f8b1a59$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $a17ed51d0f8b1a59$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $d5f58f93bb541547$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $d5f58f93bb541547$export$25245567f53f158f)((0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $a17ed51d0f8b1a59$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $cf5b00b61f6e83f2$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $1f185ef3d3aa53eb$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $d5f58f93bb541547$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $a17ed51d0f8b1a59$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $2598bd8d85fe5b91$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $d5f58f93bb541547$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(isHourElem) && (0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $1f185ef3d3aa53eb$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $1f185ef3d3aa53eb$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $5ea753774305934a$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $5ea753774305934a$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $5ea753774305934a$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $5ea753774305934a$var$_flatpickr([
            this
        ], config);
    };
}
var $5ea753774305934a$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $5ea753774305934a$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $5ea753774305934a$var$_flatpickr([
        selector
    ], config);
    else return $5ea753774305934a$var$_flatpickr(selector, config);
};
$5ea753774305934a$var$flatpickr.defaultConfig = {};
$5ea753774305934a$var$flatpickr.l10ns = {
    en: $5ea753774305934a$var$__assign({}, (0, $63e4d6df9da8dd0f$export$2e2bcd8739ae039)),
    default: $5ea753774305934a$var$__assign({}, (0, $63e4d6df9da8dd0f$export$2e2bcd8739ae039))
};
$5ea753774305934a$var$flatpickr.localize = function(l10n) {
    $5ea753774305934a$var$flatpickr.l10ns.default = $5ea753774305934a$var$__assign($5ea753774305934a$var$__assign({}, $5ea753774305934a$var$flatpickr.l10ns.default), l10n);
};
$5ea753774305934a$var$flatpickr.setDefaults = function(config) {
    $5ea753774305934a$var$flatpickr.defaultConfig = $5ea753774305934a$var$__assign($5ea753774305934a$var$__assign({}, $5ea753774305934a$var$flatpickr.defaultConfig), config);
};
$5ea753774305934a$var$flatpickr.parseDate = (0, $a17ed51d0f8b1a59$export$cfa2ef2687faeda2)({});
$5ea753774305934a$var$flatpickr.formatDate = (0, $a17ed51d0f8b1a59$export$ff1a0b75284ac636)({});
$5ea753774305934a$var$flatpickr.compareDates = (0, $a17ed51d0f8b1a59$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $5ea753774305934a$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $5ea753774305934a$var$flatpickr;
var $5ea753774305934a$export$2e2bcd8739ae039 = $5ea753774305934a$var$flatpickr;


"use strict";
$90a82cd45add0cec$exports = function datepicker() {
    this.init = function(el) {
        var options = {
            enableTime: false,
            allowInput: true,
            wrap: true,
            dateFormat: "M d, Y",
            position: "right"
        };
        (0, $5ea753774305934a$exports.default)(el, options);
    };
    this.range = function(el) {
        var options = {
            enableTime: false,
            allowInput: true,
            wrap: true,
            dateFormat: "M d, Y",
            mode: "range",
            defaultDate: [
                "Jan 23, 2022",
                "Jan 30, 2022"
            ]
        };
        (0, $5ea753774305934a$exports.default)(el, options);
    };
};


var $a15947ff1c3a13e2$exports = {};
//
// Datepicker
// using the Flatpickr plugin
//
"use strict";
// import Choices from "choices.js";
$a15947ff1c3a13e2$exports = function choicesPlugin() {
    this.init = function(el) {
        const items = [
            {
                value: "Value 1",
                label: '<img src="/img/crypto/bitcoin.svg" class="w-rem-6 h-rem-6 me-2" /> Bitcoin',
                id: 1
            },
            {
                value: "Value 2",
                label: "Label 2",
                id: 2,
                customProperties: {
                    random: "I am a custom property"
                }
            }
        ];
        const options = {
            choices: items,
            allowHTML: true
        };
        const choices = new Choices(".js-choice", options);
    };
};


document.addEventListener("DOMContentLoaded", ()=>{
    // Tooltip
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new $922d1ae1010e6efd$export$28c660c63b792dea(tooltipTriggerEl);
    });
    // Popover
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
        return new $922d1ae1010e6efd$export$5b6b19405a83ff9d(popoverTriggerEl);
    });
    // Line chart
    const chartOneEl = document.querySelector("#chart-line");
    if (chartOneEl) new $9782e7c5651bfc5f$exports().init(chartOneEl);
    // Bar chart
    const chartTwoEl = document.querySelector("#chart-bar");
    if (chartTwoEl) new $8a75de220626f106$exports().init(chartTwoEl);
    // Users chart
    const chartThreeEl = document.querySelector("#chart-users");
    if (chartThreeEl) new $32bc6d93a2e33f71$exports().init(chartThreeEl);
    // Users chart
    const chartFourEl = document.querySelector("#chart-crypto-price");
    if (chartFourEl) new $53deaa4ce77c32ef$exports().init(chartFourEl);
    // Spark chart
    const sparkChartsEl = document.querySelectorAll("[data-toggle='spark-chart']");
    if (sparkChartsEl) Array.prototype.forEach.call(sparkChartsEl, function(el) {
        new $27965befda2b0938$exports().init(el);
    });
    // Datepicker
    const dateRangePickerEl = document.querySelector(".daterangepicker");
    if (dateRangePickerEl) new $90a82cd45add0cec$exports().range(".daterangepicker");
    const datepickerEl = document.querySelector(".datepicker");
    if (datepickerEl) new $90a82cd45add0cec$exports().init(".datepicker");
    const choicesEl = document.querySelector(".js-choice");
    if (choicesEl) new $a15947ff1c3a13e2$exports().init();
});

})();
//# sourceMappingURL=main.js.map
